var jl = Object.defineProperty;
var El = (r, t, e) => t in r ? jl(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e;
var Er = (r, t, e) => (El(r, typeof t != "symbol" ? t + "" : t, e), e);
/*!
    DivKit v32.26.0
    https://github.com/divkit/divkit
    @licence Apache-2.0
*/
function E() {
}
const xl = (r) => r;
function Al(r) {
  return r();
}
function Cl() {
  return /* @__PURE__ */ Object.create(null);
}
function os(r) {
  r.forEach(Al);
}
function Sl(r) {
  return typeof r == "function";
}
function Vl(r, t) {
  return r != r ? t == t : r !== t || r && typeof r == "object" || typeof r == "function";
}
function $(r, ...t) {
  if (r == null) {
    for (const i of t)
      i(void 0);
    return E;
  }
  const e = r.subscribe(...t);
  return e.unsubscribe ? () => e.unsubscribe() : e;
}
function Ro(r) {
  let t;
  return $(r, (e) => t = e)(), t;
}
function Fl(r, t, { bubbles: e = !1, cancelable: i = !1 } = {}) {
  return new CustomEvent(r, { detail: t, bubbles: e, cancelable: i });
}
let Vn;
function Sn(r) {
  Vn = r;
}
function yo() {
  if (!Vn)
    throw new Error("Function called outside component initialization");
  return Vn;
}
function Kr(r) {
  yo().$$.on_destroy.push(r);
}
function Il() {
  const r = yo();
  return (t, e, { cancelable: i = !1 } = {}) => {
    const n = r.$$.callbacks[t];
    if (n) {
      const o = Fl(
        /** @type {string} */
        t,
        e,
        { cancelable: i }
      );
      return n.slice().forEach((l) => {
        l.call(r, o);
      }), !o.defaultPrevented;
    }
    return !0;
  };
}
function Yi(r, t) {
  return yo().$$.context.set(r, t), t;
}
function kr(r) {
  return yo().$$.context.get(r);
}
const $n = [], Is = [];
let Kn = [];
const Ds = [], Ra = /* @__PURE__ */ Promise.resolve();
let Bo = !1;
function Dl() {
  Bo || (Bo = !0, Ra.then(Ml));
}
function $i() {
  return Dl(), Ra;
}
function Tl(r) {
  Kn.push(r);
}
const Co = /* @__PURE__ */ new Set();
let nn = 0;
function Ml() {
  if (nn !== 0)
    return;
  const r = Vn;
  do {
    try {
      for (; nn < $n.length; ) {
        const t = $n[nn];
        nn++, Sn(t), Pl(t.$$);
      }
    } catch (t) {
      throw $n.length = 0, nn = 0, t;
    }
    for (Sn(null), $n.length = 0, nn = 0; Is.length; )
      Is.pop()();
    for (let t = 0; t < Kn.length; t += 1) {
      const e = Kn[t];
      Co.has(e) || (Co.add(e), e());
    }
    Kn.length = 0;
  } while ($n.length);
  for (; Ds.length; )
    Ds.pop()();
  Bo = !1, Co.clear(), Sn(r);
}
function Pl(r) {
  if (r.fragment !== null) {
    r.update(), os(r.before_update);
    const t = r.dirty;
    r.dirty = [-1], r.fragment && r.fragment.p(r.ctx, t), r.after_update.forEach(Tl);
  }
}
function zl(r) {
  return (r == null ? void 0 : r.length) !== void 0 ? r : Array.from(r);
}
const Ol = (
  /** @type {const} */
  [
    "allowfullscreen",
    "allowpaymentrequest",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "hidden",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected"
  ]
), Nl = /* @__PURE__ */ new Set([...Ol]), Rl = /[&"<]/g, Bl = /[&<]/g;
function ft(r, t = !1) {
  const e = String(r), i = t ? Rl : Bl;
  i.lastIndex = 0;
  let n = "", o = 0;
  for (; i.test(e); ) {
    const l = i.lastIndex - 1, c = e[l];
    n += e.substring(o, l) + (c === "&" ? "&amp;" : c === '"' ? "&quot;" : "&lt;"), o = l + 1;
  }
  return n + e.substring(o);
}
const Ll = /^(?:area|base|br|col|command|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/;
function Oi(r) {
  return Ll.test(r) || r.toLowerCase() === "!doctype";
}
const Hl = /[\s'">/=\u{FDD0}-\u{FDEF}\u{FFFE}\u{FFFF}\u{1FFFE}\u{1FFFF}\u{2FFFE}\u{2FFFF}\u{3FFFE}\u{3FFFF}\u{4FFFE}\u{4FFFF}\u{5FFFE}\u{5FFFF}\u{6FFFE}\u{6FFFF}\u{7FFFE}\u{7FFFF}\u{8FFFE}\u{8FFFF}\u{9FFFE}\u{9FFFF}\u{AFFFE}\u{AFFFF}\u{BFFFE}\u{BFFFF}\u{CFFFE}\u{CFFFF}\u{DFFFE}\u{DFFFF}\u{EFFFE}\u{EFFFF}\u{FFFFE}\u{FFFFF}\u{10FFFE}\u{10FFFF}]/u;
function fn(r, t) {
  const e = Object.assign({}, ...r);
  if (t) {
    const n = t.classes, o = t.styles;
    n && (e.class == null ? e.class = n : e.class += " " + n), o && (e.style == null ? e.style = Lo(o) : e.style = Lo(
      Wl(e.style, o)
    ));
  }
  let i = "";
  return Object.keys(e).forEach((n) => {
    if (Hl.test(n))
      return;
    const o = e[n];
    o === !0 ? i += " " + n : Nl.has(n.toLowerCase()) ? o && (i += " " + n) : o != null && (i += ` ${n}="${o}"`);
  }), i;
}
function Wl(r, t) {
  const e = {};
  for (const i of r.split(";")) {
    const n = i.indexOf(":"), o = i.slice(0, n).trim(), l = i.slice(n + 1).trim();
    o && (e[o] = l);
  }
  for (const i in t) {
    const n = t[i];
    n ? e[i] = n : delete e[i];
  }
  return e;
}
function Jr(r) {
  return typeof r == "string" || r && typeof r == "object" ? ft(r, !0) : r;
}
function gn(r) {
  const t = {};
  for (const e in r)
    t[e] = Jr(r[e]);
  return t;
}
function Or(r, t) {
  r = zl(r);
  let e = "";
  for (let i = 0; i < r.length; i += 1)
    e += t(r[i], i);
  return e;
}
const Ul = {
  $$render: () => ""
};
function Yt(r, t) {
  if (!r || !r.$$render)
    throw t === "svelte:component" && (t += " this={...}"), new Error(
      `<${t}> is not a valid SSR component. You may need to review your build config to ensure that dependencies are compiled, rather than imported as pre-compiled modules. Otherwise you may need to fix a <${t}>.`
    );
  return r;
}
let So;
function xr(r) {
  function t(e, i, n, o, l) {
    const c = Vn, d = {
      on_destroy: So,
      context: new Map(l || (c ? c.$$.context : [])),
      // these will be immediately discarded
      on_mount: [],
      before_update: [],
      after_update: [],
      callbacks: Cl()
    };
    Sn({ $$: d });
    const f = r(e, i, n, o);
    return Sn(c), f;
  }
  return {
    render: (e = {}, { $$slots: i = {}, context: n = /* @__PURE__ */ new Map() } = {}) => {
      So = [];
      const o = { title: "", head: "", css: /* @__PURE__ */ new Set() }, l = t(o, e, {}, i, n);
      return os(So), {
        html: l,
        css: {
          code: Array.from(o.css).map((c) => c.code).join(`
`),
          map: null
          // TODO
        },
        head: o.title + o.head
      };
    },
    $$render: t
  };
}
function j(r, t, e) {
  if (t == null || e)
    return "";
  const i = `="${ft(t, !0)}"`;
  return ` ${r}${i}`;
}
function Lo(r) {
  return Object.keys(r).filter((t) => r[t] != null && r[t] !== "").map((t) => `${t}: ${Jr(r[t])};`).join(" ");
}
function Hr(r) {
  const t = Lo(r);
  return t ? ` style="${t}"` : "";
}
const on = [];
function Gl(r, t) {
  return {
    subscribe: Ci(r, t).subscribe
  };
}
function Ci(r, t = E) {
  let e;
  const i = /* @__PURE__ */ new Set();
  function n(c) {
    if (Vl(r, c) && (r = c, e)) {
      const d = !on.length;
      for (const f of i)
        f[1](), on.push(f, r);
      if (d) {
        for (let f = 0; f < on.length; f += 2)
          on[f][0](on[f + 1]);
        on.length = 0;
      }
    }
  }
  function o(c) {
    n(c(r));
  }
  function l(c, d = E) {
    const f = [c, d];
    return i.add(f), i.size === 1 && (e = t(n, o) || E), c(r), () => {
      i.delete(f), i.size === 0 && e && (e(), e = null);
    };
  }
  return { set: n, update: o, subscribe: l };
}
function vn(r, t, e) {
  const i = !Array.isArray(r), n = i ? [r] : r;
  if (!n.every(Boolean))
    throw new Error("derived() expects stores as input, got a falsy value");
  const o = t.length < 2;
  return Gl(e, (l, c) => {
    let d = !1;
    const f = [];
    let h = 0, C = E;
    const T = () => {
      if (h)
        return;
      C();
      const z = t(i ? f[0] : f, l, c);
      o ? l(z) : C = Sl(z) ? z : E;
    }, P = n.map(
      (z, G) => $(
        z,
        (I) => {
          f[G] = I, h &= ~(1 << G), d && T();
        },
        () => {
          h |= 1 << G;
        }
      )
    );
    return d = !0, T(), function() {
      os(P), C(), d = !1;
    };
  });
}
const ql = "appkit-root_platform_desktop", Jl = "appkit-root__clickable", Yl = "appkit-root", Kl = "appkit-root__selectable", Xl = "appkit-root__unselectable", Lr = {
  root_platform_desktop: ql,
  root__clickable: Jl,
  "root__clickable-no-transition": "appkit-root__clickable-no-transition",
  "root__any-actions": "appkit-root__any-actions",
  root: Yl,
  root__selectable: Kl,
  root__unselectable: Xl,
  "root_restrict-scroll": "appkit-root_restrict-scroll",
  "root_disabled-context-menu": "appkit-root_disabled-context-menu"
}, Wr = Symbol("root");
function x(r, t = {}) {
  const e = r;
  return e.level = t.level || "error", t.additional && (e.additional = t.additional), e;
}
const Zl = "appkit-outer", Ql = "appkit-root__clickable", ec = "appkit-outer_width_content", tc = "appkit-outer_height_content", rc = "appkit-outer__border", ic = "appkit-outer_visibility_invisible", nc = "appkit-outer_visibility_gone", Ho = {
  outer: Zl,
  root__clickable: Ql,
  "root__clickable-no-transition": "appkit-root__clickable-no-transition",
  "outer_hide-on-transition-in": "appkit-outer_hide-on-transition-in",
  "outer_halign-self_start": "appkit-outer_halign-self_start",
  "outer_halign-self_center": "appkit-outer_halign-self_center",
  "outer_halign-self_end": "appkit-outer_halign-self_end",
  "outer_halign-self_stretch": "appkit-outer_halign-self_stretch",
  "outer_valign-self_start": "appkit-outer_valign-self_start",
  "outer_valign-self_center": "appkit-outer_valign-self_center",
  "outer_valign-self_end": "appkit-outer_valign-self_end",
  "outer_valign-self_stretch": "appkit-outer_valign-self_stretch",
  "outer_parent-flex_vertical": "appkit-outer_parent-flex_vertical",
  "outer_parent-flex_horizontal": "appkit-outer_parent-flex_horizontal",
  "outer_valign-self_baseline": "appkit-outer_valign-self_baseline",
  outer_width_content: ec,
  outer_height_content: tc,
  "outer_width-constrained": "appkit-outer_width-constrained",
  "outer_parent-grid": "appkit-outer_parent-grid",
  "outer_height-constrained": "appkit-outer_height-constrained",
  "outer_parent-overlap": "appkit-outer_parent-overlap",
  "outer_scroll-snap_start": "appkit-outer_scroll-snap_start",
  "outer_scroll-snap_center": "appkit-outer_scroll-snap_center",
  "outer_scroll-snap_end": "appkit-outer_scroll-snap_end",
  outer__border: rc,
  outer_visibility_invisible: ic,
  outer_visibility_gone: nc,
  "outer_has-action-animation": "appkit-outer_has-action-animation",
  "outer_has-custom-focus": "appkit-outer_has-custom-focus"
};
function fr(r) {
  if (!r)
    return;
  let t = "";
  for (const e in r)
    if (r.hasOwnProperty(e)) {
      if (!r[e] && r[e] !== 0)
        continue;
      t && (t += ";"), t += e + ":" + String(r[e]);
    }
  return t || void 0;
}
function Se(r) {
  if (typeof r != "number" && typeof r != "string" || !r)
    return "0";
  const t = Number(r);
  return Number.isNaN(t) ? "0" : Math.ceil(t * 1e3) / 1e4 + "em";
}
function Yr(r) {
  let t = Se(r);
  return t === "0" && (t += "em"), t;
}
function Ba(r, t) {
  for (; r.length < t; )
    r = "0" + r;
  return r;
}
function lr(r, t = 1, e = "transparent") {
  if (r = (typeof r == "string" && r || "").toLowerCase(), r.charAt(0) !== "#")
    return e;
  const i = ji(r);
  return i ? (i.a *= t, ss(i)) : e;
}
function oc(r, t, e = "transparent") {
  if (r = (typeof r == "string" && r || "").toLowerCase(), r.charAt(0) !== "#")
    return e;
  const i = ji(r);
  return i ? (i.a = t, ss(i)) : e;
}
function ss(r) {
  return r.a === 255 ? `#${[r.r, r.g, r.b].map((t) => Ba(Math.round(t).toString(16), 2)).join("")}` : `rgba(${r.r},${r.g},${r.b},${(r.a / 255).toFixed(2)})`;
}
function ji(r) {
  const t = (
    // #AARRGGBB
    r.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i) || // #ARGB
    r.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])([0-9a-f])$/i) || // #RRGGBB
    r.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i) || // #RGB
    r.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i)
  );
  if (t) {
    if (t.length === 5) {
      const [f, h, C, T, P] = t, z = C.length === 2 ? C : C + C, G = T.length === 2 ? T : T + T, I = P.length === 2 ? P : P + P, F = h.length === 2 ? h : h + h;
      return {
        a: parseInt(F, 16),
        r: parseInt(z, 16),
        g: parseInt(G, 16),
        b: parseInt(I, 16)
      };
    }
    const [e, i, n, o] = t, l = i.length === 2 ? i : i + i, c = n.length === 2 ? n : n + n, d = o.length === 2 ? o : o + o;
    return {
      a: 255,
      r: parseInt(l, 16),
      g: parseInt(c, 16),
      b: parseInt(d, 16)
    };
  }
  return null;
}
function Wo(r) {
  let t = String(r);
  return t.indexOf("&") > -1 && (t = t.replace(/&/g, "&amp;")), t.indexOf("<") > -1 && (t = t.replace(/</g, "&lt;")), t.indexOf(">") > -1 && (t = t.replace(/>/g, "&gt;")), t.indexOf('"') > -1 && (t = t.replace(/"/g, "&quot;")), t;
}
const Fi = Boolean;
function wo(r, t) {
  if (r.length === 1 && r[0].type === "solid")
    return ac({
      bg: r[0]
    });
  const e = r.map((i) => {
    if (i.type === "solid")
      return sc({
        bg: i
      });
    if (i.type === "gradient")
      return lc({
        bg: i
      });
    if (i.type === "image")
      return dc({
        bg: i,
        direction: t
      });
    if (i.type === "radial_gradient")
      return uc({
        bg: i
      });
  }).filter(Fi).reverse().reduce(function(i, n) {
    return i.image.push(n.image), i.size.push(n.size || "auto"), i.position.push(n.pos || "50% 50%"), i;
  }, {
    image: [],
    size: [],
    position: []
  });
  return {
    image: e.image.join(","),
    size: e.size.join(","),
    position: e.position.join(",")
  };
}
function sc(r) {
  const t = lr(r.bg.color || "transparent");
  return {
    size: void 0,
    pos: void 0,
    image: `linear-gradient(to bottom,${t},${t})`
  };
}
function ac(r) {
  return {
    color: lr(r.bg.color || "transparent"),
    size: "auto",
    position: "50% 50%"
  };
}
function La(r) {
  return r.every((i) => i.color && typeof i.position == "number" && i.position >= 0 && i.position <= 1) ? r.sort((i, n) => Math.abs(i.position - n.position) < 1e-6 ? 0 : i.position - n.position).map((i) => `${lr(i.color)} ${(i.position * 100).toFixed(2)}%`).join(",") : void 0;
}
function lc(r) {
  var i, n, o, l;
  if (!Array.isArray((i = r.bg) == null ? void 0 : i.colors) && !Array.isArray((n = r.bg) == null ? void 0 : n.color_map))
    return;
  const t = (o = r.bg.colors) == null ? void 0 : o.filter(Fi);
  if (!(t != null && t.length) && !((l = r.bg) != null && l.color_map))
    return;
  let e;
  if (r.bg.color_map) {
    const c = La(r.bg.color_map);
    if (!c)
      return;
    e = "linear-gradient(" + (90 - Number(r.bg.angle || 0) + "deg") + "," + c + ")";
  } else {
    if (!t)
      return;
    e = "linear-gradient(" + (90 - Number(r.bg.angle || 0) + "deg") + "," + t.map((c) => lr(c)).join(",") + ")";
  }
  return {
    size: void 0,
    pos: void 0,
    image: e
  };
}
const cc = {
  nearest_corner: "closest-corner",
  farthest_corner: "farthest-corner",
  nearest_side: "closest-side",
  farthest_side: "farthest-side"
};
function Ts(r) {
  if (r && typeof r == "object" && "type" in r && r.value !== void 0) {
    if (r.type === "fixed")
      return Yr(r.value);
    if (r.type === "relative")
      return `${Number(r.value) * 100}%`;
  }
  return "50%";
}
function uc(r) {
  var c, d, f, h;
  if (!Array.isArray((c = r.bg) == null ? void 0 : c.colors) && !Array.isArray((d = r.bg) == null ? void 0 : d.color_map))
    return;
  const t = (f = r.bg.colors) == null ? void 0 : f.filter(Fi);
  if (!(t != null && t.length) && !((h = r.bg) != null && h.color_map))
    return;
  let e;
  if (r.bg.color_map ? e = La(r.bg.color_map) : t && (e = t.map((C) => lr(C)).join(",")), !e)
    return;
  const i = r.bg.radius;
  let n;
  i && typeof i == "object" && "type" in i && i.value !== void 0 && (i.type === "fixed" ? n = Yr(i.value) : i.type === "relative" && (n = cc[i.value]));
  const o = Ts(r.bg.center_x), l = Ts(r.bg.center_y);
  return {
    size: void 0,
    pos: void 0,
    image: `radial-gradient(circle ${n || "farthest-corner"} at ${o} ${l},` + e + ")"
  };
}
function dc(r) {
  var e;
  const t = (e = r.bg) == null ? void 0 : e.image_url;
  if (t)
    return {
      size: Ha(r.bg.scale),
      pos: Wa(r.bg, r.direction),
      image: 'url("' + Wo(t) + '")'
    };
}
function Ha(r) {
  return r === "fit" ? "contain" : r === "stretch" ? "fill" : r === "no_scale" ? "none" : "cover";
}
function Wa(r, t) {
  let e, i;
  return r.content_alignment_horizontal === "left" || t === "ltr" && r.content_alignment_horizontal === "start" || t === "rtl" && r.content_alignment_horizontal === "end" ? e = "0%" : r.content_alignment_horizontal === "right" || t === "ltr" && r.content_alignment_horizontal === "end" || t === "rtl" && r.content_alignment_horizontal === "start" ? e = "100%" : e = "50%", r.content_alignment_vertical === "top" ? i = "0%" : r.content_alignment_vertical === "bottom" ? i = "100%" : i = "50%", e + " " + i;
}
function wr(r, t) {
  const e = Number(r);
  return Number.isNaN(e) || e < 0 ? t : e;
}
function Ms(r, t, e) {
  return typeof t == "number" && (r && t > 0 && t <= 100 || !r && t >= 0 && t < 100) ? t : e;
}
function fc(r) {
  return r.is_enabled !== 0 && r.is_enabled !== !1 && r.index !== void 0;
}
function gc(r, {
  visibilityActions: t,
  disappearActions: e,
  rootCtx: i,
  componentContext: n
}) {
  const o = [];
  t && t.forEach((P) => {
    o.push({
      type: "visibility",
      index: o.length,
      action: P,
      visible: !1,
      count: 0,
      finished: !1
    });
  }), e && e.forEach((P) => {
    o.push({
      type: "disappear",
      index: o.length,
      action: P,
      // false, so disappear only works after the element becomes visible
      visible: !1,
      count: 0,
      finished: !1
    });
  });
  const l = o.map((P, z) => {
    const G = P.type === "visibility";
    return n.getDerivedFromVars({
      index: z,
      visibility_percentage: P.action.visibility_percentage,
      visibility_duration: G ? P.action.visibility_duration : P.action.disappear_duration,
      log_limit: P.action.log_limit,
      is_enabled: P.action.is_enabled
    }, void 0, !0);
  });
  let c;
  const d = () => {
    c && c.disconnect(), o.forEach((P) => {
      P.timer && clearTimeout(P.timer);
    });
  }, f = vn(l, (P) => P);
  let h;
  const C = (P) => {
    const z = P.type === "visibility";
    n.execAnyActions([P.action], {
      logType: z ? "visible" : "disappear",
      node: r,
      processUrls: !1
    });
  }, T = f.subscribe((P) => {
    h = P.filter(fc);
    const z = {};
    h.forEach((F) => {
      z[F.index] = F;
    }), d();
    const G = [...new Set(h.map((F) => {
      const ke = o[F.index].type === "visibility";
      return Ms(
        ke,
        F.visibility_percentage,
        ke ? 50 : 0
      ) / 100;
    }))];
    if (!G.length)
      return;
    const I = (F) => {
      F.forEach((ke) => {
        h.forEach((K) => {
          const ge = o[K.index], Q = ge.type === "visibility", ue = Ms(
            Q,
            K.visibility_percentage,
            Q ? 50 : 0
          );
          let oe;
          ue === 0 ? oe = ke.intersectionRatio >= 1e-12 : oe = ke.intersectionRatio >= ue / 100, (Q ? !ge.visible && oe : ge.visible && !oe) ? ge.finished || (ge.timer = setTimeout(() => {
            ++ge.count;
            const be = K.log_limit === 0 ? 1 / 0 : K.log_limit || 1;
            ge.count >= be && (ge.finished = !0), C(ge);
          }, wr(K.visibility_duration, 800))) : (Q ? !oe : oe) && ge.timer && clearTimeout(ge.timer), ge.visible = oe;
        });
      });
    };
    c = new IntersectionObserver(I, {
      threshold: G
    }), c.observe(r);
  });
  return {
    destroy() {
      h == null || h.forEach((P) => {
        const z = o[P.index];
        !z || z.type !== "disappear" || !z.visible || z.finished || i.registerTimeout(window.setTimeout(() => {
          C(z);
        }, P.visibility_duration));
      }), d(), T();
    }
  };
}
function Ps(r, t) {
  t && r.push(t);
}
function rr(r, t, e) {
  const i = [];
  Ps(i, t[r]);
  for (const n in e)
    if (e.hasOwnProperty(n)) {
      const o = e[n];
      if (o) {
        const l = `${r}_${n}` + (typeof o == "string" ? `_${o}` : "");
        Ps(i, t[l]);
      }
    }
  return i.join(" ");
}
function pc(r, t, e, i) {
  var n;
  return (n = t.componentDevtool) == null || n.call(t, {
    type: "mount",
    node: r,
    json: e.json,
    origJson: e.origJson,
    templateContext: e.templateContext,
    componentContext: e,
    devapi: i
  }), {
    update(o) {
      var l;
      (l = t.componentDevtool) == null || l.call(t, {
        type: "update",
        node: r,
        json: o.json,
        origJson: o.origJson,
        templateContext: o.templateContext,
        componentContext: o
      });
    },
    destroy() {
      var o;
      (o = t.componentDevtool) == null || o.call(t, {
        type: "destroy",
        node: r,
        json: e.json,
        origJson: e.origJson,
        templateContext: e.templateContext,
        componentContext: e
      });
    }
  };
}
const zs = pc, as = Symbol("state");
function Vi(r, t) {
  var l, c;
  const e = r.top || 0, i = ((l = t === "ltr" ? r.end : r.start) != null ? l : r.right) || 0, n = r.bottom || 0, o = ((c = t === "ltr" ? r.start : r.end) != null ? c : r.left) || 0;
  return e === 0 && i === 0 && n === 0 && o === 0 ? "" : Se(e) + " " + Se(i) + " " + Se(n) + " " + Se(o);
}
function ko(r) {
  if (typeof r != "number" && typeof r != "string")
    return !1;
  const t = Number(r);
  return !Number.isNaN(t);
}
function si(r) {
  return ko(r) && r >= 0;
}
function po(r, t, e) {
  var n, o;
  if (!r)
    return e;
  const i = [
    r.top,
    (n = t === "ltr" ? r.end : r.start) != null ? n : r.right,
    r.bottom,
    (o = t === "ltr" ? r.start : r.end) != null ? o : r.left
  ];
  for (let l = 0; l < i.length; ++l)
    if (i[l] && !si(i[l]))
      return e;
  return Vi(r, t);
}
function hc(r, t) {
  return !si(r) || r === void 0 || r > 1 ? t : Number(r);
}
const _c = Object.prototype.hasOwnProperty;
function bn(r, t) {
  if (Object.is(r, t))
    return !0;
  if (typeof r != "object" || r === null || typeof t != "object" || t === null)
    return Object.is(r, t);
  const e = Object.keys(r), i = Object.keys(t);
  if (e.length !== i.length)
    return !1;
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    if (!_c.call(t, o) || !bn(r[o], t[o]))
      return !1;
  }
  return !0;
}
function Ni(r, t) {
  return bn(r, t) ? t : r;
}
function mc(r, t) {
  return r === "visible" || r === "invisible" || r === "gone" ? r : t;
}
function Ua(r, t) {
  return r === "linear" || r === "ease" || r === "ease_in_out" || r === "ease_in" || r === "ease_out" ? r : t;
}
function dn(r, t) {
  const e = Number(r);
  return Number.isNaN(e) ? t : e;
}
function Ga(r) {
  const t = [];
  return r.name === "set" ? (r.items || []).forEach((e) => {
    t.push(...Ga(e));
  }) : t.push(r), t;
}
function yn(r, t) {
  if (!r || typeof r != "object")
    return t;
  const e = [
    "top",
    "right",
    "bottom",
    "left"
  ];
  for (let i = 0; i < e.length; ++i)
    if (r[e[i]] && !si(r[e[i]]))
      return t;
  return r;
}
function vc(r, t) {
  if (!r && !t)
    return {};
  if (!t)
    return r;
  if (!r)
    return t;
  const e = {};
  return [
    "top",
    "right",
    "bottom",
    "left",
    "start",
    "end"
  ].forEach((i) => {
    const n = r[i];
    n && (e[i] = n);
    const o = t[i];
    o && (e[i] = (e[i] || 0) + o);
  }), e;
}
function bc(r, t) {
  const e = [
    r["top-left"],
    r["top-right"],
    r["bottom-right"],
    r["bottom-left"]
  ];
  for (let i = 0; i < e.length; ++i)
    if (e[i] && !si(e[i]))
      return t;
  return r;
}
function Xn(r, t = 0, e = 10) {
  return [
    r["top-left"],
    r["top-right"],
    r["bottom-right"],
    r["bottom-left"]
  ].map((i) => Se((i || t) / e * 10)).join(" ");
}
function yc(r) {
  var t, e, i, n, o, l;
  return Se(((e = (t = r.offset) == null ? void 0 : t.x) == null ? void 0 : e.value) || 0) + " " + Se(((n = (i = r.offset) == null ? void 0 : i.y) == null ? void 0 : n.value) || 0) + " " + Se((o = r.blur) != null ? o : 2) + " " + lr(r.color || "#000000", (l = r.alpha) != null ? l : 0.19);
}
function wc(r, t) {
  var e, i, n, o, l, c;
  return "drop-shadow(" + lr(r.color || "#000000", (e = r.alpha) != null ? e : 0.19) + " " + Se((((n = (i = r.offset) == null ? void 0 : i.x) == null ? void 0 : n.value) || 0) * 10 / t) + " " + Se((((l = (o = r.offset) == null ? void 0 : o.y) == null ? void 0 : l.value) || 0) * 10 / t) + " " + Se(((c = r.blur) != null ? c : 2) * 10 / t) + ")";
}
function ls(r) {
  return r.is_enabled !== 0 && r.is_enabled !== !1;
}
let Vo;
function kc() {
  return typeof matchMedia > "u" ? !1 : (Vo || (Vo = window.matchMedia("(prefers-reduced-motion)")), Vo.matches);
}
const $c = 8, jc = (r, t, e, i) => {
  let n;
  return (e || i) && typeof ResizeObserver < "u" && (n = new ResizeObserver(async () => {
    let o = 0;
    const l = {}, c = (f, h) => {
      if (f) {
        const C = t.getVariable(f, "integer");
        if (C) {
          if (h = Math.round(h), l[f] || (l[f] = /* @__PURE__ */ new Set()), !l[f].has(h))
            return C.setValue(h), l[f].add(h), !0;
        } else {
          const T = new Error("Missing variable");
          T.level = "error", T.additional = {
            variableName: f
          }, t.logError(T);
        }
      }
      return !1;
    }, d = () => {
      if (!r)
        return !1;
      const f = r.getBoundingClientRect(), h = c(e, f.width), C = c(i, f.height);
      return h || C;
    };
    for (; d(); ) {
      if (++o > $c) {
        const f = new Error("Recursive layout in size_provider");
        f.level = "warn", f.additional = {
          widthVariableName: e,
          heightVariableName: i
        }, t.logError(f);
        break;
      }
      await $i();
    }
  }), n.observe(r)), n;
}, cs = Symbol("enabled");
function ri(r, t) {
  return r === 1 || r === 0 || r === !1 || r === !0 ? !!r : t;
}
function pn(r) {
  return [
    r.state_description,
    r.description,
    r.hint
  ].filter(Boolean).join(", ");
}
const hn = 2, Ec = "appkit-actionable__button", xc = {
  actionable__button: Ec
};
function Ac() {
}
const Xi = Symbol("action");
function qa(r) {
  if (r.startsWith("tel:"))
    return "tel";
  if (r.startsWith("/"))
    return "https";
  const t = /^([^/]+):\/\//.exec(r);
  return t && t[1] || "";
}
function Ja(r, t) {
  return t.has(r);
}
const Cc = /* @__PURE__ */ new Set(["button", "image", "checkbox", "radio", "header"]), $o = xr((r, t, e, i) => {
  let n, o, l = E, c = () => (l(), l = $(n, (te) => o = te), n), { componentContext: d } = t, { id: f = "" } = t, { actions: h = void 0 } = t, { doubleTapActions: C = void 0 } = t, { longTapActions: T = void 0 } = t, { pressStartActions: P = void 0 } = t, { pressEndActions: z = void 0 } = t, { hoverStartActions: G = void 0 } = t, { hoverEndActions: I = void 0 } = t, { cls: F = "" } = t, { style: ke = null } = t, { attrs: K = void 0 } = t, { use: ge = Ac } = t, { customAction: Q = null } = t, { isNativeActionAnimation: ue = !0 } = t, { hasInnerFocusable: oe = !1 } = t, { customAccessibility: ye = void 0 } = t, { captureFocusOnAction: ee = !0 } = t, { containerElement: be = "span" } = t;
  const $e = kr(Wr), ne = kr(Xi);
  Yi(Xi, {
    hasAction() {
      return !!(ne.hasAction() || h != null && h.length || (ye == null ? void 0 : ye.mode) === "exclude");
    }
  });
  let Ne, Ie = "", Me, Re = !1, Be, Fe, Ue = !1;
  function xe(te) {
  }
  function J(te) {
    ne.hasAction();
  }
  Kr(() => {
    typeof window < "u" && (window.removeEventListener("pointermove", xe), window.removeEventListener("pointerup", J), window.removeEventListener("pointercancel", J)), f && !oe && $e.unregisterFocusable(f);
  }), t.componentContext === void 0 && e.componentContext && d !== void 0 && e.componentContext(d), t.id === void 0 && e.id && f !== void 0 && e.id(f), t.actions === void 0 && e.actions && h !== void 0 && e.actions(h), t.doubleTapActions === void 0 && e.doubleTapActions && C !== void 0 && e.doubleTapActions(C), t.longTapActions === void 0 && e.longTapActions && T !== void 0 && e.longTapActions(T), t.pressStartActions === void 0 && e.pressStartActions && P !== void 0 && e.pressStartActions(P), t.pressEndActions === void 0 && e.pressEndActions && z !== void 0 && e.pressEndActions(z), t.hoverStartActions === void 0 && e.hoverStartActions && G !== void 0 && e.hoverStartActions(G), t.hoverEndActions === void 0 && e.hoverEndActions && I !== void 0 && e.hoverEndActions(I), t.cls === void 0 && e.cls && F !== void 0 && e.cls(F), t.style === void 0 && e.style && ke !== void 0 && e.style(ke), t.attrs === void 0 && e.attrs && K !== void 0 && e.attrs(K), t.use === void 0 && e.use && ge !== void 0 && e.use(ge), t.customAction === void 0 && e.customAction && Q !== void 0 && e.customAction(Q), t.isNativeActionAnimation === void 0 && e.isNativeActionAnimation && ue !== void 0 && e.isNativeActionAnimation(ue), t.hasInnerFocusable === void 0 && e.hasInnerFocusable && oe !== void 0 && e.hasInnerFocusable(oe), t.customAccessibility === void 0 && e.customAccessibility && ye !== void 0 && e.customAccessibility(ye), t.captureFocusOnAction === void 0 && e.captureFocusOnAction && ee !== void 0 && e.captureFocusOnAction(ee), t.containerElement === void 0 && e.containerElement && be !== void 0 && e.containerElement(be), Ue = (ye == null ? void 0 : ye.mode) === "exclude", c(n = d.getDerivedFromVars(h, void 0, !0));
  {
    if (Array.isArray(o) && (o != null && o.length))
      for (let te = 0; te < o.length; ++te) {
        const de = o[te].url;
        if (console.log("url 13333333", de), de) {
          Ie = de, Me = o[te].target || void 0;
          break;
        }
      }
    Re = !!Q, (Ie || Array.isArray(o) && (o != null && o.length)) && (ne.hasAction() || Ue) ? (Ie = "", d.logError(x(new Error("Actionable element is forbidden inside other actionable element or inside accessibility mode=exlucde"), {
      level: "warn",
      additional: { actions: o }
    }))) : Ie && !Ie.startsWith("javascript:") && !Ja(qa(Ie), $e.getBuiltinProtocols()) ? (Ie = "", Re = !0) : !Ie && Array.isArray(o) && (o != null && o.length) && (Re = !0, o.some((te) => te.url || te.typed || te.menu_items) || d.logError(x(new Error("The component has a list of actions, but does not have a real action"), {
      level: "warn",
      additional: { actions: o }
    })));
  }
  return ye != null && ye.type && Cc.has(ye.type) ? ye.type === "header" ? Be = "heading" : Be = ye.type : Ie ? Be = void 0 : Re && (Be = "button"), (Be === "checkbox" || Be === "radio") && typeof (ye == null ? void 0 : ye.is_checked) == "boolean" ? Fe = ye.is_checked : Fe = void 0, l(), `${Ie ? `<a${fn(
    [
      { href: Jr(Ie) },
      { target: Jr(Me) },
      { style: Jr(ke) },
      { role: Jr(Be) },
      {
        "aria-checked": Jr(Fe)
      },
      {
        class: ft(F, !0) + " " + ft(Lr["root__any-actions"], !0) + " " + ft(
          ue ? Lr.root__clickable : Lr["root__clickable-no-transition"],
          !0
        ) + " " + ft(
          T != null && T.length ? Lr["root_disabled-context-menu"] : "",
          !0
        )
      },
      {
        tabindex: Jr(d.fakeElement === hn ? -1 : null)
      },
      gn(K)
    ],
    {}
  )}${j("this", Ne, 0)}>${i.default ? i.default({}) : ""}</a>` : `${Re ? `<button${fn(
    [
      {
        class: ft(F, !0) + " " + ft(xc.actionable__button, !0) + " " + ft(Lr["root__any-actions"], !0) + ft(
          ` ${ue ? Lr.root__clickable : Lr["root__clickable-no-transition"]} ${Lr.root__unselectable}`,
          !0
        ) + " " + ft(
          T != null && T.length ? Lr["root_disabled-context-menu"] : "",
          !0
        )
      },
      { style: Jr(ke) },
      { role: Jr(Be) },
      {
        "aria-checked": Jr(Fe)
      },
      { type: "button" },
      {
        tabindex: Jr(d.fakeElement === hn ? -1 : null)
      },
      gn(K)
    ],
    {}
  )}${j("this", Ne, 0)}>${i.default ? i.default({}) : ""}</button>` : `${((te) => te ? `<${be}${fn(
    [
      {
        class: ft(F, !0) + " " + ft(
          T != null && T.length ? Lr["root_disabled-context-menu"] : "",
          !0
        ) + " " + ft("", !0)
      },
      { style: Jr(ke) },
      { role: Jr(Be) },
      {
        "aria-checked": Jr(Fe)
      },
      {
        "aria-hidden": Jr(Ue || void 0)
      },
      gn(K)
    ],
    {}
  )}${j("this", Ne, 0)}>${Oi(te) ? "" : `${i.default ? i.default({}) : ""}`}${Oi(te) ? "" : `</${te}>`}` : "")(be)}`}`}`;
}), Tn = {
  "outer-background": "appkit-outer-background",
  "outer-background_clip": "appkit-outer-background_clip",
  "outer-background__item": "appkit-outer-background__item"
};
function ui(r) {
  return ko(r) && r > 0;
}
function Ya(r, t) {
  return r.map((e) => {
    if (!e) {
      t(x(new Error("Incorrect filter"), {
        level: "warn"
      }));
      return;
    }
    if (e.type === "blur") {
      if (ui(e.radius))
        return `blur(${Yr(e.radius / 2)})`;
    } else {
      if (e.type === "rtl_mirror")
        return;
      t(x(new Error("Unknown filter"), {
        level: "warn",
        additional: {
          filter: e.type
        }
      }));
    }
  }).filter(Boolean).join(" ");
}
const Sc = xr((r, t, e, i) => {
  let n, { direction: o } = t, { componentContext: l } = t, { background: c = [] } = t, { radius: d = "" } = t;
  return t.direction === void 0 && e.direction && o !== void 0 && e.direction(o), t.componentContext === void 0 && e.componentContext && l !== void 0 && e.componentContext(l), t.background === void 0 && e.background && c !== void 0 && e.background(c), t.radius === void 0 && e.radius && d !== void 0 && e.radius(d), n = c.map((f) => {
    const h = {}, C = { style: h };
    if (f.type === "nine_patch_image" && f.insets)
      h["border-image"] = `url("${f.image_url}") ${f.insets.top || 0} ${f.insets.right || 0} ${f.insets.bottom || 0} ${f.insets.left || 0} fill`, h["border-image-width"] = "auto";
    else {
      const T = wo([f], o);
      f.type === "solid" && (h["background-color"] = T.color), f.type === "gradient" && (h["background-image"] = T.image), f.type === "image" && (h.opacity = Number(f.alpha), C.image_url = f.image_url, h["object-fit"] = T.size, h["object-position"] = T.position, Array.isArray(f.filters) && f.filters.length && (h.filter = Ya(f.filters, l.logError), o === "rtl" && f.filters.some((P) => P.type === "rtl_mirror") && (h.transform = "scale(-1,1)")));
    }
    return C;
  }), `<span${j("class", Tn["outer-background"] + (d ? " " + Tn["outer-background_clip"] : ""), 0)}${Hr({ "border-radius": d })}>${Or(n, (f) => `${f.image_url ? `<img${j("src", f.image_url, 0)} alt="" aria-hidden="true" loading="lazy" decoding="async"${j("class", Tn["outer-background__item"], 0)}${j("style", fr(f.style), 0)}>` : `<span${j("class", Tn["outer-background__item"], 0)}${j("style", fr(f.style), 0)}></span>`}`)}</span>`;
}), Vc = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
}, Fc = {
  left: "end",
  center: "center",
  right: "start",
  start: "start",
  end: "end"
}, Ic = {
  top: "start",
  center: "center",
  bottom: "end",
  baseline: "baseline"
}, Fo = (r) => `The component id with the "${r}" property for state change is missing. Either specify the id, or specify the "transition_trigger" property without "state_change" value.`;
function Dc(r) {
  return r.some((t) => t.name === "native");
}
const ai = xr((r, t, e, i) => {
  var wi, ks, $s, js, Es, xs, As, Cs, Ss, Vs, Fs;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee, be, $e, ne = E, Ne = () => (ne(), ne = $(K, (X) => $e = X), K), Ie, Me = E, Re = () => (Me(), Me = $(ke, (X) => Ie = X), ke), Be, Fe = E, Ue = () => (Fe(), Fe = $(ge, (X) => Be = X), ge), xe, J = E, te = () => (J(), J = $(F, (X) => xe = X), F), de, fe, Qe, Ge = E, gt = () => (Ge(), Ge = $(I, (X) => Qe = X), I), lt, pt = E, R = () => (pt(), pt = $(l, (X) => lt = X), l), We, pe = E, Le = () => (pe(), pe = $(G, (X) => We = X), G), ht, xt = E, Je = () => (xt(), xt = $(z, (X) => ht = X), z), Ke, He = E, Ae = () => (He(), He = $(P, (X) => Ke = X), P), qe, it = E, nt = () => (it(), it = $(T, (X) => qe = X), T), Pe, Ce = E, zt = () => (Ce(), Ce = $(f, (X) => Pe = X), f), Y, wt = E, et = () => (wt(), wt = $(C, (X) => Y = X), C), ot, tt = E, It = () => (tt(), tt = $(h, (X) => ot = X), h), De, Wt = E, At = () => (Wt(), Wt = $(d, (X) => De = X), d), kt, Xe = E, re = () => (Xe(), Xe = $(c, (X) => kt = X), c), ct, Gt, { componentContext: b } = t, { cls: Nt = "" } = t, { style: se = void 0 } = t, { layoutParams: Ve = {} } = t, { customDescription: bt = !1 } = t, { customPaddings: ve = !1 } = t, { customActions: _e = "" } = t, { additionalPaddings: ae = null } = t, { heightByAspect: Ot = !1 } = t, { parentOf: St = void 0 } = t, { parentOfSimpleMode: Vt = void 0 } = t, { replaceItems: Lt = void 0 } = t, { containerElement: _t = "span" } = t, { hasInnerFocusable: $t = !1 } = t, { alwaysCustomFocus: yt = !1 } = t, { devapi: Dt = void 0 } = t;
  const Ct = kr(Wr), Xt = kr(as), { isEnabled: Ut } = kr(cs);
  Gt = $(Ut, (X) => ct = X);
  const jt = Ct.direction;
  fe = $(jt, (X) => de = X);
  let Ht, Rt, mt = null, Ze = [], er = {}, ir = {}, nr = !1, tr = 1, qt = "transparent", U = 0, S = {
    "top-left": 0,
    "top-right": 0,
    "bottom-right": 0,
    "bottom-left": 0
  }, H = "", B = null, V = "", Ee = {}, m, ie, L, Te = 0, ze = 0, pr = 0, je = !1, Ar = !1, Xr = {}, s, he, Jt, Kt = 0, Tt = 0, D = 0, _r = !1, mr = !1, ut = 1, Rr, Zr, Br, vr, Mr = [], Sr = !1, O = !1, $r, Nr, Vr, Qr = [], Fr = [], br = [], ci = [], u = [], g = [], _ = [], A = [], y = [], me = [], W = "", rt, dt, le, vt, Oe = !1, Bt = "visible", sr = 0, ce = 0, Ir, Ur, cr, Ye = !1, a = !0, p, w, v, N = null, M;
  function st() {
    B = null, V = "", ut = 1, Oe = !1, Bt = "visible", sr = 0, ce = 0, Ir = void 0, Ur = void 0, a = !0, Mr = b.fakeElement ? [] : b.json.transition_triggers || ["state_change", "visibility_change"], Sr = Mr.indexOf("state_change") !== -1, O = Mr.indexOf("visibility_change") !== -1, Ht && Gi(Ht), w == null || w(), ct && (w = Ct.processVariableTriggers(b, b.json.variable_triggers));
  }
  function at(X, Et) {
    if (!Array.isArray(St) || !Lt || Vt && (Array.isArray(Et) ? Et.length : 0) !== 1)
      return;
    const Zt = St.findIndex((Mt) => (Mt == null ? void 0 : Mt.id) === X), or = St.slice();
    or.splice(Zt, 1, ...(Et || []).map((Mt) => ({ json: Mt, id: Mt == null ? void 0 : Mt.id }))), St = or, Lt(or.map((Mt) => Mt == null ? void 0 : Mt.json));
  }
  function Cr(X) {
    const Et = dn(X.start_value, 1), Zt = dn(X.end_value, 1), or = wr(X.start_delay, 0), Mt = kc() ? 0 : wr(X.duration, 300), ar = Ua(X.interpolator, "ease_in_out").replace(/_/g, "-");
    switch (X.name) {
      case "fade":
        return rt = Et, dt = Zt, `opacity ${Mt}ms ${ar} ${or}ms`;
      case "scale":
        return le = Et, vt = Zt, `transform ${Mt}ms ${ar} ${or}ms`;
      case "native":
      case "no_animation":
        return "";
      default:
        return b.logError(x(new Error("Unknown action_animation name"), {
          additional: { animation: X.name }
        })), "";
    }
  }
  async function ur(X) {
    Bt = X;
    const Et = X === "visible" ? "in" : "out", Zt = Et === "in" ? b.json.transition_in : b.json.transition_out;
    if (O && Zt) {
      let or;
      X === "gone" && (or = Ht.getBoundingClientRect()), await $i(), Et === "in" && (Nr = !0), Xt.runVisibilityTransition(
        {
          ...b.json,
          visibility: "visible"
        },
        b,
        Zt,
        Ht,
        Et,
        or
      ).then(() => {
        Et === "in" && (Nr = !1);
      }).catch((Mt) => {
        throw Et === "in" && (Nr = !1), Mt;
      });
    }
  }
  function yr() {
    if (mt && Ht) {
      const X = Ct.getExtensionContext(b);
      mt.forEach((Et) => {
        var Zt;
        (Zt = Et.unmountView) == null || Zt.call(Et, Ht, X);
      }), mt = null;
    }
  }
  function Gi(X) {
    var ti, mi, vi;
    v == null || v.destroy(), Ht = X, Sr && b.json.transition_in && (b.id ? Xt.registerChildWithTransitionIn(b.json, b, b.json.transition_in, X).then(() => {
      $r = !1;
    }).catch((jr) => {
      throw $r = !1, jr;
    }) : b.logError(x(new Error(Fo("transition_in")), { level: "warn" }))), Sr && b.json.transition_out && (b.id ? Xt.registerChildWithTransitionOut(b.json, b, b.json.transition_out, X) : b.logError(x(new Error(Fo("transition_out")), { level: "warn" }))), b.fakeElement || (b.json.transition_change && !b.id && b.logError(x(new Error(Fo("transition_change")), { level: "warn" })), Xt.registerChildWithTransitionChange(b.json, b, b.json.transition_change, X).then(() => {
      Vr = !1;
    }).catch((jr) => {
      throw Vr = !1, jr;
    }));
    const Et = !b.fakeElement || b.fakeElement === hn, Zt = Et ? b.json.visibility_actions || b.json.visibility_action && [b.json.visibility_action] : [], or = Et ? b.json.disappear_actions : [];
    let Mt;
    (Array.isArray(Zt) && Zt.length || Array.isArray(or) && or.length) && (Mt = gc(X, {
      visibilityActions: Zt,
      disappearActions: or,
      rootCtx: Ct,
      componentContext: b
    }));
    const ar = b.id;
    return ar && (M == null || M(), M = Ct.registerId(ar, {
      context: () => b,
      node: () => Ht
    }), Xt.registerChild(ar)), (ti = b.json.tooltips) == null || ti.forEach((jr) => {
      Ct.registerTooltip(X, jr);
    }), cr && (cr.disconnect(), cr = void 0), cr = jc(Ht, b, (mi = b.json.layout_provider) == null ? void 0 : mi.width_variable_name, (vi = b.json.layout_provider) == null ? void 0 : vi.height_variable_name), zs && !b.fakeElement && (N = zs(X, Ct, b, Dt)), v = {
      destroy() {
        M && (M(), M = void 0), ar && Xt.unregisterChild(ar), Mt && Mt.destroy(), N && N.destroy();
      }
    }, v;
  }
  function Pi() {
    b.json.focus && ((yt || !Ro(Ct.isPointerFocus)) && (Ye = !0), b.execAnyActions(ci));
  }
  function rn() {
    b.json.focus && (Ye = !1, b.execAnyActions(u));
  }
  Kr(() => {
    var X;
    Ze.forEach((Et) => {
      Ct.unregisterParentOf(Et);
    }), Ze = [], cr && (cr.disconnect(), cr = void 0), (X = b.json.tooltips) == null || X.forEach((Et) => {
      Ct.unregisterTooltip(Et);
    }), w == null || w(), yr();
  }), t.componentContext === void 0 && e.componentContext && b !== void 0 && e.componentContext(b), t.cls === void 0 && e.cls && Nt !== void 0 && e.cls(Nt), t.style === void 0 && e.style && se !== void 0 && e.style(se), t.layoutParams === void 0 && e.layoutParams && Ve !== void 0 && e.layoutParams(Ve), t.customDescription === void 0 && e.customDescription && bt !== void 0 && e.customDescription(bt), t.customPaddings === void 0 && e.customPaddings && ve !== void 0 && e.customPaddings(ve), t.customActions === void 0 && e.customActions && _e !== void 0 && e.customActions(_e), t.additionalPaddings === void 0 && e.additionalPaddings && ae !== void 0 && e.additionalPaddings(ae), t.heightByAspect === void 0 && e.heightByAspect && Ot !== void 0 && e.heightByAspect(Ot), t.parentOf === void 0 && e.parentOf && St !== void 0 && e.parentOf(St), t.parentOfSimpleMode === void 0 && e.parentOfSimpleMode && Vt !== void 0 && e.parentOfSimpleMode(Vt), t.replaceItems === void 0 && e.replaceItems && Lt !== void 0 && e.replaceItems(Lt), t.containerElement === void 0 && e.containerElement && _t !== void 0 && e.containerElement(_t), t.hasInnerFocusable === void 0 && e.hasInnerFocusable && $t !== void 0 && e.hasInnerFocusable($t), t.alwaysCustomFocus === void 0 && e.alwaysCustomFocus && yt !== void 0 && e.alwaysCustomFocus(yt), t.devapi === void 0 && e.devapi && Dt !== void 0 && e.devapi(Dt), n = b.json["custom-class"] || "", o = b.origJson, o && st(), ct ? (w == null || w(), w = Ct.processVariableTriggers(b, b.json.variable_triggers)) : w == null || w(), R(l = b.getDerivedFromVars(b.json.focus)), re(c = b.getDerivedFromVars(b.json.border)), At(d = b.getDerivedFromVars(b.json.paddings)), zt(f = b.getDerivedFromVars(b.json.margins)), It(h = b.getDerivedFromVars(b.json.width)), et(C = b.getDerivedFromVars(b.json.alignment_horizontal)), nt(T = b.getDerivedFromVars(b.json.height)), Ae(P = b.getDerivedFromVars(b.json.alignment_vertical)), Je(z = b.getDerivedFromVars(b.json.alpha)), Le(G = b.getDerivedFromVars(b.json.accessibility)), gt(I = b.getDerivedFromVars(b.json.background)), te(F = b.getDerivedFromVars(b.json.action_animation)), Re(ke = b.getDerivedFromVars(b.json.visibility)), Ne(K = b.getDerivedFromVars(b.json.transform)), Ue(ge = b.getDerivedFromVars(b.json.capture_focus_on_action)), Ze.forEach((X) => {
    Ct.unregisterParentOf(X);
  }), Ze = [], St && St.forEach((X) => {
    X != null && X.id && (Ze.push(X.id), Ct.registerParentOf(X.id, {
      replaceWith: at,
      isSingleMode: !!Vt
    }));
  });
  {
    const X = Ye && (lt != null && lt.border) ? lt.border : kt;
    let Et = {}, Zt = {}, or = !1, Mt = "";
    if (X) {
      if (ri(X.has_shadow, !1)) {
        const ar = X.shadow;
        ar ? Et["box-shadow"] = yc(ar) : Et["box-shadow"] = "0 1px 2px 0 rgba(0,0,0,.18), 0 0 0 1px rgba(0,0,0,.07)";
      }
      if (X.stroke) {
        or = !0, tr = wr(X.stroke.width, tr), qt = lr(X.stroke.color, 1, qt);
        const ar = ((wi = X.stroke.style) == null ? void 0 : wi.type) === "dashed" ? "dashed" : "solid";
        Zt["--divkit-border"] = `${Se(tr + 1)} ${ar} ${qt}`;
      }
      if (X.corners_radius && typeof X.corners_radius == "object") {
        S = bc(X.corners_radius, S), Et["border-radius"] = Xn(S);
        const ar = {};
        ["top-left", "top-right", "bottom-right", "bottom-left"].forEach((ti) => {
          ar[ti] = (S[ti] || 0) + 1;
        }), Zt["--divkit-border-radius"] = Xn(ar);
      } else
        X.corner_radius && (U = wr(X.corner_radius, U), S = {
          "top-left": U,
          "top-right": U,
          "bottom-right": U,
          "bottom-left": U
        }, Et["border-radius"] = Se(U), Zt["--divkit-border-radius"] = Se(U + 1));
      if (or && tr && (X.corners_radius || X.corner_radius)) {
        let ar = { ...S };
        ["top-left", "top-right", "bottom-right", "bottom-left"].forEach((ti) => {
          ar[ti] = (ar[ti] || 0) + tr / 2;
        }), Mt = Xn(ar);
      }
    }
    er = Ni(Et, er), ir = Ni(Zt, ir), nr = or, H = Mt;
  }
  B = yn(
    De && !ve ? De : void 0,
    B
  ), Q = Vi(vc(B, ae), de), V = po(Pe, de, V);
  {
    let X, Et, Zt, or, Mt = {}, ar = 0, ti = 0, mi = !1, vi = !1;
    const jr = (ks = b.json.width) == null ? void 0 : ks.type;
    if (jr === "fixed")
      Te = wr(ot == null ? void 0 : ot.value, Te), Et = Se(Te);
    else if (jr === "wrap_content" || (jr === "match_parent" || !jr) && Ve.parentHorizontalWrapContent) {
      if (X = "content", (jr === "wrap_content" && (ot != null && ot.constrained) || (jr === "match_parent" || !jr) && Ve.parentHorizontalWrapContent) && (Mt["width-constrained"] = !0, Ve.parentContainerOrientation === "horizontal" && (ti = 1)), jr === "wrap_content") {
        const hr = ot;
        let ei, Gr;
        hr.min_size && si(hr.min_size.value) && (ei = hr.min_size.value), hr.max_size && si(hr.max_size.value) && (Gr = hr.max_size.value), ei !== void 0 && Gr !== void 0 && ei > Gr && (b.logError(x(new Error("Element has incorrect width constraints (min size is bigger than max size)."), {
          additional: {
            id: b.json.id,
            minSize: ei + "dp",
            maxSize: Gr + "dp"
          }
        })), ei = Gr = void 0), ei !== void 0 && (Zt = Se(ei)), Gr !== void 0 && (or = Se(Gr));
      }
      (jr === "match_parent" || !jr) && b.logError(x(new Error("Incorrect child size. Container with wrap_content size contains child with match_parent size along the main axis"), { level: "warn" }));
    } else if (X = "parent", Ve.parentContainerOrientation === "vertical" && Ve.parentContainerWrap && (vi = !0, b.logError(x(new Error("Cannot place a match_parent items on the cross-axis of wrap"), { level: "error" }))), Ve.parentLayoutOrientation === "vertical" || Ve.parentContainerOrientation === "vertical" && Ve.parentContainerKnownWidth || Ve.stretchWidth) {
      const hr = (js = ($s = de === "ltr" ? Pe == null ? void 0 : Pe.start : Pe == null ? void 0 : Pe.end) != null ? $s : Pe == null ? void 0 : Pe.left) != null ? js : 0, ei = (xs = (Es = de === "ltr" ? Pe == null ? void 0 : Pe.end : Pe == null ? void 0 : Pe.start) != null ? Es : Pe == null ? void 0 : Pe.right) != null ? xs : 0, Gr = `calc(100% - ${Yr(hr + ei)})`;
      Ve.stretchWidth ? (Et = "0", Zt = Gr) : Et = Gr;
    } else
      Ve.parentContainerOrientation === "horizontal" && (ar = ot && "weight" in ot && ot.weight || 1, Ve.parentContainerWrap && (mi = !0));
    if (X === "parent")
      Mt["halign-self"] = "stretch";
    else {
      const hr = Y;
      hr === "left" || hr === "center" || hr === "right" || hr === "start" || hr === "end" ? Mt["halign-self"] = (de === "ltr" ? Vc : Fc)[hr] : Mt["halign-self"] = Ve.parentHAlign || "start";
    }
    X && (Mt.width = X), m = Et, ie = Zt, L = or, ze = ar, pr = ti, Ee = Ni(Mt, Ee), je = mi, Ar = vi;
  }
  {
    let X, Et, Zt, or, Mt = {}, ar = 0, ti = 0, mi = !1, vi = !1;
    const jr = (As = b.json.height) == null ? void 0 : As.type;
    if (!Ot)
      if (jr === "fixed")
        Kt = wr(qe == null ? void 0 : qe.value, Kt), Et = Se(Kt);
      else if (jr === "match_parent" && !Ve.parentVerticalWrapContent)
        if (X = "parent", Ve.parentContainerOrientation === "horizontal" && Ve.parentContainerWrap && (vi = !0, b.logError(x(new Error("Cannot place a match_parent items on the cross-axis of wrap"), { level: "error" }))), Ve.parentLayoutOrientation === "horizontal" || Ve.parentContainerOrientation === "horizontal" && Ve.parentContainerKnownHeight || Ve.stretchHeight) {
          const hr = (Cs = Pe == null ? void 0 : Pe.top) != null ? Cs : 0, ei = (Ss = Pe == null ? void 0 : Pe.bottom) != null ? Ss : 0, Gr = `calc(100% - ${Yr(hr + ei)})`;
          Ve.stretchHeight ? (Et = "0", Zt = Gr) : Et = Gr;
        } else
          Ve.parentContainerOrientation === "vertical" && (ar = (qe == null ? void 0 : qe.weight) || 1, Ve.parentContainerWrap && (mi = !0));
      else {
        if (X = "content", (jr === "wrap_content" && (qe != null && qe.constrained) || jr === "match_parent" && Ve.parentVerticalWrapContent) && (Mt["height-constrained"] = !0, Ve.parentContainerOrientation === "vertical" && (ti = 1)), jr === "wrap_content") {
          const hr = qe;
          let ei, Gr;
          hr.min_size && si(hr.min_size.value) && (ei = hr.min_size.value), hr.max_size && si(hr.max_size.value) && (Gr = hr.max_size.value), ei !== void 0 && Gr !== void 0 && ei > Gr && (b.logError(x(new Error("Element has incorrect height constraints (min size is bigger than max size)."), {
            additional: {
              id: b.json.id,
              minSize: ei + "dp",
              maxSize: Gr + "dp"
            }
          })), ei = Gr = void 0), ei !== void 0 && (Zt = Se(ei)), Gr !== void 0 && (or = Se(Gr));
        }
        jr === "match_parent" && b.logError(x(new Error("Incorrect child size. Container with wrap_content size contains child with match_parent size along the main axis"), { level: "warn" }));
      }
    if (X === "parent")
      Mt["valign-self"] = "stretch";
    else {
      const hr = Ke;
      hr === "top" || hr === "center" || hr === "bottom" || hr === "baseline" && Ve.parentContainerOrientation === "horizontal" ? Mt["valign-self"] = Ic[hr] : Mt["valign-self"] = Ve.parentVAlign || "start";
    }
    X && (Mt.height = X), s = Et, he = Zt, Jt = or, Tt = ar, D = ti, Xr = Ni(Mt, Xr), _r = mi, mr = vi;
  }
  if (ue = Ve.overlapParent ? !0 : void 0, oe = Ve.gridArea ? `${Ve.gridArea.y + 1}/${Ve.gridArea.x + 1}/span ${Ve.gridArea.rowSpan}/span ${Ve.gridArea.colSpan}` : void 0, ut = hc(ht, ut), Rr = ut === 1 ? void 0 : ut, Rt = void 0, We && !bt) {
    const X = pn(We);
    X && (Rt = {}, Rt["aria-label"] = X);
  }
  if (Zr = Ye && (lt != null && lt.background) ? lt.background : Qe, Br = {}, vr = !1, Array.isArray(Zr) && (vr = Zr.some((X) => X.type === "image" || X.type === "nine_patch_image") || !!H, !vr)) {
    const X = wo(Zr, de);
    Br["background-color"] = X.color, Br["background-image"] = X.image, Br["background-size"] = X.size, Br["background-position"] = X.position, Br["background-repeat"] = "no-repeat";
  }
  $r = void 0, Sr && b.id && b.json.transition_in && Ct.isRunning("stateChange") && ($r = !0), Vr = void 0, Sr && b.id && Ct.isRunning("stateChange") && Xt.hasTransitionChange(b.id) && (Vr = !0);
  {
    const X = b.json;
    let Et = X.actions || X.action && [X.action] || [], Zt = X.doubletap_actions || [], or = X.longtap_actions || [], Mt = ((Vs = X.focus) == null ? void 0 : Vs.on_focus) || [], ar = ((Fs = X.focus) == null ? void 0 : Fs.on_blur) || [], ti = X.press_start_actions || [], mi = X.press_end_actions || [], vi = X.hover_start_actions || [], jr = X.hover_end_actions || [];
    b.fakeElement && b.fakeElement !== hn ? (Et = [], Zt = [], or = [], Mt = [], ar = []) : (Array.isArray(Et) || (Et = [], b.logError(x(new Error("Actions should be array")))), Array.isArray(Zt) || (Zt = [], b.logError(x(new Error("DoubleTapActions should be array")))), Array.isArray(or) || (or = [], b.logError(x(new Error("LongTapActions should be array")))), Array.isArray(Mt) || (Mt = [], b.logError(x(new Error("FocusActions should be array")))), Array.isArray(ar) || (ar = [], b.logError(x(new Error("BlurActions should be array")))), Array.isArray(ti) || (ti = [], b.logError(x(new Error("PressStartActions should be array")))), Array.isArray(mi) || (mi = [], b.logError(x(new Error("PressEndActions should be array")))), Array.isArray(vi) || (vi = [], b.logError(x(new Error("HoverStartActions should be array")))), Array.isArray(jr) || (jr = [], b.logError(x(new Error("HoverEndActions should be array"))))), (Et.length || Zt.length || or.length || g.length || _.length || A.length || y.length) && _e && (Et = [], Zt = [], or = [], g = [], _ = [], A = [], y = [], b.logError(x(new Error(`Cannot use action on component "${_e}"`)))), Qr = Et, Fr = Zt, br = or, ci = Mt, u = ar, g = ti, _ = mi, A = vi, y = jr;
  }
  xe && (me = Ga(xe), W = me.map(Cr).filter(Boolean).join(", ")), typeof Be == "boolean" && (a = Be);
  {
    const X = Bt, Et = mc(Ie, Bt);
    X !== Et && (Oe && (Bt === "visible" || Et === "visible") ? ur(Et) : Bt = Et), Oe || (Oe = !0);
  }
  if (b.json && Ht && !bn(b.json.extensions, p)) {
    let X = p = b.json.extensions;
    $i().then(() => {
      if (!(X !== p || !Ht) && (yr(), Array.isArray(b.json.extensions))) {
        const Et = Ct.getExtensionContext(b);
        mt = b.json.extensions.map((Zt) => {
          var ar;
          const or = Zt.id;
          if (!or)
            return;
          const Mt = Ct.getExtension(or, Zt.params);
          return Mt && ((ar = Mt.mountView) == null || ar.call(Mt, Ht, Et)), Mt;
        }).filter(Fi);
      }
    });
  }
  if (ye = {
    ...Ee,
    ...Xr,
    "parent-overlap": ue,
    "scroll-snap": Ve.scrollSnap,
    "hide-on-transition-in": $r || Nr || Vr,
    visibility: Bt,
    "has-action-animation": !!W,
    "parent-flex": Ve.parentContainerOrientation || void 0,
    "parent-grid": !!Ve.gridArea || void 0,
    "has-custom-focus": !!(Ye && b.json.focus)
  }, $e && $e.rotation !== void 0) {
    const X = $e.pivot_x || { type: "pivot-percentage", value: 50 };
    sr = dn(X.value, sr);
    const Et = X.type === "pivot-fixed" ? Se(sr) : `${sr}%`, Zt = $e.pivot_y || { type: "pivot-percentage", value: 50 };
    ce = dn(Zt.value, ce);
    const or = Zt.type === "pivot-fixed" ? Se(ce) : `${ce}%`;
    Ir = `${Et} ${or}`, Ur = `rotate(${$e.rotation}deg)`;
  }
  return ee = je || _r ? "100%" : ze || Tt ? 0 : void 0, be = {
    ...se,
    ...Br,
    ...er,
    width: m,
    "min-width": ie,
    "max-width": L,
    height: s,
    "min-height": he,
    // input max-height
    "max-height": Jt || (se == null ? void 0 : se["max-height"]),
    "grid-area": oe,
    padding: Q,
    margin: V,
    opacity: Rr,
    transition: W,
    "transform-origin": Ir,
    transform: Ur,
    "flex-grow": ze || Tt || void 0,
    "flex-shrink": pr || D ? 1 : void 0,
    "flex-basis": ee,
    "--divkit-animation-opacity-start": rt,
    "--divkit-animation-opacity-end": dt,
    "--divkit-animation-scale-start": le,
    "--divkit-animation-scale-end": vt
  }, ne(), Me(), Fe(), J(), fe(), Ge(), pt(), pe(), xt(), He(), it(), Ce(), wt(), tt(), Wt(), Xe(), Gt(), `${!Ar && !mr ? `${Yt($o, "Actionable").$$render(
    r,
    {
      componentContext: b,
      id: b.json.id,
      use: Gi,
      cls: Nt + " " + rr("outer", Ho, ye) + (n ? ` ${n}` : ""),
      style: fr(be),
      actions: Qr,
      doubleTapActions: Fr,
      longTapActions: br,
      pressStartActions: g,
      pressEndActions: _,
      hoverStartActions: A,
      hoverEndActions: y,
      attrs: Rt,
      hasInnerFocusable: $t,
      isNativeActionAnimation: !me.length || Dc(me),
      customAccessibility: We,
      captureFocusOnAction: a,
      containerElement: _t
    },
    {},
    {
      default: () => ` ${vr ? `${Yt(Sc, "OuterBackground").$$render(
        r,
        {
          componentContext: b,
          direction: de,
          background: Zr,
          radius: H
        },
        {},
        {}
      )}` : ""}${i.default ? i.default({
        focusHandler: Pi,
        blurHandler: rn,
        hasCustomFocus: Ye
      }) : ""}${nr ? `<span${j("class", Ho.outer__border, 0)}${j("style", fr(ir), 0)}></span>` : ""}`
    }
  )}` : ""}`;
}), Tc = "appkit-text", Mc = "appkit-text_halign_start", Pc = "appkit-text_halign_center", zc = "appkit-text_halign_end", Oc = "appkit-text_valign_start", Nc = "appkit-text_valign_center", Rc = "appkit-text_valign_end", Bc = "appkit-text_valign_baseline", Lc = "appkit-text__inner", Hc = "appkit-text_singleline", Wc = "appkit-text_multiline", Uc = "appkit-text_truncate_none", Gc = "appkit-text__inner_gradient", qc = "appkit-text__image", Jc = "appkit-text__image_hidden", sn = {
  "text-range": "appkit-text-range",
  text: Tc,
  text_halign_start: Mc,
  text_halign_center: Pc,
  text_halign_end: zc,
  text_valign_start: Oc,
  text_valign_center: Nc,
  text_valign_end: Rc,
  text_valign_baseline: Bc,
  text__inner: Lc,
  text_singleline: Hc,
  text_multiline: Wc,
  text_truncate_none: Uc,
  "text__inner_has-cloud-bg": "appkit-text__inner_has-cloud-bg",
  "text__inner_cloud-bg": "appkit-text__inner_cloud-bg",
  text__inner_gradient: Gc,
  "text__image-wrapper": "appkit-text__image-wrapper",
  "text__image-wrapper_crop": "appkit-text__image-wrapper_crop",
  "text__image-wrapper_align_top": "appkit-text__image-wrapper_align_top",
  "text__image-wrapper_align_center": "appkit-text__image-wrapper_align_center",
  "text__image-wrapper_align_bottom": "appkit-text__image-wrapper_align_bottom",
  "text__image-wrapper_align_baseline": "appkit-text__image-wrapper_align_baseline",
  text__image: qc,
  text__image_hidden: Jc,
  "text_has-focus-color": "appkit-text_has-focus-color"
}, Ii = {
  "text-range": "appkit-text-range",
  "text-range_cloud": "appkit-text-range_cloud",
  "text-range_singleline": "appkit-text-range_singleline",
  "text-range__top-offset": "appkit-text-range__top-offset",
  "text-range_decoration_both": "appkit-text-range_decoration_both",
  "text-range_decoration_underline": "appkit-text-range_decoration_underline",
  "text-range_decoration_strike": "appkit-text-range_decoration_strike",
  "text-range_decoration_none": "appkit-text-range_decoration_none",
  "text-range_align_top": "appkit-text-range_align_top",
  "text-range_align_center": "appkit-text-range_align_center",
  "text-range_align_bottom": "appkit-text-range_align_bottom",
  "text-range_align_baseline": "appkit-text-range_align_baseline",
  "text-range__cloud-svg": "appkit-text-range__cloud-svg",
  "text-range_relative-vertical-align": "appkit-text-range_relative-vertical-align",
  "text-range_has-particles-mask": "appkit-text-range_has-particles-mask",
  "text-range__mask-animation": "appkit-text-range__mask-animation",
  "text-range_mask-animated": "appkit-text-range_mask-animated",
  "divkit-mask-particles-0": "appkit-divkit-mask-particles-0",
  "divkit-mask-particles-1": "appkit-divkit-mask-particles-1",
  "divkit-mask-particles-2": "appkit-divkit-mask-particles-2",
  "divkit-mask-particles-3": "appkit-divkit-mask-particles-3",
  "divkit-mask-particles-4": "appkit-divkit-mask-particles-4",
  "divkit-mask-particles-5": "appkit-divkit-mask-particles-5"
};
function fi(r, t) {
  const e = Number(r);
  return Number.isNaN(e) || e <= 0 ? t : e;
}
function Yc(r) {
  if (r === "light" || r === "medium" || r === "bold" || r === "regular")
    return r === "medium" ? 500 : r === "bold" ? 700 : r === "light" ? 300 : 400;
}
function _n(r, t, e) {
  return typeof t == "number" && t > 0 ? t : Yc(r) || e;
}
function Uo(r, t) {
  if (!r)
    return {};
  const e = {};
  for (const i of ["left", "top", "right", "bottom", "start", "end"]) {
    const n = r[i];
    n && (e[i] = n * t);
  }
  return e;
}
const Io = xr((r, t, e, i) => {
  var Qe, Ge, gt, lt, pt, R, We, pe;
  let n, o, l, c, d, f, h, C, T, P, { componentContext: z } = t, { text: G } = t, { rootFontSize: I } = t, { textStyles: F = {} } = t, { singleline: ke = !1 } = t, { actions: K = void 0 } = t, { cloudBg: ge = !1 } = t, { cloudBgId: Q = "" } = t, { customLineHeight: ue = null } = t;
  const oe = kr(Wr), ye = oe.direction;
  P = $(ye, (Le) => T = Le);
  const ee = ge && Q || oe.genId("text-range") || "";
  let be = "none", $e = 12, ne = 1.25, Ne = "", Ie, Me = "", Re = "", Be, Fe = null, Ue, xe, J = !1, te, de, fe;
  t.componentContext === void 0 && e.componentContext && z !== void 0 && e.componentContext(z), t.text === void 0 && e.text && G !== void 0 && e.text(G), t.rootFontSize === void 0 && e.rootFontSize && I !== void 0 && e.rootFontSize(I), t.textStyles === void 0 && e.textStyles && F !== void 0 && e.textStyles(F), t.singleline === void 0 && e.singleline && ke !== void 0 && e.singleline(ke), t.actions === void 0 && e.actions && K !== void 0 && e.actions(K), t.cloudBg === void 0 && e.cloudBg && ge !== void 0 && e.cloudBg(ge), t.cloudBgId === void 0 && e.cloudBgId && Q !== void 0 && e.cloudBgId(Q), t.customLineHeight === void 0 && e.customLineHeight && ue !== void 0 && e.customLineHeight(ue), z.json && (be = "none", $e = 12, ne = 1.25, Ne = "", Ie = void 0, Me = "", Re = "", Be = void 0, Fe = null, Ue = void 0, xe = void 0, J = !1, te = void 0, de = void 0, fe = void 0);
  {
    let Le = "none";
    (F.underline || F.strike) && (F.underline === "single" && F.strike === "single" ? Le = "both" : F.underline === "single" ? Le = "underline" : F.strike === "single" && (Le = "strike")), be = Le;
  }
  $e = fi(F.font_size, $e), ui(F.line_height) && (ne = Number(F.line_height) / $e), si(F.letter_spacing) && (Ne = Se(F.letter_spacing)), Ie = _n(F.font_weight, F.font_weight_value, Ie), typeof F.font_family == "string" && F.font_family ? Me = oe.typefaceProvider(F.font_family, { fontWeight: Ie || 400 }) : Me = "", Re = lr(F.text_color, 1, Re), n = F.top_offset ? Se(F.top_offset) : "", o = ((Qe = F.background) == null ? void 0 : Qe.type) === "cloud", l = ((Ge = F.background) == null ? void 0 : Ge.type) === "cloud" ? F.background.paddings : void 0;
  {
    const Le = F.mask, ht = !!(Le && (Le.type === "solid" || Le.type === "particles") && Le.is_enabled !== !1 && Le.color);
    if (ge || ht ? Be = "transparent" : Be = void 0, J = !1, te = void 0, de = void 0, fe = void 0, ge)
      o ? xe = oc(F.background.color, 255, "transparent") : xe = void 0;
    else if (Le && ht) {
      if (Le.type === "solid")
        xe = lr(Le.color);
      else if (Le.type === "particles") {
        const xt = fi((gt = Le.particle_size) == null ? void 0 : gt.value, 1), Je = Se(xt * 10 / $e), Ke = fi(Le.density, 0.8), He = lr(Le.color);
        xe = void 0, te = He, de = Je, fe = String(Ke), J = Le.is_animated === !0;
      }
    } else
      ((lt = F.background) == null ? void 0 : lt.type) === "solid" ? xe = wo([F.background], T).color : xe = void 0;
  }
  return (pt = F.border) != null && pt.stroke && F.border.stroke.color && lr(F.border.stroke.color) !== "transparent" && ui(F.border.stroke.width) && ((R = F.background) == null ? void 0 : R.type) !== "cloud" ? Fe = {
    color: F.border.stroke.color,
    width: F.border.stroke.width,
    corner_radius: F.border.corner_radius
  } : Fe = null, c = ge ? o && F.background.corner_radius || 0 : Fe ? fi(Fe.corner_radius, 0) : 0, d = F.text_shadow ? wc(F.text_shadow, $e) : void 0, typeof F.baseline_offset == "number" && (Ue = F.baseline_offset), f = typeof F.baseline_offset == "number" ? void 0 : F.alignment_vertical, h = {
    singleline: ke,
    decoration: be,
    align: f,
    cloud: o,
    "relative-vertical-align": !!(ue && Ue),
    "has-particles-mask": !!te,
    "mask-animated": J
  }, C = {
    "font-size": Se($e * 10 / I),
    "line-height": f ? "normal" : ne,
    "letter-spacing": Ne,
    "font-weight": Ie,
    "font-family": Me,
    "vertical-align": ue || Ue === void 0 ? void 0 : Se(Ue * 10 / $e),
    top: ue && Ue !== void 0 ? Se(-Ue * 10 / $e) : void 0,
    margin: l ? Vi(Uo(l, -10 / $e), T) : void 0,
    padding: l ? Vi(Uo(l, 10 / $e), T) : void 0,
    filter: ge && o && !Q ? `url(#${ee})` : d,
    color: Be || Re,
    background: xe,
    opacity: ge && o && !Q ? ((pe = (We = ji(F.background.color)) == null ? void 0 : We.a) != null ? pe : 255) / 255 : void 0,
    /**
    * box-shadow instead of border because:
    * 1) Doesn't take space as border does
    * 2) There should not be a border-radius on line breaks, but there should be a border
    */
    "box-shadow": Fe ? `inset 0 0 0 ${Se(Fe.width * 10 / $e)} ${Fe.color}` : void 0,
    "border-radius": c ? Se(c * 10 / $e) : void 0,
    "font-feature-settings": F.font_feature_settings || void 0,
    "--divkit-text-mask-color": te,
    "--divkit-text-mask-size": de,
    "--divkit-text-mask-density": fe
  }, P(), `${ge && o ? `<svg${j("class", Ii["text-range__cloud-svg"], 0)}><defs><filter${j("id", ee, 0)}><feGaussianBlur in="SourceGraphic" result="blurred" stdDeviation="3"></feGaussianBlur><feColorMatrix in="blurred" result="withMatrix" type="matrix" values="${"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 " + ft(2 * c, !0) + " -" + ft(c, !0)}"></feColorMatrix><feBlend in="SourceGraphic" in2="withMatrix"></feBlend></filter></defs></svg>` : ""}${n ? `<span${j("class", Ii["text-range__top-offset"], 0)}${Hr({ "margin-top": n })}></span>` : ""}${Yt($o, "Actionable").$$render(
    r,
    {
      componentContext: z,
      cls: rr("text-range", Ii, h),
      actions: K,
      style: fr(C)
    },
    {},
    {
      default: () => `${te ? `<div${j("class", Ii["text-range__mask-animation"], 0)}></div><div${j("class", Ii["text-range__mask-animation"], 0)}></div><div${j("class", Ii["text-range__mask-animation"], 0)}></div><div${j("class", Ii["text-range__mask-animation"], 0)}></div><div${j("class", Ii["text-range__mask-animation"], 0)}></div><div${j("class", Ii["text-range__mask-animation"], 0)}></div>` : ""}${ft(G || "​")}`
    }
  )}`;
});
function us(r, t, e) {
  return r === "left" || r === "center" || r === "right" || r === "start" || r === "end" ? r === "left" ? t === "ltr" ? "start" : "end" : r === "right" ? t === "ltr" ? "end" : "start" : r : e;
}
function ds(r, t) {
  return r === "top" || r === "center" || r === "bottom" || r === "baseline" ? r === "top" ? "start" : r === "bottom" ? "end" : r : t;
}
function Kc(r) {
  return String(r != null ? r : "");
}
function Ka(r, t) {
  return r === "source_in" || r === "source_atop" || r === "darken" || r === "lighten" || r === "multiply" || r === "screen" ? r : t;
}
function Xc(r, t) {
  let e;
  return function(...i) {
    e !== null && clearTimeout(e), e = setTimeout(() => {
      r.apply(this, i), e = null;
    }, t);
  };
}
const Zc = xr((r, t, e, i) => {
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee, be, $e, ne, Ne, Ie, Me, Re, Be = E, Fe = () => (Be(), Be = $(K, (B) => Re = B), K), Ue, xe = E, J = () => (xe(), xe = $(l, (B) => Ue = B), l), te, de = E, fe = () => (de(), de = $(o, (B) => te = B), o), Qe, Ge = E, gt = () => (Ge(), Ge = $(F, (B) => Qe = B), F), lt, pt = E, R = () => (pt(), pt = $(I, (B) => lt = B), I), We, pe = E, Le = () => (pe(), pe = $(G, (B) => We = B), G), ht, xt = E, Je = () => (xt(), xt = $(z, (B) => ht = B), z), Ke, He = E, Ae = () => (He(), He = $(P, (B) => Ke = B), P), qe, it = E, nt = () => (it(), it = $(h, (B) => qe = B), h), Pe, Ce = E, zt = () => (Ce(), Ce = $(T, (B) => Pe = B), T), Y, wt = E, et = () => (wt(), wt = $(C, (B) => Y = B), C), ot, tt = E, It = () => (tt(), tt = $(ke, (B) => ot = B), ke), De, Wt = E, At = () => (Wt(), Wt = $(f, (B) => De = B), f), kt, Xe = E, re = () => (Xe(), Xe = $(d, (B) => kt = B), d), ct, Gt = E, b = () => (Gt(), Gt = $(c, (B) => ct = B), c), Nt, se = E, Ve = () => (se(), se = $(ge, (B) => Nt = B), ge), bt, ve = E, _e = () => (ve(), ve = $(n, (B) => bt = B), n), { componentContext: ae } = t, { layoutParams: Ot = void 0 } = t;
  const St = kr(Wr), Vt = St.direction;
  Me = $(Vt, (B) => Ie = B);
  let Lt = "", _t = 12, $t = 1.25, yt = null, Dt = "", Ct = "", Xt = !1, Ut = "start", jt = "start", Ht = "", Rt = "", mt = "", Ze = !1, er = [], ir = !1, nr = "", tr, qt = [], U = {}, S = "span";
  function H(B, V, Ee, m) {
    var Xr, s;
    let ie = [];
    if (qt.forEach(([he, Jt]) => {
      St.removeSvgFilter(he, Jt);
    }), qt = [], !(Array.isArray(V) && V.length || Array.isArray(Ee) && Ee.length && B)) {
      er = [];
      return;
    }
    const L = B;
    let Te = V || [{ start: 0, end: L.length }], ze = Ee || [], pr = 0, je = [], Ar = [];
    Te.forEach((he) => {
      const Jt = he.start || 0, Kt = he.end || B.length, Tt = {
        top_offset: 0,
        ...he,
        start: Jt,
        end: Kt
      };
      Ar.push({
        index: Jt,
        range: Tt,
        type: "rangeStart",
        isStart: !0
      }), Ar.push({
        index: Kt,
        range: Tt,
        type: "rangeEnd"
      });
    }), ze.forEach((he, Jt) => {
      he.start !== void 0 && he.url && he.start <= L.length && Ar.push({
        index: he.indexing_direction === "reversed" ? B.length - he.start : he.start,
        image: he,
        type: "image",
        arrayIndex: Jt
      });
    }), Ar.sort((he, Jt) => he.index === Jt.index ? he.type !== Jt.type ? he.type === "image" ? -1 : Jt.type === "image" ? 1 : he.type < Jt.type ? -1 : 1 : he.type === "image" && Jt.type === "image" ? Jt.arrayIndex - he.arrayIndex : he.type === "rangeStart" && Jt.type === "rangeStart" ? he.range.end - Jt.range.end : he.type === "rangeStart" ? 1 : Jt.type === "rangeStart" ? -1 : he.type !== "image" && Jt.type !== "image" ? he.range.start - Jt.range.start : 0 : he.index - Jt.index), Ar.forEach((he) => {
      var Tt, D, _r, mr;
      let Jt = he.type === "image" ? null : he.range, Kt = he.index;
      if (Kt > pr) {
        let ut = Object.assign({ ...m }, ...je);
        je.length && je[je.length - 1].start !== pr && (ut.top_offset = 0), ie.push({
          text: L.substring(pr, Kt),
          textStyles: ut,
          actions: he.type === "rangeEnd" && ((D = (Tt = he.range) == null ? void 0 : Tt.actions) == null ? void 0 : D.filter(ls)) || void 0
        });
      }
      if (he.type === "rangeStart" && Jt)
        je.push(Jt);
      else if (he.type === "rangeEnd")
        je = je.filter((ut) => ut !== he.range);
      else if (he.type === "image") {
        let ut = Object.assign({ ...m }, ...je), Rr = Se((he.image.width && he.image.width.value || 20) * 10 / (ut.font_size || 12)), Zr = Se((he.image.height && he.image.height.value || 20) * 10 / (ut.font_size || 12));
        const Br = {
          "font-size": Se((Number(ut.font_size) || 12) * 10 / _t)
        };
        let vr = "";
        const Mr = he.image.tint_color, Sr = Ka(he.image.tint_mode, "source_in");
        if (Mr) {
          const Vr = lr(he.image.tint_color);
          vr = St.addSvgFilter(Vr, Sr), qt.push([Vr, Sr]);
        }
        const O = {}, $r = (_r = he.image.accessibility) == null ? void 0 : _r.type, Nr = ((mr = he.image.accessibility) == null ? void 0 : mr.description) || "";
        ($r === "button" || $r === "image") && Nr ? O.role = $r : (!Nr || $r === "none") && (O["aria-hidden"] = "true"), ie.push({
          image: {
            url: he.image.url,
            width: Rr,
            height: Zr,
            wrapperStyle: Br,
            svgFilterId: vr,
            preloadRequired: !!he.image.preload_required,
            verticalAlign: he.image.alignment_vertical,
            description: Nr,
            a11yAttrs: O
          }
        });
      }
      pr = Kt;
    }), pr < L.length && ie.push({
      text: L.substring(pr),
      textStyles: { ...m }
    }), er = ie, ir = ie.some((he) => {
      var Jt;
      return "text" in he && ((Jt = he.textStyles.background) == null ? void 0 : Jt.type) === "cloud";
    }), nr = ir && ie.length === 1 ? St.genId("text-whole-bg") : "", tr = nr ? ((s = (Xr = ji(ie[0].textStyles.background.color)) == null ? void 0 : Xr.a) != null ? s : 255) / 255 : void 0;
  }
  Kr(() => {
    qt.forEach(([B, V]) => {
      St.removeSvgFilter(B, V);
    });
  }), t.componentContext === void 0 && e.componentContext && ae !== void 0 && e.componentContext(ae), t.layoutParams === void 0 && e.layoutParams && Ot !== void 0 && e.layoutParams(Ot), ae.json && (_t = 12, $t = 1.25, yt = null, Dt = "", Ct = "", Xt = !1, Ut = "start", jt = "start", Ht = "", mt = "", Ze = !1), _e(n = ae.getDerivedFromVars(ae.json.text)), fe(o = ae.getDerivedFromVars(ae.json.ranges)), J(l = ae.getDerivedFromVars(ae.json.images)), b(c = ae.getDerivedFromVars({
    font_size: ae.json.font_size,
    letter_spacing: ae.json.letter_spacing,
    font_weight: ae.json.font_weight,
    font_weight_value: ae.json.font_weight_value,
    font_family: ae.json.font_family,
    text_color: ae.json.text_color,
    underline: ae.json.underline,
    strike: ae.json.strike,
    line_height: ae.json.line_height,
    text_shadow: ae.json.text_shadow,
    font_feature_settings: ae.json.font_feature_settings
  })), re(d = ae.getDerivedFromVars(ae.json.font_size)), At(f = ae.getDerivedFromVars(ae.json.line_height)), nt(h = ae.getDerivedFromVars(ae.json.max_lines)), et(C = ae.getDerivedFromVars(ae.json.text_alignment_horizontal)), zt(T = ae.getDerivedFromVars(ae.json.text_alignment_vertical)), Ae(P = ae.getDerivedFromVars(ae.json.text_color)), Je(z = ae.getDerivedFromVars(ae.json.focused_text_color)), Le(G = ae.getDerivedFromVars(ae.json.truncate)), R(I = ae.getDerivedFromVars(ae.json.text_gradient)), gt(F = ae.getDerivedFromVars(ae.json.selectable)), It(ke = ae.getDerivedFromVars(ae.json.auto_ellipsize)), Fe(K = ae.getDerivedFromVars(ae.json.paddings)), Ve(ge = ae.getDerivedFromVars(ae.json.heading_type)), typeof ae.json.text == "string" ? Lt = Kc(bt) : (Lt = "", ae.logError(x(new Error("Incorrect text value type")))), Q = (() => {
    const B = Nt;
    if (B && typeof B == "string") {
      const V = B.toLowerCase();
      if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(V))
        return V;
    }
    return "p";
  })(), S = Q !== "span" ? "div" : "span";
  {
    let B = "";
    if (lt) {
      const V = wo([lt], Ie);
      V.image && (B = V.image);
    }
    mt = B;
  }
  U = mt ? { ...ct, text_color: "" } : ct, _t = fi(kt, _t);
  {
    const B = De;
    ui(B) ? ($t = Number(B) / _t, yt = $t) : yt = null;
  }
  ue = qe === 1;
  {
    let B = "", V = "", Ee = !1;
    if (qe && qe > 1) {
      const m = Number(qe);
      B = m * $t + "em", V = m, Ee = !0;
    } else
      ot && qe !== 1 && (Ee = !0);
    Dt = B, Ct = V, Xt = Ee;
  }
  Ut = us(Y, Ie, Ut), jt = ds(Pe, jt), oe = !te || Lt && te.length === 1 && te[0] && (!te[0].start || te[0].start === 0) && (!te[0].end || typeof te[0].end == "number" && te[0].end >= Lt.length), ye = !!(!mt && Ke) != !!(te && te[0] && te[0].text_color);
  {
    let B = "";
    qe && oe && ye && (B = lr(Ke || te && te[0] && te[0].text_color, 1, Ht)), Ht = B;
  }
  return Rt = lr(ht, 1, Rt), ee = We === "none" ? "none" : "", Ze = ri(Qe, Ze), H(Lt, te, Ue, U), be = {
    singleline: ue,
    multiline: Xt,
    halign: Ut,
    valign: jt,
    truncate: ee,
    "has-focus-color": !!Rt
  }, $e = {
    gradient: !!mt,
    "has-cloud-bg": ir
  }, ne = {
    "font-size": Se(_t),
    "line-height": $t,
    "max-height": Dt,
    "-webkit-line-clamp": Ct,
    color: Ht,
    "background-image": mt,
    "--divkit-text-focus-color": Rt
  }, Ne = Vi(Uo(yn(Re, {}) || {}, 10 / _t), Ie), Me(), Be(), xe(), de(), Ge(), pt(), pe(), xt(), He(), it(), Ce(), wt(), tt(), Wt(), Xe(), Gt(), se(), ve(), `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("text", sn, be) + " " + (Ze ? Lr.root__selectable : Lr.root__unselectable),
      componentContext: ae,
      layoutParams: Ot,
      containerElement: S
    },
    {},
    {
      default: () => `${ir ? `${((B) => B ? `<${Q}${j("class", rr("text__inner", sn, { ...$e, "cloud-bg": !0 }), 0)}${j(
        "style",
        fr({
          ...ne,
          padding: Ne,
          filter: nr ? `url(#${nr})` : void 0,
          opacity: tr
        }),
        0
      )}>${Oi(B) ? "" : `${Or(er, (V) => `${"text" in V ? `${V.text ? `${Yt(Io, "TextRangeView").$$render(
        r,
        {
          componentContext: ae,
          text: V.text,
          rootFontSize: _t,
          textStyles: V.textStyles,
          singleline: ue,
          cloudBg: !0,
          cloudBgId: nr
        },
        {},
        {}
      )}` : ""}` : `${V.image ? `<span${j("style", fr(V.image.wrapperStyle), 0)}><span${j(
        "class",
        rr("text__image-wrapper", sn, {
          align: V.image.verticalAlign,
          crop: yt !== null
        }),
        0
      )}${j(
        "style",
        fr({
          width: V.image.width,
          height: yt && V.image.verticalAlign !== "baseline" ? yt + "em" : void 0
        }),
        0
      )}></span></span>` : ""}`}`)}`}${Oi(B) ? "" : `</${B}>`}` : "")(Q)}` : ""} ${((B) => B ? `<${Q}${j("class", rr("text__inner", sn, $e), 0)}${j("style", fr(ne), 0)}>${Oi(B) ? "" : `${er.length ? `${Or(er, (V) => `${"text" in V ? `${V.text ? `${Yt(Io, "TextRangeView").$$render(
        r,
        {
          componentContext: ae,
          text: V.text,
          rootFontSize: _t,
          textStyles: V.textStyles,
          singleline: ue,
          actions: V.actions,
          customLineHeight: yt
        },
        {},
        {}
      )}` : ""}` : `${V.image ? `<span${j("style", fr(V.image.wrapperStyle), 0)}><span${j(
        "class",
        rr("text__image-wrapper", sn, {
          align: V.image.verticalAlign,
          crop: yt !== null
        }),
        0
      )}${j(
        "style",
        fr({
          width: V.image.width,
          height: yt && V.image.verticalAlign !== "baseline" ? yt + "em" : void 0
        }),
        0
      )}><img${fn(
        [
          {
            class: Jr(sn.text__image)
          },
          {
            src: Jr(V.image.url)
          },
          {
            loading: Jr(V.image.preloadRequired ? "eager" : "lazy")
          },
          { decoding: "async" },
          {
            alt: Jr(V.image.description)
          },
          gn(V.image.a11yAttrs),
          {
            style: Jr(fr({
              height: V.image.height,
              filter: V.image.svgFilterId ? `url(#${V.image.svgFilterId})` : void 0
            }))
          }
        ],
        {}
      )}></span></span>` : ""}`}`)}` : `${Yt(Io, "TextRangeView").$$render(
        r,
        {
          componentContext: ae,
          text: Lt,
          rootFontSize: _t,
          textStyles: U,
          singleline: ue,
          customLineHeight: yt
        },
        {},
        {}
      )}`}`}${Oi(B) ? "" : `</${B}>`}` : "")(Q)}`
    }
  )}`;
}), Qc = "appkit-container", eu = "appkit-container_wrap", tu = "appkit-container_overflow_visible", ru = "appkit-container_orientation_vertical", iu = "appkit-container_valign_start", nu = "appkit-container_valign_center", ou = "appkit-container_valign_end", su = "appkit-container_halign_start", au = "appkit-container_halign_center", lu = "appkit-container_halign_end", cu = "appkit-container_orientation_horizontal", uu = "appkit-container_orientation_overlap", du = {
  container: Qc,
  container_wrap: eu,
  container_overflow_visible: tu,
  container_orientation_vertical: ru,
  container_valign_start: iu,
  container_valign_center: nu,
  container_valign_end: ou,
  "container_valign_space-between": "appkit-container_valign_space-between",
  "container_valign_space-around": "appkit-container_valign_space-around",
  "container_valign_space-evenly": "appkit-container_valign_space-evenly",
  container_halign_start: su,
  container_halign_center: au,
  container_halign_end: lu,
  "container_halign_space-between": "appkit-container_halign_space-between",
  "container_halign_space-around": "appkit-container_halign_space-around",
  "container_halign_space-evenly": "appkit-container_halign_space-evenly",
  container_orientation_horizontal: cu,
  container_orientation_overlap: uu,
  "container_fixed-container": "appkit-container_fixed-container",
  "container_responsive-mobile-vertical": "appkit-container_responsive-mobile-vertical",
  "container_responsive-mobile-horizontal": "appkit-container_responsive-mobile-horizontal",
  "container_responsive-mobile-has-height": "appkit-container_responsive-mobile-has-height",
  "container_responsive-tablet-vertical": "appkit-container_responsive-tablet-vertical",
  "container_responsive-tablet-horizontal": "appkit-container_responsive-tablet-horizontal",
  "container_responsive-tablet-has-height": "appkit-container_responsive-tablet-has-height"
};
function Os(r) {
  return {
    top: Number(r == null ? void 0 : r.top) || 0,
    right: Number(r == null ? void 0 : r.right) || 0,
    bottom: Number(r == null ? void 0 : r.bottom) || 0,
    left: Number(r == null ? void 0 : r.left) || 0
  };
}
function Ns(r, t, e) {
  const i = ((t == null ? void 0 : t.margins.left) || 0) + ((t == null ? void 0 : t.margins.right) || 0), n = ((t == null ? void 0 : t.margins.top) || 0) + ((t == null ? void 0 : t.margins.bottom) || 0);
  t != null && t.show_at_start && (e ? r.top = t.style.height + n : r.left = t.style.width + i), t != null && t.show_at_end && (e ? r.bottom = t.style.height + n : r.right = t.style.width + i);
}
function fu(r, t, e) {
  const i = {};
  return Ns(i, t, r === "vertical"), Ns(i, e, r === "horizontal"), i;
}
function gu({
  orientation: r,
  separator: t,
  lineSeparator: e,
  itemSpacing: i,
  lineSpacing: n
}) {
  let o;
  const l = ((t == null ? void 0 : t.margins.left) || 0) + ((t == null ? void 0 : t.margins.right) || 0), c = ((t == null ? void 0 : t.margins.top) || 0) + ((t == null ? void 0 : t.margins.bottom) || 0), d = ((e == null ? void 0 : e.margins.left) || 0) + ((e == null ? void 0 : e.margins.right) || 0), f = ((e == null ? void 0 : e.margins.top) || 0) + ((e == null ? void 0 : e.margins.bottom) || 0);
  return r === "horizontal" ? o = [
    e != null && e.show_between ? e.style.height + f : n,
    t != null && t.show_between ? t.style.width + l : i
  ] : o = [
    t != null && t.show_between ? t.style.height + c : i,
    e != null && e.show_between ? e.style.width + d : n
  ], o.map(Se).join(" ");
}
function pu(r) {
  var e;
  const t = (e = r.width) == null ? void 0 : e.type;
  return t !== "wrap_content" && t !== "fixed";
}
function hu(r) {
  var e;
  return ((e = r.height) == null ? void 0 : e.type) === "match_parent";
}
function _u(r, t) {
  return r === "vertical" || r === "horizontal" || r === "overlap" ? r : t;
}
function mu(r) {
  var t, e, i;
  return {
    width: wr((t = r.item_width) == null ? void 0 : t.value, 10),
    height: wr((e = r.item_height) == null ? void 0 : e.value, 10),
    radius: wr((i = r.corner_radius) == null ? void 0 : i.value, 5)
  };
}
function vu(r) {
  var e;
  const t = wr((e = r.radius) == null ? void 0 : e.value, 10) * 2;
  return {
    width: t,
    height: t,
    radius: t
  };
}
function bu(r, t, e) {
  var d;
  const i = {}, n = t.stroke || (e == null ? void 0 : e.stroke), o = n != null && n.color ? lr(n.color) : "", l = n != null && n.width ? Number((d = n.width) != null ? d : 1) : "";
  i.width = r.width, i.height = r.height, i.borderRadius = r.radius;
  const c = t.background_color || (e == null ? void 0 : e.color);
  return i.background = lr(c), o && l && (i.boxShadow = `inset 0 0 0 ${Se(l)} ${o}`), i;
}
function bi(r, t, e) {
  if (!r || !r.shape || !r.shape.type || !t.includes(r.shape.type) || r.type !== "shape_drawable")
    return e;
  let i;
  if (r.shape.type === "rounded_rectangle")
    i = mu(r.shape);
  else if (r.shape.type === "circle")
    i = vu(r.shape);
  else
    return e;
  return bu(i, r.shape, {
    color: r.color,
    stroke: r.stroke
  });
}
let jn;
function Rs() {
  if (typeof document > "u" && (jn = !0), jn !== void 0)
    return jn;
  const r = document.createElement("div");
  return r.style.position = "absolute", r.style.display = "flex", r.style.flexDirection = "column", r.style.gap = "1px", r.appendChild(document.createElement("div")), r.appendChild(document.createElement("div")), document.body.appendChild(r), jn = r.scrollHeight === 1, document.body.removeChild(r), jn;
}
function yu(r, t) {
  return r === "top" || r === "center" || r === "bottom" || r === "baseline" || r === "space-between" || r === "space-around" || r === "space-evenly" ? r === "top" ? "start" : r === "bottom" ? "end" : r : t;
}
function wu(r, t, e) {
  return r === "left" || r === "center" || r === "right" || r === "space-between" || r === "space-around" || r === "space-evenly" || r === "start" || r === "end" ? r === "left" ? t === "ltr" ? "start" : "end" : r === "right" ? t === "ltr" ? "end" : "start" : r : e;
}
function ku() {
}
function Ki(r) {
  return {
    subscribe(t) {
      return t(r), ku;
    }
  };
}
function fs(r, t, e, i) {
  const n = [], o = i.prototypes;
  return o && r.forEach((l, c) => {
    if (l === null || typeof l != "object")
      return;
    const d = t.preparePrototypeVariables(i.data_element_name || "it", l, c);
    let f, h;
    for (let C = 0; C < o.length; ++C) {
      const T = o[C];
      if (!T.div)
        continue;
      if (T.selector === void 0) {
        f = T.div, h = e.getJsonWithVars(T.id, d);
        break;
      }
      if (e.getJsonWithVars(T.selector, d)) {
        f = T.div, h = e.getJsonWithVars(T.id, d);
        break;
      }
    }
    f && n.push({
      div: f,
      id: h,
      vars: d,
      key: h || { index: c, data: l }
    });
  }), n;
}
const En = {
  "container-separator": "appkit-container-separator",
  "container-separator__item": "appkit-container-separator__item",
  "container-separator__shape": "appkit-container-separator__shape"
};
function $u(r, t) {
  let e = 0, i, n = !1;
  return function() {
    const o = Date.now();
    return !e || Math.abs(o - e) > t ? (e = o, i = r.apply(this, arguments)) : (n || (n = !0, setTimeout(() => {
      n = !1, i = r.apply(this, arguments);
    }, t)), i);
  };
}
function ju(r) {
  const t = r.getBoundingClientRect(), e = getComputedStyle(r);
  return {
    top: t.top - parseFloat(e.marginTop),
    right: t.right + parseFloat(e.marginRight),
    bottom: t.bottom + parseFloat(e.marginBottom),
    left: t.left - parseFloat(e.marginLeft)
  };
}
const Eu = 10;
function Do(r, t, e, i, n, o) {
  const l = t.margins.left, c = t.margins.right, d = t.margins.top, f = t.margins.bottom;
  o ? r.push({
    top: e.bottom + d,
    left: n.left + l,
    width: Math.max(0, n.right - n.left - l - c),
    height: i.top - e.bottom - d - f,
    style: t.style
  }) : r.push({
    top: n.top + d,
    left: e.right + l,
    width: i.left - e.right - l - c,
    height: Math.max(0, n.bottom - n.top - d - f),
    style: t.style
  });
}
function Bs(r, t, e, i, n, o) {
  const l = {
    top: Math.min(...e.map((c) => c.top)),
    right: Math.max(...e.map((c) => c.right)),
    bottom: Math.max(...e.map((c) => c.bottom)),
    left: Math.min(...e.map((c) => c.left))
  };
  if (t != null && t.show_at_start) {
    let c, d;
    n === "space-around" || n === "space-evenly" ? (c = o.left - t.style.width, d = o.top - t.style.height) : (c = e[0].left - t.style.width - t.margins.left - t.margins.right, d = e[0].top - t.style.height - t.margins.top - t.margins.bottom), Do(
      r,
      t,
      // only right and bottom is used
      { right: c, bottom: d },
      e[0],
      l,
      i
    );
  }
  if (t != null && t.show_between)
    for (let c = 0; c < e.length - 1; ++c)
      Do(r, t, e[c], e[c + 1], l, i);
  if (t != null && t.show_at_end) {
    const c = e[e.length - 1];
    let d, f;
    n === "space-around" || n === "space-evenly" ? (d = o.bottom + t.style.height, f = o.right + t.style.width) : (d = c.bottom + t.style.height + t.margins.top + t.margins.bottom, f = c.right + t.style.width + t.margins.left + t.margins.right), Do(
      r,
      t,
      c,
      // only top and left is used
      { top: d, left: f },
      l,
      i
    );
  }
}
const xu = xr((r, t, e, i) => {
  let n, { orientation: o } = t, { separator: l } = t, { lineSeparator: c } = t, { contentHAlign: d } = t, { contentVAlign: f } = t, { direction: h } = t;
  const C = $u(ke, Eu);
  let T = [], P, z = !1, G = null, I = null;
  function F(K) {
    K.some((ge) => {
      var ue;
      const Q = (ue = ge.target) == null ? void 0 : ue.classList;
      return !(Q != null && Q.contains(En["container-separator__shape"])) && !(Q != null && Q.contains(En["container-separator"]));
    }) && C();
  }
  function ke() {
    if (!n)
      return;
    const K = n.getBoundingClientRect(), ge = window.getComputedStyle(n), Q = {
      top: K.top + parseFloat(ge.paddingTop),
      right: K.right - parseFloat(ge.paddingRight),
      bottom: K.bottom - parseFloat(ge.paddingBottom),
      left: K.left + parseFloat(ge.paddingLeft)
    };
    T = [];
    let ue = [...n.children].filter((ee) => ee !== P && ee instanceof HTMLElement && !ee.classList.contains(Ho.outer__border) && getComputedStyle(ee).display !== "none"), oe = [];
    for (; ue.length; ) {
      const ee = [], be = ue.shift();
      ee.push(be);
      let $e = be.getBoundingClientRect(), ne = $e.left, Ne = $e.right, Ie = $e.bottom;
      for (; ue.length; ) {
        let Me = ue[0], Re = Me.getBoundingClientRect();
        if (o === "vertical") {
          if (Re.top < Ie)
            break;
        } else if (h === "ltr" ? Re.left < Ne : Re.right > ne)
          break;
        Ne = Math.max(Ne, Re.right), ne = Math.min(ne, Re.left), Ie = Math.max(Ie, Re.bottom), ee.push(Me), ue.shift();
      }
      oe.push(ee);
    }
    const ye = [];
    oe.forEach((ee) => {
      const be = ee.map((ne) => ju(ne));
      h === "rtl" && o === "horizontal" && be.reverse(), l && Bs(
        T,
        l,
        be,
        o === "vertical",
        o === "vertical" ? f : d,
        Q
      );
      const $e = {
        top: Math.min(...be.map((ne) => ne.top)),
        right: Math.max(...be.map((ne) => ne.right)),
        bottom: Math.max(...be.map((ne) => ne.bottom)),
        left: Math.min(...be.map((ne) => ne.left))
      };
      ye.push($e);
    }), h === "rtl" && o === "vertical" && ye.reverse(), c && Bs(
      T,
      c,
      ye,
      o === "horizontal",
      o === "vertical" ? d : f,
      Q
    ), T.forEach((ee) => {
      ee.top -= K.top, ee.left -= K.left;
    });
  }
  return Kr(() => {
    z = !1;
  }), t.orientation === void 0 && e.orientation && o !== void 0 && e.orientation(o), t.separator === void 0 && e.separator && l !== void 0 && e.separator(l), t.lineSeparator === void 0 && e.lineSeparator && c !== void 0 && e.lineSeparator(c), t.contentHAlign === void 0 && e.contentHAlign && d !== void 0 && e.contentHAlign(d), t.contentVAlign === void 0 && e.contentVAlign && f !== void 0 && e.contentVAlign(f), t.direction === void 0 && e.direction && h !== void 0 && e.direction(h), n = null, (z && n || G || I) && (G && (G.disconnect(), G = null), I && (I.disconnect(), I = null), z && n && (typeof MutationObserver < "u" && (G = new MutationObserver(F), G.observe(n, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  })), typeof ResizeObserver < "u" && (I = new ResizeObserver(C), I.observe(n)))), z && n && C(), ` <div${j("class", En["container-separator"], 0)}${j("this", P, 0)}>${Or(T, (K) => `<div${j("class", En["container-separator__item"], 0)}${Hr({
    left: `${K.left}px`,
    top: `${K.top}px`,
    width: `${K.width}px`,
    height: `${K.height}px`
  })}><div${j("class", En["container-separator__shape"], 0)}${Hr({
    width: `${K.style.width}px`,
    height: `${K.style.height}px`,
    "border-radius": `${K.style.borderRadius}px`,
    background: K.style.background,
    "box-shadow": K.style.boxShadow
  })}></div> </div>`)}</div>`;
}), Au = {
  start: "start",
  center: "center",
  end: "end",
  // 'space-*' values doesn't supported for cross-axis in wrap-container
  "space-between": "start",
  "space-around": "start",
  "space-evenly": "start"
}, Cu = {
  start: "start",
  center: "center",
  end: "end",
  baseline: "baseline",
  // 'space-*' doesn't supported for cross-axis in wrap-container
  "space-between": "start",
  "space-around": "start",
  "space-evenly": "start"
}, Ls = ["rounded_rectangle", "circle"], Su = xr((r, t, e, i) => {
  var er, ir, nr, tr, qt, U, S, H, B, V, Ee;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee, be, $e, ne, Ne = E, Ie = () => (Ne(), Ne = $(ke, (m) => ne = m), ke), Me, Re = E, Be = () => (Re(), Re = $(ge, (m) => Me = m), ge), Fe, Ue = E, xe = () => (Ue(), Ue = $(F, (m) => Fe = m), F), J, te = E, de = () => (te(), te = $(I, (m) => J = m), I), fe, Qe = E, Ge = () => (Qe(), Qe = $(K, (m) => fe = m), K), gt, lt = E, pt = () => (lt(), lt = $(G, (m) => gt = m), G), R, We = E, pe = () => (We(), We = $(T, (m) => R = m), T), Le, ht = E, xt = () => (ht(), ht = $(C, (m) => Le = m), C), Je, Ke = E, He = () => (Ke(), Ke = $(z, (m) => Je = m), z), Ae, qe = E, it = () => (qe(), qe = $(P, (m) => Ae = m), P), nt, Pe, Ce, zt = E, Y = () => (zt(), zt = $(h, (m) => Ce = m), h), wt, et = E, ot = () => (et(), et = $(f, (m) => wt = m), f), tt, It = E, De = () => (It(), It = $(_e, (m) => tt = m), _e), Wt, At = E, kt = () => (At(), At = $(d, (m) => Wt = m), d), Xe, re = E, ct = () => (re(), re = $(c, (m) => Xe = m), c), Gt, b = E, Nt = () => (b(), b = $(l, (m) => Gt = m), l), { componentContext: se } = t, { layoutParams: Ve = void 0 } = t;
  const bt = kr(Wr), ve = bt.direction;
  Pe = $(ve, (m) => nt = m);
  let _e, ae = "vertical", Ot = "start", St = "start", Vt = null, Lt = null, _t, $t = {}, yt = 0, Dt = 0, Ct = !1;
  function Xt() {
    ae = "vertical", Ot = "start", St = "start", _t = void 0, yt = 0, Dt = 0, Ct = !1;
  }
  function Ut(m) {
    se = Ht = {
      ...se,
      json: {
        ...se.json,
        items: m.filter(Fi)
      }
    };
  }
  let jt = [], Ht, Rt = {}, mt, Ze;
  Kr(() => {
    jt.forEach((m) => {
      m.destroy();
    });
  }), t.componentContext === void 0 && e.componentContext && se !== void 0 && e.componentContext(se), t.layoutParams === void 0 && e.layoutParams && Ve !== void 0 && e.layoutParams(Ve), n = se.origJson, n && Xt(), o = se.json.items, Nt(l = typeof ((er = se.json.item_builder) == null ? void 0 : er.data) == "string" ? se.getDerivedFromVars((ir = se.json.item_builder) == null ? void 0 : ir.data, void 0, !0) : (nr = se.json.item_builder) != null && nr.data ? Ki(se.json.item_builder.data) : void 0), ct(c = se.getDerivedFromVars(se.json.orientation)), kt(d = se.getDerivedFromVars(se.json.layout_mode)), ot(f = se.getDerivedFromVars(se.json.content_alignment_vertical)), Y(h = se.getDerivedFromVars(se.json.content_alignment_horizontal)), xt(C = se.getDerivedFromVars(se.json.separator)), pe(T = se.getDerivedFromVars(se.json.line_separator)), it(P = se.getDerivedFromVars(se.json.item_spacing)), He(z = se.getDerivedFromVars(se.json.line_spacing)), pt(G = se.getDerivedFromVars(se.json.aspect)), de(I = se.getDerivedFromVars(se.json.width)), xe(F = se.getDerivedFromVars(se.json.height)), Ie(ke = se.getDerivedFromVars(se.json.clip_to_bounds)), Ge(K = se.getDerivedFromVars(se.json.max_width)), Be(ge = se.getDerivedFromVars(se.json.responsive));
  {
    let m = [];
    if (se.json.item_builder && Array.isArray(Gt) && Array.isArray(se.json.item_builder.prototypes)) {
      const ze = se.json.item_builder;
      m = fs(Gt, bt, se, ze);
    } else
      m = (Array.isArray(o) && o || []).map((ze, pr) => ({
        div: ze,
        key: ze.id || { index: pr, data: ze }
      }));
    const ie = new Set(jt), L = /* @__PURE__ */ new Map();
    let Te = !1;
    Ht === se && jt.forEach((ze) => {
      ze.key && (typeof ze.key == "string" && L.has(ze.key) ? Te || (Te = !0, se.logError(x(new Error("Duplicate key for child elements inside item_builder"), { additional: { key: ze.key } }))) : L.set(
        typeof ze.key == "string" ? ze.key : ze.key.index,
        ze
      ));
    }), jt = m.map((ze, pr) => {
      let je = !Te && L.get(ze.id), Ar = L.get(pr);
      return !je && !ze.id && typeof ze.key == "object" && typeof (Ar == null ? void 0 : Ar.key) == "object" && bn(Ar.key.data, ze.key.data) && (je = Ar), je ? (ie.delete(je), je) : se.produceChildContext(ze.div, {
        path: pr,
        variables: ze.vars,
        id: ze.id,
        key: ze.key
      });
    });
    for (const ze of ie)
      ze.destroy();
    Ht = se;
  }
  {
    let m = [];
    jt.forEach((ie) => {
      m.push(se.getDerivedFromVars({
        width: ie.json.width,
        height: ie.json.height
      }));
    }), De(_e = vn(m, (ie) => [...ie]));
  }
  if (ae = _u(Xe, ae), Q = Wt === "wrap", ue = ae !== "horizontal" && !Q, oe = ae !== "vertical" && !Q, ye = ae === "overlap" && !tt.every(pu), ee = ae === "overlap" && !tt.every(hu), Ot = yu(wt, Ot), St = wu(Ce, nt, St), yt = wr(Ae, yt), Dt = wr(Je, Dt), Le != null && Le.style && ae !== "overlap" && Rs()) {
    const m = bi(Le.style, Ls, (Vt == null ? void 0 : Vt.style) || null);
    m ? (Vt = {
      show_at_start: !!((tr = Le.show_at_start) != null && tr),
      show_at_end: !!((qt = Le.show_at_end) != null && qt),
      show_between: !!((U = Le.show_between) == null || U),
      style: m,
      margins: Os(Le.margins)
    }, Vt.show_between && yt && se.logError(x(new Error("item_spacing will be ignored due to the 'separator' property."), { level: "warn" }))) : Vt = null;
  } else
    Vt = null;
  if (R != null && R.style && ae !== "overlap" && Rs()) {
    const m = bi(R.style, Ls, (Lt == null ? void 0 : Lt.style) || null);
    m ? (Lt = {
      show_at_start: !!((S = R.show_at_start) != null && S),
      show_at_end: !!((H = R.show_at_end) != null && H),
      show_between: !!((B = R.show_between) == null || B),
      style: m,
      margins: Os(R.margins)
    }, Lt.show_between && Dt && se.logError(x(new Error("line_spacing will be ignored due to the 'line_separator' property."), { level: "warn" }))) : Lt = null;
  } else
    Lt = null;
  be = Vt || Lt ? fu(ae, Vt, Lt) : null;
  {
    const m = gt == null ? void 0 : gt.ratio;
    m && ui(m) ? _t = m : _t = void 0;
  }
  Ct = (fe == null ? void 0 : fe.type) === "fixed";
  {
    let m = {};
    ae === "overlap" && (m.overlapParent = !0), ae !== "horizontal" && (m.parentHAlign = Q ? "start" : Au[St]), ae !== "vertical" && (m.parentVAlign = Q ? "start" : Cu[Ot]);
    const ie = (J == null ? void 0 : J.type) === "wrap_content" || (J == null ? void 0 : J.type) === "match_parent" && (Ve == null ? void 0 : Ve.parentHorizontalWrapContent), L = !Fe || Fe.type === "wrap_content" || Fe.type === "match_parent" && (Ve == null ? void 0 : Ve.parentVerticalWrapContent);
    !ue && ie && (m.parentHorizontalWrapContent = !0), !_t && !oe && L && (m.parentVerticalWrapContent = !0), ie || (m.parentContainerKnownWidth = !0), L || (m.parentContainerKnownHeight = !0), m.stretchWidth = ye, m.stretchHeight = ee, ae === "horizontal" && (m.parentContainerOrientation = "horizontal"), ae === "vertical" && (m.parentContainerOrientation = "vertical"), Q && (m.parentContainerWrap = !0), $t = Ni(m, $t);
  }
  {
    let m, ie;
    if (mt = void 0, Ze = void 0, Me) {
      const L = Me == null ? void 0 : Me.mobile, Te = Me == null ? void 0 : Me.tablet;
      if (L != null && L.orientation && (m = String(L.orientation)), Te != null && Te.orientation && (ie = String(Te.orientation)), ((V = L == null ? void 0 : L.height) == null ? void 0 : V.type) === "fixed" && L.height.value !== void 0) {
        const ze = wr(L.height.value, 0);
        mt = ze > 0 ? ze : void 0;
      }
      if (((Ee = Te == null ? void 0 : Te.height) == null ? void 0 : Ee.type) === "fixed" && Te.height.value !== void 0) {
        const ze = wr(Te.height.value, 0);
        Ze = ze > 0 ? ze : void 0;
      }
    }
    Rt = {
      orientation: ae,
      valign: Ot,
      halign: St,
      wrap: Q,
      overflow: ne === !1 || ne === 0 ? "visible" : void 0,
      "fixed-container": Ct,
      "responsive-mobile-vertical": m === "vertical",
      "responsive-mobile-horizontal": m === "horizontal",
      "responsive-tablet-vertical": ie === "vertical",
      "responsive-tablet-horizontal": ie === "horizontal",
      "responsive-mobile-has-height": mt !== void 0,
      "responsive-tablet-has-height": Ze !== void 0
    };
  }
  return $e = {
    gap: Vt || Lt || yt || Dt ? gu({
      orientation: ae,
      separator: Vt,
      lineSeparator: Lt,
      itemSpacing: yt,
      lineSpacing: Dt
    }) : void 0,
    "aspect-ratio": _t,
    "--responsive-mobile-height": mt !== void 0 ? Se(mt) : void 0,
    "--responsive-tablet-height": Ze !== void 0 ? Se(Ze) : void 0
  }, Ne(), Re(), Ue(), te(), Qe(), lt(), We(), ht(), Ke(), qe(), Pe(), zt(), et(), It(), At(), re(), b(), `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("container", du, Rt),
      componentContext: se,
      layoutParams: Ve,
      style: $e,
      additionalPaddings: be,
      heightByAspect: !!_t,
      parentOf: jt,
      replaceItems: Ut
    },
    {},
    {
      default: () => `${Or(jt, (m) => `${Yt(yi, "Unknown").$$render(
        r,
        {
          componentContext: m,
          layoutParams: $t
        },
        {},
        {}
      )}`)} ${Vt || Lt ? `${Yt(xu, "ContainerSeparators").$$render(
        r,
        {
          direction: nt,
          separator: Vt,
          lineSeparator: Lt,
          orientation: ae,
          contentHAlign: St,
          contentVAlign: Ot
        },
        {},
        {}
      )}` : ""}`
    }
  )}`;
}), Vu = "appkit-separator", Fu = "appkit-separator_orientation_horizontal", Iu = "appkit-separator_orientation_vertical", Du = "appkit-separator__inner", Hs = {
  separator: Vu,
  separator_orientation_horizontal: Fu,
  separator_orientation_vertical: Iu,
  separator__inner: Du
};
function gs(r, t) {
  return r === "vertical" || r === "horizontal" ? r : t;
}
const Tu = xr((r, t, e, i) => {
  let n, o, l, c, d, f, h, C, T = E, P = () => (T(), T = $(o, (K) => C = K), o), { componentContext: z } = t, { layoutParams: G = void 0 } = t, I = "horizontal", F = "rgba(0,0,0,0.08)";
  function ke() {
    I = "horizontal", F = "rgba(0,0,0,0.08)";
  }
  return t.componentContext === void 0 && e.componentContext && z !== void 0 && e.componentContext(z), t.layoutParams === void 0 && e.layoutParams && G !== void 0 && e.layoutParams(G), n = z.origJson, n && ke(), P(o = z.getDerivedFromVars(z.json.delimiter_style)), I = gs(C == null ? void 0 : C.orientation, I), l = !(C != null && C.color && (C.color === "transparent" || C.color.length === 9 && C.color.indexOf("#00") === 0)), F = lr(C == null ? void 0 : C.color, 1, F), c = I === "horizontal" ? "100%" : Se(1), d = I === "horizontal" ? Se(1) : "100%", f = { background: F, width: c, height: d }, h = { orientation: I }, T(), `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("separator", Hs, h),
      componentContext: z,
      layoutParams: G
    },
    {},
    {
      default: () => `${l ? `<span${j("class", Hs.separator__inner, 0)}${j("style", fr(f), 0)}></span>` : ""}`
    }
  )}`;
}), Mu = "appkit-image", Pu = "appkit-image__image", zu = "appkit-image_error", Ou = "appkit-image_aspect", Nu = "appkit-image_loaded", Mn = {
  image: Mu,
  "image_is-width-content": "appkit-image_is-width-content",
  "image_is-height-content": "appkit-image_is-height-content",
  image__image: Pu,
  image_error: zu,
  "image_is-rtl-mirror": "appkit-image_is-rtl-mirror",
  "image__aspect-wrapper": "appkit-image__aspect-wrapper",
  "image_aspect-content": "appkit-image_aspect-content",
  "image_aspect-valign_top": "appkit-image_aspect-valign_top",
  "image_aspect-valign_bottom": "appkit-image_aspect-valign_bottom",
  image_aspect: Ou,
  image_loaded: Nu,
  "divkit-image-appearance": "appkit-divkit-image-appearance",
  "image_before-appearance": "appkit-image_before-appearance"
};
function Ru(r, t, e) {
  const i = r.content_alignment_horizontal, n = r.content_alignment_vertical;
  return i && i !== "left" && i !== "center" && i !== "right" && i !== "start" && i !== "end" || n && n !== "top" && n !== "center" && n !== "bottom" ? e : Wa({
    content_alignment_horizontal: i,
    content_alignment_vertical: n
  }, t);
}
function Xa(r) {
  return r.startsWith("data:") ? Wo(r) : `data:image/jpg;base64,${Wo(r)}`;
}
const To = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", Bu = "empty://", Lu = "rgba(0,0,0,0.08)", xn = 0, Ws = 1, Pn = 2, Us = xr((r, t, e, i) => {
  var B;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee, be, $e = E, ne = () => ($e(), $e = $(ke, (V) => be = V), ke), Ne, Ie, Me, Re = E, Be = () => (Re(), Re = $(F, (V) => Me = V), F), Fe, Ue = E, xe = () => (Ue(), Ue = $(I, (V) => Fe = V), I), J, te = E, de = () => (te(), te = $(G, (V) => J = V), G), fe, Qe = E, Ge = () => (Qe(), Qe = $(T, (V) => fe = V), T), gt, lt = E, pt = () => (lt(), lt = $(z, (V) => gt = V), z), R, We = E, pe = () => (We(), We = $(P, (V) => R = V), P), Le, ht = E, xt = () => (ht(), ht = $(C, (V) => Le = V), C), Je, Ke = E, He = () => (Ke(), Ke = $(h, (V) => Je = V), h), Ae, qe = E, it = () => (qe(), qe = $(f, (V) => Ae = V), f), nt, Pe = E, Ce = () => (Pe(), Pe = $(d, (V) => nt = V), d), zt, Y = E, wt = () => (Y(), Y = $(c, (V) => zt = V), c), et, ot = E, tt = () => (ot(), ot = $(ge, (V) => et = V), ge), It, De = E, Wt = () => (De(), De = $(o, (V) => It = V), o), At, kt = E, Xe = () => (kt(), kt = $(l, (V) => At = V), l), re, ct = E, Gt = () => (ct(), ct = $(K, (V) => re = V), K), { componentContext: b } = t, { layoutParams: Nt = void 0 } = t;
  const se = kr(Wr), Ve = se.direction;
  Ie = $(Ve, (V) => Ne = V);
  let bt, ve = xn, _e = !1, ae = Lu, Ot = !1, St, Vt = "", Lt = "none", _t = "50% 50%", $t = "0", yt = "0", Dt = !1, Ct = "center", Xt, Ut = "source_in", jt = "", Ht = "", Rt = 0, mt = 0, Ze = 0, er = "", ir = "", nr = !1, tr = !1, qt = !1;
  function U() {
    Dt = !1, Lt = "none", _t = "50% 50%", Ut = "source_in", tr = !1, qt = !1;
  }
  function S(V) {
    ve = xn;
  }
  function H(V) {
    _t = Ru(V, Ne, _t);
  }
  Kr(() => {
    se.removeSvgFilter(Xt, Ut);
  }), t.componentContext === void 0 && e.componentContext && b !== void 0 && e.componentContext(b), t.layoutParams === void 0 && e.layoutParams && Nt !== void 0 && e.layoutParams(Nt), n = b.origJson, n && U(), Wt(o = b.getDerivedFromVars(b.json.image_url)), Xe(l = b.getDerivedFromVars(b.json.gif_url)), wt(c = b.getDerivedFromVars(b.json.width)), Ce(d = b.getDerivedFromVars(b.json.height)), it(f = b.getDerivedFromVars(b.json.preview)), He(h = b.getDerivedFromVars(b.json.placeholder_color)), xt(C = b.getDerivedFromVars(b.json.scale)), Ge(T = b.getDerivedFromVars({
    content_alignment_horizontal: b.json.content_alignment_horizontal,
    content_alignment_vertical: b.json.content_alignment_vertical
  })), pe(P = b.getDerivedFromVars(b.json.accessibility)), pt(z = b.getDerivedFromVars(b.json.aspect)), de(G = b.getDerivedFromVars(b.json.tint_color)), xe(I = b.getDerivedFromVars(b.json.tint_mode)), Be(F = b.getDerivedFromVars(b.json.appearance_animation)), ne(ke = b.getDerivedFromVars(b.json.filters)), Gt(K = b.getDerivedFromVars(b.json.preload_required)), tt(ge = b.getDerivedFromVars(b.json.high_priority_preview_show));
  {
    let V = b.json.type === "gif" ? At : It;
    _e = V === Bu, _e && (V = To), St = V;
  }
  S(), tr = ri(et, tr), St ? Ot = !1 : (Ot = !0, b.logError(x(new Error(`Missing "${b.json.type === "gif" ? "gif_url" : "image_url"}" for "${b.json.type}"`)))), Q = (zt == null ? void 0 : zt.type) === "wrap_content", ue = (nt == null ? void 0 : nt.type) === "wrap_content";
  {
    const V = Ae;
    (ve === xn || ve === Pn || _e) && V ? (Vt = `url("${Xa(V)}")`, qt = tr) : (Vt = "", qt = !1);
  }
  ve === xn || ve === Pn || _e ? ae = lr(Je, 1, ae) : ae = "", Lt = Ha(Le) || Lt, H(fe), oe = (R == null ? void 0 : R.description) || "";
  {
    Ct = "center", $t = "0", yt = "0";
    const V = gt == null ? void 0 : gt.ratio;
    if (V && ui(V)) {
      const Ee = 100 / Number(V);
      Dt = ((B = b.json.width) == null ? void 0 : B.type) === "wrap_content", Dt ? fe.content_alignment_vertical === "top" ? (yt = Ee.toFixed(2), Ct = "top") : fe.content_alignment_vertical === "bottom" ? ($t = Ee.toFixed(2), Ct = "bottom") : $t = yt = (Ee / 2).toFixed(2) : yt = Ee.toFixed(2);
    } else
      yt = "0";
  }
  {
    const V = J, Ee = V ? lr(V) : void 0, m = Ka(Fe, Ut);
    (Ee !== Xt || m !== Ut) && (se.removeSvgFilter(Xt, Ut), jt = Ee ? se.addSvgFilter(Ee, m) : "", Xt = Ee, Ut = m);
  }
  if (Me && Me.type === "fade") {
    const V = Me;
    Ht = Ua(V.interpolator, "ease_in_out").replace(/_/g, "-"), Ze = wr(V.duration, 300), mt = wr(V.start_delay, 0), Rt = wr(V.alpha, 0);
  }
  {
    let V = "", Ee = "";
    Array.isArray(be) && be.length && (V = Ya(be, b.logError)), V && (Ee = "polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%)"), er = V, ir = Ee, nr = Ne === "rtl" && Array.isArray(be) && be.some((m) => m.type === "rtl_mirror");
  }
  return ye = {
    aspect: yt !== "0" || $t !== "0",
    "aspect-content": Dt,
    "aspect-valign": Ct !== "center" ? Ct : void 0,
    "is-width-content": Q,
    "is-height-content": ue,
    loaded: ve === Ws,
    "before-appearance": !!Ht && ve === xn,
    "is-rtl-mirror": nr
  }, ee = {
    // Image preview shows, if loading of original image is failed
    "background-image": Vt,
    "background-color": Vt ? void 0 : ae,
    "background-size": Lt,
    "clip-path": ir || void 0,
    "object-fit": Lt,
    "object-position": _t,
    filter: [
      ve === Ws && jt ? `url(#${jt})` : "",
      er
    ].filter(Boolean).join(" "),
    "--divkit-appearance-interpolator": Ht || void 0,
    "--divkit-appearance-fade-start": Ht ? Rt : void 0,
    "--divkit-appearance-delay": Ht ? `${mt}ms` : void 0,
    "--divkit-appearance-duration": Ht ? `${Ze}ms` : void 0
  }, $e(), Ie(), Re(), Ue(), te(), Qe(), lt(), We(), ht(), Ke(), qe(), Pe(), Y(), ot(), De(), kt(), ct(), `${Ot ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("image", Mn, ye),
      componentContext: b,
      layoutParams: Nt,
      customDescription: !0
    },
    {},
    {
      default: () => ` ${ye.aspect ? `<span${j("class", Mn["image__aspect-wrapper"], 0)}${Hr({
        "padding-top": `${$t}%`,
        "padding-bottom": `${yt}%`
      })}><img${j("class", Mn.image__image, 0)}${j("src", ve === Pn ? To : St, 0)}${j("loading", re || qt ? "eager" : "lazy", 0)}${j("decoding", qt ? "sync" : "async", 0)}${j("style", fr(ee), 0)}${j("alt", oe, 0)}${j("aria-hidden", oe ? null : "true", 0)}${j("this", bt, 0)}></span>` : `<img${j("class", Mn.image__image, 0)}${j("src", ve === Pn ? To : St, 0)}${j("loading", re || qt ? "eager" : "lazy", 0)}${j("decoding", qt ? "sync" : "async", 0)}${j("style", fr(ee), 0)}${j("alt", oe, 0)}${j("aria-hidden", oe ? null : "true", 0)}${j("this", bt, 0)}>`}`
    }
  )}`}`;
}), Hu = "appkit-grid", Wu = "appkit-grid_halign_start", Uu = "appkit-grid_halign_center", Gu = "appkit-grid_halign_end", qu = "appkit-grid_valign_start", Ju = "appkit-grid_valign_center", Yu = "appkit-grid_valign_end", Ku = {
  grid: Hu,
  grid_halign_start: Wu,
  grid_halign_center: Uu,
  grid_halign_end: Gu,
  grid_valign_start: qu,
  grid_valign_center: Ju,
  grid_valign_end: Yu
};
function Gs(r) {
  return r > 0 && r < 1;
}
function qs(r) {
  return String(Math.ceil(r * 1e3) / 1e3);
}
function Js(r, t, e, i) {
  if (r.some(Gs)) {
    const d = Math.max(...r.filter(Gs).map((f) => 1 / f));
    r = r.map((f) => f * d);
  }
  const n = r.every(Boolean);
  let o = 0, l = 0;
  const c = [];
  if (n) {
    l = r.reduce((d, f) => d + f, 0);
    for (let d = 0; d < i; ++d) {
      if (!t[d])
        continue;
      const f = t[d] / r[d] * l;
      f > o && (o = f);
    }
  }
  for (let d = 0; d < i; ++d)
    o && !e[d] ? c[d] = `minmax(${Se(o * r[d] / l)},${qs(r[d])}fr)` : n || !e[d] && r[d] ? c[d] = `${qs(r[d])}fr` : c[d] = "auto";
  return c.join(" ");
}
const Xu = xr((r, t, e, i) => {
  let n, o, l, c, d, f, h, C, T, P, z = E, G = () => (z(), z = $(d, (R) => P = R), d), I, F = E, ke = () => (F(), F = $(c, (R) => I = R), c), K, ge = E, Q = () => (ge(), ge = $(Me, (R) => K = R), Me), ue, oe = E, ye = () => (oe(), oe = $(l, (R) => ue = R), l), { componentContext: ee } = t, { layoutParams: be = void 0 } = t;
  const ne = kr(Wr).direction;
  T = $(ne, (R) => C = R);
  let Ne = !1, Ie = 0, Me, Re, Be = [], Fe = [], Ue = [], xe = [], J = [], te = [], de = 0, fe = "start", Qe = "start", Ge = [], gt;
  function lt() {
    Ne = !1, Ie = 0, fe = "start", Qe = "start";
  }
  function pt(R) {
    ee = gt = {
      ...ee,
      json: {
        ...ee.json,
        items: R.filter(Fi)
      }
    };
  }
  Kr(() => {
    Ge.forEach((R) => {
      R.destroy();
    });
  }), t.componentContext === void 0 && e.componentContext && ee !== void 0 && e.componentContext(ee), t.layoutParams === void 0 && e.layoutParams && be !== void 0 && e.layoutParams(be), n = ee.origJson, n && lt(), o = Array.isArray(ee.json.items) && ee.json.items || [], ye(l = ee.getDerivedFromVars(ee.json.column_count)), ke(c = ee.getDerivedFromVars(ee.json.content_alignment_vertical)), G(d = ee.getDerivedFromVars(ee.json.content_alignment_horizontal)), Ie = fi(ue, Ie), Ie < 1 ? (Ne = !0, ee.logError(x(new Error("Incorrect column_count for grid")))) : Ne = !1;
  {
    const R = new Set(Ge), We = /* @__PURE__ */ new Map();
    gt === ee && Ge.forEach((pe) => {
      We.set(pe.json, pe);
    }), Ge = o.map((pe, Le) => {
      const ht = We.get(pe);
      return ht ? (R.delete(ht), ht) : ee.produceChildContext(pe, { path: Le });
    });
    for (const pe of R)
      pe.destroy();
    gt = ee;
  }
  {
    let R = [];
    Ge.forEach((We) => {
      R.push(ee.getDerivedFromVars({
        rowSpan: We.json.row_span,
        columnSpan: We.json.column_span,
        width: We.json.width,
        height: We.json.height
      }));
    }), Q(Me = vn(R, (We) => [...We]));
  }
  {
    const R = {};
    let We = 0, pe = 0;
    Be = [], Fe = [], Ue = [], xe = [], J = [], te = [];
    let Le = 0;
    Re = Ge.map((ht, xt) => {
      var Ce, zt, Y, wt;
      const Je = K[xt], Ke = Math.min(Ie, Number(Je.columnSpan) || 1), He = Number(Je.rowSpan) || 1, Ae = ((Ce = Je.width) == null ? void 0 : Ce.type) === "match_parent" ? Number(Je.width.weight || 1) / Ke : 0, qe = ((zt = Je.height) == null ? void 0 : zt.type) === "match_parent" ? Number(Je.height.weight || 1) / He : 0, it = ((Y = Je.width) == null ? void 0 : Y.type) === "fixed" && Je.width.value ? Number(Je.width.value) / Ke : 0, nt = ((wt = Je.height) == null ? void 0 : wt.type) === "fixed" && Je.height.value ? Number(Je.height.value) / He : 0;
      for (; ; ) {
        let et = !0;
        e:
          for (let ot = We; ot < We + Ke; ++ot)
            for (let tt = pe; tt < pe + He; ++tt)
              if (R[ot + "_" + tt]) {
                et = !1;
                break e;
              }
        if (et)
          break;
        ++We, We > Ie - Ke && (We = 0, ++pe);
      }
      const Pe = { x: We, y: pe, colSpan: Ke, rowSpan: He };
      for (let et = We; et < We + Ke; ++et)
        for (let ot = pe; ot < pe + He; ++ot)
          R[et + "_" + ot] = !0, (!Be[et] || Be[et] < Ae) && (Be[et] = Ae), (!Fe[ot] || Fe[ot] < qe) && (Fe[ot] = qe), Ke === 1 && (!Ue[et] || Ue[et] < it) && (Ue[et] = it), He === 1 && (!xe[ot] || xe[ot] < nt) && (xe[ot] = nt), Ke === 1 && it && (J[et] = it), He === 1 && nt && (te[et] = nt);
      return Le = Math.max(Le, pe + He), {
        componentContext: ht,
        layoutParams: { gridArea: Pe }
      };
    }), de = Math.max(pe + 1, Le);
  }
  return fe = ds(I, fe), Qe = us(P, C, Qe), f = {
    valign: fe,
    halign: Qe
  }, h = {
    "grid-template-columns": Js(Be, Ue, J, Ie),
    "grid-template-rows": Js(Fe, xe, te, de)
  }, T(), z(), F(), ge(), oe(), `${Ne ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("grid", Ku, f),
      componentContext: ee,
      style: h,
      layoutParams: be,
      parentOf: Ge,
      replaceItems: pt
    },
    {},
    {
      default: () => `${Or(Re, (R) => `${Yt(yi, "Unknown").$$render(
        r,
        {
          componentContext: R.componentContext,
          layoutParams: R.layoutParams
        },
        {},
        {}
      )}`)}`
    }
  )}`}`;
}), Zu = "appkit-gallery", Qu = "appkit-gallery__scroller", ed = "appkit-gallery_scrollbar_none", td = "appkit-gallery_orientation_horizontal", rd = "appkit-gallery_orientation_vertical", id = "appkit-gallery__items", nd = "appkit-gallery__arrow", An = {
  gallery: Zu,
  gallery__scroller: Qu,
  gallery_scrollbar_none: ed,
  gallery_orientation_horizontal: td,
  gallery_orientation_vertical: rd,
  "gallery_scroll-snap": "appkit-gallery_scroll-snap",
  "gallery__items-grid": "appkit-gallery__items-grid",
  gallery__items: id,
  gallery__arrow: nd,
  "gallery__arrow-icon-path": "appkit-gallery__arrow-icon-path"
}, od = "appkit-arrow", sd = "appkit-arrow__icon", ad = "appkit-arrow_left", ld = "appkit-arrow_right", an = {
  arrow: od,
  arrow__icon: sd,
  arrow_left: ad,
  arrow_right: ld
};
function cd(r, t) {
  return r === "start" || r === "center" || r === "end" ? r : t;
}
function ud(r) {
  const t = [];
  let e = r[0], i = 1;
  for (let n = 1; n <= r.length; n++)
    r[n] !== e ? (t.push(i > 1 ? `repeat(${i}, ${e})` : e), e = r[n], i = 1) : i++;
  return t.join(" ");
}
function Ai(r, t) {
  let e = r % t;
  return e < 0 && (e += t), e;
}
function dd(r, t, e) {
  let i = 0, n = [], o = [];
  for (let l = 0; l < r.length; ++l)
    n[i] || (n[i] = []), n[i].push({
      index: l,
      hasGapBefore: o[i] && t[l].visibility !== "gone",
      componentContext: r[l]
    }), !o[i] && t[l].visibility !== "gone" && (o[i] = !0), ++i >= e && (i = 0);
  return n;
}
const fd = xr((r, t, e, i) => {
  var er, ir, nr, tr, qt, U;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee = E, be = () => (ee(), ee = $(I, (S) => S), I), $e, ne = E, Ne = () => (ne(), ne = $(G, (S) => $e = S), G), Ie, Me = E, Re = () => (Me(), Me = $(P, (S) => Ie = S), P), Be, Fe = E, Ue = () => (Fe(), Fe = $(_e, (S) => Be = S), _e), xe, J = E, te = () => (J(), J = $(T, (S) => xe = S), T), de, fe = E, Qe = () => (fe(), fe = $(C, (S) => de = S), C), Ge, gt = E, lt = () => (gt(), gt = $(h, (S) => Ge = S), h), pt, R = E, We = () => (R(), R = $(f, (S) => pt = S), f), pe, Le = E, ht = () => (Le(), Le = $(d, (S) => pe = S), d), xt, Je = E, Ke = () => (Je(), Je = $(c, (S) => xt = S), c), He, Ae, qe, it = E, nt = () => (it(), it = $(l, (S) => qe = S), l), Pe, Ce = E, zt = () => (Ce(), Ce = $(z, (S) => Pe = S), z), { componentContext: Y } = t, { layoutParams: wt = void 0 } = t;
  const et = kr(Wr), ot = et.direction;
  ye = $(ot, (S) => oe = S);
  let tt, It = [], De = null, Wt, At = !1;
  et.getCustomization("galleryLeftClass"), et.getCustomization("galleryRightClass");
  let kt, Xe = 1, re = "horizontal", ct = "start", Gt, b = 8, Nt, se, Ve = "", bt, ve = [], _e, ae = {}, Ot = !1, St = {};
  function Vt() {
    Xe = 1, re = "horizontal", ct = "start", b = 8, Ve = "";
  }
  function Lt(S) {
    Y = yt = {
      ...Y,
      json: {
        ...Y.json,
        items: S.filter(Fi)
      }
    };
  }
  const _t = et.isDesktop;
  Ae = $(_t, (S) => He = S);
  let $t = [], yt;
  function Dt() {
  }
  const Ct = Xc(Dt, 50);
  function Xt() {
    let S = [], H = It[0].children.length;
    for (let B = 0; B < H; B += 2)
      for (let V = 0; V < Xe; ++V) {
        const Ee = It[V].children[B];
        Ee && S.push(Ee);
      }
    return S;
  }
  function Ut(S, H = !0) {
    const V = re === "horizontal" ? "left" : "top";
    tt.scroll({
      [V]: S,
      behavior: H ? "smooth" : "instant"
    });
  }
  function jt(S, H, { animated: B = !0, extraOffset: V = 0, overflow: Ee = "clamp" } = {}) {
    const m = re === "horizontal", ie = m ? "offsetLeft" : "offsetTop";
    H > S.length - 1 ? H = Ee === "ring" ? Ai(H, S.length) : S.length - 1 : H < 0 && (H = Ee === "ring" ? Ai(H, S.length) : 0);
    const L = S[H];
    if (L) {
      let Te;
      if (oe === "ltr" || !m)
        Te = L[ie] + 0.01 - b / 2;
      else {
        const ze = tt.offsetWidth;
        Te = L[ie] + L.offsetWidth + 0.01 - b / 2 - ze;
      }
      if (V) {
        Te += V;
        const ze = m ? tt.scrollWidth - tt.offsetWidth : tt.scrollHeight - tt.offsetHeight;
        Te > ze && (Ee === "clamp" ? Te = ze : Ee === "ring" && (Te = Ai(Te, ze))), Te < 0 && (Ee === "clamp" ? Te = 0 : Ee === "ring" && (Te = Ai(Te, ze)));
      }
      Ut(Te, B);
    }
  }
  function Ht(S, { overflow: H = "clamp", animated: B = !0 } = {}) {
    const V = re === "horizontal", Ee = oe === "ltr" || !V ? 1 : -1, m = V ? tt.scrollLeft : tt.scrollTop, ie = V ? tt.scrollWidth - tt.offsetWidth : tt.scrollHeight - tt.offsetHeight;
    let L = m * Ee + S;
    L > ie ? H === "clamp" ? L = ie : H === "ring" && (L = Ai(L, ie)) : L < 0 && (H === "clamp" ? L = 0 : H === "ring" && (L = Ai(L, ie))), Ut(L * Ee, B);
  }
  function Rt(S, H) {
    return re === "horizontal" ? H.right > S.left && S.right > H.left : H.bottom > S.top && S.bottom > H.top;
  }
  function mt(S, H) {
    return re === "horizontal" ? H.left >= S.left && H.right <= S.right : H.top >= S.top && H.bottom <= S.bottom;
  }
  function Ze(S) {
    const H = Xt(), B = tt.getBoundingClientRect(), V = H.findIndex((ie) => mt(B, ie.getBoundingClientRect()));
    if (V !== -1)
      return V;
    const Ee = H.map((ie) => Rt(B, ie.getBoundingClientRect())), m = Ee.findIndex(Boolean);
    return m !== -1 ? S === "prev" && Ee.filter(Boolean).length === 2 ? m + 1 : m : S === "prev" ? 1 : H.length - 2;
  }
  Kr(() => {
    At = !1, $t.forEach((S) => {
      S.destroy();
    }), kt && !Y.fakeElement && (et.unregisterInstance(kt), kt = void 0);
  }), t.componentContext === void 0 && e.componentContext && Y !== void 0 && e.componentContext(Y), t.layoutParams === void 0 && e.layoutParams && wt !== void 0 && e.layoutParams(wt), n = Y.origJson, n && Vt(), o = Array.isArray(Y.json.items) && Y.json.items || [], nt(l = typeof ((er = Y.json.item_builder) == null ? void 0 : er.data) == "string" ? Y.getDerivedFromVars((ir = Y.json.item_builder) == null ? void 0 : ir.data, void 0, !0) : (nr = Y.json.item_builder) != null && nr.data ? Ki(Y.json.item_builder.data) : void 0), Ke(c = Y.getDerivedFromVars(Y.json.column_count)), ht(d = Y.getDerivedFromVars(Y.json.orientation)), We(f = Y.getDerivedFromVars(Y.json.cross_content_alignment)), lt(h = Y.getDerivedFromVars(Y.json.item_spacing)), Qe(C = Y.getDerivedFromVars(Y.json.cross_spacing)), te(T = Y.getDerivedFromVars(Y.json.paddings)), Re(P = Y.getDerivedFromVars(Y.json.scroll_mode)), zt(z = Y.getDerivedFromVars(Y.json.restrict_parent_scroll)), Ne(G = Y.getDerivedFromVars(Y.json.scrollbar)), be(I = Y.getDerivedFromVars(Y.json.default_item));
  {
    let S = [];
    if (Y.json.item_builder && Array.isArray(qe) && Array.isArray(Y.json.item_builder.prototypes)) {
      const Ee = Y.json.item_builder;
      S = fs(qe, et, Y, Ee);
    } else
      S = (Array.isArray(o) && o || []).map((Ee, m) => ({
        div: Ee,
        key: Ee.id || { index: m, data: Ee }
      }));
    const H = new Set($t), B = /* @__PURE__ */ new Map();
    let V = !1;
    yt === Y && $t.forEach((Ee) => {
      Ee.key && (typeof Ee.key == "string" && B.has(Ee.key) ? V || (V = !0, Y.logError(x(new Error("Duplicate key for child elements inside item_builder"), { additional: { key: Ee.key } }))) : B.set(
        typeof Ee.key == "string" ? Ee.key : Ee.key.index,
        Ee
      ));
    }), $t = S.map((Ee, m) => {
      let ie = !V && B.get(Ee.id), L = B.get(m);
      return !ie && !Ee.id && typeof Ee.key == "object" && typeof (L == null ? void 0 : L.key) == "object" && bn(L.key.data, Ee.key.data) && (ie = L), ie ? (H.delete(ie), ie) : Y.produceChildContext(Ee.div, {
        path: m,
        variables: Ee.vars,
        id: Ee.id,
        key: Ee.key
      });
    });
    for (const Ee of H)
      Ee.destroy();
    yt = Y;
  }
  F = He && At, F ? typeof ResizeObserver < "u" && (De = new ResizeObserver(() => {
    Ct();
  }), De.observe(Wt)) : De && (De.disconnect(), De = null), Xe = fi(xt, Xe), re = gs(pe, re), ct = cd(pt, ct), b = wr(Ge, b), Gt = Se(b), se = wr(de, b), Nt = Se(se);
  {
    Ve = po(xe, oe, Ve);
    const S = re === "horizontal" ? (qt = (tr = xe == null ? void 0 : xe.end) != null ? tr : xe == null ? void 0 : xe[oe === "ltr" ? "right" : "left"]) != null ? qt : 0 : (U = xe == null ? void 0 : xe.bottom) != null ? U : 0, H = Se(S);
    bt = {
      width: re === "horizontal" ? H : "1px",
      height: re === "horizontal" ? "1px" : H,
      "margin-right": re === "horizontal" && oe === "ltr" ? "-" + H : void 0,
      "margin-left": re === "horizontal" && oe === "rtl" ? "-" + H : void 0,
      "margin-bottom": re === "vertical" ? "-" + H : void 0
    };
  }
  ke = re === "horizontal" ? "grid-template-columns" : "grid-template-rows";
  {
    let S = [];
    $t.forEach((H) => {
      const B = re === "horizontal" ? "width" : "height";
      S.push(H.getDerivedFromVars({
        size: H.json[B],
        visibility: H.json.visibility
      }));
    }), Ue(_e = vn(S, (H) => [...H]));
  }
  K = dd($t, Be, Xe), ve = [], Xe > 1 || Be.forEach((S, H) => {
    var B;
    S.visibility !== "gone" && (!S.size && re === "horizontal" || ((B = S.size) == null ? void 0 : B.type) === "match_parent" ? ve.push("100%") : ve.push("max-content"), H + 1 < Be.length && ve.push("auto"));
  }), ve.push("auto");
  {
    const S = {};
    let H = {};
    if (Ot = !1, re === "horizontal" ? H.parentVAlign = ct : H.parentHAlign = ct, Ie === "paging") {
      Ot = !0, H.scrollSnap = "start";
      const B = re === "horizontal" ? "scroll-padding-left" : "scroll-padding-top";
      S[B] = Se(b / 2);
    }
    Xe === 1 && (H.parentLayoutOrientation = re), ae = Ni(S, ae), St = Ni(H, St);
  }
  return ge = { padding: Ve, "grid-gap": Nt }, Q = {
    [ke]: ud(ve)
  }, ue = {
    orientation: re,
    "scroll-snap": Ot,
    scrollbar: $e === "auto" ? "auto" : "none"
  }, Y.json && Ct(), Y.json && (kt && (et.unregisterInstance(kt), kt = void 0), Y.id && !Y.fakeElement && (kt = Y.id, et.registerInstance(kt, {
    setCurrentItem(S, H) {
      const B = Xt();
      if (S < 0 || S > B.length - 1)
        throw new Error('Item is out of range in "set-current-item" action');
      jt(B, S, { animated: H });
    },
    setPreviousItem(S, H, B) {
      const V = Ze("prev"), Ee = Xt();
      let m = V - S;
      jt(Ee, m, { animated: B, overflow: H });
    },
    setNextItem(S, H, B) {
      const V = re === "horizontal", Ee = oe === "ltr" || !V ? 1 : -1, m = V ? tt.scrollLeft * Ee + tt.offsetWidth === tt.scrollWidth : tt.scrollTop + tt.offsetHeight === tt.scrollHeight, ie = Xt();
      if (m && H === "ring") {
        jt(ie, 0, { animated: B });
        return;
      }
      let Te = Ze("next") + S;
      jt(ie, Te, { animated: B, overflow: H });
    },
    scrollToStart(S) {
      Ut(0, S);
    },
    scrollToEnd(S) {
      Ut(
        oe === "ltr" || re !== "horizontal" ? 1e6 : -1e6,
        S
      );
    },
    scrollToPosition(S, H) {
      Ut(
        oe === "ltr" || re !== "horizontal" ? S : -S,
        H
      );
    },
    scrollCombined({ step: S, offset: H, overflow: B, animated: V }) {
      if (S) {
        const m = Ze(S > 0 ? "next" : "prev") + S;
        jt(Xt(), m, { animated: V, extraOffset: H, overflow: B });
      } else
        H && Ht(H, { overflow: B, animated: V });
    }
  }))), ye(), ee(), ne(), Me(), Fe(), J(), fe(), gt(), R(), Le(), Je(), Ae(), it(), Ce(), ` ${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("gallery", An, ue),
      componentContext: Y,
      layoutParams: wt,
      customPaddings: !0,
      customActions: "gallery",
      parentOf: $t,
      replaceItems: Lt
    },
    {},
    {
      default: () => `<div class="${ft(An.gallery__scroller, !0) + " " + ft(
        Pe ? Lr["root_restrict-scroll"] : "",
        !0
      )}"${j("style", fr(ae), 0)}${j("this", tt, 0)}><div${j("class", An["gallery__items-grid"], 0)}${j("style", fr(ge), 0)}${j("this", Wt, 0)}>${Or(K, (S, H) => `<div${j("class", An.gallery__items, 0)}${j("style", fr(Q), 0)}${j("this", It[H], 0)}>${Or(S, (B) => `${B.hasGapBefore ? `<div${j("class", An.gallery__gap, 0)}${Hr({
        width: re === "horizontal" ? Gt : void 0,
        height: re !== "horizontal" ? Gt : void 0
      })}></div>` : ""} ${Yt(yi, "Unknown").$$render(
        r,
        {
          componentContext: B.componentContext,
          layoutParams: St
        },
        {},
        {}
      )}`)} <div${j("style", fr(bt), 0)}></div> </div>`)}</div></div> ${re === "horizontal" ? " " : ""}`
    }
  )}`;
}), gd = "appkit-outer", pd = "appkit-tabs", hd = "appkit-tabs__list", _d = "appkit-tabs__item", md = "appkit-tabs__item_selected", vd = "appkit-tabs_animation_fade", bd = "appkit-tabs_animation_none", yd = "appkit-tabs__item_actionable", wd = "appkit-tabs__panels", kd = "appkit-tabs__swiper", $d = "appkit-tabs__swiper_animated", jd = "appkit-tabs__swiper_inited", Ed = "appkit-tabs__panel", xd = "appkit-tabs__panel_visible", Ad = "appkit-tabs__separator", Cd = "appkit-tabs__delimitier", pi = {
  outer: gd,
  "root__any-actions": "appkit-root__any-actions",
  tabs: pd,
  tabs__list: hd,
  "tabs__items-bg": "appkit-tabs__items-bg",
  "tabs__items-text": "appkit-tabs__items-text",
  tabs__item: _d,
  tabs__item_selected: md,
  tabs_animation_fade: vd,
  tabs_animation_none: bd,
  tabs__item_actionable: yd,
  tabs__panels: wd,
  "tabs_own-height": "appkit-tabs_own-height",
  tabs__swiper: kd,
  tabs__swiper_animated: $d,
  tabs__swiper_inited: jd,
  tabs__panel: Ed,
  tabs__panel_visible: xd,
  "tabs_height-parent_yes": "appkit-tabs_height-parent_yes",
  tabs__separator: Ad,
  tabs__delimitier: Cd,
  "tabs__tabs-highlighter": "appkit-tabs__tabs-highlighter"
};
function Sd(r, t) {
  var i, n;
  if (!r || !r.image_url || typeof r.image_url != "string")
    return t;
  const e = {
    url: r.image_url
  };
  return ((i = r.width) == null ? void 0 : i.type) === "fixed" && ui(r.width.value) && (e.width = r.width.value), ((n = r.height) == null ? void 0 : n.type) === "fixed" && ui(r.height.value) && (e.height = r.height.value), e;
}
function Vd(r, t, e, i) {
  const n = [
    r["top-left"],
    r["top-right"],
    r["bottom-right"],
    r["bottom-left"]
  ];
  for (let o = 0; o < n.length; ++o)
    if (n[o] && !si(n[o]))
      return i;
  return Xn(r, t, e);
}
const Fd = xr((r, t, e, i) => {
  let { componentContext: n } = t, { layoutParams: o = void 0 } = t, { enabled: l } = t;
  const c = Ci(l);
  return Yi(cs, { isEnabled: c }), t.componentContext === void 0 && e.componentContext && n !== void 0 && e.componentContext(n), t.layoutParams === void 0 && e.layoutParams && o !== void 0 && e.layoutParams(o), t.enabled === void 0 && e.enabled && l !== void 0 && e.enabled(l), c.set(l), `${Yt(yi, "Unknown").$$render(r, { componentContext: n, layoutParams: o }, {}, {})}`;
}), Id = xr((r, t, e, i) => {
  var ir, nr, tr, qt, U, S, H, B, V, Ee;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue = E, oe = () => (ue(), ue = $(d, (m) => Q = m), d), ye, ee = E, be = () => (ee(), ee = $(G, (m) => ye = m), G), $e, ne = E, Ne = () => (ne(), ne = $(z, (m) => $e = m), z), Ie = E, Me = () => (Ie(), Ie = $(T, (m) => m), T), Re, Be, Fe, Ue = E, xe = () => (Ue(), Ue = $(C, (m) => Fe = m), C), J, te = E, de = () => (te(), te = $(h, (m) => J = m), h), fe, Qe = E, Ge = () => (Qe(), Qe = $(f, (m) => fe = m), f), gt, lt = E, pt = () => (lt(), lt = $(P, (m) => gt = m), P), { componentContext: R } = t, { layoutParams: We = void 0 } = t;
  const pe = kr(Wr), Le = pe.direction;
  Be = $(Le, (m) => Re = m);
  const ht = pe.genId("tabs");
  let xt, Je = !1, Ke = Ci([]);
  ge = $(Ke, (m) => K = m);
  let He = {}, Ae, qe, it, nt = {}, Pe = 12, Ce = "", zt = "", Y = "", wt = "", et, ot = "", tt, It = "", De = "", Wt = "", At = "", kt = "", Xe = 0, re = "", ct = "", Gt = null, b = !1, Nt = !1, se, Ve = [], bt = [], ve = null, _e, ae = "slide", Ot, St, Vt, Lt;
  function _t() {
    Pe = 12, Ce = "", wt = "", et = void 0, ot = "", tt = void 0, It = "", De = "", Wt = "", At = "", kt = "", Xe = 0, re = "", ct = "", Gt = null, _e = void 0, ae = "slide", Ot = 300, St = void 0, er();
  }
  function $t(m) {
    R.json.items && (R = Vt = {
      ...R,
      json: {
        ...R.json,
        items: R.json.items.map((ie, L) => ({ ...ie, div: m[L] }))
      }
    });
  }
  function yt(m) {
    if (Je)
      return;
    const ie = new Set(Ve.filter(Fi)), L = /* @__PURE__ */ new Map();
    Vt === R && Ve.forEach((Te) => {
      Te && L.set(Te.json, Te);
    }), Ve = m.map((Te, ze) => {
      if ((ze === I || Ve[ze]) && (Te != null && Te.div)) {
        const pr = L.get(Te.div);
        return pr ? (ie.delete(pr), pr) : R.produceChildContext(Te.div, { path: ze });
      }
    }), bt = m.map((Te, ze) => ze === I);
    for (const Te of ie)
      Te.destroy();
    Vt = R;
  }
  async function Dt(m, ie, L) {
    se = I, I = m, mt(), Xt(L), er();
  }
  function Ct(m, ie) {
    return I !== ie ? (Dt(ie, !1, !0), !1) : !0;
  }
  function Xt(m = !0) {
    Nt = m, Ut(-I * 100), jt(), Ht(), Rt(), -I * qe.clientWidth;
  }
  async function Ut(m) {
    await $i(), it.style.transform = `translate3d(${m}%,0,0)`;
  }
  function jt(m = !1) {
    const ie = m ? Math.max(0, I - 1) : Math.min(I, se != null ? se : I), L = m ? Math.min(o.length - 1, I + 1) : Math.max(I, se != null ? se : I);
    pe.devtoolCreateHierarchy, Ve.forEach((Te) => {
      Te == null || Te.destroy();
    }), Ve = Ve.map((Te, ze) => {
      var je;
      if (Te)
        return Te;
      const pr = (je = o[ze]) == null ? void 0 : je.div;
      if ((ze >= ie && ze <= L || pe.devtoolCreateHierarchy === "eager" && !1) && pr)
        return R.produceChildContext(pr, { path: ze });
    }), bt = bt.map((Te, ze) => ze >= ie && ze <= L);
  }
  async function Ht() {
    var ie;
    if (((ie = R.json.height) == null ? void 0 : ie.type) === "match_parent")
      return;
    await $i();
    const m = document.getElementById(`${ht}-panel-${I}`);
    m && (qe.style.height = Se(m.offsetHeight));
  }
  function Rt() {
    ve && clearTimeout(ve), ve = window.setTimeout(
      () => {
        bt = o.map((m, ie) => ie === I);
      },
      400
    );
  }
  function mt() {
    b || (b = !0, qe.style.height = Se(qe.clientHeight), it.style.transform = `translate3d(${-(se != null ? se : I) * 100}%,0,0)`);
  }
  function Ze(m, ie) {
    return m > o.length - 1 ? ie === "ring" ? Ai(m, o.length) : o.length - 1 : m < 0 ? ie === "ring" ? Ai(m, o.length) : 0 : m;
  }
  function er() {
    ae === "slide" && $i().then(() => {
    });
  }
  if (Kr(() => {
    Ve.forEach((m) => {
      m == null || m.destroy();
    }), xt && (pe.unregisterInstance(xt), xt = void 0);
  }), t.componentContext === void 0 && e.componentContext && R !== void 0 && e.componentContext(R), t.layoutParams === void 0 && e.layoutParams && We !== void 0 && e.layoutParams(We), n = R.origJson, n && _t(), o = Array.isArray(R.json.items) && R.json.items || [], l = o.map((m) => {
    var ie;
    return { json: m.div, id: (ie = m.div) == null ? void 0 : ie.id };
  }), c = R.getJsonWithVars(R.json.selected_tab), oe(d = R.getDerivedFromVars(R.json.tab_title_style)), Ge(f = R.getDerivedFromVars(R.json.has_separator)), de(h = R.getDerivedFromVars(R.json.separator_color)), xe(C = R.getDerivedFromVars(R.json.separator_paddings)), Me(T = R.getDerivedFromVars(R.json.switch_tabs_by_content_swipe_enabled)), pt(P = R.getDerivedFromVars(R.json.restrict_parent_scroll)), Ne(z = R.getDerivedFromVars(R.json.title_paddings)), be(G = R.getDerivedFromVars(R.json.tab_title_delimiter)), I = c && Number(c) || 0, Array.isArray(o) && o.length) {
    let m = [];
    o.forEach((ie, L) => {
      const Te = R.getJsonWithVars({
        index: L,
        title: ie.title,
        title_click_action: ie.title_click_action
      });
      Te.title && typeof Te.title == "string" ? m.push(Te) : R.logError(x(new Error("Incorrect title for the tab"), { additional: { index: L } }));
    }), Ke.set(m);
  } else
    Ke.set([]);
  K != null && K.length ? Je = !1 : (Je = !0, R.logError(x(new Error('Incorrect or empty "items" prop for div "tabs"'))));
  {
    let m = { parentContainerOrientation: "horizontal" };
    ((ir = R.json.width) == null ? void 0 : ir.type) === "wrap_content" && (m.parentHorizontalWrapContent = !0), (!R.json.height || R.json.height.type === "wrap_content") && (m.parentVerticalWrapContent = !0), He = Ni(m, He);
  }
  if (!Je && (I < 0 || I >= o.length) && (R.logError(x(new Error('Incorrect "selected_tab" prop for div "tabs"'), {
    additional: {
      selected: R.json.selected_tab,
      length: o.length
    }
  })), I = I < 0 ? 0 : o.length - 1), !Je && !K.some((m) => I === m.index) && (R.logError(x(new Error('Incorrect "selected_tab" prop for div "tabs"'), {
    additional: {
      selected: R.json.selected_tab
    }
  })), I = ((nr = K[0]) == null ? void 0 : nr.index) || 0), F = Q || {}, Pe = fi(F.font_size, Pe), F.font_size || F.paddings) {
    const m = F.paddings || { top: 6, right: 8, bottom: 6, left: 8 }, ie = {
      top: (Number(m.top) || 0) / Pe * 10,
      right: (Number(Re === "ltr" ? m.end : m.start) || Number(m.right) || 0) / Pe * 10,
      bottom: (Number(m.bottom) || 0) / Pe * 10,
      left: (Number(Re === "ltr" ? m.start : m.end) || Number(m.left) || 0) / Pe * 10
    };
    Ce = po(ie, Re, Ce);
  }
  {
    const m = F.line_height;
    m !== void 0 && ui(m) && (zt = Se(m / Pe * 10));
  }
  {
    const m = F.letter_spacing;
    m !== void 0 && si(m) && (Y = Se(m / Pe * 10));
  }
  if (F.corner_radius || F.corners_radius || F.font_size) {
    const m = (tr = F.corner_radius) != null ? tr : 1e3;
    F.corners_radius ? wt = Vd(F.corners_radius, m, Pe, wt) : si(m) && (wt = Se(m / Pe * 10));
  }
  return et = _n(F.active_font_weight || F.font_weight, void 0, et), F.font_family && typeof F.font_family == "string" ? ot = pe.typefaceProvider(F.font_family, { fontWeight: et || 400 }) : ot = "", tt = _n(F.inactive_font_weight || F.font_weight, void 0, tt), F.font_family && typeof F.font_family == "string" ? It = pe.typefaceProvider(F.font_family, { fontWeight: tt || 400 }) : It = "", De = lr(F.active_text_color, 1, De), Wt = lr(F.inactive_text_color, 1, Wt), At = lr(F.active_background_color, 1, At), kt = lr(F.inactive_background_color, 1, kt), Xe = wr(F.item_spacing, Xe), fe && (J && (re = lr(J, 1, re)), Fe && (ct = po(Fe, Re, ct))), ke = {
    background: re,
    margin: ct
  }, Gt = yn($e || void 0, Gt), _e = Sd(ye, _e), ((Q == null ? void 0 : Q.animation_type) === "fade" || (Q == null ? void 0 : Q.animation_type) === "none") && (ae = Q.animation_type), si(Q == null ? void 0 : Q.animation_duration) && (Ot = Q.animation_duration), yt(o), R.json && (xt && (pe.unregisterInstance(xt), xt = void 0), R.id && !Je && !R.fakeElement && (xt = R.id, pe.registerInstance(xt, {
    setCurrentItem(m, ie) {
      if (m < 0 || m > o.length - 1)
        throw new Error('Item is out of range in "set-current-item" action');
      Dt(m, !1, ie);
    },
    setPreviousItem(m, ie, L) {
      let Te = Ze(I - m, ie);
      Dt(Te, !1, L);
    },
    setNextItem(m, ie, L) {
      let Te = Ze(I + m, ie);
      Dt(Te, !1, L);
    },
    scrollToStart(m) {
      Dt(0, !1, m);
    },
    scrollToEnd(m) {
      Dt(o.length - 1, !1, m);
    },
    scrollCombined({ step: m, overflow: ie, animated: L }) {
      m && Dt(Ze(I + m, ie || "clamp"), !1, L || !0);
    }
  }))), nt = {
    "height-parent": ((qt = R.json.height) == null ? void 0 : qt.type) === "match_parent" ? "yes" : "",
    "own-height": (((U = R.json.height) == null ? void 0 : U.type) === "match_parent" || ((S = R.json.height) == null ? void 0 : S.type) === "fixed") && !(((V = (B = (H = o[I]) == null ? void 0 : H.div) == null ? void 0 : B.height) == null ? void 0 : V.type) === "wrap_content" && ((Ee = o[I].div) != null && Ee.height.constrained)),
    animation: ae
  }, ge(), ue(), ee(), ne(), Ie(), Be(), Ue(), te(), Qe(), lt(), ` ${Je ? "" : `${Yt(ai, "Outer").$$render(r, Object.assign({}, { cls: rr("tabs", pi, nt) }, { componentContext: R }, { layoutParams: We }, { customActions: "tabs" }, { parentOf: l }, { parentOfSimpleMode: !0 }, { replaceItems: $t }, Lt), {}, {
    default: () => ` <div class="${ft(pi.tabs__list, !0) + " " + ft(
      gt ? Lr["root_restrict-scroll"] : "",
      !0
    )}" role="tablist"${Hr({
      "--divkit-tabs-title-padding": Gt ? Vi(Gt, Re) : "",
      "--divkit-tabs-font-size": Se(Pe),
      "--divkit-tabs-paddings": Ce,
      "--divkit-tabs-line-height": zt,
      "--divkit-tabs-letter-spacing": Y,
      "--divkit-tabs-active-font-weight": et || "",
      "--divkit-tabs-inactive-font-weight": tt || "",
      "--divkit-tabs-active-font-family": ot || "",
      "--divkit-tabs-inactive-font-family": It || "",
      "--divkit-tabs-active-text-color": De,
      "--divkit-tabs-inactive-text-color": Wt,
      "--divkit-tabs-active-background-color": At,
      "--divkit-tabs-inactive-background-color": kt,
      "--divkit-tabs-border-radius": wt,
      "--divkit-tabs-items-spacing": Xe ? Yr(Xe * 10 / Pe) : "",
      "--divkit-tabs-animation-duration": Ot !== void 0 ? `${Ot}ms` : ""
    })}${j("this", Ae, 0)}><div${j("class", pi["tabs__items-bg"], 0)} aria-hidden="true">${Or(K, (m) => {
      let ie = m.index, L = ie === I;
      return `  ${_e && ie > 0 ? `<span${j("class", pi.tabs__delimitier, 0)}${Hr({
        width: _e.width ? Se(_e.width) : void 0,
        height: _e.height ? Se(_e.height) : void 0
      })}></span>` : ""} <span${j(
        "class",
        rr("tabs__item", pi, {
          selected: L,
          actionable: !!m.title_click_action
        }),
        0
      )}>${ft(m.title)}</span>`;
    })}</div> ${ae === "slide" && St ? `<div${j("class", pi["tabs__tabs-highlighter"], 0)}${j("style", fr(St), 0)}></div>` : ""} <div${j("class", pi["tabs__items-text"], 0)}>${Or(K, (m) => {
      let ie = m.index, L = ie === I;
      return `  ${_e && ie > 0 ? `<img${j("class", pi.tabs__delimitier, 0)} alt="" loading="lazy" decoding="async"${j("src", _e.url, 0)}${Hr({
        width: _e.width ? Se(_e.width) : void 0,
        height: _e.height ? Se(_e.height) : void 0
      })}>` : ""} ${Yt($o, "Actionable").$$render(
        r,
        {
          componentContext: R,
          cls: rr("tabs__item", pi, {
            selected: L,
            actionable: !!m.title_click_action
          }),
          actions: m.title_click_action && !R.fakeElement ? [m.title_click_action].filter(ls) : [],
          attrs: {
            id: `${ht}-tab-${ie}`,
            "aria-controls": `${ht}-panel-${ie}`,
            role: "tab",
            // eslint-disable-next-line no-nested-ternary
            tabindex: L && !R.fakeElement ? m.title_click_action ? void 0 : "0" : "-1",
            "aria-selected": L ? "true" : "false"
          },
          customAction: R.fakeElement ? null : (Te) => Ct(Te, ie)
        },
        {},
        {
          default: () => `${ft(m.title)}`
        }
      )}`;
    })}</div></div> ${fe ? `<div${j("class", pi.tabs__separator, 0)}${j("style", fr(ke), 0)}></div>` : ""} <div class="${ft(pi.tabs__panels, !0) + " " + ft(
      gt ? Lr["root_restrict-scroll"] : "",
      !0
    )}"${j("this", qe, 0)}><div${j(
      "class",
      rr("tabs__swiper", pi, {
        inited: b,
        animated: Nt
      }),
      0
    )}${j("this", it, 0)}>${Or(K, (m) => {
      let ie = m.index, L = Ve[ie];
      return `  <div${j("class", rr("tabs__panel", pi, { visible: bt[ie] }), 0)} role="tabpanel" id="${ft(ht, !0) + "-panel-" + ft(ie, !0)}" aria-labelledby="${ft(ht, !0) + "-tab-" + ft(ie, !0)}" style="${"left: " + ft(ie * 100, !0) + "%"}">${L ? `${Yt(Fd, "EnabledContext").$$render(
        r,
        {
          componentContext: L,
          layoutParams: He,
          enabled: ie === I
        },
        {},
        {}
      )}` : ""} </div>`;
    })}</div></div>`
  })}`}`;
}), Dd = "appkit-state", Td = "appkit-state_overflow_visible", Md = "appkit-state__animations", ln = {
  state: Dd,
  state_overflow_visible: Td,
  state__animations: Md,
  "state__animation-child": "appkit-state__animation-child",
  "state__animation-child-inner": "appkit-state__animation-child-inner"
};
function Pd(r) {
  return r < 0.5 ? 4 * r * r * r : 0.5 * Math.pow(2 * r - 2, 3) + 1;
}
function zd(r) {
  return r * r * r;
}
function Od(r) {
  const t = r - 1;
  return t * t * t + 1;
}
function Za(r) {
  return (t) => {
    if (t <= 0)
      return 0;
    if (t >= 1)
      return 1;
    const e = t * r.length, i = Math.floor(e), n = r[i], o = r[i + 1], l = e - i;
    return n * l + o * (1 - l);
  };
}
const Nd = [
  21e-4,
  45e-4,
  71e-4,
  0.01,
  0.0131,
  0.0165,
  0.0202,
  0.0242,
  0.0284,
  0.033,
  0.0378,
  0.0429,
  0.0483,
  0.054,
  0.0601,
  0.0664,
  0.0731,
  0.08,
  0.0872,
  0.0948,
  0.1026,
  0.1108,
  0.1192,
  0.1279,
  0.1369,
  0.1461,
  0.1556,
  0.1653,
  0.1753,
  0.1855,
  0.1958,
  0.2064,
  0.2171,
  0.2279,
  0.2389,
  0.25,
  0.2612,
  0.2725,
  0.2839,
  0.2952,
  0.3067,
  0.3181,
  0.3295,
  0.341,
  0.3524,
  0.3637,
  0.375,
  0.3863,
  0.3974,
  0.4085,
  0.4195,
  0.4304,
  0.4412,
  0.4519,
  0.4624,
  0.4729,
  0.4832,
  0.4934,
  0.5034,
  0.5133,
  0.5231,
  0.5327,
  0.5422,
  0.5516,
  0.5608,
  0.5699,
  0.5788,
  0.5876,
  0.5963,
  0.6048,
  0.6132,
  0.6214,
  0.6295,
  0.6375,
  0.6453,
  0.653,
  0.6606,
  0.668,
  0.6754,
  0.6825,
  0.6896,
  0.6965,
  0.7034,
  0.7101,
  0.7166,
  0.7231,
  0.7295,
  0.7357,
  0.7418,
  0.7479,
  0.7538,
  0.7596,
  0.7653,
  0.7709,
  0.7764,
  0.7818,
  0.7871,
  0.7923,
  0.7974,
  0.8024,
  0.8073,
  0.8122,
  0.8169,
  0.8216,
  0.8261,
  0.8306,
  0.835,
  0.8394,
  0.8436,
  0.8478,
  0.8518,
  0.8558,
  0.8598,
  0.8636,
  0.8674,
  0.8711,
  0.8747,
  0.8783,
  0.8818,
  0.8852,
  0.8886,
  0.8919,
  0.8951,
  0.8983,
  0.9014,
  0.9044,
  0.9074,
  0.9103,
  0.9131,
  0.9159,
  0.9187,
  0.9213,
  0.924,
  0.9265,
  0.929,
  0.9315,
  0.9339,
  0.9362,
  0.9385,
  0.9408,
  0.943,
  0.9451,
  0.9472,
  0.9492,
  0.9512,
  0.9532,
  0.9551,
  0.9569,
  0.9587,
  0.9605,
  0.9622,
  0.9638,
  0.9655,
  0.967,
  0.9686,
  0.9701,
  0.9715,
  0.9729,
  0.9743,
  0.9756,
  0.9769,
  0.9782,
  0.9794,
  0.9805,
  0.9817,
  0.9828,
  0.9838,
  0.9848,
  0.9858,
  0.9868,
  0.9877,
  0.9886,
  0.9894,
  0.9902,
  0.991,
  0.9917,
  0.9924,
  0.9931,
  0.9937,
  0.9943,
  0.9949,
  0.9954,
  0.9959,
  0.9964,
  0.9969,
  0.9973,
  0.9977,
  0.998,
  0.9983,
  0.9986,
  0.9989,
  0.9991,
  0.9993,
  0.9995,
  0.9997,
  0.9998,
  0.9999,
  0.9999,
  1,
  1
], Rd = Za(Nd), Bd = [
  5e-4,
  2e-3,
  45e-4,
  78e-4,
  0.0119,
  0.0168,
  0.0224,
  0.0286,
  0.0355,
  0.0429,
  0.0508,
  0.0592,
  0.0681,
  0.0774,
  0.087,
  0.0969,
  0.1072,
  0.1177,
  0.1285,
  0.1395,
  0.1507,
  0.1621,
  0.1736,
  0.1853,
  0.197,
  0.2089,
  0.2208,
  0.2328,
  0.2448,
  0.2569,
  0.2689,
  0.281,
  0.293,
  0.305,
  0.317,
  0.3289,
  0.3408,
  0.3526,
  0.3644,
  0.376,
  0.3876,
  0.3991,
  0.4105,
  0.4218,
  0.433,
  0.444,
  0.455,
  0.4658,
  0.4765,
  0.4871,
  0.4975,
  0.5078,
  0.518,
  0.528,
  0.5379,
  0.5477,
  0.5573,
  0.5668,
  0.5761,
  0.5853,
  0.5944,
  0.6033,
  0.612,
  0.6206,
  0.6291,
  0.6374,
  0.6456,
  0.6537,
  0.6616,
  0.6693,
  0.677,
  0.6845,
  0.6918,
  0.699,
  0.7061,
  0.713,
  0.7199,
  0.7265,
  0.7331,
  0.7395,
  0.7458,
  0.752,
  0.758,
  0.764,
  0.7698,
  0.7755,
  0.781,
  0.7865,
  0.7918,
  0.7971,
  0.8022,
  0.8072,
  0.8121,
  0.8169,
  0.8216,
  0.8262,
  0.8307,
  0.8351,
  0.8394,
  0.8436,
  0.8477,
  0.8517,
  0.8557,
  0.8595,
  0.8633,
  0.8669,
  0.8705,
  0.874,
  0.8775,
  0.8808,
  0.8841,
  0.8873,
  0.8904,
  0.8934,
  0.8964,
  0.8993,
  0.9022,
  0.9049,
  0.9076,
  0.9103,
  0.9129,
  0.9154,
  0.9178,
  0.9202,
  0.9226,
  0.9249,
  0.9271,
  0.9293,
  0.9314,
  0.9335,
  0.9355,
  0.9375,
  0.9394,
  0.9413,
  0.9431,
  0.9449,
  0.9466,
  0.9483,
  0.95,
  0.9516,
  0.9532,
  0.9547,
  0.9562,
  0.9576,
  0.9591,
  0.9605,
  0.9618,
  0.9631,
  0.9644,
  0.9657,
  0.9669,
  0.9681,
  0.9692,
  0.9703,
  0.9714,
  0.9725,
  0.9736,
  0.9746,
  0.9756,
  0.9765,
  0.9775,
  0.9784,
  0.9793,
  0.9802,
  0.981,
  0.9818,
  0.9826,
  0.9834,
  0.9842,
  0.9849,
  0.9856,
  0.9863,
  0.987,
  0.9877,
  0.9883,
  0.989,
  0.9896,
  0.9902,
  0.9908,
  0.9913,
  0.9919,
  0.9924,
  0.993,
  0.9935,
  0.994,
  0.9944,
  0.9949,
  0.9954,
  0.9958,
  0.9963,
  0.9967,
  0.9971,
  0.9975,
  0.9979,
  0.9983,
  0.9986,
  0.999,
  0.9993,
  0.9997,
  1
], Ld = Za(Bd), Hd = {
  linear: xl,
  ease: Rd,
  ease_in: zd,
  ease_out: Od,
  ease_in_out: Pd,
  spring: Ld
};
function Wd(r) {
  return Hd[r];
}
function Cn(r, t, e) {
  return r * (1 - e) + t * e;
}
const Ud = xr((r, t, e, i) => {
  let n, o, l, c, d, f, h, C, T, P, z = E, G = () => (z(), z = $(l, (J) => P = J), l), { componentContext: I } = t, { layoutParams: F = void 0 } = t;
  const ke = kr(Wr);
  let K = !1, ge, Q = /* @__PURE__ */ new Map(), ue = /* @__PURE__ */ new Set(), oe = [], ye = [], ee = [], be = [], $e, ne, Ne, Ie = !1, Me;
  function Re() {
    Ie = !1;
  }
  function Be(J) {
    Ne && Ne.destroy(), Ne = J != null && J.div ? I.produceChildContext(J.div, {
      path: J.state_id || "<unknown>"
    }) : void 0;
  }
  function Fe(J) {
    const te = I.json.states;
    if (!te)
      return;
    const de = /* @__PURE__ */ new Set();
    h = te.map((fe, Qe) => (h[Qe].div !== J[Qe] && fe.state_id && de.add(fe.state_id), { ...fe, div: J[Qe] })), I.json = { ...I.json, states: h }, ne && de.has(ne) && Be(h.find((fe) => fe.state_id === ne) || null);
  }
  async function Ue(J) {
    if (ne === J)
      return I;
    ke.setRunning("stateChange", !0), new Set(ue), oe.forEach((de) => {
      de.resolvePromise && de.resolvePromise();
    }), oe = [], be.forEach((de) => {
      de.transitions && Q.set(de.id, {
        transitions: de.transitions,
        rect: de.node.getBoundingClientRect()
      });
    }), ye = [], ee = [], be = [];
    const te = h.find((de) => de.state_id === J) || null;
    te ? (ne = J, d == null || d.setValue(ne), Be(te)) : I.logError(x(new Error("Cannot find state with id"), { additional: { stateId: J } })), await $i();
  }
  Yi(as, {
    // eslint-disable-next-line max-params
    runVisibilityTransition(J, te, de, fe, Qe, Ge) {
      return Promise.resolve();
    },
    registerChildWithTransitionIn(J, te, de, fe) {
      const Qe = {
        json: J,
        parentComponentContext: te,
        transitions: de,
        node: fe
      };
      return ye.push(Qe), new Promise((Ge) => {
        Qe.resolvePromise = Ge;
      });
    },
    registerChildWithTransitionOut(J, te, de, fe) {
      const Qe = {
        json: J,
        parentComponentContext: te,
        transitions: de,
        node: fe
      };
      return ee.push(Qe), new Promise((Ge) => {
        Qe.resolvePromise = Ge;
      });
    },
    registerChildWithTransitionChange(J, te, de, fe) {
      const Qe = te.id;
      if (!Qe)
        return Promise.resolve();
      const Ge = {
        id: Qe,
        json: J,
        parentComponentContext: te,
        transitions: de,
        node: fe
      };
      return be.push(Ge), new Promise((gt) => {
        Ge.resolvePromise = gt;
      });
    },
    hasTransitionChange(J) {
      return J ? Q.has(J) : !1;
    },
    registerChild(J) {
      ue.add(J);
    },
    unregisterChild(J) {
      ue.delete(J);
    }
  });
  function xe(J) {
    if (!Ie && (Ie = !0, J.length)) {
      const te = (d == null ? void 0 : d.getValue()) || o;
      if (te) {
        ne = te;
        const de = J.find((fe) => fe.state_id === ne) || null;
        Be(de), de || I.logError(x(new Error("Cannot find state for default_state_id"), { additional: { selectedId: ne } }));
      } else {
        const de = J[0];
        ne = de.state_id, Be(de);
      }
      d && (d.setValue(ne), d.subscribe((de) => {
        Ue(de);
      }));
    }
  }
  return Kr(() => {
    Ne && Ne.destroy(), $e && ($e(), $e = void 0);
  }), t.componentContext === void 0 && e.componentContext && I !== void 0 && e.componentContext(I), t.layoutParams === void 0 && e.layoutParams && F !== void 0 && e.layoutParams(F), n = I.json.div_id || I.id, o = I.getJsonWithVars(I.json.default_state_id), G(l = I.getDerivedFromVars(I.json.clip_to_bounds)), c = I.json.state_id_variable, d = c ? I.getVariable(c, "string") || ke.awaitGlobalVariable(c, "string", "") : null, f = I.origJson, f && Re(), n ? K = !1 : (K = !0, I.logError(x(new Error('Missing "id" prop for div "state"')))), I.json && (ue = /* @__PURE__ */ new Set()), h = Array.isArray(I.json.states) && I.json.states || [], C = h.map((J) => {
    var te;
    return { json: J.div, id: (te = J.div) == null ? void 0 : te.id };
  }), h != null && h.length ? K = !1 : (K = !0, I.logError(x(new Error('Empty "states" prop for div "state"')))), I.json && ($e && ($e(), $e = void 0), n && !(I != null && I.fakeElement) && ($e = I.registerState(n, Ue))), !Ie && xe(h), T = {
    overflow: P === !1 || P === 0 ? "visible" : void 0
  }, z(), `${K ? "" : `${Yt(ai, "Outer").$$render(r, Object.assign({}, { cls: rr("state", ln, T) }, { componentContext: I }, { layoutParams: F }, { parentOf: C }, { parentOfSimpleMode: !0 }, { replaceItems: Fe }, Me), {}, {
    default: () => ` ${Ne ? `${Yt(yi, "Unknown").$$render(
      r,
      {
        componentContext: Ne
      },
      {},
      {}
    )}` : ""} <div${j("class", ln.state__animations, 0)} aria-hidden="true"${j("this", ge, 0)}>${Or(oe, (J) => `${"direction" in J ? `<div${j("class", ln["state__animation-child"], 0)}${Hr({
      left: `${J.offsetLeft}px`,
      top: `${J.offsetTop}px`,
      width: `${J.width}px`,
      height: `${J.height}px`
    })}><div${j("class", ln["state__animation-child-inner"], 0)}>${Yt(yi, "Unknown").$$render(
      r,
      {
        componentContext: J.componentContextCopy
      },
      {},
      {}
    )}</div> </div>` : `<div${j("class", ln["state__animation-child"], 0)}><div${j("class", ln["state__animation-child-inner"], 0)}>${Yt(yi, "Unknown").$$render(
      r,
      {
        componentContext: J.componentContextCopy
      },
      {},
      {}
    )}</div> </div>`}`)}</div>`
  })}`}`;
}), Gd = "appkit-pager", qd = "appkit-pager__items", Jd = "appkit-pager_animated", Yd = "appkit-pager__item", Kd = "appkit-pager_clip", Xd = "appkit-pager_orientation_horizontal", Zd = "appkit-pager_orientation_vertical", Qd = "appkit-pager__item_height_content", ef = "appkit-pager__item_height_fixed", tf = "appkit-pager__item_width_content", rf = "appkit-pager__item_width_fixed", nf = "appkit-pager__arrow", qi = {
  pager: Gd,
  pager__items: qd,
  pager_animated: Jd,
  pager__item: Yd,
  "pager_scroll-align_start": "appkit-pager_scroll-align_start",
  "pager_scroll-align_center": "appkit-pager_scroll-align_center",
  "pager_scroll-align_end": "appkit-pager_scroll-align_end",
  pager_clip: Kd,
  pager_orientation_horizontal: Xd,
  pager_orientation_vertical: Zd,
  "pager_cross-align_center": "appkit-pager_cross-align_center",
  "pager_cross-align_end": "appkit-pager_cross-align_end",
  pager__item_height_content: Qd,
  pager__item_height_fixed: ef,
  "pager__item_height-constrained": "appkit-pager__item_height-constrained",
  pager__item_width_content: tf,
  pager__item_width_fixed: rf,
  "pager__item_width-constrained": "appkit-pager__item_width-constrained",
  pager__arrow: nf,
  "pager__arrow-icon-path": "appkit-pager__arrow-icon-path"
}, zn = {
  wrap_content: "content",
  fixed: "fixed",
  match_parent: "parent"
}, Di = 2;
function of(r, t) {
  var i, n, o, l;
  if (r === "horizontal") {
    const c = ((i = t.height) == null ? void 0 : i.type) || "";
    return {
      height: c in zn ? zn[c] : "content",
      "height-constrained": ((n = t.height) == null ? void 0 : n.type) === "wrap_content" ? ri(t.height.constrained, !1) : !1
    };
  }
  const e = ((o = t.width) == null ? void 0 : o.type) || "";
  return {
    width: e in zn ? zn[e] : "parent",
    "width-constrained": ((l = t.width) == null ? void 0 : l.type) === "wrap_content" ? ri(t.width.constrained, !1) : !1
  };
}
const sf = xr((r, t, e, i) => {
  var er, ir, nr, tr, qt;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee, be = E, $e = () => (be(), be = $(C, (U) => ee = U), C), ne, Ne = E, Ie = () => (Ne(), Ne = $(l, (U) => ne = U), l), Me, Re = E, Be = () => (Re(), Re = $(T, (U) => Me = U), T), Fe, Ue = E, xe = () => (Ue(), Ue = $(f, (U) => Fe = U), f), J, te = E, de = () => (te(), te = $(d, (U) => J = U), d), fe, Qe = E, Ge = () => (Qe(), Qe = $(c, (U) => fe = U), c), gt, lt = E, pt = () => (lt(), lt = $(tt, (U) => gt = U), tt), R, We = E, pe = () => (We(), We = $(o, (U) => R = U), o), Le, ht = E, xt = () => (ht(), ht = $(P, (U) => Le = U), P), Je, Ke = E, He = () => (Ke(), Ke = $(h, (U) => Je = U), h), { componentContext: Ae } = t, { layoutParams: qe = void 0 } = t;
  const it = kr(Wr), nt = it.direction;
  ue = $(nt, (U) => Q = U);
  const Pe = it.genId("pager"), Ce = it.getCustomization("pagerLeftClass"), zt = it.getCustomization("pagerRightClass"), Y = it.isDesktop;
  ye = $(Y, (U) => oe = U);
  let wt, et, ot = !1, tt, It = 0, De = 0, Wt = !1, At = "horizontal", kt = "0em", Xe = {}, re = "", ct = "", Gt = {}, b = "start", Nt = "center", se = [], Ve = 0, bt = [], ve = {}, _e = {}, ae, Ot, St = !1, Vt = !1, Lt = !1, _t = "";
  function $t() {
    Xe = {}, Gt = {}, b = "start", Nt = "center", St = !1, Vt = !1;
  }
  function yt(U) {
    Ae = ae = {
      ...Ae,
      json: {
        ...Ae.json,
        items: U.filter(Fi)
      }
    };
  }
  function Dt(U, S) {
    Ot && Ot.update({
      instId: Pe,
      currentItem: _e[S],
      size: U,
      scrollToPagerItem(H) {
        Ut(ve[H]);
      }
    });
  }
  function Ct(U) {
    var H;
    if (U === De || (De = U, !se[U]))
      return;
    const S = (H = se[U].json) == null ? void 0 : H.selected_actions;
    S != null && S.length && Ae.execAnyActions(S);
  }
  function Xt(U, S) {
  }
  function Ut(U, S = !0) {
    var H;
    (H = _e[U]) != null;
  }
  function jt(U, S) {
    return Vt && U >= -Di && U < Ve + Di ? U : U > bt.length - 1 ? S === "ring" ? Ai(U, bt.length) : bt.length - 1 : U < 0 ? S === "ring" ? Ai(U, bt.length) : 0 : U;
  }
  function Ht(U, S, H) {
    jt(_e[It] - U, S);
  }
  function Rt(U, S, H) {
    jt(_e[It] + U, S);
  }
  function mt() {
    Ot == null || Ot.destroy(), Ot = void 0, wt && (it.unregisterInstance(wt), wt = void 0), Ae.fakeElement || (Ot = Ae.registerPager(Ae.id || void 0)), Ae.id && !Ae.fakeElement && (wt = Ae.id, it.registerInstance(
      wt,
      {
        setCurrentItem(U, S) {
          if (U < 0 || U > se.length - 1)
            throw new Error('Item is out of range in "set-current-item" action');
          Ut(U, S);
        },
        setPreviousItem: Ht,
        setNextItem: Rt,
        scrollToStart(U) {
          Ut(bt[Vt ? Di : 0].index, U);
        },
        scrollToEnd(U) {
          Ut(bt[bt.length - 1 - (Vt ? Di : 0)].index, U);
        },
        scrollCombined({ step: U, overflow: S, animated: H }) {
          U && Ut(jt(_e[It] + U, S || "clamp"), H);
        }
      },
      "warn"
    ));
  }
  function Ze() {
    $i().then(() => {
      Ut(It, !1);
    });
  }
  Kr(() => {
    ot = !1, se.forEach((U) => {
      U.destroy();
    }), wt && (it.unregisterInstance(wt), wt = void 0), Ot == null || Ot.destroy(), Ot = void 0;
  }), t.componentContext === void 0 && e.componentContext && Ae !== void 0 && e.componentContext(Ae), t.layoutParams === void 0 && e.layoutParams && qe !== void 0 && e.layoutParams(qe), n = Ae.origJson, n && $t(), pe(o = typeof ((er = Ae.json.item_builder) == null ? void 0 : er.data) == "string" ? Ae.getDerivedFromVars((ir = Ae.json.item_builder) == null ? void 0 : ir.data, void 0, !0) : (nr = Ae.json.item_builder) != null && nr.data ? Ki(Ae.json.item_builder.data) : void 0), Ie(l = Ae.getDerivedFromVars(Ae.json.layout_mode)), Ge(c = Ae.getDerivedFromVars(Ae.json.orientation)), de(d = Ae.getDerivedFromVars(Ae.json.item_spacing)), xe(f = Ae.getDerivedFromVars(Ae.json.paddings)), He(h = Ae.getDerivedFromVars(Ae.json.restrict_parent_scroll)), $e(C = Ae.getDerivedFromVars(Ae.json.cross_axis_alignment)), Be(T = Ae.getDerivedFromVars(Ae.json.scroll_axis_alignment)), xt(P = Ae.getDerivedFromVars(Ae.json.infinite_scroll)), St = ri(Le, St);
  {
    let U = [];
    if (Ae.json.item_builder && Array.isArray(R) && Array.isArray(Ae.json.item_builder.prototypes)) {
      const V = Ae.json.item_builder;
      U = fs(R, it, Ae, V);
    } else
      U = (Array.isArray(Ae.json.items) && Ae.json.items || []).map((V, Ee) => ({
        div: V,
        key: V.id || { index: Ee, data: V }
      }));
    const S = new Set(se), H = /* @__PURE__ */ new Map();
    let B = !1;
    ae === Ae && se.forEach((V) => {
      V.key && (typeof V.key == "string" && H.has(V.key) ? B || (B = !0, Ae.logError(x(new Error("Duplicate key for child elements inside item_builder"), { additional: { key: V.key } }))) : H.set(
        typeof V.key == "string" ? V.key : V.key.index,
        V
      ));
    }), se = U.map((V, Ee) => {
      let m = !B && H.get(V.id), ie = H.get(Ee);
      return !m && !V.id && typeof V.key == "object" && typeof (ie == null ? void 0 : ie.key) == "object" && bn(ie.key.data, V.key.data) && (m = ie), m ? (S.delete(m), m) : Ae.produceChildContext(V.div, {
        path: Ee,
        variables: V.vars,
        id: V.id,
        key: V.key
      });
    });
    for (const V of S)
      V.destroy();
    ae = Ae;
  }
  {
    let U = [];
    se.forEach((S) => {
      U.push(Ae.getDerivedFromVars({
        width: S.json.width,
        height: S.json.height,
        visibility: S.json.visibility
      }));
    }), pt(tt = vn(U, (S) => [...S]));
  }
  {
    if (_e = {}, ve = {}, bt = gt.map((U, S) => ({
      width: U.width,
      height: U.height,
      index: S,
      componentContext: se[S]
    })).filter((U, S) => gt[S].visibility !== "gone"), bt.forEach((U, S) => {
      ve[S] = U.index, _e[U.index] = S;
    }), Ve = bt.length, St && bt.length >= Di) {
      const U = bt.slice(0, Di).map((H) => ({
        ...H,
        componentContext: H.componentContext.dup(hn),
        duplicate: !0
      })), S = bt.slice(bt.length - Di).map((H) => ({
        ...H,
        componentContext: H.componentContext.dup(hn),
        duplicate: !0
      }));
      U.forEach((H, B) => {
        ve[bt.length + B] = B;
      }), S.forEach((H, B) => {
        ve[B - Di] = bt.length - Di + B;
      }), bt = [].concat(S, bt, U), Vt = !0;
    } else
      Vt = !1;
    Ze();
  }
  ne ? ne.type !== "percentage" && ne.type !== "fixed" && ne.type !== "wrap_content" ? (Wt = !0, Ae.logError(x(new Error('Incorrect value of "layout_mode.type" for div "pager"')))) : Wt = !1 : (Wt = !0, Ae.logError(x(new Error('Empty "layout_mode" prop for div "pager"')))), At = gs(fe, At);
  {
    const U = J == null ? void 0 : J.value;
    U && si(U) && (kt = Yr(U || 0));
  }
  Xe = yn(Fe, Xe), re = Vi(Xe, Q), z = At === "horizontal" ? "grid-auto-columns" : "grid-auto-rows", (Me === "start" || Me === "center" || Me === "end") && (Nt = Me, Ze());
  {
    const U = Yr(At === "horizontal" ? (Xe == null ? void 0 : Xe.start) || (Q === "ltr" ? Xe == null ? void 0 : Xe.left : Xe == null ? void 0 : Xe.right) || 0 : (Xe == null ? void 0 : Xe.top) || 0), S = Yr(At === "horizontal" ? (Xe == null ? void 0 : Xe.end) || (Q === "ltr" ? Xe == null ? void 0 : Xe.right : Xe == null ? void 0 : Xe.left) || 0 : (Xe == null ? void 0 : Xe.bottom) || 0);
    if ((ne == null ? void 0 : ne.type) === "fixed") {
      const H = ((tr = ne.neighbour_page_width) == null ? void 0 : tr.value) || 0;
      Nt === "center" ? ct = `calc(100% + ${U} + ${S} - 2 * ${Yr(H)} - 2 * ${kt})` : Nt === "start" ? ct = `calc(100% + ${S} - ${Yr(H)} - ${kt})` : ct = `calc(100% + ${U} - ${Yr(H)} - ${kt})`;
    } else if ((ne == null ? void 0 : ne.type) === "percentage") {
      let H = (qt = ne.page_width) == null ? void 0 : qt.value;
      (typeof H != "number" || H < 0) && (H = 100), ct = `calc(${(H / 100).toFixed(2)} * (100% + ${U} + ${S}))`;
    } else
      (ne == null ? void 0 : ne.type) === "wrap_content" && (ct = "minmax(max-content, auto)");
  }
  if ((ee === "start" || ee === "center" || ee === "end") && (b = ee, Gt = {
    [At === "horizontal" ? "parentVAlign" : "parentHAlign"]: b
  }), G = {
    "grid-gap": kt,
    padding: re,
    [z]: ct,
    transform: _t
  }, I = {
    animated: Lt,
    clip: it.pagerChildrenClipEnabled,
    orientation: At,
    "cross-align": b,
    "scroll-align": Nt
  }, F = Wt, ke = oe && ot && !F, Ae.json) {
    const U = Ae.getJsonWithVars(Ae.json.default_item);
    typeof U == "number" && U >= 0 && U < se.length && (It = De = U, Dt(se.length, U)), mt();
  }
  return K = Vt || (Q === "ltr" ? _e[It] > 0 : _e[It] + 1 < bt.length), ge = Vt || (Q === "ltr" ? _e[It] + 1 < bt.length : _e[It] > 0), Dt(Ve, It), Ct(It), ue(), ye(), be(), Ne(), Re(), Ue(), te(), Qe(), lt(), We(), ht(), Ke(), ` ${F ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("pager", qi, I),
      componentContext: Ae,
      layoutParams: qe,
      customPaddings: !0,
      parentOf: se,
      replaceItems: yt
    },
    {},
    {
      default: () => `  <div class="${ft(qi.pager__items, !0) + " " + ft(
        Je ? Lr["root_restrict-scroll"] : "",
        !0
      )}"${j("style", fr(G), 0)}${j("this", et, 0)}>${Or(bt, (U) => `<div${j("class", rr("pager__item", qi, of(At, U)), 0)} role="tabpanel" id="${ft(Pe, !0) + "-panel-" + ft(U.index, !0)}" aria-labelledby="${ft(Pe, !0) + "-tab-" + ft(U.index, !0)}">${Yt(yi, "Unknown").$$render(
        r,
        {
          componentContext: U.componentContext,
          layoutParams: Gt
        },
        {},
        {}
      )} </div>`)}</div> ${K && ke ? `  <div${j("class", Ce || `${qi.pager__arrow} ${an.arrow} ${an.arrow_left}`, 0)}>${Ce ? "" : `<svg${j("class", an.arrow__icon, 0)} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path${j("class", qi["pager__arrow-icon-path"], 0)} d="m10 16 8.3 8 1.03-1-4-6-.7-1 .7-1 4-6-1.03-1z"></path></svg>`}</div>` : ""} ${ge && ke ? `  <div${j("class", zt || `${qi.pager__arrow} ${an.arrow} ${an.arrow_right}`, 0)}>${zt ? "" : `<svg${j("class", an.arrow__icon, 0)} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path${j("class", qi["pager__arrow-icon-path"], 0)} d="M22 16l-8.3 8-1.03-1 4-6 .7-1-.7-1-4-6 1.03-1 8.3 8z"></path></svg>`}</div>` : ""}`
    }
  )}`}`;
}), af = "appkit-indicator", lf = "appkit-indicator_visible", cf = "appkit-indicator__scroller", uf = "appkit-indicator__items", df = "appkit-indicator__item", ff = "appkit-indicator_placement_default", gf = "appkit-indicator__item_active", pf = "appkit-indicator_direction_ltr", hf = "appkit-indicator_direction_rtl", _f = "appkit-indicator_placement_stretch", On = {
  indicator: af,
  indicator_visible: lf,
  indicator__scroller: cf,
  indicator__items: uf,
  indicator__item: df,
  indicator_placement_default: ff,
  indicator__item_active: gf,
  indicator_direction_ltr: pf,
  indicator_direction_rtl: hf,
  indicator_placement_stretch: _f
}, Mo = ["rounded_rectangle", "circle"], mf = xr((r, t, e, i) => {
  var nt, Pe;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F = E, ke = () => (F(), F = $(C, (Ce) => I = Ce), C), K, ge = E, Q = () => (ge(), ge = $(T, (Ce) => K = Ce), T), ue, oe = E, ye = () => (oe(), oe = $(l, (Ce) => ue = Ce), l), ee, be = E, $e = () => (be(), be = $(c, (Ce) => ee = Ce), c), ne, Ne = E, Ie = () => (Ne(), Ne = $(o, (Ce) => ne = Ce), o), Me, Re = E, Be = () => (Re(), Re = $(d, (Ce) => Me = Ce), d), Fe, Ue = E, xe = () => (Ue(), Ue = $(h, (Ce) => Fe = Ce), h), J, te = E, de = () => (te(), te = $(f, (Ce) => J = Ce), f), { componentContext: fe } = t, { layoutParams: Qe = void 0 } = t;
  const gt = kr(Wr).direction;
  G = $(gt, (Ce) => z = Ce);
  let lt = {
    width: 13,
    height: 13,
    borderRadius: 6.5,
    background: "#ffdc60"
  }, pt = {
    width: 10,
    height: 10,
    borderRadius: 5,
    background: "#33919cb5"
  }, R = "default", We = 15, pe = 10, Le = 5, ht, xt, Je, Ke, He = !1;
  function Ae() {
    R = "default", We = 15, pe = 10, Le = 5, lt = {
      width: 13,
      height: 13,
      borderRadius: 6.5,
      background: "#ffdc60"
    }, pt = {
      width: 10,
      height: 10,
      borderRadius: 5,
      background: "#33919cb5"
    };
  }
  async function qe(Ce) {
    Je = Ce, await $i();
  }
  function it() {
    Ke == null || Ke(), Ke = void 0;
    const Ce = fe.json.pager_id;
    Ke = fe.listenPager(Ce, qe);
  }
  if (Kr(() => {
    He = !1, Ke == null || Ke(), Ke = void 0;
  }), t.componentContext === void 0 && e.componentContext && fe !== void 0 && e.componentContext(fe), t.layoutParams === void 0 && e.layoutParams && Qe !== void 0 && e.layoutParams(Qe), n = fe.origJson, n && Ae(), n && He && it(), Ie(o = fe.getDerivedFromVars(fe.json.shape)), ye(l = fe.getDerivedFromVars(fe.json.active_item_color)), $e(c = fe.getDerivedFromVars(fe.json.inactive_item_color)), Be(d = fe.getDerivedFromVars(fe.json.active_item_size)), de(f = fe.getDerivedFromVars(fe.json.active_shape)), xe(h = fe.getDerivedFromVars(fe.json.inactive_shape)), ke(C = fe.getDerivedFromVars(fe.json.space_between_centers)), Q(T = fe.getDerivedFromVars(fe.json.items_placement)), J && (lt = bi(
    {
      type: "shape_drawable",
      shape: J
    },
    Mo,
    lt
  )), Fe && (pt = bi(
    {
      type: "shape_drawable",
      shape: Fe
    },
    Mo,
    pt
  )), !J && !Fe && ne) {
    const Ce = fi(Me, 1.3);
    pt = bi(
      {
        type: "shape_drawable",
        shape: ne,
        color: pt.background
      },
      Mo,
      pt
    ), pt.background = lr(ee, 1, pt.background), lt = {
      ...pt,
      width: pt.width * Ce,
      height: pt.height * Ce,
      borderRadius: pt.borderRadius * Ce,
      background: lt.background
    }, lt.background = lr(ue, 1, lt.background);
  }
  if (K && (K.type === "default" || K.type === "stretch")) {
    if (R = K.type, R === "default")
      We = wr((nt = K.space_between_centers) == null ? void 0 : nt.value, We);
    else if (R === "stretch") {
      const Ce = K;
      pe = fi(Ce.max_visible_items, pe), Le = wr((Pe = Ce.item_spacing) == null ? void 0 : Pe.value, Le);
    }
  } else
    R = "default", I && (We = wr(I.value, We));
  return P = {
    placement: R,
    direction: z,
    visible: (Je == null ? void 0 : Je.size) > 1
  }, G(), F(), ge(), oe(), be(), Ne(), Re(), Ue(), te(), `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("indicator", On, P),
      componentContext: fe,
      layoutParams: Qe
    },
    {},
    {
      default: () => `<div${j("class", On.indicator__scroller, 0)}${j("this", ht, 0)}><div${j("class", On.indicator__items, 0)} role="tablist"${Hr({
        margin: R === "default" ? `0 ${Se(Math.max(0, lt.width - pt.width) / 2)}` : "",
        "--divkit-indicator-inactive-width": Se(pt.width),
        "--divkit-indicator-inactive-height": Se(pt.height),
        "--divkit-indicator-inactive-border-radius": Se(pt.borderRadius),
        "--divkit-indicator-inactive-background": pt.background || "",
        "--divkit-indicator-inactive-box-shadow": pt.boxShadow || "",
        "--divkit-indicator-active-width": Se(lt.width),
        "--divkit-indicator-active-height": Se(lt.height),
        "--divkit-indicator-active-border-radius": Se(lt.borderRadius),
        "--divkit-indicator-active-background": lt.background || "",
        "--divkit-indicator-active-box-shadow": lt.boxShadow || "",
        "--divkit-indicator-active-scale": lt.width / pt.width,
        "--divkit-indicator-default-margin": R === "default" ? `0 ${Se((We - pt.width) / 2)}` : "",
        "--divkit-indicator-stretch-margin": R === "stretch" ? Se(Le) : "",
        "--divkit-indicator-stretch-max-count": R === "stretch" ? pe : "",
        "--divkit-indicator-stretch-max-spacer": R === "stretch" ? Se((pe - 1) * Le) : ""
      })}${j("this", xt, 0)}>${Je ? `${Or(Array(Je.size), (Ce, zt) => {
        let Y = zt === Je.currentItem;
        return ` <div class="${ft(rr("indicator__item", On, { active: Y }), !0) + " " + ft(Lr.root__clickable, !0)}" role="tab" id="${ft(Je.instId, !0) + "-tab-" + ft(zt, !0)}" aria-controls="${ft(Je.instId, !0) + "-panel-" + ft(zt, !0)}"${j("aria-selected", Y ? "true" : "false", 0)}${j("tabindex", Y ? 0 : -1, 0)}></div>`;
      })}` : ""}</div></div>`
    }
  )}`;
}), vf = "appkit-slider", bf = "appkit-slider__input", yf = "appkit-slider__input_secondary", wf = "appkit-slider__thumb", kf = "appkit-slider_direction_rtl", $f = "appkit-slider__thumb_secondary", jf = "appkit-slider__track", Ef = "appkit-slider__tick", xf = "appkit-slider__tick_active", Af = "appkit-slider__tick_inactive", qr = {
  slider: vf,
  slider__input: bf,
  slider__input_secondary: yf,
  slider__thumb: wf,
  slider_direction_rtl: kf,
  slider__thumb_secondary: $f,
  "slider__tracks-wrapper": "appkit-slider__tracks-wrapper",
  "slider__tracks-inner": "appkit-slider__tracks-inner",
  "slider__tracks-ranges": "appkit-slider__tracks-ranges",
  "slider__tracks-ranges_rtl": "appkit-slider__tracks-ranges_rtl",
  slider__track: jf,
  "slider__thumb-text": "appkit-slider__thumb-text",
  "slider__thumb-text_secondary": "appkit-slider__thumb-text_secondary",
  slider__tick: Ef,
  slider__tick_active: xf,
  slider__tick_inactive: Af
};
function Ys(r, t) {
  var o, l;
  if (!r || !r.font_size)
    return t;
  const e = r.offset, i = r.text_color && lr(r.text_color) || "#000", n = _n(r.font_weight, r.font_weight_value, void 0);
  if (ui(r.font_size) && i !== "transparent") {
    const c = {
      fontSize: Se(r.font_size),
      fontWeight: n,
      textColor: i
    };
    return typeof ((o = e == null ? void 0 : e.x) == null ? void 0 : o.value) == "number" && typeof ((l = e == null ? void 0 : e.y) == null ? void 0 : l.value) == "number" && (c.offset = {
      x: e.x.value,
      y: e.y.value
    }), c;
  }
}
function Ri(r, t, e) {
  return Math.max(t, Math.min(e, Number(r)));
}
function ps(r) {
  return BigInt(r);
}
const Fn = ps("9223372036854775807"), In = ps("-9223372036854775808");
function zr(r) {
  const t = ps(r);
  if (t > Fn || t < In)
    throw new Error("Integer overflow.");
  return t;
}
const Zi = zr(0);
function Qa(r) {
  let t = r;
  return t < 0 && (t = -t), t;
}
function el(r) {
  let t = 0;
  return r > 0 ? t = 1 : r < 0 && (t = -1), zr(t);
}
function hi(r, t) {
  var e;
  switch ((e = t[r.type]) == null || e.call(t, r), r.type) {
    case "TemplateLiteral":
      r.expressions.forEach((i) => {
        hi(i, t);
      });
      break;
    case "BinaryExpression":
    case "LogicalExpression":
      hi(r.left, t), hi(r.right, t);
      break;
    case "UnaryExpression":
      hi(r.argument, t);
      break;
    case "ConditionalExpression":
      hi(r.test, t), hi(r.consequent, t), hi(r.alternate, t);
      break;
    case "TryExpression":
      hi(r.test, t), hi(r.alternate, t);
      break;
    case "CallExpression":
      r.arguments.forEach((i) => {
        hi(i, t);
      });
      break;
    case "MethodExpression":
      hi(r.object, t), r.arguments.forEach((i) => {
        hi(i, t);
      });
      break;
  }
}
const Cf = 2147483647, Sf = -2147483648, Vf = Number.MAX_VALUE, Ff = Number.MIN_VALUE, Z = "string", q = "integer", we = "number", gr = "boolean", Pr = "color", _i = "url", Qt = "datetime", Ft = "dict", Pt = "array";
function ho(r) {
  return r.type === "url" || r.type === "color" ? {
    type: "string",
    value: r.value
  } : r;
}
function tl(r) {
  return r.toISOString().replace("T", " ").replace(/\.\d{3}Z$/, "");
}
function Qi(r, t) {
  if (r.type === "string")
    return r.value;
  if (r.type === "integer")
    return String(r.value);
  if (r.type === "number") {
    let e = String(r.value);
    return e.includes(".") || (e.includes("e") ? e = e.replace("e", ".0e") : e += ".0"), e = e.replace(/e\+?/i, "E"), e;
  } else {
    if (r.type === "boolean")
      return r.value ? "true" : "false";
    if (r.type === "datetime")
      return tl(r.value);
    if (r.type === "color")
      return tn(jo(r.value));
    if (r.type === "url")
      return r.value;
    if ((r.type === "dict" || r.type === "array") && t)
      return JSON.stringify(r.value);
    if (r.type === "dict")
      return "<dict>";
    if (r.type === "array")
      return "<array>";
  }
  throw new Error(`Unexpected type ${r.type}`);
}
function Dr(r) {
  let t = Qi(r, !1);
  return r.type === "string" && (t = "'" + t.replace(/\\/g, "\\\\").replace(/'/g, "\\'") + "'"), t;
}
function gi(r) {
  return r === "datetime" ? "DateTime" : r.charAt(0).toUpperCase() + r.substring(1);
}
function en(r, t) {
  return zr(t);
}
function li(r, t) {
  if (t < In || t > Fn)
    throw new Error("Integer overflow.");
}
function Ei(r) {
  if (typeof r != "string")
    throw new Error("Incorrect url value.");
  try {
    new URL(r);
  } catch {
    throw new Error("Incorrect url value.");
  }
}
function If(r) {
  const t = /* @__PURE__ */ new Set();
  return hi(r, {
    Variable(e) {
      t.add(e.id.name);
    }
  }), [...t];
}
function Tr(r, t) {
  throw new Error(`Failed to evaluate [${r}]. ${t}`);
}
function jo(r) {
  const t = ji(r);
  if (t)
    return t;
  throw new Error("Unable to convert value to Color, expected format #AARRGGBB.");
}
function tn(r) {
  return `#${[r.a, r.r, r.g, r.b].map((t) => {
    if (t < 0 || t > 255)
      throw new Error("Value out of range 0..1.");
    return Ba(Math.round(t).toString(16), 2);
  }).join("").toUpperCase()}`;
}
function Bi(r) {
  return tn(jo(r));
}
function Go(r) {
  return {
    type: we,
    value: Number(r.value)
  };
}
const Df = {
  string: "string",
  number: "number",
  integer: "number",
  boolean: "boolean",
  color: "string",
  url: "string",
  array: "array",
  dict: "object"
};
function hs(r, t, e) {
  const i = Df[e];
  let n = typeof t;
  if (i === "array" && !Array.isArray(t) || i !== "array" && n !== i || n === "object" && t === null)
    throw n === "object" && (Array.isArray(t) ? n = "array" : t === null ? n = "null" : n = "dict"), new Error(`Incorrect value type: expected ${gi(e)}, got ${gi(n)}.`);
  if (i === "number" && e === "integer") {
    r && li(r, t);
    try {
      t = zr(t);
    } catch {
      throw new Error("Cannot convert value to integer.");
    }
  }
  return i === "string" && e === "color" && (t = Bi(t)), i === "string" && e === "url" && Ei(t), i === "boolean" && e === gr && (t = t ? 1 : 0), {
    type: e,
    value: t
  };
}
function Tf(r) {
  return r.type === "number" || r.type === "integer" ? Number(r.value) : r.type === "boolean" ? !!r.value : r.value;
}
function Eo(r) {
  return Tf(
    hs(void 0, r.value, r.type)
  );
}
class Mi {
  constructor(t, e) {
    Er(this, "name");
    Er(this, "value");
    Er(this, "store");
    const i = this.convertValue(e);
    this.name = t, this.value = i;
  }
  getName() {
    return this.name;
  }
  subscribe(t) {
    return this.store || (this.store = Ci(this.value)), this.store.subscribe(t);
  }
  set(t) {
    const e = this.fromString(t);
    this.setValue(e);
  }
  setValue(t) {
    const e = this.convertValue(t);
    this.value = e, this.store && this.store.set(e);
  }
  getValue() {
    return this.value;
  }
}
class rl extends Mi {
  convertValue(t) {
    if (typeof t != "string")
      throw new Error("Incorrect variable value");
    return t;
  }
  fromString(t) {
    return t;
  }
  getType() {
    return "string";
  }
}
class il extends Mi {
  convertValue(t) {
    if (typeof t != "bigint" && typeof t != "number")
      throw new Error("Incorrect variable value");
    try {
      return zr(t);
    } catch {
      throw new Error("Incorrect variable value");
    }
  }
  fromString(t) {
    try {
      return zr(t);
    } catch {
      throw new Error("Incorrect variable value");
    }
  }
  getType() {
    return "integer";
  }
}
class nl extends Mi {
  convertValue(t) {
    if (typeof t != "number" || Number.isNaN(t) || !isFinite(t))
      throw new Error("Incorrect variable value");
    return t;
  }
  fromString(t) {
    const e = Number(t);
    return this.convertValue(e);
  }
  getType() {
    return "number";
  }
}
class ol extends Mi {
  convertValue(t) {
    if (t !== 1 && t !== 0 && t !== !0 && t !== !1)
      throw new Error("Incorrect variable value");
    return !!t;
  }
  fromString(t) {
    if (t === "1" || t === "true")
      return !0;
    if (t === "0" || t === "false")
      return !1;
    throw new Error("Incorrect variable value");
  }
  getType() {
    return "boolean";
  }
}
class sl extends Mi {
  convertValue(t) {
    if (typeof t != "string" || !ji(t))
      throw new Error("Incorrect variable value");
    return Bi(t);
  }
  fromString(t) {
    return this.convertValue(t);
  }
  getType() {
    return "color";
  }
}
class al extends Mi {
  convertValue(t) {
    if (typeof t != "string")
      throw new Error("Incorrect variable value");
    return Ei(t), t;
  }
  fromString(t) {
    return Ei(t), t;
  }
  getType() {
    return "url";
  }
}
class ll extends Mi {
  convertValue(t) {
    if (typeof t != "object" || !t)
      throw new Error("Incorrect variable value");
    return t;
  }
  fromString(t) {
    try {
      return JSON.parse(t);
    } catch {
      throw new Error("Incorrect dict value");
    }
  }
  getType() {
    return "dict";
  }
}
class cl extends Mi {
  convertValue(t) {
    if (!Array.isArray(t))
      throw new Error("Incorrect variable value");
    return t;
  }
  fromString(t) {
    try {
      return JSON.parse(t);
    } catch {
      throw new Error("Incorrect array value");
    }
  }
  getType() {
    return "array";
  }
}
const qo = {
  string: rl,
  number: nl,
  integer: il,
  boolean: ol,
  color: sl,
  url: al,
  dict: ll,
  array: cl
};
function Si(r, t, e) {
  if (!(t in qo))
    throw new Error("Unsupported variable type");
  return new qo[t](r, e);
}
function Mf() {
}
function Pf(r) {
  return r(this.value), Mf;
}
function Ks() {
  throw new Error("Cannot change the value of this type of variable");
}
class zf extends rl {
}
class Of extends nl {
}
class Nf extends il {
}
class Rf extends ol {
}
class Bf extends sl {
}
class Lf extends al {
}
class Hf extends ll {
}
class Wf extends cl {
}
class Uf extends Mi {
  convertValue(t) {
    if (!(t instanceof Date))
      throw new Error("Incorrect variable value");
    return t;
  }
  fromString() {
    throw new Error("Datetime variable does not support setter from string");
  }
  getType() {
    return "datetime";
  }
}
const _o = {
  string: zf,
  number: Of,
  integer: Nf,
  boolean: Rf,
  color: Bf,
  url: Lf,
  dict: Hf,
  array: Wf,
  datetime: Uf
};
for (const r in _o) {
  const t = _o[r];
  t.prototype.subscribe = Pf, t.prototype.set = Ks, t.prototype.setValue = Ks;
}
function Zn(r, t, e) {
  if (!(t in _o))
    throw new Error("Unsupported variable type");
  return new _o[t](r, e);
}
function Gf(r) {
  const t = r.getType();
  let e = r.getValue();
  return t === gr && (e = e ? 1 : 0), {
    type: t,
    value: e
  };
}
function qf(r, t) {
  if (t === "string")
    return r;
  if (t === "integer")
    try {
      return zr(r);
    } catch {
      throw new Error("Incorrect variable value");
    }
  else if (t === "number") {
    const e = Number(r);
    if (Number.isNaN(e) || !isFinite(e))
      throw new Error("Incorrect variable value");
    return e;
  } else if (t === "boolean") {
    if (r === "1" || r === "true")
      return !0;
    if (r === "0" || r === "false")
      return !1;
    throw new Error("Incorrect variable value");
  } else if (t === "color") {
    if (typeof r != "string" || !ji(r))
      throw new Error("Incorrect variable value");
    return Bi(r);
  } else if (t === "url") {
    if (typeof r != "string")
      throw new Error("Incorrect variable value");
    return Ei(r), r;
  } else if (t === "dict" || t === "array")
    try {
      return JSON.parse(r);
    } catch {
      throw new Error("Incorrect dict value");
    }
  throw new Error(`Unexpected type ${t}`);
}
const di = {
  width: 10,
  height: 10,
  borderRadius: 5,
  background: "#000"
}, Nn = ["rounded_rectangle", "circle"], Po = ["rounded_rectangle"];
function Rn(r, t, e, i, n) {
  let o = [];
  if (n)
    for (let l = r; l < t; ++l)
      o.push((l - e) / (i - e));
  else {
    for (let l = e; l < r; ++l)
      o.push((l - e) / (i - e));
    for (let l = t; l < i + 1; ++l)
      o.push((l - e) / (i - e));
  }
  return o;
}
const Jf = xr((r, t, e, i) => {
  var V, Ee, m, ie;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee, be, $e, ne, Ne, Ie, Me, Re, Be, Fe = E, Ue = () => (Fe(), Fe = $(ue, (L) => Be = L), ue), xe, J = E, te = () => (J(), J = $(ge, (L) => xe = L), ge), de, fe = E, Qe = () => (fe(), fe = $(Q, (L) => de = L), Q), Ge, gt = E, lt = () => (gt(), gt = $(K, (L) => Ge = L), K), pt, R = E, We = () => (R(), R = $(ke, (L) => pt = L), ke), pe, Le = E, ht = () => (Le(), Le = $(F, (L) => pe = L), F), xt, Je = E, Ke = () => (Je(), Je = $(I, (L) => xt = L), I), He, Ae = E, qe = () => (Ae(), Ae = $(G, (L) => He = L), G), it, nt = E, Pe = () => (nt(), nt = $(z, (L) => it = L), z), Ce, zt = E, Y = () => (zt(), zt = $(P, (L) => Ce = L), P), wt, et = E, ot = () => (et(), et = $(T, (L) => wt = L), T), tt, It = E, De = () => (It(), It = $(C, (L) => tt = L), C), Wt, At = E, kt = () => (At(), At = $(d, (L) => Wt = L), d), Xe, re = E, ct = () => (re(), re = $(c, (L) => Xe = L), c), Gt, b = E, Nt = () => (b(), b = $(h, (L) => Gt = L), h), se, Ve = E, bt = () => (Ve(), Ve = $(f, (L) => se = L), f), { componentContext: ve } = t, { layoutParams: _e = void 0 } = t;
  const ae = kr(Wr), Ot = kr(Xi), St = ae.direction;
  Re = $(St, (L) => Me = L);
  let Vt, Lt, _t = 0, $t = 100, yt = di, Dt = yt, Ct = di, Xt = di, Ut, jt = null, Ht, Rt = null, mt, Ze = mt, er = "", ir = "", nr = !0, tr = !1, qt = [];
  function U() {
    yt = di, Dt = yt, Ct = di, Xt = di, jt = null, Rt = null, mt = void 0, Ze = void 0, er = "", nr = !0, ir = "";
  }
  let S = Ri(Xe || 0, _t, $t), H = Ri(Wt || 0, _t, $t);
  function B({ direction: L, minValue: Te, maxValue: ze, trackActiveOffset: pr, trackActivePart: je, trackInactiveStyle: Ar, trackActiveStyle: Xr, ranges: s = [] }) {
    const he = [], Jt = (Tt, D, _r) => {
      var ut, Rr, Zr, Br;
      const mr = (vr, Mr, Sr, O) => {
        var Vr, Qr, Fr, br;
        const $r = Math.max(vr, D);
        if (Math.min(Mr, _r) - $r > 0) {
          const ci = O && (Qr = (Vr = O[L === "ltr" ? "start" : "end"]) != null ? Vr : O.left) != null ? Qr : 0, u = O && (br = (Fr = O[L === "ltr" ? "end" : "start"]) != null ? Fr : O.right) != null ? br : 0;
          he.push({
            left: vr,
            right: Mr,
            totalLeft: D,
            totalRight: _r,
            leftMargin: ci,
            rightMargin: u,
            style: Sr
          });
        }
      };
      if ((!s[0] || ((ut = s[0].start) != null ? ut : Te) > D) && mr(D, s[0] ? (Rr = s[0].start) != null ? Rr : Te : _r, Tt === "inactive" ? Ar : Xr), s.forEach((vr, Mr) => {
        var br, ci, u, g;
        const Sr = vr[Tt === "inactive" ? "track_inactive_style" : "track_active_style"], $r = Sr ? bi(Sr, Po, di) : Tt === "inactive" ? Ar : Xr, Nr = s[Mr - 1], Vr = s[Mr + 1], Qr = (ci = (br = vr.start) != null ? br : Nr == null ? void 0 : Nr.end) != null ? ci : D, Fr = (g = (u = vr.end) != null ? u : Vr == null ? void 0 : Vr.start) != null ? g : _r;
        mr(Qr, Fr, $r, vr.margins);
      }), s[s.length - 1] && ((Zr = s[s.length - 1].end) != null ? Zr : ze) < _r) {
        const vr = (Br = s[s.length - 1].end) != null ? Br : ze;
        mr(vr, _r, Tt === "inactive" ? Ar : Xr);
      }
    };
    Jt("inactive", Te, ze), Jt("active", pr, pr + je);
    const Kt = ze - Te;
    qt = he.map((Tt) => {
      let D = `${(Tt.left - Te) * 100 / Kt}%`;
      Tt.leftMargin && (D = `calc(${D} + ${Yr(Tt.leftMargin)})`);
      let _r;
      Tt.totalLeft < Tt.left ? _r = D : Tt.leftMargin ? _r = `max(${(Tt.totalLeft - Te) * 100 / Kt}%, ${D})` : _r = `${(Math.max(Tt.totalLeft, Tt.left) - Te) * 100 / Kt}%`;
      let mr = `${(1 - (Tt.right - Te) / Kt) * 100}%`;
      Tt.rightMargin && (mr = `calc(${mr} + ${Yr(Tt.rightMargin)})`);
      let ut;
      return Tt.totalRight > Tt.right ? ut = mr : Tt.rightMargin ? ut = `max(${(1 - (Tt.totalRight - Te) / Kt) * 100}%, ${mr})` : ut = `${(1 - (Math.max(Tt.totalRight, Tt.right) - Te) / Kt) * 100}%`, {
        left: _r,
        right: ut,
        height: Se(Tt.style.height),
        borderRadius: Se(Tt.style.borderRadius),
        background: Tt.style.background,
        boxShadow: Tt.style.boxShadow || ""
      };
    });
  }
  Kr(() => {
  }), t.componentContext === void 0 && e.componentContext && ve !== void 0 && e.componentContext(ve), t.layoutParams === void 0 && e.layoutParams && _e !== void 0 && e.layoutParams(_e), n = ve.origJson, n && U(), o = ve.json.thumb_value_variable, l = ve.json.thumb_secondary_value_variable, ct(c = o && (ve.getVariable(o, "integer") || ae.awaitGlobalVariable(o, "integer", 0)) || Si("temp", "integer", 0)), kt(d = l && (ve.getVariable(l, "integer") || ae.awaitGlobalVariable(l, "integer", 0)) || Si("temp", "integer", 0)), bt(f = ve.getDerivedFromVars(ve.json.min_value)), Nt(h = ve.getDerivedFromVars(ve.json.max_value)), De(C = ve.getDerivedFromVars(ve.json.thumb_style)), ot(T = ve.getDerivedFromVars(ve.json.thumb_secondary_style)), Y(P = ve.getDerivedFromVars(ve.json.track_inactive_style)), Pe(z = ve.getDerivedFromVars(ve.json.track_active_style)), qe(G = ve.getDerivedFromVars(ve.json.tick_mark_active_style)), Ke(I = ve.getDerivedFromVars(ve.json.tick_mark_inactive_style)), ht(F = ve.getDerivedFromVars(ve.json.thumb_text_style)), We(ke = ve.getDerivedFromVars(ve.json.thumb_secondary_text_style)), lt(K = ve.getDerivedFromVars(ve.json.accessibility)), te(ge = ve.getDerivedFromVars(ve.json.secondary_value_accessibility)), Qe(Q = ve.getDerivedFromVars(ve.json.is_enabled)), Ue(ue = ve.getDerivedFromVars(ve.json.ranges)), _t = dn(se, _t), $t = dn(Gt, $t);
  {
    const L = Ri(Xe || 0, _t, $t);
    L !== S && (S = L);
  }
  {
    const L = Ri(Wt || 0, _t, $t);
    L !== H && (H = L);
  }
  yt = bi(tt, Nn, yt), Dt = bi(wt, Nn, yt), Ct = bi(Ce, Po, Ct), Xt = bi(it, Po, Xt);
  {
    let L = bi(He, Nn, di);
    L !== di && (jt = L);
  }
  jt ? Ut = l ? Rn(Math.min(S, H), Math.max(S, H) + 1, _t, $t, !0) : Rn(_t, S, _t, $t, !0) : Ut = [];
  {
    let L = bi(xt, Nn, di);
    L !== di && (Rt = L);
  }
  Rt ? Ht = l ? Rn(Math.min(S, H), Math.max(S, H) + 1, _t, $t, !1) : Rn(S + 1, $t + 1, _t, $t, !0) : Ht = [], mt = Ys(pe, mt), Ze = Ys(pt, mt), Ge != null && Ge.description ? er = pn(Ge) : ve.logError(x(new Error('Missing accessibility "description" for slider'), { level: "warn" })), nr = ri(de, nr), xe != null && xe.description ? ir = pn(xe) : l && ve.logError(x(new Error('Missing second accessibility "description" for slider'), { level: "warn" }));
  {
    let L = !1;
    Ot.hasAction() ? (ve.logError(x(new Error('Cannot show "slider" inside component with an action or inside accessibility mode=exclude'))), L = !0) : yt === di ? (ve.logError(x(new Error('Missing "thumb_style" in slider'))), L = !0) : Xt === di ? (ve.logError(x(new Error('Missing "track_active_style" in slider'))), L = !0) : Ct === di && (ve.logError(x(new Error('Missing "track_inactive_style" in slider'))), L = !0), L !== tr && (tr = L);
  }
  return oe = Se(Math.max(...[yt.width, Dt.width, 0].filter(si))), ye = Se(Math.max(...[yt.height, Dt.height, 0].filter(si))), ee = (S - _t) / ($t - _t), be = l ? (H - _t) / ($t - _t) : void 0, $e = be !== void 0 ? Math.min(S, H) : _t, ne = be !== void 0 ? Math.abs(H - S) : S - _t, B({
    direction: Me,
    minValue: _t,
    maxValue: $t,
    trackActiveOffset: $e,
    trackActivePart: ne,
    trackInactiveStyle: Ct,
    trackActiveStyle: Xt,
    ranges: Be
  }), Ne = {
    "--divkit-slider-thumb-width": Se(yt.width),
    "--divkit-slider-thumb-height": Se(yt.height),
    "--divkit-slider-thumb-secondary-width": Se(Dt.width),
    "--divkit-slider-thumb-secondary-height": Se(Dt.height),
    "--divkit-slider-text-offset-x": (V = mt == null ? void 0 : mt.offset) != null && V.x ? Yr(mt.offset.x) : void 0,
    "--divkit-slider-text-offset-y": (Ee = mt == null ? void 0 : mt.offset) != null && Ee.y ? Yr(mt.offset.y) : void 0,
    "--divkit-slider-text-secondary-offset-x": (m = Ze == null ? void 0 : Ze.offset) != null && m.x ? Yr(Ze.offset.x) : void 0,
    "--divkit-slider-text-secondary-offset-y": (ie = Ze == null ? void 0 : Ze.offset) != null && ie.y ? Yr(Ze.offset.y) : void 0,
    "--divkit-slider-tick-active-width": jt ? Se(jt.width) : void 0,
    "--divkit-slider-tick-active-height": jt ? Se(jt.height) : void 0,
    "--divkit-slider-tick-active-border-radius": jt ? Se(jt.borderRadius) : void 0,
    "--divkit-slider-tick-active-background": (jt == null ? void 0 : jt.background) || void 0,
    "--divkit-slider-tick-active-box-shadow": (jt == null ? void 0 : jt.boxShadow) || void 0,
    "--divkit-slider-tick-inactive-width": Rt ? Se(Rt.width) : void 0,
    "--divkit-slider-tick-inactive-height": Rt ? Se(Rt.height) : void 0,
    "--divkit-slider-tick-inactive-border-radius": Rt ? Se(Rt.borderRadius) : void 0,
    "--divkit-slider-tick-inactive-background": (Rt == null ? void 0 : Rt.background) || void 0,
    "--divkit-slider-tick-inactive-box-shadow": (Rt == null ? void 0 : Rt.boxShadow) || void 0,
    "--divkit-slider-max-thumb-width": oe,
    "--divkit-slider-max-thumb-height": ye,
    "--divkit-slider-track-part": ee,
    "--divkit-slider-track-secondary-part": be
  }, Ie = { direction: Me }, ve.json, Re(), Fe(), J(), fe(), gt(), R(), Le(), Je(), Ae(), nt(), zt(), et(), It(), At(), re(), b(), Ve(), ` ${tr ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("slider", qr, Ie),
      style: Ne,
      customDescription: !0,
      customActions: "slider",
      hasInnerFocusable: !0,
      componentContext: ve,
      layoutParams: _e
    },
    {},
    {
      default: ({ focusHandler: L, blurHandler: Te }) => `<div${j("class", qr["slider__tracks-wrapper"], 0)}><div${j("class", qr["slider__tracks-inner"], 0)}${j("this", Lt, 0)}><div${j(
        "class",
        qr["slider__tracks-ranges"] + (Me === "rtl" ? " " + qr["slider__tracks-ranges_rtl"] : ""),
        0
      )}>${Or(qt, (ze) => `<div${j("class", qr.slider__track, 0)}${Hr({
        left: ze.left,
        right: ze.right,
        height: ze.height,
        "border-radius": ze.borderRadius,
        background: ze.background,
        "box-shadow": ze.boxShadow
      })}></div>`)}</div> ${Or(Ut, (ze) => `<div class="${ft(qr.slider__tick, !0) + " " + ft(qr.slider__tick_active, !0)}"${Hr({ "--divkit-slider-tick": ze })}></div>`)} ${Or(Ht, (ze) => `<div class="${ft(qr.slider__tick, !0) + " " + ft(qr.slider__tick_inactive, !0)}"${Hr({ "--divkit-slider-tick": ze })}></div>`)} <div${j("class", qr.slider__thumb, 0)}${Hr({
        "border-radius": Se(yt.borderRadius),
        background: yt.background,
        "box-shadow": yt.boxShadow || ""
      })}>${mt ? `<div${j("class", qr["slider__thumb-text"], 0)}><div${j("class", qr["slider__thumb-text-inner"], 0)}${Hr({
        "font-size": (mt == null ? void 0 : mt.fontSize) || "1em",
        "font-weight": (mt == null ? void 0 : mt.fontWeight) || "",
        color: (mt == null ? void 0 : mt.textColor) || "#000"
      })}>${ft(S)}</div></div>` : ""}</div> ${l ? `<div class="${ft(qr.slider__thumb, !0) + " " + ft(qr.slider__thumb_secondary, !0)}"${Hr({
        "border-radius": Se(Dt.borderRadius),
        background: Dt.background,
        "box-shadow": Dt.boxShadow || ""
      })}>${Ze ? `<div class="${ft(qr["slider__thumb-text"], !0) + " " + ft(qr["slider__thumb-text_secondary"], !0)}"><div${j("class", qr["slider__thumb-text-inner"], 0)}${Hr({
        "font-size": (Ze == null ? void 0 : Ze.fontSize) || "1em",
        "font-weight": (Ze == null ? void 0 : Ze.fontWeight) || "",
        color: (Ze == null ? void 0 : Ze.textColor) || "#000"
      })}>${ft(H)}</div></div>` : ""}</div>` : ""} <input type="range"${j(
        "class",
        qr.slider__input,
        0
      )}${j("min", _t, 0)}${j("max", $t, 0)} step="1"${j("value", S, 0)} ${nr ? "" : "disabled"}${j("aria-label", er, 0)}${j("this", Vt, 0)}> ${l ? `<input type="range"${j(
        "class",
        `${qr.slider__input} ${qr.slider__input_secondary}`,
        0
      )}${j("min", _t, 0)}${j("max", $t, 0)} step="1"${j("value", H, 0)} ${nr ? "" : "disabled"}${j("aria-label", ir, 0)}>` : ""}</div></div>`
    }
  )}`}`;
}), Yf = "appkit-input", Kf = "appkit-input__aligner", Xf = "appkit-input__input", Zf = "appkit-input__placeholder", Qf = "appkit-input__input_singleline", eg = "appkit-input__input_multiline", Ji = {
  input: Yf,
  "input_alignment-horizontal_center": "appkit-input_alignment-horizontal_center",
  "input_alignment-horizontal_end": "appkit-input_alignment-horizontal_end",
  input__aligner: Kf,
  input__input: Xf,
  input__placeholder: Zf,
  "input_alignment-vertical_start": "appkit-input_alignment-vertical_start",
  "input_alignment-vertical_end": "appkit-input_alignment-vertical_end",
  "input_alignment-vertical_baseline": "appkit-input_alignment-vertical_baseline",
  "input_highlight-color": "appkit-input_highlight-color",
  input__input_singleline: Qf,
  "input__scroll-wrapper": "appkit-input__scroll-wrapper",
  input__input_multiline: eg,
  "input__input_has-custom-focus": "appkit-input__input_has-custom-focus"
};
function Dn(r, t) {
  if (r === t)
    return {
      start: r.length,
      added: 0,
      removed: 0
    };
  if (r.length > t.length) {
    const o = Dn(t, r);
    return {
      start: o.start,
      added: o.removed,
      removed: o.added
    };
  }
  let e = 0, i = t.length - 1;
  const n = t.length - r.length;
  for (; e < i && e < r.length && r[e] === t[e]; )
    ++e;
  for (; i - n >= e && r[i - n] === t[i]; )
    --i;
  return ++i, {
    start: e,
    added: i - e,
    removed: i - e - n
  };
}
class Xs {
  constructor(t) {
    this.char = t;
  }
}
class ki {
  constructor(t, e, i) {
    this.char = t, this.filter = e, this.placeholder = i;
  }
}
class _s {
  constructor(t) {
    Er(this, "maskData");
    Er(this, "filters", /* @__PURE__ */ new Map());
    Er(this, "destructedValue", []);
    Er(this, "cursorPos", 0);
    this.maskData = t, this.updateMaskData(t);
  }
  get cursorPosition() {
    return this.cursorPos;
  }
  get rawValue() {
    return this.collectValueRange(0, this.destructedValue.length - 1);
  }
  get value() {
    let t = "";
    for (let e = 0; e < this.destructedValue.length; ++e) {
      const i = this.destructedValue[e];
      if (i instanceof Xs)
        t += i.char;
      else if (i instanceof ki)
        if (i.char)
          t += i.char;
        else if (this.maskData.alwaysVisible)
          t += i.placeholder;
        else
          break;
    }
    return t;
  }
  firstEmptyHolderIndex() {
    const t = this.destructedValue.findIndex((e) => e instanceof ki && !e.char);
    return t !== -1 ? t : this.destructedValue.length;
  }
  updateMaskData(t, e = !0) {
    const i = this.maskData !== t && e ? this.rawValue : null;
    this.filters = /* @__PURE__ */ new Map(), this.maskData = t, this.maskData.decoding.forEach((n) => {
      if (n.filter)
        try {
          const o = new RegExp(n.filter);
          this.filters.set(n.key, o);
        } catch (o) {
          this.onException(x(o, {
            level: "error",
            additional: {
              key: n.key
            }
          }));
        }
    }), this.destructedValue = this.maskData.pattern.split("").map((n) => {
      const o = this.maskData.decoding.find((l) => l.key === n);
      return o ? new ki(
        null,
        this.filters.get(o.key),
        o.placeholder
      ) : new Xs(n);
    }), i !== null && this.overrideRawValue(i);
  }
  overrideRawValue(t) {
    this.clearRange(0, this.destructedValue.length), this.replaceChars(t, 0), this.cursorPos = Math.min(this.cursorPos, this.value.length);
  }
  applyChangeFrom(t, e) {
    const i = Dn(this.value, t);
    e !== void 0 && (i.start = Math.max(0, e - i.added));
    const n = this.replaceBodyTail(i, t);
    this.calculateCursorPosition(i, n);
  }
  replaceBodyTail(t, e) {
    const i = this.buildBodySubstring(t, e), n = this.buildTailSubstring(t);
    this.cleanup(t);
    const o = this.firstEmptyHolderIndex(), l = n ? this.calculateMaxShift(n, o) : void 0;
    this.replaceChars(i, o, l);
    const c = this.firstEmptyHolderIndex();
    return this.replaceChars(n, c), c;
  }
  buildBodySubstring(t, e) {
    return e.substring(t.start, t.start + t.added);
  }
  buildTailSubstring(t) {
    return this.collectValueRange(
      t.start + t.removed,
      this.destructedValue.length - 1
    );
  }
  calculateMaxShift(t, e) {
    if (this.filters.size <= 1) {
      let o = 0, l = e;
      for (; l < this.destructedValue.length; )
        this.destructedValue[l] instanceof ki && ++o, ++l;
      return Math.max(0, o - t.length);
    }
    const i = this.calculateInsertableSubstring(t, e);
    let n = 0;
    for (; n < this.destructedValue.length && i === this.calculateInsertableSubstring(t, e + n); )
      ++n;
    return Math.max(0, n - 1);
  }
  cleanup(t) {
    if (t.added === 0 && t.removed === 1) {
      let e = t.start;
      for (; e >= 0; ) {
        const i = this.destructedValue[e];
        if (i instanceof ki && i.char !== null) {
          i.char = null;
          break;
        } else
          --e;
      }
    }
    this.clearRange(t.start, this.destructedValue.length);
  }
  clearRange(t, e) {
    let i = t;
    for (; i < e && i < this.destructedValue.length; ) {
      const n = this.destructedValue[i];
      n instanceof ki && (n.char = null), ++i;
    }
  }
  calculateCursorPosition(t, e) {
    const i = this.firstEmptyHolderIndex();
    let n;
    t.start < i ? n = Math.min(this.firstHolderAfter(e), this.value.length) : n = i, this.cursorPos = n;
  }
  calculateInsertableSubstring(t, e) {
    let i = "", n = e;
    const o = () => {
      var l;
      for (; n < this.destructedValue.length && !(this.destructedValue[n] instanceof ki); )
        ++n;
      return (l = this.destructedValue[n]) == null ? void 0 : l.filter;
    };
    return t.split("").forEach((l) => {
      const c = o();
      c != null && c.test(l) && (i += l, ++n);
    }), i;
  }
  collectValueRange(t, e) {
    let i = "", n = t;
    for (; n <= e; ) {
      const o = this.destructedValue[n];
      o instanceof ki && o.char !== null && (i += o.char), ++n;
    }
    return i;
  }
  replaceChars(t, e, i) {
    let n = this.calculateInsertableSubstring(t, e);
    i !== void 0 && (n = n.substring(0, i));
    let o = e, l = 0;
    for (; o < this.destructedValue.length && l < n.length; ) {
      const c = this.destructedValue[o], d = n[l];
      c instanceof ki && (c.char = d, ++l), ++o;
    }
  }
  firstHolderAfter(t) {
    let e = t;
    for (; e < this.destructedValue.length && !(this.destructedValue[e] instanceof ki); )
      ++e;
    return e;
  }
}
class tg extends _s {
  constructor(t, e) {
    super(t), this.logError = e;
  }
  onException(t) {
    this.logError(t);
  }
}
function rg(r, t, e) {
  if (typeof r.pattern == "string" && Array.isArray(r.pattern_elements) && r.pattern_elements.every((i) => i.key && typeof i.key == "string")) {
    const i = {
      pattern: r.pattern,
      alwaysVisible: !!r.always_visible,
      decoding: r.pattern_elements.map((n) => ({
        key: n.key,
        filter: n.regex && typeof n.regex == "string" ? n.regex : void 0,
        placeholder: n.placeholder && typeof n.placeholder == "string" ? n.placeholder : "_"
      }))
    };
    return e ? (e.updateMaskData(i), e) : new tg(i, t);
  }
  return e || null;
}
class ig extends _s {
  constructor(e = void 0, i) {
    super({
      pattern: "",
      decoding: [],
      alwaysVisible: !1
    });
    Er(this, "currencyFormatter", new Intl.NumberFormat());
    Er(this, "decimalSeparator", ".");
    Er(this, "localeDigits", {});
    Er(this, "trimZeroRegExp", new RegExp(""));
    this.logError = i, this.initFormatter(e);
  }
  updateCurrencyParams(e) {
    const i = this.parseFormat(this.rawValue) || 0;
    this.initFormatter(e);
    const n = i.toString().replace(".", this.decimalSeparator);
    this.applyChangeFrom(n);
  }
  initFormatter(e) {
    try {
      this.currencyFormatter = new Intl.NumberFormat(e, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }), this.decimalSeparator = this.currencyFormatter.format(0)[1], this.localeDigits = new Array(10).fill("").reduce((i, n, o) => (i[o] = this.currencyFormatter.format(o)[0], i), {}), this.trimZeroRegExp = new RegExp(`^${this.localeDigits[0]}+`);
    } catch (i) {
      this.onException(x(i, {
        level: "error",
        additional: {
          locale: e
        }
      }));
    }
  }
  invalidateMaskDataForFormatted(e) {
    const i = this.currencyFormatter.format(e), n = this.formatPattern(i), o = [{
      key: "#",
      filter: `[${[...Object.values(this.localeDigits)].join("")}]`,
      placeholder: this.localeDigits[0]
    }, {
      key: this.decimalSeparator,
      filter: `[${this.decimalSeparator}]`,
      placeholder: this.decimalSeparator
    }];
    this.updateMaskData({
      pattern: n,
      decoding: o,
      alwaysVisible: this.maskData.alwaysVisible
    }, !1);
  }
  overrideRawValue(e) {
    const i = this.parseFormat(e) || 0;
    this.invalidateMaskDataForFormatted(i), super.overrideRawValue(e);
  }
  applyChangeFrom(e, i) {
    const n = Dn(this.value, e), o = this.value.lastIndexOf(this.decimalSeparator), l = e.lastIndexOf(this.decimalSeparator), c = o !== l || o === -1 && l === -1, d = this.validFormat(e, n);
    this.cleanup(n);
    const f = this.parseFormat(d) || 0;
    c && this.invalidateMaskDataForFormatted(f), this.replaceChars(d, 0), this.value.length > n.start && !this.isDigit(this.value[n.start]) ? this.cursorPos = i != null ? i : this.cursorPosition : this.cursorPos = Math.abs(this.value.length - (e.length - (i != null ? i : this.cursorPosition)));
  }
  parseFormat(e) {
    return parseFloat(
      e.replace(/./g, (i) => {
        const n = this.localeDigits[i];
        return n || (i === this.decimalSeparator ? "." : "");
      })
    );
  }
  formatPattern(e) {
    let i = "";
    for (const n of e)
      i += this.isDigit(n) ? "#" : n;
    return i;
  }
  validFormat(e, i) {
    if (!e)
      return "";
    let n = -1, o = 0;
    for (; o < e.length; ) {
      if (e[o] === this.decimalSeparator && !this.inDiff(i, o)) {
        n = o;
        break;
      }
      o++;
    }
    let l = -1;
    i.added === 1 && i.removed === 0 && [",", "."].includes(e[i.start]) && (l = i.start);
    const c = this.currencyFormatter.resolvedOptions().maximumFractionDigits || 0;
    let d = c;
    if (n !== -1)
      for (o = n; o < e.length; )
        this.isDigit(e[o]) && !this.inDiff(i, o) && d--, o++;
    else {
      let T = !1;
      for (let P = 0; P < e.length; P++) {
        const z = e[P];
        z === this.decimalSeparator ? T = !0 : !this.inDiff(i, P) && T && this.isDigit(z) && d--;
      }
    }
    const f = e.includes(this.decimalSeparator) || l !== -1, h = [];
    o = e.length - 1;
    let C = !1;
    for (; o >= 0; ) {
      const T = e[o], P = h.length <= c;
      this.isDigit(T) ? this.inDiff(i, o) && !C && f ? d > 0 && (h.push(T), d--) : h.push(T) : P && n === -1 && o === l ? (h.push(this.decimalSeparator), C = !0) : P && T === this.decimalSeparator && (n === o || n === -1) && (h.push(this.decimalSeparator), C = !0, n = o), o--;
    }
    return h.reverse().join("").replace(this.trimZeroRegExp, "");
  }
  inDiff(e, i) {
    return e.start <= i && i < e.start + e.added;
  }
  isDigit(e) {
    return !!this.localeDigits[e];
  }
  onException(e) {
    this.logError(e);
  }
}
function ng(r, t, e) {
  return e ? (e.updateCurrencyParams(r.locale), e) : new ig(r.locale, t);
}
const og = {
  rus_local: {
    value: "0 (000) 000-00-00"
  },
  rus: {
    value: "+0 (000) 000-00-00"
  },
  am: {
    value: "+000 (000) 000-00-00"
  },
  az: {
    value: "+000 (000) 000-00-00"
  },
  br: {
    value: "+00 (00) 0000-0000"
  },
  by: {
    value: "+000 (00) 000-00-00"
  },
  kg: {
    value: "+000 (000) 000-00-00"
  },
  md: {
    value: "+000 (000) 0-00-00"
  },
  kz: {
    value: "+0 (000) 000-00-00"
  },
  ua: {
    value: "+000 (00) 000-00-00"
  },
  uz: {
    value: "+000 (00) 000-00-00"
  },
  uk: {
    value: "+00 0000 000000"
  },
  swiss: {
    value: "+00 00 000-00-00"
  },
  angola: {
    value: "+000 000 000 000"
  },
  netherlands: {
    value: "+00 00 000 0000"
  },
  ge: {
    value: "+000 (000) 00-00-00"
  },
  short: {
    value: "+0 (000) 000-00-00"
  },
  middle: {
    value: "+00 (000) 000-00-00"
  },
  long: {
    value: "+000 (00) 000-00-00"
  },
  universal: {
    value: "+0000000000000"
  }
}, sg = {
  value: {
    default_value: {
      1: {
        $ref: "#/constants/short"
      },
      2: {
        0: {
          $ref: "#/constants/middle"
        },
        4: {
          4: {
            $ref: "#/constants/angola"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        7: {
          $ref: "#/constants/middle"
        },
        "*": {
          $ref: "#/constants/long"
        }
      },
      3: {
        1: {
          $ref: "#/constants/netherlands"
        },
        5: {
          0: {
            $ref: "#/constants/ua"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        7: {
          3: {
            $ref: "#/constants/md"
          },
          4: {
            $ref: "#/constants/am"
          },
          5: {
            $ref: "#/constants/by"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        8: {
          0: {
            $ref: "#/constants/ua"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      4: {
        1: {
          $ref: "#/constants/swiss"
        },
        2: {
          $ref: "#/constants/long"
        },
        4: {
          $ref: "#/constants/uk"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      5: {
        0: {
          $ref: "#/constants/long"
        },
        5: {
          $ref: "#/constants/br"
        },
        9: {
          $ref: "#/constants/long"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      6: {
        7: {
          $ref: "#/constants/long"
        },
        8: {
          $ref: "#/constants/long"
        },
        9: {
          $ref: "#/constants/long"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      7: {
        3: {
          3: {
            $ref: "#/constants/kz"
          },
          "*": {
            $ref: "#/constants/rus"
          }
        },
        7: {
          $ref: "#/constants/kz"
        },
        "*": {
          $ref: "#/constants/rus"
        }
      },
      8: {
        5: {
          $ref: "#/constants/long"
        },
        8: {
          $ref: "#/constants/long"
        },
        9: {
          $ref: "#/constants/rus_local"
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      9: {
        6: {
          $ref: "#/constants/long"
        },
        7: {
          $ref: "#/constants/long"
        },
        9: {
          4: {
            $ref: "#/constants/az"
          },
          5: {
            $ref: "#/constants/ge"
          },
          6: {
            $ref: "#/constants/kg"
          },
          8: {
            $ref: "#/constants/uz"
          },
          "*": {
            $ref: "#/constants/long"
          }
        },
        "*": {
          $ref: "#/constants/middle"
        }
      },
      "*": {
        $ref: "#/constants/universal"
      }
    }
  }
}, ul = {
  constants: og,
  properties: sg
}, ag = "000000000000000", Zs = "*", lg = "00", Qs = [{
  key: "0",
  filter: "\\d",
  placeholder: "_"
}];
class cg extends _s {
  constructor(e) {
    super({
      pattern: ta(""),
      decoding: Qs,
      alwaysVisible: !1
    });
    Er(this, "decimalSeparator", ".");
    Er(this, "localeDigits", {});
    Er(this, "trimZeroRegExp", new RegExp(""));
    this.logError = e;
  }
  overrideRawValue(e) {
    this.tryInvalidateMaskDataWith(e), super.overrideRawValue(e);
  }
  applyChangeFrom(e, i) {
    const n = Dn(this.value, e);
    i !== void 0 && (n.start = Math.max(0, i - n.added));
    const o = this.rawValue, l = this.replaceBodyTail(n, e), c = this.rawValue, d = this.newMaskPatternFor(c);
    if (d == null) {
      this.calculateCursorPosition(n, l);
      return;
    }
    this.updateMaskDataWith(d), this.replaceChars(c, 0);
    const f = Dn(o, c), h = f.start + f.added;
    this.calculateCursorPositionBy(h);
  }
  calculateCursorPositionBy(e) {
    let i = 0, n = 0;
    for (; i < this.destructedValue.length && n < e; )
      this.destructedValue[i++] instanceof ki && n++;
    this.cursorPos = this.firstHolderAfter(i);
  }
  tryInvalidateMaskDataWith(e) {
    const i = this.newMaskPatternFor(e);
    i && this.updateMaskDataWith(i);
  }
  newMaskPatternFor(e) {
    const i = ta(e), n = this.maskData.pattern;
    return i !== n ? i : null;
  }
  updateMaskDataWith(e) {
    return this.updateMaskData({
      pattern: e,
      decoding: Qs,
      alwaysVisible: this.maskData.alwaysVisible
    }, !1);
  }
  onException(e) {
    this.logError(e);
  }
}
function ea(r) {
  return "$ref" in r ? ul.constants[r.$ref.split("/").pop()] : r;
}
function ta(r) {
  if (!r)
    return ag;
  let t = ul.properties.value.default_value, e = 0;
  for (; !("value" in t); ) {
    if (e >= r.length) {
      t = ea(t[Zs]);
      break;
    }
    const i = r[e++];
    t = ea(t[i in t ? i : Zs]);
  }
  return t.value + lg;
}
function ug(r, t) {
  return t || new cg(r);
}
const dg = typeof document < "u" && "inputMode" in document.createElement("input"), ra = {
  email: "email",
  number: "number",
  phone: "tel",
  text: "text",
  single_line_text: "text",
  multi_line_text: "text",
  uri: "url",
  password: "password"
}, fg = xr((r, t, e, i) => {
  var sr;
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee, be, $e, ne, Ne, Ie, Me, Re, Be, Fe, Ue, xe, J, te, de, fe = E, Qe = () => (fe(), fe = $(c, (ce) => de = ce), c), Ge, gt = E, lt = () => (gt(), gt = $(d, (ce) => Ge = ce), d), pt = E, R = () => (pt(), pt = $(Re, (ce) => ce), Re), We, pe = E, Le = () => (pe(), pe = $(Ie, (ce) => We = ce), Ie), ht, xt = E, Je = () => (xt(), xt = $(ee, (ce) => ht = ce), ee), Ke, He = E, Ae = () => (He(), He = $(Ne, (ce) => Ke = ce), Ne), qe, it, nt, Pe = E, Ce = () => (Pe(), Pe = $(ye, (ce) => nt = ce), ye), zt, Y = E, wt = () => (Y(), Y = $(oe, (ce) => zt = ce), oe), et, ot = E, tt = () => (ot(), ot = $(ue, (ce) => et = ce), ue), It, De = E, Wt = () => (De(), De = $(Q, (ce) => It = ce), Q), At, kt = E, Xe = () => (kt(), kt = $(ne, (ce) => At = ce), ne), re, ct = E, Gt = () => (ct(), ct = $($e, (ce) => re = ce), $e), b, Nt = E, se = () => (Nt(), Nt = $(ge, (ce) => b = ce), ge), Ve, bt = E, ve = () => (bt(), bt = $(K, (ce) => Ve = ce), K), _e, ae = E, Ot = () => (ae(), ae = $(ke, (ce) => _e = ce), ke), St, Vt = E, Lt = () => (Vt(), Vt = $(F, (ce) => St = ce), F), _t, $t = E, yt = () => ($t(), $t = $(I, (ce) => _t = ce), I), Dt, Ct = E, Xt = () => (Ct(), Ct = $(G, (ce) => Dt = ce), G), Ut, jt = E, Ht = () => (jt(), jt = $(z, (ce) => Ut = ce), z), Rt, mt = E, Ze = () => (mt(), mt = $(P, (ce) => Rt = ce), P), er, ir = E, nr = () => (ir(), ir = $(T, (ce) => er = ce), T), tr, qt = E, U = () => (qt(), qt = $(C, (ce) => tr = ce), C), S, H = E, B = () => (H(), H = $(h, (ce) => S = ce), h), V, Ee = E, m = () => (Ee(), Ee = $(f, (ce) => V = ce), f), ie, L = E, Te = () => (L(), L = $(Me, (ce) => ie = ce), Me), ze = E, pr = () => (ze(), ze = $(be, (ce) => ce), be), { componentContext: je } = t, { layoutParams: Ar = void 0 } = t;
  const Xr = kr(Wr), s = kr(Xi), he = Xr.direction;
  it = $(he, (ce) => qe = ce);
  let Jt, Kt = null, Tt = "", D = "", _r = !1, mr = "", ut = 12, Rr, Zr = "", Br, vr = "", Mr = "#000", Sr = "", O = "start", $r = "center", Nr = "multi_line_text", Vr = "text", Qr, Fr = "", br = null, ci = "", u = "", g = "", _ = !0, A = 1 / 0, y = "off", me = "default", W = "", rt = !1, dt = !0;
  function le() {
    mr = "", ut = 12, Rr = void 0, Zr = "", Br = void 0, Mr = "#000", Sr = "", O = "left", $r = "center", Nr = "multi_line_text", Vr = "text", Qr = void 0, _ = !0, A = 1 / 0, y = "off", me = "default", W = "";
  }
  function vt(ce) {
    (ce == null ? void 0 : ce.type) === "fixed_length" ? Kt = rg(ce, je.logError, Kt) : (ce == null ? void 0 : ce.type) === "currency" ? Kt = ng(ce, je.logError, Kt) : (ce == null ? void 0 : ce.type) === "phone" && (Kt = ug(je.logError, Kt)), Kt && Oe();
  }
  async function Oe() {
  }
  function Bt() {
    const ce = dt;
    dt = !1;
    const Ir = je.json.validators;
    if (!Array.isArray(Ir) || !Ir.length)
      return;
    const cr = je.getJsonWithVars(Ir).filter((a) => (a.type === "regex" || a.type === "expression") && a.label_id && a.variable), Ye = [];
    cr.forEach((a) => {
      const p = je.getVariable(a.variable);
      if (!p)
        return;
      if (p.getType() !== "boolean") {
        ce && je.logError(x(new Error("Incorrect variable type for the validator"), {
          additional: { variable: a.variable }
        }));
        return;
      }
      let w = !1;
      if (Tt === "" && (a.allow_empty === !0 || a.allow_empty === 1))
        w = !0;
      else if (a.type === "regex") {
        if (!a.pattern || typeof a.pattern != "string")
          return;
        try {
          w = new RegExp("^" + a.pattern + "$").test(Tt);
        } catch {
          ce && je.logError(x(new Error("Failed to create a regular expression using the validator pattern"), {
            additional: { pattern: a.pattern }
          }));
          return;
        }
      } else if (a.type === "expression")
        w = a.condition === !0 || a.condition === 1;
      else
        return;
      if (p.setValue(w), !w) {
        const v = Xr.getComponentId(a.label_id);
        v && Ye.push(v);
      }
    }), W = Ye.join(" ");
  }
  Kr(() => {
    rt = !1;
  }), t.componentContext === void 0 && e.componentContext && je !== void 0 && e.componentContext(je), t.layoutParams === void 0 && e.layoutParams && Ar !== void 0 && e.layoutParams(Ar), n = je.origJson, n && le(), o = je.json.text_variable, l = (sr = je.json.mask) == null ? void 0 : sr.raw_text_variable, Qe(c = o && (je.getVariable(o, "string") || Xr.awaitGlobalVariable(o, "string", "")) || Si("temp", "string", "")), lt(d = l && (je.getVariable(l, "string") || Xr.awaitGlobalVariable(l, "string", "")) || Si("temp", "string", "")), m(f = je.getDerivedFromVars(je.json.hint_text)), B(h = je.getDerivedFromVars(je.json.hint_color)), U(C = je.getDerivedFromVars(je.json.font_size)), nr(T = je.getDerivedFromVars(je.json.font_weight)), Ze(P = je.getDerivedFromVars(je.json.font_weight_value)), Ht(z = je.getDerivedFromVars(je.json.font_family)), Xt(G = je.getDerivedFromVars(je.json.line_height)), yt(I = je.getDerivedFromVars(je.json.letter_spacing)), Lt(F = je.getDerivedFromVars(je.json.text_color)), Ot(ke = je.getDerivedFromVars(je.json.highlight_color)), ve(K = je.getDerivedFromVars(je.json.text_alignment_horizontal)), se(ge = je.getDerivedFromVars(je.json.text_alignment_vertical)), Wt(Q = je.getDerivedFromVars(je.json.keyboard_type)), tt(ue = je.getDerivedFromVars(je.json.mask)), wt(oe = je.getDerivedFromVars(je.json.max_visible_lines)), Ce(ye = je.getDerivedFromVars(je.json.paddings)), Je(ee = je.getDerivedFromVars(je.json.accessibility)), pr(be = je.getDerivedFromVars(je.json.select_all_on_focus)), Gt($e = je.getDerivedFromVars(je.json.is_enabled)), Xe(ne = je.getDerivedFromVars(je.json.max_length)), Ae(Ne = je.getDerivedFromVars(je.json.autocapitalization)), Le(Ie = je.getDerivedFromVars(je.json.enter_key_type)), Te(Me = je.getDerivedFromVars(je.json.validators)), R(Re = je.getDerivedFromVars(je.json.filters));
  {
    let ce = !1;
    o ? (s.hasAction() || (ht == null ? void 0 : ht.mode) === "exclude") && (ce = !0, je.logError(x(new Error('Cannot show "input" inside component with an action or inside accessibility mode=exclude')))) : (_r = !0, je.logError(x(new Error('Missing "text_variable" in "input"')))), _r !== ce && (_r = ce);
  }
  if (vt(et), A = fi(At, A), !Kt && Tt !== de) {
    let ce = de;
    ce.length > A && (ce = ce.slice(0, A), c.setValue(ce)), Tt = D = ce, Bt();
  }
  Kt && Kt.rawValue !== Ge && (Oe(), Bt()), ie && rt && Bt(), Be = V, mr = lr(S, 1, mr), ut = fi(tr, ut), Rr = _n(er, Rt, Rr), Ut && typeof Ut == "string" ? Zr = Xr.typefaceProvider(Ut, { fontWeight: Rr || 400 }) : Zr = "";
  {
    const ce = Dt;
    ui(ce) && (Br = ce / ut);
  }
  return ko(_t) && (vr = Se(_t)), Mr = lr(St, 1, Mr), Sr = lr(_e, 1, Sr), O = us(Ve, qe, O), $r = ds(b, $r), _ = ri(re, _), It && It in ra && (Vr = ra[It], Nr = It), (et == null ? void 0 : et.type) === "currency" ? (Vr = dg ? "text" : "tel", Qr = "decimal") : Nr === "number" ? Qr = "decimal" : Qr = void 0, Fe = Nr === "multi_line_text", ui(zt) ? Fr = `calc(${zt * (Br || 1.25) * (ut / 10) + "em"} + ${Yr(wr(nt == null ? void 0 : nt.top, 0) + wr(nt == null ? void 0 : nt.bottom, 0))})` : Fr = "", br = yn(nt || void 0, br), ci = br ? Vi(
    {
      top: (Number(br.top) || 0) / ut * 10,
      right: (Number(qe === "ltr" ? br.end : br.start) || Number(br.right) || 0) / ut * 10,
      bottom: (Number(br.bottom) || 0) / ut * 10,
      left: (Number(qe === "ltr" ? br.start : br.end) || Number(br.left) || 0) / ut * 10
    },
    qe
  ) : "", u = br ? Vi(
    {
      top: (Number(br.top) || 0) / ut * 10,
      bottom: (Number(br.bottom) || 0) / ut * 10
    },
    qe
  ) : "", Ke === "all_characters" ? y = "characters" : Ke === "sentences" ? y = "sentences" : Ke === "words" ? y = "words" : (Ke === "none" || Ke === "auto") && (y = "off"), ht != null && ht.description ? g = pn(ht) : je.logError(x(new Error('Missing accessibility "description" for input'), { level: "warn" })), (We === "default" || We === "done" || We === "go" || We === "search" || We === "send") && (me = We), Ue = {
    "highlight-color": !!Sr,
    multiline: Fe,
    "alignment-horizontal": O,
    "alignment-vertical": $r
  }, xe = {
    "--divkit-input-hint-color": mr,
    "--divkit-input-highlight-color": Sr,
    "--divkit-input-line-height": Br,
    "font-weight": Rr,
    "font-family": Zr,
    "letter-spacing": vr,
    color: Mr,
    "max-height": Fr
  }, J = { "font-size": Se(ut), padding: ci }, te = {
    "font-size": Se(ut),
    padding: u
  }, fe(), gt(), pt(), pe(), xt(), He(), it(), Pe(), Y(), ot(), De(), kt(), ct(), Nt(), bt(), ae(), Vt(), $t(), Ct(), jt(), mt(), ir(), qt(), H(), Ee(), L(), ze(), `${_r ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      alwaysCustomFocus: !0,
      cls: rr("input", Ji, Ue),
      style: xe,
      customDescription: !0,
      customActions: "input",
      customPaddings: !0,
      hasInnerFocusable: !0,
      componentContext: je,
      layoutParams: Ar
    },
    {},
    {
      default: ({ focusHandler: ce, blurHandler: Ir, hasCustomFocus: Ur }) => `${Fe ? `<span${j("class", Ji["input__scroll-wrapper"], 0)}>${!D && Be ? `<div${j("class", Ji.input__placeholder, 0)} aria-hidden="true"${j("style", fr(J), 0)}>${ft(Be)}</div>` : ""}  <span${j("class", Ji.input__aligner, 0)} aria-hidden="true"${j("style", fr(te), 0)}>​</span> ${_ ? `<span${j(
        "class",
        rr("input__input", Ji, {
          "has-custom-focus": Ur,
          multiline: !0
        }),
        0
      )}${j("autocapitalize", y, 0)} contenteditable="true" role="textbox" tabindex="0"${j("aria-label", g, 0)} aria-multiline="true"${j("enterkeyhint", me === "default" ? void 0 : me, 0)}${j("aria-describedby", W || void 0, 0)}${j("style", fr(J), 0)}${j("this", Jt, 0)}>${/* @__PURE__ */ ((cr) => cr === void 0 ? "" : cr)(D)}</span>` : `<span${j("class", rr("input__input", Ji, { multiline: !0 }), 0)}${j("autocapitalize", y, 0)} contenteditable="false" role="textbox"${j("aria-label", g, 0)} aria-disabled="true" aria-multiline="true"${j("aria-describedby", W || void 0, 0)}${j("style", fr(J), 0)}${j("this", Jt, 0)}>${/* @__PURE__ */ ((cr) => cr === void 0 ? "" : cr)(D)}</span>`}</span>` : `<input${j("type", Vr, 0)}${j("inputmode", Qr, 0)}${j(
        "class",
        rr("input__input", Ji, {
          "has-custom-focus": Ur,
          singleline: !0
        }),
        0
      )} autocomplete="off"${j("autocapitalize", y, 0)}${j("aria-label", g, 0)}${j("aria-describedby", W || void 0, 0)}${j("style", fr(J), 0)} ${_ ? "" : "disabled"}${j("maxlength", A === 1 / 0 ? void 0 : A, 0)}${j("placeholder", Be, 0)}${j("value", Tt, 0)}${j("enterkeyhint", me === "default" ? void 0 : me, 0)}${j("this", Jt, 0)}>`}`
    }
  )}`}`;
}), gg = "appkit-select", pg = "appkit-select_hint", hg = "appkit-select__select", _g = "appkit-select__option", Bn = {
  select: gg,
  "select__select-text": "appkit-select__select-text",
  select_hint: pg,
  select__select: hg,
  "select__select_has-custom-focused": "appkit-select__select_has-custom-focused",
  "has-custom-focused": "appkit-has-custom-focused",
  select__option: _g
}, mg = xr((r, t, e, i) => {
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K, ge, Q, ue, oe, ye, ee = E, be = () => (ee(), ee = $(K, (_e) => ye = _e), K), $e, ne = E, Ne = () => (ne(), ne = $(ke, (_e) => $e = _e), ke), Ie, Me = E, Re = () => (Me(), Me = $(F, (_e) => Ie = _e), F), Be, Fe = E, Ue = () => (Fe(), Fe = $(I, (_e) => Be = _e), I), xe, J = E, te = () => (J(), J = $(G, (_e) => xe = _e), G), de, fe = E, Qe = () => (fe(), fe = $(z, (_e) => de = _e), z), Ge, gt = E, lt = () => (gt(), gt = $(P, (_e) => Ge = _e), P), pt, R = E, We = () => (R(), R = $(T, (_e) => pt = _e), T), pe, Le = E, ht = () => (Le(), Le = $(C, (_e) => pe = _e), C), xt, Je, Ke, He = E, Ae = () => (He(), He = $(f, (_e) => Ke = _e), f), qe, it = E, nt = () => (it(), it = $(d, (_e) => qe = _e), d), Pe, Ce = E, zt = () => (Ce(), Ce = $(h, (_e) => Pe = _e), h), { componentContext: Y } = t, { layoutParams: wt = void 0 } = t;
  const et = kr(Wr), ot = kr(Xi), tt = et.direction;
  Je = $(tt, (_e) => xt = _e);
  let It, De = !1, Wt = "", At = null, kt = "", Xe = "rgba(0,0,0,.45)", re = 12, ct, Gt = "", b, Nt = "", se = "#000", Ve = "", bt;
  function ve() {
    At = null, Xe = "rgba(0,0,0,.45)", re = 12, ct = void 0, Gt = "", b = void 0, Nt = "", se = "#000", Ve = "";
  }
  Kr(() => {
  }), t.componentContext === void 0 && e.componentContext && Y !== void 0 && e.componentContext(Y), t.layoutParams === void 0 && e.layoutParams && wt !== void 0 && e.layoutParams(wt), n = Y.origJson, n && ve(), o = Y.json.value_variable, l = Y.json.options, c = Array.isArray(l) && l.filter((_e) => typeof _e.value == "string") || [], nt(d = o && (Y.getVariable(o, "string") || et.awaitGlobalVariable(o, "string", "")) || Si("temp", "string", "")), Ae(f = Y.getDerivedFromVars(Y.json.paddings)), zt(h = Y.getDerivedFromVars(Y.json.hint_text)), ht(C = Y.getDerivedFromVars(Y.json.hint_color)), We(T = Y.getDerivedFromVars(Y.json.font_size)), lt(P = Y.getDerivedFromVars(Y.json.font_weight)), Qe(z = Y.getDerivedFromVars(Y.json.font_weight_value)), te(G = Y.getDerivedFromVars(Y.json.font_family)), Ue(I = Y.getDerivedFromVars(Y.json.line_height)), Re(F = Y.getDerivedFromVars(Y.json.letter_spacing)), Ne(ke = Y.getDerivedFromVars(Y.json.text_color)), be(K = Y.getDerivedFromVars(Y.json.accessibility)), Array.isArray(c) && c.length || Y.logError(x(new Error('Empty selection "items" in "select"')));
  {
    let _e = !1;
    o ? (ot.hasAction() || (ye == null ? void 0 : ye.mode) === "exclude") && (_e = !0, Y.logError(x(new Error('Cannot show "select" inside component with an action or inside accessibility mode=exclude')))) : (De = !0, Y.logError(x(new Error('Missing "value_variable" in "select"')))), De !== _e && (De = _e);
  }
  {
    const _e = c.find((ae) => ae.value === qe);
    _e ? Wt = (typeof _e.text == "string" ? _e.text : _e.value) || "" : (Wt = "", qe && bt !== qe && (bt = qe, Y.logError(x(new Error('Value from the variable was not found in the selection items for "select"')))));
  }
  re = fi(pt, re), At = yn(Ke || void 0, At), kt = At ? Vi(
    {
      top: (Number(At.top) || 0) / re * 10,
      right: (Number(xt === "ltr" ? At.end : At.start) || Number(At.right) || 0) / re * 10,
      bottom: (Number(At.bottom) || 0) / re * 10,
      left: (Number(xt === "ltr" ? At.start : At.end) || Number(At.left) || 0) / re * 10
    },
    xt
  ) : "", Xe = lr(pe, 1, Xe), ct = _n(Ge, de, ct), xe && typeof xe == "string" ? Gt = et.typefaceProvider(xe, { fontWeight: ct || 400 }) : Gt = "";
  {
    const _e = Be;
    ui(_e) && (b = _e / re);
  }
  return ko(Ie) && (Nt = Se(Ie / re * 10)), se = lr($e, 1, se), ye != null && ye.description ? Ve = pn(ye) : Y.logError(x(new Error('Missing accessibility "description" for select'), { level: "warn" })), ge = { hint: !Wt }, Q = {
    "--divkit-input-hint-color": Xe,
    "font-weight": ct,
    "font-family": Gt,
    color: se
  }, ue = {
    padding: kt,
    "font-size": Se(re),
    "line-height": b,
    "letter-spacing": Nt
  }, oe = {
    "font-size": Se(re),
    "line-height": b,
    "letter-spacing": Nt
  }, Y.json, ee(), ne(), Me(), Fe(), J(), fe(), gt(), R(), Le(), Je(), He(), it(), Ce(), `${De ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("select", Bn, ge),
      style: Q,
      customDescription: !0,
      customActions: "select",
      customPaddings: !0,
      hasInnerFocusable: !0,
      componentContext: Y,
      layoutParams: wt
    },
    {},
    {
      default: ({ hasCustomFocus: _e, focusHandler: ae, blurHandler: Ot }) => `<span${j("class", Bn["select__select-text"], 0)}${j("style", fr(ue), 0)} aria-hidden="true"> ${ft(Wt || Pe || "​")}</span> <select${j("class", rr("select__select", Bn, { "has-custom-focus": _e }), 0)}${j("aria-label", Ve, 0)}${j("style", fr(oe), 0)}${j("this", It, 0)}>${Or(c, (St) => `<option${j("class", Bn.select__option, 0)}${j("value", St.value, 0)}>${ft(St.text || St.value)}</option>`)}</select>`
    }
  )}`}`;
}), vg = "appkit-video__video", bg = "appkit-video__container", yg = "appkit-video_absolute", cn = {
  video__video: vg,
  video__container: bg,
  "video__aspect-wrapper": "appkit-video__aspect-wrapper",
  video_absolute: yg
};
function wg(r, t) {
  return Array.isArray(r) && r.length ? r.filter((e) => (e == null ? void 0 : e.type) === "video_source" && typeof e.url == "string" && typeof e.mime_type == "string").map((e) => {
    const i = {
      src: e.url
    };
    return e.mime_type && (i.type = e.mime_type), i;
  }) : t;
}
function kg(r) {
  return r === "fill" ? "cover" : r === "no_scale" ? "none" : "contain";
}
const $g = xr((r, t, e, i) => {
  let n, o, l, c, d, f, h, C, T, P, z, G, I, F, ke, K = E, ge = () => (K(), K = $(d, (re) => ke = re), d), Q, ue = E, oe = () => (ue(), ue = $(G, (re) => Q = re), G), ye, ee = E, be = () => (ee(), ee = $(z, (re) => ye = re), z), $e, ne = E, Ne = () => (ne(), ne = $(P, (re) => $e = re), P), Ie, Me = E, Re = () => (Me(), Me = $(T, (re) => Ie = re), T), Be, Fe = E, Ue = () => (Fe(), Fe = $(C, (re) => Be = re), C), xe, J = E, te = () => (J(), J = $(h, (re) => xe = re), h), de, fe = E, Qe = () => (fe(), fe = $(f, (re) => de = re), f), Ge, gt = E, lt = () => (gt(), gt = $(c, (re) => Ge = re), c), pt, R = E, We = () => (R(), R = $(l, (re) => pt = re), l), { componentContext: pe } = t, { layoutParams: Le = void 0 } = t;
  const ht = kr(Wr), xt = ht.videoPlayerProvider;
  let Je, Ke = !1, He, Ae, qe = [], it = !1, nt = !1, Pe = !1, Ce = !1, zt, Y = "fit", wt = "0", et = !1, ot, tt = "", It, De = !!xt;
  if (xt) {
    const re = xt;
    if (typeof re.template == "string")
      tt = re.template;
    else {
      const ct = Wt(pe.json);
      ct ? tt = re.template(ct) : De = !1;
    }
  }
  function Wt(re) {
    var bt, ve;
    const ct = pe.getJsonWithVars({
      sources: re.video_sources,
      repeatable: re.repeatable,
      autostart: re.autostart,
      preloadRequired: re.preload_required,
      muted: re.muted,
      preview: re.preview,
      aspect: re.aspect,
      scale: re.scale,
      payload: re.player_settings_payload
    }), Gt = ri(ct.repeatable, !1), b = ri(ct.autostart, !1), Nt = ri(ct.preloadRequired, !1), se = ri(ct.muted, !1), Ve = (bt = ct.aspect) != null && bt.ratio && ui(ct.aspect.ratio) ? ct.aspect.ratio : void 0;
    if ((ve = ct.sources) != null && ve.length)
      return {
        sources: ct.sources,
        repeatable: Gt,
        autostart: b,
        preloadRequired: Nt,
        muted: se,
        preview: ct.preview,
        aspect: Ve,
        scale: ct.scale,
        payload: ct.payload
      };
  }
  function At(re) {
  }
  function kt() {
  }
  function Xe() {
  }
  Kr(() => {
    Je && (ht.unregisterInstance(Je), Je = void 0), ot && (ot(), ot = void 0);
  }), t.componentContext === void 0 && e.componentContext && pe !== void 0 && e.componentContext(pe), t.layoutParams === void 0 && e.layoutParams && Le !== void 0 && e.layoutParams(Le), pe.json && (it = !1, nt = !1, Pe = !1, Ce = !1, zt = void 0, Y = "fit", et = !1, De = !!xt), pe.json, n = pe.json.elapsed_time_variable, o = n && (pe.getVariable(n, "integer") || ht.awaitGlobalVariable(n, "integer", 0)) || Si("temp", "integer", 0), o && (ot && ot(), ot = o.subscribe(At)), We(l = pe.getDerivedFromVars(pe.json.video_sources)), lt(c = pe.getDerivedFromVars(pe.json.repeatable)), ge(d = pe.getDerivedFromVars(pe.json.autostart)), Qe(f = pe.getDerivedFromVars(pe.json.muted)), te(h = pe.getDerivedFromVars(pe.json.preload_required)), Ue(C = pe.getDerivedFromVars(pe.json.preview)), Re(T = pe.getDerivedFromVars(pe.json.scale)), Ne(P = pe.getDerivedFromVars(pe.json.aspect)), be(z = pe.getDerivedFromVars(pe.json.width)), oe(G = pe.getDerivedFromVars(pe.json.height)), qe = wg(pt, qe), qe.length ? Ke = !1 : (Ke = !0, pe.logError(x(new Error('Missing "video_sources" in "video"')))), it = ri(Ge, it), nt = ri(ke, nt), Pe = ri(de, Pe), Ce = ri(xe, Ce), zt = typeof Be == "string" ? Xa(Be) : zt, Y = kg(Ie) || Y;
  {
    const re = $e == null ? void 0 : $e.ratio;
    re && ui(re) ? (wt = (100 / Number(re)).toFixed(2), et = !0) : (wt = "0", et = (!ye || ye.type === "match_parent") && (Q == null ? void 0 : Q.type) === "match_parent");
  }
  return pe.json && (Je && (ht.unregisterInstance(Je), Je = void 0), pe.id && !Ke && !pe.fakeElement && (Je = pe.id, ht.registerInstance(Je, { pause: kt, start: Xe }))), pe.json, I = { absolute: et }, F = { "object-fit": Y }, K(), ue(), ee(), ne(), Me(), Fe(), J(), fe(), gt(), R(), `${Ke ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("video", cn, I),
      customActions: "video",
      componentContext: pe,
      layoutParams: Le,
      heightByAspect: wt !== "0"
    },
    {},
    {
      default: () => `${wt !== "0" ? `<div${j("class", cn["video__aspect-wrapper"], 0)}${Hr({
        "padding-bottom": `${wt}%`
      })}>${De ? `<div${j("class", cn.video__container, 0)}${j("this", Ae, 0)}> ${tt}</div>` : `<video${j("class", cn.video__video, 0)}${j("style", fr(F), 0)} playsinline ${it ? "loop" : ""} ${nt ? "autoplay" : ""} ${Pe ? "muted" : ""}${j("poster", zt, 0)}${j("preload", Ce ? "metadata" : "auto", 0)}${j("this", He, 0)}>${Or(qe, (re) => `<source${j("src", re.src, 0)}${j("type", re.type, 0)}>`)}</video>`}</div>` : `${De ? `<div${j("class", cn.video__container, 0)}${j("this", Ae, 0)}> ${tt}</div>` : `<video${j("class", cn.video__video, 0)}${j("style", fr(F), 0)} playsinline ${it ? "loop" : ""} ${nt ? "autoplay" : ""} ${Pe ? "muted" : ""}${j("poster", zt, 0)}${j("preload", Ce ? "metadata" : "auto", 0)}${j("this", He, 0)}>${Or(qe, (re) => `<source${j("src", re.src, 0)}${j("type", re.type, 0)}>`)}</video>`}`}`
    }
  )}`}`;
}), jg = "appkit-switch__tumbler", Eg = "appkit-switch__tumbler_checked", xg = "appkit-switch_disabled", Ag = "appkit-switch__thumb", Cg = "appkit-switch_direction_rtl", Sg = "appkit-switch__input", Ln = {
  switch: "appkit-switch",
  switch__tumbler: jg,
  switch__tumbler_checked: Eg,
  switch_disabled: xg,
  switch__thumb: Ag,
  switch_direction_rtl: Cg,
  switch__input: Sg
};
function zo(r) {
  return r === !0 || r === 1;
}
const Vg = xr((r, t, e, i) => {
  let n, o, l, c, d, f, h, C, T, P, z, G = E, I = () => (G(), G = $(c, (de) => z = de), c), F, ke = E, K = () => (ke(), ke = $(f, (de) => F = de), f), ge, Q = E, ue = () => (Q(), Q = $(d, (de) => ge = de), d), oe, ye = E, ee = () => (ye(), ye = $(l, (de) => oe = de), l), { componentContext: be } = t, { layoutParams: $e = void 0 } = t;
  const ne = kr(Wr), Ne = kr(Xi), Ie = ne.direction;
  P = $(Ie, (de) => T = de);
  let Me, Re = !1, Be = !1, Fe = "", Ue = !0, xe = "#129386", J = "#1293864c";
  function te() {
    Ue = !0, xe = "#129386", J = "#1293864c";
  }
  Kr(() => {
  }), t.componentContext === void 0 && e.componentContext && be !== void 0 && e.componentContext(be), t.layoutParams === void 0 && e.layoutParams && $e !== void 0 && e.layoutParams($e), n = be.origJson, n && te(), o = be.json.is_on_variable, ee(l = o && (be.getVariable(o, "boolean") || ne.awaitGlobalVariable(o, "boolean", !1)) || Si("temp", "boolean", !1)), I(c = be.getDerivedFromVars(be.json.accessibility)), ue(d = be.getDerivedFromVars(be.json.is_enabled)), K(f = be.getDerivedFromVars(be.json.on_color));
  {
    let de = !1;
    o ? (Ne.hasAction() || (z == null ? void 0 : z.mode) === "exclude") && (de = !0, be.logError(x(new Error('Cannot show "switch" inside component with an action or inside accessibility mode=exclude')))) : (de = !0, be.logError(x(new Error('Missing "is_on_variable" in "switch"')))), Be !== de && (Be = de);
  }
  if (zo(Re) !== zo(oe) && (Re = zo(oe)), Ue = ri(ge, Ue), xe = lr(F, 1, xe), typeof F == "string") {
    const de = ji(F);
    de && (de.a *= 0.3, J = ss(de));
  }
  return z != null && z.description ? Fe = pn(z) : be.logError(x(new Error('Missing accessibility "description" for switch'), { level: "warn" })), h = {
    disabled: !Ue,
    direction: T
  }, C = {
    "--divkit-switch-on-color": xe,
    "--divkit-switch-on-sub-color": J
  }, P(), G(), ke(), Q(), ye(), `${Be ? "" : `${Yt(ai, "Outer").$$render(
    r,
    {
      cls: rr("switch", Ln, h),
      style: C,
      customDescription: !0,
      customActions: "switch",
      hasInnerFocusable: !0,
      componentContext: be,
      layoutParams: $e
    },
    {},
    {
      default: ({ focusHandler: de, blurHandler: fe, hasCustomFocus: Qe }) => `<div${j("class", rr("switch__tumbler", Ln, { checked: Re }), 0)}><div${j("class", Ln.switch__thumb, 0)}></div></div> <input type="checkbox"${j("class", rr("switch__input", Ln, { "has-custom-focus": Qe }), 0)} autocomplete="off"${j("aria-label", Fe, 0)} ${Ue ? "" : "disabled"} ${Re ? "checked" : ""}${j("this", Me, 0)}>`
    }
  )}`}`;
}), Fg = xr((r, t, e, i) => {
  var z;
  let n, { componentContext: o } = t, { layoutParams: l = void 0 } = t;
  const c = kr(Wr);
  let d, f = null, h = "", C = {}, T = [], P = !1;
  if (Kr(() => {
    T.forEach((G) => {
      G.destroy();
    });
  }), t.componentContext === void 0 && e.componentContext && o !== void 0 && e.componentContext(o), t.layoutParams === void 0 && e.layoutParams && l !== void 0 && e.layoutParams(l), typeof o.json.custom_type == "string" && o.json.custom_type && ((z = c.customComponents) != null && z.has(o.json.custom_type))) {
    if (f = c.customComponents.get(o.json.custom_type), typeof f.template == "function") {
      const G = c.getExtensionContext(o), I = /* @__PURE__ */ new Map();
      for (const [F, ke] of G.variables)
        I.set(F, ke.getValue());
      h = f.template({
        props: o.json.custom_props,
        variables: I
      });
    } else
      f.template && typeof f.template == "string" ? h = f.template : h = "";
    C = {
      shadowrootmode: f.shadowRootMode || "open"
    };
  } else
    f = null, h = ";", o.logError(x(new Error('Unknown or incorrect "custom_type" prop for div "custom"')));
  return n = o.json.items, n !== void 0 && !Array.isArray(n) ? (P = !0, o.logError(x(new Error('Incorrect "items" prop for div "custom"')))) : P = !1, T.forEach((G) => {
    G.destroy();
  }), T = (!P && n || []).map((G, I) => o.produceChildContext(G, { path: I })), `${f ? `${Yt(ai, "Outer").$$render(r, { componentContext: o, layoutParams: l }, {}, {
    default: () => `${((G) => G ? `<${f.element}${fn([gn(o.json.custom_props || {})], {})}${j("this", d, 0)}>${Oi(G) ? "" : `${h ? `<template${fn([gn(C)], {})}> ${h}</template>` : ""} ${!P && n ? `${Or(T, (I) => `${Yt(yi, "Unknown").$$render(r, { componentContext: I }, {}, {})}`)}` : ""}`}${Oi(G) ? "" : `</${G}>`}` : "")(f.element)}`
  })}` : ""}`;
}), dl = {
  text: Zc,
  container: Su,
  separator: Tu,
  image: Us,
  gif: Us,
  grid: Xu,
  gallery: fd,
  tabs: Id,
  state: Ud,
  pager: sf,
  indicator: mf,
  slider: Jf,
  input: fg,
  select: mg,
  video: $g,
  switch: Vg,
  custom: Fg
}, yi = xr((r, t, e, i) => {
  let { componentContext: n } = t, { layoutParams: o = void 0 } = t;
  const l = kr(Wr);
  let c;
  t.componentContext === void 0 && e.componentContext && n !== void 0 && e.componentContext(n), t.layoutParams === void 0 && e.layoutParams && o !== void 0 && e.layoutParams(o);
  {
    const d = n.json;
    if (c = (d == null ? void 0 : d.type) && dl[d.type] || void 0, !c) {
      let f;
      d != null && d.type && l.hasTemplate(d.type) ? f = "Recursive template" : f = "Unknown component", n.logError(x(new Error(f), {
        additional: {
          component: (d == null ? void 0 : d.type) || "<missing>"
        }
      }));
    }
  }
  return `${c ? `${Yt(c || Ul, "svelte:component").$$render(r, { componentContext: n, layoutParams: o }, {}, {})}` : ""}`;
}), Ig = {
  "root-svg-filters": "appkit-root-svg-filters"
}, Dg = xr((r, t, e, i) => {
  let { svgFiltersMap: n } = t;
  return t.svgFiltersMap === void 0 && e.svgFiltersMap && n !== void 0 && e.svgFiltersMap(n), `${Object.keys(n).length ? `<svg${j("class", Ig["root-svg-filters"], 0)} aria-hidden="true"><defs>${Or([...Object.keys(n)], (o) => {
    let [l, c] = o.split(":");
    return ` <filter${j("id", n[o], 0)}><feFlood${j("flood-color", l, 0)}></feFlood>${c === "source_in" || c === "source_atop" ? `<feComposite in2="SourceGraphic"${j("operator", c.split("_")[1], 0)}></feComposite>` : `${c === "multiply" ? '<feComposite in2="SourceGraphic" operator="arithmetic" k1="1" k2="0" k3="0" k4="0"></feComposite>' : `<feBlend in2="SourceGraphic"${j("mode", c, 0)}></feBlend>`}`}</filter>`;
  })}</defs></svg>` : ""}`;
});
function Tg(r, t, e, i) {
  const n = e[r.type];
  if (!n)
    return i(x(new Error("No such template"), {
      additional: {
        template: r.type
      }
    })), {
      json: r,
      templateContext: t
    };
  let o;
  const l = {};
  for (o in t)
    t.hasOwnProperty(o) && (l[o] = t[o]);
  for (o in r)
    o === "type" || o === "__proto__" || r.hasOwnProperty(o) && (l[o] = r[o]);
  function c(f, h) {
    const C = Object.keys(h).filter((z) => z !== "__proto__"), T = C.filter((z) => z.charAt(0) !== "$"), P = C.filter((z) => z.charAt(0) === "$");
    return T.forEach((z) => {
      const G = h[z];
      typeof G == "object" && G !== null ? (f[z] = Array.isArray(G) ? [] : {}, c(f[z], G)) : f[z] = G;
    }), P.forEach((z) => {
      const G = h[z], I = l[G];
      if (I !== void 0) {
        const F = z.substring(1);
        f[F] = I;
      }
    }), f;
  }
  const d = c({}, n);
  for (o in r)
    o === "type" || o === "__proto__" || r.hasOwnProperty(o) && (d[o] = r[o]);
  return {
    json: d,
    templateContext: l
  };
}
const Qn = /* @__PURE__ */ new Map(), Jo = /* @__PURE__ */ new Map(), eo = /* @__PURE__ */ new Map(), Yo = /* @__PURE__ */ new Map();
function k(r, t, e) {
  const i = {
    args: t,
    cb: e
  }, n = Qn.get(r) || [];
  Qn.has(r) || Qn.set(r, n), n.push(i);
  const o = r + ":" + t.map((l) => typeof l == "object" ? l.type : l).join("#");
  Jo.set(o, i);
}
function dr(r, t, e) {
  const i = {
    args: t,
    cb: e
  }, n = eo.get(r) || [];
  eo.has(r) || eo.set(r, n), n.push(i);
  const o = r + ":" + t.map((l) => typeof l == "object" ? l.type : l).join("#");
  Yo.set(o, i);
}
function Mg(r, t, e) {
  const i = r.args.length;
  let n = r.args.length, o = 0;
  const l = r.args[r.args.length - 1];
  if (typeof l == "object" && l.isVararg && (n = 1 / 0), t.length < i)
    return {
      type: "few",
      expected: i,
      found: t.length,
      def: r,
      hasOverloads: e
    };
  if (t.length > n)
    return {
      type: "many",
      expected: n,
      found: t.length,
      def: r,
      hasOverloads: e
    };
  for (let c = 0; c < t.length; ++c) {
    let d = c >= r.args.length ? r.args[r.args.length - 1] : r.args[c];
    if (typeof d != "object" && (d = {
      type: d
    }), d.type === we && t[c].type === q) {
      ++o;
      continue;
    }
    if (d.type !== t[c].type)
      return {
        type: "mismatch",
        expected: d.type,
        found: t[c].type,
        def: r,
        hasOverloads: e
      };
  }
  return {
    type: "match",
    conversions: o
  };
}
function Ko(r, t, e) {
  const i = r.get(t);
  if (!i)
    return {
      type: "missing"
    };
  let n = null, o = null;
  for (let l = 0; l < i.length; ++l) {
    const c = Mg(i[l], e, i.length > 1);
    if (c.type === "match") {
      (!o || o.conversions > c.conversions) && (o = {
        func: i[l],
        conversions: c.conversions
      });
      continue;
    }
    n || (n = c);
  }
  if (!o) {
    if (n)
      return n;
    throw new Error("Missing function");
  }
  return o;
}
function fl(r, t) {
  return t.map((e, i) => {
    let n = i >= r.args.length ? r.args[r.args.length - 1] : r.args[i];
    return typeof n != "object" && (n = {
      type: n
    }), n.type === we && e.type === q ? Go(e) : e;
  });
}
function ia(r, t) {
  return r + ":" + t.args.map((e) => typeof e == "string" ? e : e.type).join("#");
}
function ni(r, t) {
  return {
    type: Z,
    value: Qi(t, !0)
  };
}
function na(r, t) {
  const e = Number(t.value);
  if (Number.isNaN(e) || !Number.isFinite(e))
    throw new Error("Unable to convert value to Number.");
  if (t.value === "")
    throw new Error("Unable to convert value to Number.");
  return {
    type: we,
    value: e
  };
}
function Pg(r, t) {
  if (t.value > Fn || t.value < In)
    throw new Error("Unable to convert value to Integer.");
  const e = t.value - t.value % 1;
  return {
    type: q,
    value: zr(e)
  };
}
function zg(r, t) {
  let e;
  try {
    e = zr(t.value);
  } catch {
    throw new Error("Unable to convert value to Integer.");
  }
  return {
    type: q,
    value: e
  };
}
function Og(r, t) {
  return {
    type: q,
    value: zr(t.value ? 1 : 0)
  };
}
function Ng(r, t) {
  const e = Number(t.value);
  if (e !== 1 && e !== 0)
    throw new Error("Unable to convert value to Boolean.");
  return {
    type: gr,
    value: e
  };
}
function Rg(r, t) {
  if (t.value !== "true" && t.value !== "false")
    throw new Error("Unable to convert value to Boolean.");
  return {
    type: gr,
    value: t.value === "true" ? 1 : 0
  };
}
function Bg(r, t) {
  return {
    type: Pr,
    value: Bi(t.value)
  };
}
function Lg(r, t) {
  return Ei(t.value), {
    type: _i,
    value: t.value
  };
}
function Hg(r, t) {
  try {
    return {
      type: Z,
      value: encodeURIComponent(t.value)
    };
  } catch {
    throw new Error("Unable to encodeUri string.");
  }
}
function Wg(r, t) {
  try {
    return {
      type: Z,
      value: decodeURIComponent(t.value)
    };
  } catch {
    throw new Error("Unable to decodeUri string.");
  }
}
function ms(r, t, e, i) {
  const n = r.variables.get(t.value);
  let o;
  return n && n.getType() === i ? (o = n.getValue(), r.storeUsedVars || (r.storeUsedVars = /* @__PURE__ */ new Set()), r.storeUsedVars.add(n)) : o = e.value, i === "color" ? o = Bi(o) : i === "url" && Ei(o), {
    type: i,
    // value is synced with type by params
    value: o
  };
}
function Hn(r, t, e) {
  return ms(r, t, e, e.type);
}
function oa(r, t, e) {
  return ms(r, t, e, "color");
}
function sa(r, t, e) {
  return ms(r, t, e, "url");
}
function gl(r, t) {
  for (let e = 0; e < t.length; ++e) {
    const i = r.charAt(e), n = t.charAt(e);
    if (i !== n && n)
      return n;
  }
  return "";
}
const mo = 1234567890;
function aa(r) {
  const t = new Intl.NumberFormat(r, {
    maximumFractionDigits: 0
  }), e = new Intl.NumberFormat(r, {
    minimumFractionDigits: 1
  }), i = t.format(mo), n = e.format(mo);
  return gl(i, n);
}
function Ug(r) {
  const t = new Intl.NumberFormat(r, {
    useGrouping: !1
  }), e = new Intl.NumberFormat(r, {
    useGrouping: !0
  }), i = t.format(mo), n = e.format(mo);
  return gl(i, n);
}
function zi(r, t, e, i) {
  const n = e.value, o = n.replace(/,/g, "");
  if (!/^((#+)|(#*0+))(\.0*#*)?$/.test(o) && !/^#*0*\.((0*#*)|(#+))$/.test(o) || /,.*,/.test(n) || n.indexOf(",") > n.indexOf(".") && n.indexOf(".") > -1)
    throw new Error("Incorrect format pattern.");
  const l = n.split("."), c = l[0], d = l[1] || "", f = n.replace(/[^#0.]/g, "").split("."), h = f[0], C = f[1] || "", T = c.indexOf(","), P = T > -1 ? c.length - T - 1 : -1;
  if (T > -1 && P < 1 || d.indexOf(",") > -1)
    throw new Error("Incorrect format pattern.");
  try {
    let z = 0;
    for (; h[h.length - 1 - z] === "0"; )
      ++z;
    let G = 0;
    for (; C[G] === "0"; )
      ++G;
    let I = G;
    for (; C[I] === "#"; )
      ++I;
    let ke = new Intl.NumberFormat((i == null ? void 0 : i.value) || void 0, {
      useGrouping: !1,
      minimumIntegerDigits: Math.min(Math.max(z, 1), 21),
      minimumFractionDigits: Math.min(Math.max(G, 0), 100),
      maximumFractionDigits: Math.min(Math.max(I, G, 0), 100),
      roundingMode: "halfEven"
    }).format(t.value);
    if (T > -1 && P > 0) {
      const K = Ug(i == null ? void 0 : i.value), ge = aa(i == null ? void 0 : i.value);
      if (K && ge) {
        const Q = ke.split(ge), ue = Q[0];
        let oe = "";
        for (let ye = ue.length - 1; ye >= 0; --ye)
          oe = ue[ye] + oe, ye > 0 && (ue.length - ye) % P === 0 && (oe = K + oe);
        ke = oe + (Q.length > 1 ? ge + Q[1] : "");
      }
    }
    if (G === 0 && I === 0 && n.endsWith(".")) {
      const K = aa(i == null ? void 0 : i.value);
      K && (ke += K);
    }
    return {
      type: Z,
      value: ke
    };
  } catch (z) {
    throw new Error("Incorrect or unsupported number format." + z + " " + (i == null ? void 0 : i.value) || void 0);
  }
}
function Gg() {
  k("toString", [q], ni), k("toString", [we], ni), k("toString", [gr], ni), k("toString", [Pr], ni), k("toString", [_i], ni), k("toString", [Z], ni), k("toString", [Pt], ni), k("toString", [Ft], ni), k("toNumber", [q], na), k("toNumber", [Z], na), k("toInteger", [we], Pg), k("toInteger", [Z], zg), k("toInteger", [gr], Og), k("toBoolean", [q], Ng), k("toBoolean", [Z], Rg), k("toColor", [Z], Bg), k("toUrl", [Z], Lg), k("encodeUri", [Z], Hg), k("decodeUri", [Z], Wg), k("getIntegerValue", [Z, q], Hn), k("getNumberValue", [Z, we], Hn), k("getBooleanValue", [Z, gr], Hn), k("getStringValue", [Z, Z], Hn), k("getColorValue", [Z, Pr], oa), k("getColorValue", [Z, Z], oa), k("getUrlValue", [Z, _i], sa), k("getUrlValue", [Z, Z], sa), dr("toString", [q], ni), dr("toString", [we], ni), dr("toString", [gr], ni), dr("toString", [Pr], ni), dr("toString", [_i], ni), dr("toString", [Z], ni), dr("toString", [Pt], ni), dr("toString", [Ft], ni), k("decimalFormat", [q, Z], zi), k("decimalFormat", [we, Z], zi), k("decimalFormat", [q, Z, Z], zi), k("decimalFormat", [we, Z, Z], zi), dr("decimalFormat", [q, Z], zi), dr("decimalFormat", [we, Z], zi), dr("decimalFormat", [q, Z, Z], zi), dr("decimalFormat", [we, Z, Z], zi);
}
function oi(r, t) {
  return !r || !t ? r : r.padStart(t, "0");
}
const Xo = {
  G(r, t) {
    let e;
    return r < 4 ? e = "short" : r === 5 ? e = "narrow" : e = "long", t({
      era: e
    }, "era");
  },
  d(r, t) {
    return oi(t({
      day: "numeric"
    }, "day"), r > 1 ? r : 0);
  },
  D(r, t) {
    return oi(t({}, "dayofyear"), r > 1 ? r : 0);
  },
  F(r, t) {
    return oi(t({}, "dayofweekinmonth"), r > 1 ? r : 0);
  },
  M(r, t) {
    let e;
    return r === 1 ? e = "numeric" : r === 2 ? e = "2-digit" : r === 3 ? e = "short" : r === 5 ? e = "narrow" : e = "long", t({
      month: e,
      // to get a genitive case of month
      day: "numeric"
    }, "month");
  },
  y(r, t) {
    return oi(t({
      year: r === 2 ? "2-digit" : "numeric"
    }, "year"), r > 2 ? r : void 0);
  },
  Y(r, t) {
    return oi(t({
      year: r === 2 ? "2-digit" : "numeric"
    }, "weekyear"), r > 2 ? r : void 0);
  },
  u(r, t) {
    return oi(t({
      year: "numeric"
    }, "extendedyear"), r > 1 ? r : void 0);
  },
  E(r, t) {
    let e;
    return r <= 3 ? e = "short" : r === 5 ? e = "narrow" : e = "long", t({
      weekday: e
    }, "weekday");
  },
  e(r, t) {
    return r > 2 ? Xo.E(r, t) : oi(t({}, "weekdaynumeric"), r > 1 ? r : void 0);
  },
  w(r, t) {
    return oi(t({}, "week"), r > 1 ? r : void 0);
  },
  W(r, t) {
    return oi(t({}, "weekofmonth"), r > 1 ? r : void 0);
  },
  H(r, t) {
    const e = t({
      hour: "numeric",
      hour12: !1,
      hourCycle: "h23"
    }, "hour");
    if (!e)
      return;
    const i = String(Number(e) % 24);
    return oi(i, r > 1 ? r : void 0);
  },
  h(r, t) {
    return oi(t({
      hour: "numeric",
      hour12: !0,
      hourCycle: "h12"
    }, "hour"), r > 1 ? r : void 0);
  },
  K(r, t) {
    const e = t({
      hour: "numeric",
      hour12: !0,
      hourCycle: "h11"
    }, "hour");
    if (!e)
      return;
    const i = String(Number(e) % 12);
    return oi(i, r > 1 ? r : void 0);
  },
  k(r, t) {
    return oi(t({
      hour: "numeric",
      hour12: !1,
      hourCycle: "h24"
    }, "hour"), r > 2 ? r : void 0);
  },
  a(r, t) {
    return t({
      hour: "numeric",
      hour12: !0,
      hourCycle: "h11",
      dayPeriod: void 0
    }, "dayPeriod");
  },
  m(r, t) {
    return oi(t({
      minute: "numeric"
    }, "minute"), r > 1 ? r : void 0);
  },
  s(r, t) {
    return oi(t({
      second: "numeric"
    }, "second"), r > 1 ? r : void 0);
  },
  S(r, t) {
    const e = t({
      fractionalSecondDigits: Math.min(3, r)
    }, "fractionalSecond");
    return e && r > 3 ? e.padEnd(r, "0") : e;
  },
  z(r, t) {
    return t({
      timeZoneName: r === 4 ? "long" : "short"
    }, "timeZoneName");
  },
  Z(r, t) {
    const e = -Number(t({}, "timezoneoffset")), i = Math.abs(e / 60), n = Math.floor(i) * 100 + (i - Math.floor(i)) * 60;
    return (e >= 0 ? "+" : "-") + oi(String(n), 4);
  }
}, qg = /(\w)\1*|''|'(''|[^'])+('|$)|./g, Jg = /^'([^]*?)'?$/, Yg = /''/g, Kg = /[a-zA-Z]/, vs = 1e3 * 60 * 60 * 24;
function Xg(r) {
  const t = r.match(Jg);
  return t ? t[1].replace(Yg, "'") : r;
}
function Zo(r, t, e) {
  const i = r[t ? "getUTCDay" : "getDay"](), n = i < e ? e - i - 7 : e - i;
  return new Date(r.getTime() + vs * n);
}
function la(r, t, e) {
  const i = new Date(r);
  return i[t ? "setUTCDate" : "setDate"](1), i[t ? "setUTCMonth" : "setMonth"](0), Zo(i, t, e);
}
function ca(r, t) {
  return Math.round((r.getTime() - t.getTime()) / vs);
}
function ua(r, t, e) {
  let i = 0;
  const n = la(r, t || !1, e), o = new Date(r);
  o[t ? "setUTCFullYear" : "setFullYear"](r[t ? "getUTCFullYear" : "getFullYear"]() + 1);
  const l = la(o, t || !1, e), c = r.getTime() < n.getTime(), d = r.getTime() >= l.getTime();
  let f = r[t ? "getUTCFullYear" : "getFullYear"]();
  if (c) {
    --f, n[t ? "setUTCFullYear" : "setFullYear"](n[t ? "getUTCFullYear" : "getFullYear"]() - 1);
    const h = ca(Zo(r, t, e), n);
    i = Math.round(h / 7) + 1;
  } else if (d)
    ++f, i = 1;
  else {
    const h = ca(Zo(r, t, e), n);
    i = Math.round(h / 7) + 1;
  }
  return {
    week: i,
    year: f
  };
}
function Zg(r, t, {
  locale: e,
  isUTC: i,
  weekStartDay: n = 0
} = {}) {
  const o = (l, c) => {
    if (c === "week") {
      const { week: h } = ua(r, i || !1, n);
      return String(h);
    }
    if (c === "weekofmonth") {
      const h = r[i ? "getUTCDay" : "getDay"](), C = new Date(r);
      C[i ? "setUTCDate" : "setDate"](1);
      const T = C[i ? "getUTCDay" : "getDay"](), P = r[i ? "getUTCDate" : "getDate"]();
      return String(Math.ceil(P / 7) + (h < T ? 1 : 0));
    }
    if (c === "dayofweekinmonth") {
      const h = r[i ? "getUTCDate" : "getDate"]();
      return String(Math.ceil(h / 7));
    }
    if (c === "weekdaynumeric") {
      let h = r[i ? "getUTCDay" : "getDay"]();
      return h < n && (h += 7), String(h - n + 1);
    }
    if (c === "dayofyear") {
      const h = new Date(r);
      h[i ? "setUTCMonth" : "setMonth"](0), h[i ? "setUTCDate" : "setDate"](1), h[i ? "setUTCHours" : "setHours"](1), h[i ? "setUTCMinutes" : "setMinutes"](1), h[i ? "setUTCSeconds" : "setSeconds"](1);
      const C = Math.ceil((r.getTime() - h.getTime()) / vs);
      return String(C);
    }
    if (c === "weekyear") {
      let { year: h } = ua(r, i || !1, n);
      return h < 1 && (h = 1 - h), l.year === "2-digit" ? String(h % 100) : String(h);
    }
    if (c === "extendedyear") {
      const h = r[i ? "getUTCFullYear" : "getFullYear"]();
      return l.year === "2-digit" ? String(h % 100) : String(h);
    }
    if (c === "timezoneoffset")
      return i ? "0" : String(r.getTimezoneOffset());
    i && (l.timeZone = "UTC");
    const f = new Intl.DateTimeFormat(e, l).formatToParts(r);
    for (let h = 0; h < f.length; ++h)
      if (f[h].type === c)
        return f[h].value;
  };
  return (t.match(qg) || []).map((l) => {
    if (l === "''")
      return "'";
    const c = l[0];
    if (c === "'")
      return Xg(l);
    if (Xo[c])
      return Xo[c](l.length, o);
    if (c.match(Kg))
      throw new Error(
        `Format string contains an unescaped latin alphabet character "${c}"`
      );
    return l;
  }).join("");
}
function Qg(r) {
  const t = new Date(r);
  return t.setUTCMonth(t.getUTCMonth() + 1), t.setUTCDate(0), t.getUTCDate();
}
function ep(r, t) {
  return {
    type: Qt,
    value: new Date(Number(t.value) * 1e3)
  };
}
function tp(r, t) {
  const e = new Date(Number(t.value) * 1e3), i = e.getTimezoneOffset();
  return e.setMinutes(e.getMinutes() - i), {
    type: Qt,
    value: e
  };
}
function rp() {
  return {
    type: Qt,
    value: /* @__PURE__ */ new Date()
  };
}
function ip(r, t, e) {
  return {
    type: Qt,
    value: new Date(t.value.getTime() + Number(e.value))
  };
}
function np(r, t, e) {
  const i = new Date(t.value);
  return i.setUTCFullYear(Number(e.value)), {
    type: Qt,
    value: i
  };
}
function op(r, t, e) {
  const i = Number(e.value);
  if (i < 1 || i > 12)
    throw new Error(`Expecting month in [1..12], instead got ${i}.`);
  const n = new Date(t.value);
  return n.setUTCMonth(i - 1), {
    type: Qt,
    value: n
  };
}
function sp(r, t, e) {
  const i = new Date(t.value), n = Number(e.value);
  if (n <= 0 && n !== -1 || n > Qg(i))
    throw new Error(`Unable to set day ${n} for date ${Qi(t, !1)}.`);
  return i.setUTCDate(n === -1 ? 0 : n), {
    type: Qt,
    value: i
  };
}
function ap(r, t, e) {
  const i = Number(e.value);
  if (i < 0 || i > 23)
    throw new Error(`Expecting hours in [0..23], instead got ${i}.`);
  const n = new Date(t.value);
  return n.setUTCHours(i), {
    type: Qt,
    value: n
  };
}
function lp(r, t, e) {
  const i = Number(e.value);
  if (i < 0 || i > 59)
    throw new Error(`Expecting minutes in [0..59], instead got ${i}.`);
  const n = new Date(t.value);
  return n.setUTCMinutes(i), {
    type: Qt,
    value: n
  };
}
function cp(r, t, e) {
  const i = Number(e.value);
  if (i < 0 || i > 59)
    throw new Error(`Expecting seconds in [0..59], instead got ${i}.`);
  const n = new Date(t.value);
  return n.setUTCSeconds(i), {
    type: Qt,
    value: n
  };
}
function up(r, t, e) {
  const i = Number(e.value);
  if (i < 0 || i > 999)
    throw new Error(`Expecting millis in [0..999], instead got ${i}.`);
  const n = new Date(t.value);
  return n.setUTCMilliseconds(i), {
    type: Qt,
    value: n
  };
}
const Li = (r) => (t, e) => {
  let n = new Date(e.value.getTime())[r]();
  return r === "getUTCMonth" ? ++n : r === "getUTCDay" && n === 0 && (n = 7), {
    type: q,
    value: zr(n)
  };
};
function pl(r) {
  return (t, e, i, n) => ({
    type: Z,
    value: Zg(e.value, i.value, {
      locale: n == null ? void 0 : n.value,
      isUTC: r,
      weekStartDay: t.weekStartDay
    })
  });
}
const dp = Li("getUTCFullYear"), fp = Li("getUTCMonth"), gp = Li("getUTCDate"), pp = Li("getUTCDay"), hp = Li("getUTCHours"), _p = Li("getUTCMinutes"), mp = Li("getUTCSeconds"), vp = Li("getUTCMilliseconds"), da = pl(!1), fa = pl(!0);
function bp() {
  k("parseUnixTime", [q], ep), k("parseUnixTimeAsLocal", [q], tp), k("nowLocal", [], rp), k("addMillis", [Qt, q], ip), k("setYear", [Qt, q], np), k("setMonth", [Qt, q], op), k("setDay", [Qt, q], sp), k("setHours", [Qt, q], ap), k("setMinutes", [Qt, q], lp), k("setSeconds", [Qt, q], cp), k("setMillis", [Qt, q], up), k("getYear", [Qt], dp), k("getMonth", [Qt], fp), k("getDay", [Qt], gp), k("getDayOfWeek", [Qt], pp), k("getHours", [Qt], hp), k("getMinutes", [Qt], _p), k("getSeconds", [Qt], mp), k("getMillis", [Qt], vp), k("formatDateAsLocal", [Qt, Z], da), k("formatDateAsUTC", [Qt, Z], fa), k("formatDateAsLocalWithLocale", [Qt, Z, Z], da), k("formatDateAsUTCWithLocale", [Qt, Z, Z], fa);
}
function yp(r) {
  return r.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function wp(r, t) {
  return {
    type: q,
    value: zr(t.value.length)
  };
}
function kp(r, t, e) {
  return {
    type: gr,
    value: t.value.includes(e.value) ? 1 : 0
  };
}
function $p(r, t, e, i) {
  if (i.value < e.value)
    throw new Error("Indexes should be in ascending order.");
  if (e.value < 0 || e.value > t.value.length || i.value < 0 || i.value > t.value.length)
    throw new Error("Indexes are out of bounds.");
  return {
    type: Z,
    value: t.value.substring(Number(e.value), Number(i.value))
  };
}
function jp(r, t, e, i) {
  let n;
  return e.value ? n = t.value.replace(new RegExp(yp(e.value), "g"), i.value) : n = t.value, {
    type: Z,
    value: n
  };
}
function Ep(r, t, e) {
  return {
    type: q,
    value: zr(t.value.indexOf(e.value))
  };
}
function xp(r, t, e) {
  return {
    type: q,
    value: zr(t.value.lastIndexOf(e.value))
  };
}
function Ap(r, t) {
  return {
    type: Z,
    value: t.value.trim()
  };
}
function Cp(r, t) {
  return {
    type: Z,
    value: t.value.replace(/^\s+/, "")
  };
}
function Sp(r, t) {
  return {
    type: Z,
    value: t.value.replace(/\s+$/, "")
  };
}
function Vp(r, t) {
  return {
    type: Z,
    value: t.value.toUpperCase()
  };
}
function Fp(r, t) {
  return {
    type: Z,
    value: t.value.toLowerCase()
  };
}
function hl(r, t, e, i) {
  if (!i.value.length)
    return r.warnings.push(x(new Error("String for padding is empty."), {
      level: "warn"
    })), "";
  let n = "";
  const o = t.type === Z ? t.value : Qi(t, !1);
  for (; n.length + o.length < e.value; )
    n += i.value;
  return n.length > 0 && n.length + o.length > e.value && (n = n.substring(0, Number(e.value) - Number(o.length))), n;
}
function ga(r, t, e, i) {
  const n = hl(r, t, e, i);
  return {
    type: Z,
    value: n + Qi(t, !1)
  };
}
function pa(r, t, e, i) {
  const n = hl(r, t, e, i);
  return {
    type: Z,
    value: Qi(t, !1) + n
  };
}
function Ip(r, t, e) {
  let i;
  try {
    i = new RegExp(e.value);
  } catch {
    throw new Error("Invalid regular expression.");
  }
  return {
    type: gr,
    value: i.test(t.value) ? 1 : 0
  };
}
function Dp(r, t) {
  return {
    type: Z,
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_expressions#escaping
    value: t.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  };
}
function Tp() {
  k("len", [Z], wp), k("contains", [Z, Z], kp), k("substring", [Z, q, q], $p), k("replaceAll", [Z, Z, Z], jp), k("index", [Z, Z], Ep), k("lastIndex", [Z, Z], xp), k("trim", [Z], Ap), k("trimLeft", [Z], Cp), k("trimRight", [Z], Sp), k("toUpperCase", [Z], Vp), k("toLowerCase", [Z], Fp), k("padStart", [Z, q, Z], ga), k("padStart", [q, q, Z], ga), k("padEnd", [Z, q, Z], pa), k("padEnd", [q, q, Z], pa), k("testRegex", [Z, Z], Ip), k("encodeRegex", [Z], Dp);
}
function Mp(r, t, e) {
  if (e.value === Zi)
    throw new Error("Division by zero is not supported.");
  let i = t.value / e.value;
  return i = en(r, i), li(r, i), {
    type: q,
    value: i
  };
}
function Pp(r, t, e) {
  if (e.value === 0)
    throw new Error("Division by zero is not supported.");
  const i = t.value / e.value;
  return {
    type: we,
    value: i
  };
}
function zp(r, t, e) {
  if (e.value === Zi)
    throw new Error("Division by zero is not supported.");
  let i = t.value % e.value;
  return i = en(r, i), li(r, i), {
    type: q,
    value: i
  };
}
function Op(r, t, e) {
  if (e.value === 0)
    throw new Error("Division by zero is not supported.");
  const i = t.value % e.value;
  return {
    type: we,
    value: i
  };
}
function Np(r, ...t) {
  let e = t.length ? t[0].value : Zi;
  for (let i = 1; i < t.length; ++i)
    e *= t[i].value, e = en(r, e), li(r, e);
  return {
    type: q,
    value: e
  };
}
function Rp(r, ...t) {
  let e = t.length ? t[0].value : 0;
  for (let i = 1; i < t.length; ++i)
    e *= t[i].value;
  return {
    type: we,
    value: e
  };
}
function Bp(r, ...t) {
  let e = t.length ? t[0].value : Zi;
  for (let i = 1; i < t.length; ++i)
    e -= t[i].value, e = en(r, e), li(r, e);
  return {
    type: q,
    value: e
  };
}
function Lp(r, ...t) {
  let e = t.length ? t[0].value : 0;
  for (let i = 1; i < t.length; ++i)
    e -= t[i].value;
  return {
    type: we,
    value: e
  };
}
function Hp(r, ...t) {
  let e = Zi;
  for (let i = 0; i < t.length; ++i)
    e += t[i].value, e = en(r, e), li(r, e);
  return {
    type: q,
    value: e
  };
}
function Wp(r, ...t) {
  let e = 0;
  for (let i = 0; i < t.length; ++i)
    e += t[i].value;
  return {
    type: we,
    value: e
  };
}
function Up(r, t) {
  const e = Qa(t.value);
  return li(r, e), {
    type: t.type,
    value: e
  };
}
function Gp(r, t) {
  const e = Math.abs(t.value);
  return {
    type: we,
    value: e
  };
}
function qp(r, ...t) {
  if (!t.length)
    throw new Error("Function requires non empty argument list.");
  let e = t[0].value;
  for (let i = 1; i < t.length; ++i)
    t[i].value > e && (e = t[i].value);
  return {
    type: q,
    value: e
  };
}
function Jp(r, ...t) {
  if (!t.length)
    throw new Error("Function requires non empty argument list.");
  return {
    type: we,
    value: Math.max(...t.map((e) => e.value))
  };
}
function Yp(r, ...t) {
  if (!t.length)
    throw new Error("Function requires non empty argument list.");
  let e = t[0].value;
  for (let i = 1; i < t.length; ++i)
    t[i].value < e && (e = t[i].value);
  return {
    type: q,
    value: e
  };
}
function Kp(r, ...t) {
  if (!t.length)
    throw new Error("Function requires non empty argument list.");
  return {
    type: we,
    value: Math.min(...t.map((e) => e.value))
  };
}
function Xp() {
  return {
    type: we,
    value: Vf
  };
}
function Zp() {
  return {
    type: we,
    value: Ff
  };
}
function Qp(r) {
  return li(r, Fn), {
    type: q,
    value: Fn
  };
}
function eh(r) {
  return li(r, In), {
    type: q,
    value: In
  };
}
function th(r, t) {
  const e = Math.sign(t.value);
  return {
    type: we,
    // js treats Math.round(-0.5) as 0, which is different to other platforms
    value: e * Math.round(Math.abs(t.value))
  };
}
function rh(r, t) {
  return {
    type: we,
    value: Math.floor(t.value)
  };
}
function ih(r, t) {
  return {
    type: we,
    value: Math.ceil(t.value)
  };
}
function nh(r, t) {
  return {
    type: q,
    value: el(t.value)
  };
}
function oh(r, t) {
  return {
    type: we,
    value: Math.sign(t.value)
  };
}
function sh(r, t, e) {
  let i;
  if (e.value === Zi)
    i = t.value;
  else if (t.value === Zi)
    i = zr(0);
  else {
    const n = el(e.value);
    i = Qa(t.value) * n;
  }
  return li(r, i), {
    type: q,
    value: i
  };
}
function ah(r, t, e) {
  let i = Math.sign(e.value);
  i === 0 && (i = Object.is(i, 0) ? 1 : -1);
  const n = Math.abs(t.value) * i;
  return {
    type: we,
    value: n
  };
}
function lh() {
  k("div", [q, q], Mp), k("div", [we, we], Pp), k("mod", [q, q], zp), k("mod", [we, we], Op), k("mul", [{
    type: q,
    isVararg: !0
  }], Np), k("mul", [{
    type: we,
    isVararg: !0
  }], Rp), k("sub", [{
    type: q,
    isVararg: !0
  }], Bp), k("sub", [{
    type: we,
    isVararg: !0
  }], Lp), k("sum", [{
    type: q,
    isVararg: !0
  }], Hp), k("sum", [{
    type: we,
    isVararg: !0
  }], Wp), k("abs", [q], Up), k("abs", [we], Gp), k("max", [{
    type: q,
    isVararg: !0
  }], qp), k("max", [{
    type: we,
    isVararg: !0
  }], Jp), k("min", [{
    type: q,
    isVararg: !0
  }], Yp), k("min", [{
    type: we,
    isVararg: !0
  }], Kp), k("maxNumber", [], Xp), k("minNumber", [], Zp), k("maxInteger", [], Qp), k("minInteger", [], eh), k("round", [we], th), k("floor", [we], rh), k("ceil", [we], ih), k("signum", [q], nh), k("signum", [we], oh), k("copySign", [q, q], sh), k("copySign", [we, we], ah);
}
function xo(r) {
  return (t, e) => {
    const i = jo(e.value);
    return {
      type: we,
      value: i[r] / 255
    };
  };
}
function Ao(r) {
  return (t, e, i) => {
    const n = jo(e.value);
    return n[r] = i.value * 255, {
      type: Pr,
      value: tn(n)
    };
  };
}
const ha = xo("a"), _a = xo("r"), ma = xo("g"), va = xo("b"), ba = Ao("a"), ya = Ao("r"), wa = Ao("g"), ka = Ao("b");
function ch(r, t, e, i) {
  const n = {
    a: 255,
    r: t.value * 255,
    g: e.value * 255,
    b: i.value * 255
  };
  return {
    type: Pr,
    value: tn(n)
  };
}
function uh(r, t, e, i, n) {
  const o = {
    a: t.value * 255,
    r: e.value * 255,
    g: i.value * 255,
    b: n.value * 255
  };
  return {
    type: Pr,
    value: tn(o)
  };
}
function dh() {
  k("getColorAlpha", [Z], ha), k("getColorAlpha", [Pr], ha), k("getColorRed", [Z], _a), k("getColorRed", [Pr], _a), k("getColorGreen", [Z], ma), k("getColorGreen", [Pr], ma), k("getColorBlue", [Z], va), k("getColorBlue", [Pr], va), k("setColorAlpha", [Z, we], ba), k("setColorAlpha", [Pr, we], ba), k("setColorRed", [Z, we], ya), k("setColorRed", [Pr, we], ya), k("setColorGreen", [Z, we], wa), k("setColorGreen", [Pr, we], wa), k("setColorBlue", [Z, we], ka), k("setColorBlue", [Pr, we], ka), k("rgb", [we, we, we], ch), k("argb", [we, we, we, we], uh);
}
function Hi(r, t, e, i) {
  if (t.value < 0)
    throw new Error("Expecting non-negative number of milliseconds.");
  let n = zr(t.value) / zr(e);
  return li(r, n), i && (n = zr(n) % zr(i)), {
    type: q,
    value: n
  };
}
const _l = 1e3, fh = 60, ml = 1e3 * 60, gh = 60, vl = 1e3 * 60 * 60, ph = 24, hh = 1e3 * 60 * 60 * 24, _h = 1e3 * 60 * 60 * 24 * 7;
function mh(r, t) {
  return Hi(r, t, _l, fh);
}
function vh(r, t) {
  return Hi(r, t, _l);
}
function bh(r, t) {
  return Hi(r, t, ml, gh);
}
function yh(r, t) {
  return Hi(r, t, ml);
}
function wh(r, t) {
  return Hi(r, t, vl, ph);
}
function kh(r, t) {
  return Hi(r, t, vl);
}
function $h(r, t) {
  return Hi(r, t, hh);
}
function jh(r, t) {
  return Hi(r, t, _h);
}
function Eh() {
  k("getIntervalSeconds", [q], mh), k("getIntervalTotalSeconds", [q], vh), k("getIntervalMinutes", [q], bh), k("getIntervalTotalMinutes", [q], yh), k("getIntervalHours", [q], wh), k("getIntervalTotalHours", [q], kh), k("getIntervalTotalDays", [q], $h), k("getIntervalTotalWeeks", [q], jh);
}
function xh(r, t) {
  let e = r;
  for (let i = 0; i < t.length; ++i) {
    if (!e)
      throw new Error(`Missing property "${t[i]}" in the dict.`);
    const n = e[t[i]];
    if (n === void 0)
      throw new Error(`Missing property "${t[i]}" in the dict.`);
    e = n;
  }
  return e;
}
function Wi(r) {
  return (t, e, ...i) => {
    if (i.length === 0)
      throw new Error("Non empty argument list is required.");
    const n = xh(e.value, i.map((o) => o.value));
    return hs(t, n, r);
  };
}
function wn(r, t) {
  return (e, i, n, ...o) => {
    try {
      return r(e, n, ...o);
    } catch {
      let c = i.value;
      return t === "color" ? c = Bi(c) : t === "url" && Ei(c), {
        type: t,
        value: c
      };
    }
  };
}
const to = Wi(Z), ro = Wi(we), io = Wi(q), no = Wi(gr), oo = Wi(Pr), so = Wi(_i), Qo = Wi(Pt), es = Wi(Ft), $a = wn(to, Z), ja = wn(ro, we), Ea = wn(io, q), xa = wn(no, gr), Wn = wn(oo, Pr), Un = wn(so, _i);
function Ah(r, t, ...e) {
  try {
    return Qo(r, t, ...e);
  } catch {
    return {
      type: Pt,
      value: []
    };
  }
}
function Ch(r, t, ...e) {
  try {
    return es(r, t, ...e);
  } catch {
    return {
      type: Ft,
      value: {}
    };
  }
}
function Sh(r, t, e) {
  return {
    type: gr,
    value: e.value in t.value ? 1 : 0
  };
}
function Vh(r, t) {
  return {
    type: gr,
    value: Object.keys(t.value).length ? 0 : 1
  };
}
function Fh(r, t) {
  return {
    type: q,
    value: zr(Object.keys(t.value).length)
  };
}
function Ih(r, t) {
  return {
    type: Pt,
    value: Object.keys(t.value)
  };
}
function Dh(r, t) {
  return {
    type: Pt,
    value: Object.values(t.value)
  };
}
function Th() {
  const r = {
    type: Z,
    isVararg: !0
  };
  k("getDictString", [Ft, r], to), k("getStringFromDict", [Ft, r], to), k("getDictNumber", [Ft, r], ro), k("getNumberFromDict", [Ft, r], ro), k("getDictInteger", [Ft, r], io), k("getIntegerFromDict", [Ft, r], io), k("getDictBoolean", [Ft, r], no), k("getBooleanFromDict", [Ft, r], no), k("getDictColor", [Ft, r], oo), k("getColorFromDict", [Ft, r], oo), k("getDictUrl", [Ft, r], so), k("getUrlFromDict", [Ft, r], so), k("getDictOptString", [Z, Ft, r], $a), k("getOptStringFromDict", [Z, Ft, r], $a), k("getDictOptNumber", [we, Ft, r], ja), k("getOptNumberFromDict", [we, Ft, r], ja), k("getDictOptInteger", [q, Ft, r], Ea), k("getOptIntegerFromDict", [q, Ft, r], Ea), k("getDictOptBoolean", [gr, Ft, r], xa), k("getOptBooleanFromDict", [gr, Ft, r], xa), k("getDictOptColor", [Pr, Ft, r], Wn), k("getOptColorFromDict", [Pr, Ft, r], Wn), k("getDictOptColor", [Z, Ft, r], Wn), k("getOptColorFromDict", [Z, Ft, r], Wn), k("getDictOptUrl", [Z, Ft, r], Un), k("getOptUrlFromDict", [Z, Ft, r], Un), k("getDictOptUrl", [_i, Ft, r], Un), k("getOptUrlFromDict", [_i, Ft, r], Un), k("getDictFromDict", [Ft, r], es), k("getArrayFromDict", [Ft, r], Qo), k("getOptArrayFromDict", [Ft, r], Ah), k("getOptDictFromDict", [Ft, r], Ch), dr("getString", [Ft, r], to), dr("getBoolean", [Ft, r], no), dr("getInteger", [Ft, r], io), dr("getNumber", [Ft, r], ro), dr("getUrl", [Ft, r], so), dr("getColor", [Ft, r], oo), dr("getArray", [Ft, r], Qo), dr("getDict", [Ft, r], es), dr("containsKey", [Ft, Z], Sh), dr("isEmpty", [Ft], Vh), k("len", [Ft], Fh), k("getDictKeys", [Ft], Ih), k("getDictValues", [Ft], Dh);
}
function Ui(r, t) {
  return (e, i, n) => {
    if (n.value < 0 || n.value >= i.value.length)
      throw new Error(`Requested index (${n.value}) out of bounds array size (${i.value.length}).`);
    let o = i.value[Number(n.value)], l = typeof o;
    if (r === "array" && !Array.isArray(o) || r !== "array" && l !== r || l === "object" && o === null)
      throw l === "object" && (Array.isArray(o) ? l = "Array" : o === null ? l = "Null" : l = "Dict"), new Error(`Incorrect value type: expected ${gi(t)}, got ${gi(l)}.`);
    if (r === "number" && t === "integer") {
      li(e, o);
      try {
        o = zr(o);
      } catch {
        throw new Error("Cannot convert value to integer.");
      }
    }
    return r === "string" && t === "color" && (o = Bi(o)), r === "string" && t === "url" && Ei(o), {
      type: t,
      value: o
    };
  };
}
function kn(r, t) {
  return (e, i, n, o) => {
    try {
      return r(e, i, n);
    } catch {
      let c = o.value;
      return t === "color" ? c = Bi(c) : t === "url" && Ei(c), {
        type: t,
        value: c
      };
    }
  };
}
const ao = Ui("string", "string"), lo = Ui("number", "number"), co = Ui("number", "integer"), uo = Ui("boolean", "boolean"), fo = Ui("string", "color"), go = Ui("string", "url"), ts = Ui("array", "array"), rs = Ui("object", "dict"), Aa = kn(ao, "string"), Ca = kn(lo, "number"), Sa = kn(co, "integer"), Va = kn(uo, "boolean"), Gn = kn(fo, "color"), qn = kn(go, "url");
function Mh(r, t, e) {
  try {
    return ts(r, t, e);
  } catch {
    return {
      type: Pt,
      value: []
    };
  }
}
function Ph(r, t, e) {
  try {
    return rs(r, t, e);
  } catch {
    return {
      type: Ft,
      value: {}
    };
  }
}
function zh(r, t) {
  return {
    type: q,
    value: zr(t.value.length)
  };
}
function Oh(r, t) {
  return {
    type: gr,
    value: t.value.length === 0 ? 1 : 0
  };
}
function Nh() {
  k("getArrayString", [
    Pt,
    q
  ], ao), k("getStringFromArray", [
    Pt,
    q
  ], ao), k("getArrayNumber", [
    Pt,
    q
  ], lo), k("getNumberFromArray", [
    Pt,
    q
  ], lo), k("getArrayInteger", [
    Pt,
    q
  ], co), k("getIntegerFromArray", [
    Pt,
    q
  ], co), k("getArrayBoolean", [
    Pt,
    q
  ], uo), k("getBooleanFromArray", [
    Pt,
    q
  ], uo), k("getArrayColor", [
    Pt,
    q
  ], fo), k("getColorFromArray", [
    Pt,
    q
  ], fo), k("getArrayUrl", [
    Pt,
    q
  ], go), k("getUrlFromArray", [
    Pt,
    q
  ], go), k("getArrayFromArray", [
    Pt,
    q
  ], ts), k("getDictFromArray", [
    Pt,
    q
  ], rs), k("getArrayOptString", [
    Pt,
    q,
    Z
  ], Aa), k("getOptStringFromArray", [
    Pt,
    q,
    Z
  ], Aa), k("getArrayOptNumber", [
    Pt,
    q,
    we
  ], Ca), k("getOptNumberFromArray", [
    Pt,
    q,
    we
  ], Ca), k("getArrayOptInteger", [
    Pt,
    q,
    q
  ], Sa), k("getOptIntegerFromArray", [
    Pt,
    q,
    q
  ], Sa), k("getArrayOptBoolean", [
    Pt,
    q,
    gr
  ], Va), k("getOptBooleanFromArray", [
    Pt,
    q,
    gr
  ], Va), k("getArrayOptColor", [
    Pt,
    q,
    Pr
  ], Gn), k("getOptColorFromArray", [
    Pt,
    q,
    Pr
  ], Gn), k("getArrayOptColor", [
    Pt,
    q,
    Z
  ], Gn), k("getOptColorFromArray", [
    Pt,
    q,
    Z
  ], Gn), k("getArrayOptUrl", [
    Pt,
    q,
    _i
  ], qn), k("getOptUrlFromArray", [
    Pt,
    q,
    _i
  ], qn), k("getArrayOptUrl", [
    Pt,
    q,
    Z
  ], qn), k("getOptUrlFromArray", [
    Pt,
    q,
    Z
  ], qn), k("getOptArrayFromArray", [
    Pt,
    q
  ], Mh), k("getOptDictFromArray", [
    Pt,
    q
  ], Ph), k("len", [
    Pt
  ], zh), dr("getString", [Pt, q], ao), dr("getInteger", [Pt, q], co), dr("getNumber", [Pt, q], lo), dr("getBoolean", [Pt, q], uo), dr("getUrl", [Pt, q], go), dr("getColor", [Pt, q], fo), dr("getArray", [Pt, q], ts), dr("getDict", [Pt, q], rs), dr("isEmpty", [Pt], Oh);
}
function xi(r) {
  return (t, e, i) => {
    if (!t.store) {
      if (!i)
        throw new Error("Missing value.");
      return {
        type: r,
        value: i.value
      };
    }
    let n;
    r === "boolean" ? n = "boolean" : r === "number" || r === "integer" ? n = "number" : n = "string";
    let o;
    if (t.store.get ? o = t.store.get(e.value, r) : t.store.getValue && (o = t.store.getValue(e.value, n)), o === void 0) {
      if (!i)
        throw new Error("Missing value.");
      return r === "url" && Ei(i.value), {
        type: r,
        value: i.value
      };
    } else
      r === "url" && Ei(o);
    return hs(t, o, r);
  };
}
function Rh() {
  k("getStoredIntegerValue", [Z, q], xi(q)), k("getStoredNumberValue", [Z, we], xi(we)), k("getStoredStringValue", [Z, Z], xi(Z)), k("getStoredUrlValue", [Z, _i], xi(_i)), k("getStoredUrlValue", [Z, Z], xi(_i)), k("getStoredColorValue", [Z, Pr], xi(Pr)), k("getStoredColorValue", [Z, Z], xi(Pr)), k("getStoredBooleanValue", [Z, gr], xi(gr)), k("getStoredArrayValue", [Z], xi(Pt)), k("getStoredDictValue", [Z], xi(Ft));
}
function Bh() {
  return {
    type: we,
    value: Math.PI
  };
}
function Lh(r, t) {
  return {
    type: we,
    value: t.value / 180 * Math.PI
  };
}
function Hh(r, t) {
  return {
    type: we,
    value: t.value / Math.PI * 180
  };
}
function Wh(r, t) {
  return {
    type: we,
    value: Math.sin(t.value)
  };
}
function Uh(r, t) {
  return {
    type: we,
    value: Math.cos(t.value)
  };
}
function Gh(r, t) {
  return {
    type: we,
    value: Math.tan(t.value)
  };
}
function qh(r, t) {
  const e = Math.tan(t.value);
  if (Math.abs(e) < 1e-12)
    throw new Error("Cotangent is undefined for the given value.");
  return {
    type: we,
    value: 1 / e
  };
}
function Jh(r, t) {
  return {
    type: we,
    value: Math.atan(t.value)
  };
}
function Yh(r, t, e) {
  return {
    type: we,
    value: Math.atan2(t.value, e.value)
  };
}
function Kh(r, t) {
  if (t.value > 1 || t.value < -1)
    throw new Error("Arcsine is undefined for the given value.");
  return {
    type: we,
    value: Math.asin(t.value)
  };
}
function Xh(r, t) {
  if (t.value > 1 || t.value < -1)
    throw new Error("Arccosine is undefined for the given value.");
  return {
    type: we,
    value: Math.acos(t.value)
  };
}
function Zh() {
  k("pi", [], Bh), k("toRadians", [we], Lh), k("toDegrees", [we], Hh), k("sin", [we], Wh), k("cos", [we], Uh), k("tan", [we], Gh), k("cot", [we], qh), k("atan", [we], Jh), k("atan2", [we, we], Yh), k("asin", [we], Kh), k("acos", [we], Xh);
}
function Qh() {
  Gg(), bp(), Eh(), Tp(), lh(), dh(), Th(), Nh(), Rh(), Zh();
}
Qh();
function e_(r, t) {
  return {
    type: Z,
    value: t.value
  };
}
function t_(r, t) {
  return {
    type: we,
    value: t.value
  };
}
function r_(r, t) {
  return li(r, t.value), {
    type: q,
    value: t.value
  };
}
function i_(r, t) {
  return {
    type: gr,
    value: t.value ? 1 : 0
  };
}
function n_(r, t) {
  const e = ho(ii(r, t.argument));
  switch (t.operator) {
    case "!":
      if (e.type === gr)
        return {
          type: gr,
          value: e.value ? 0 : 1
        };
      Tr(`${t.operator}${Dr(e)}`, "A Boolean is expected after a unary not.");
    case "+":
    case "-":
      const i = t.operator === "+" ? 1 : -1;
      if (e.type === q) {
        const n = e.value * zr(i);
        return li(r, n), {
          type: q,
          value: n
        };
      } else {
        if (e.type === we)
          return {
            type: we,
            value: e.value * i
          };
        Tr(
          `${t.operator}${Dr(e)}`,
          `A Number is expected after a unary ${t.operator === "+" ? "plus" : "minus"}.`
        );
      }
  }
}
function o_(r, t) {
  const e = ho(ii(r, t.test));
  if (e.type === gr)
    return e.value ? ii(r, t.consequent) : ii(r, t.alternate);
  Tr(
    `${Dr(e)} ? ${Dr(ii(r, t.consequent))} : ${Dr(ii(r, t.alternate))}`,
    "Ternary must be called with a Boolean value as a condition."
  );
}
function s_(r, t) {
  try {
    return ii(r, t.test);
  } catch {
    return ii(r, t.alternate);
  }
}
function a_(r, t) {
  let e = "";
  if (t.quasis.length === 2 && t.quasis[0].value === "" && t.quasis[1].value === "")
    return ii(r, t.expressions[0]);
  for (let i = 0; i < t.expressions.length; ++i)
    e += t.quasis[i].value, e += Qi(ii(r, t.expressions[i]), !0);
  return e += t.quasis[t.quasis.length - 1].value, {
    type: Z,
    value: e
  };
}
function l_(r, t) {
  const e = ho(ii(r, t.left));
  if (e.type !== gr && Tr(
    `${Dr(e)} ${t.operator} ...`,
    `'${t.operator}' must be called with boolean operands.`
  ), t.operator === "||" && e.value)
    return e;
  if (t.operator === "&&" && !e.value)
    return {
      type: gr,
      value: 0
    };
  const i = ho(ii(r, t.right));
  return i.type !== gr && Tr(
    `${Dr(e)} ${t.operator} ${Dr(i)}`,
    `Operator '${t.operator}' cannot be applied to different types: Boolean and ${gi(i.type)}.`
  ), {
    type: gr,
    value: i.value
  };
}
function c_(r, t, e) {
  let i;
  return t.type === Qt && e.type === Qt ? i = t.value.getTime() === e.value.getTime() : i = t.value === e.value, r === "!=" && (i = !i), {
    type: gr,
    value: i ? 1 : 0
  };
}
function u_(r, t, e) {
  (t.type !== we && t.type !== q && t.type !== Qt || e.type !== we && e.type !== q && e.type !== Qt) && Tr(
    `${Dr(t)} ${r} ${Dr(e)}`,
    `Operator '${r}' cannot be applied to ${gi(t.type)} type.`
  );
  let i;
  const n = t.type === Qt ? t.value.getTime() : t.value, o = e.type === Qt ? e.value.getTime() : e.value;
  return r === ">" ? i = n > o : r === ">=" ? i = n >= o : r === "<" ? i = n < o : i = n <= o, {
    type: gr,
    value: i ? 1 : 0
  };
}
function d_(r, t, e, i) {
  if (e.type !== Z && e.type !== we && e.type !== q && Tr(
    `${Dr(e)} ${t} ${Dr(i)}`,
    `Operator '${t}' cannot be applied to ${gi(e.type)} type.`
  ), e.type === Z)
    return t === "-" && Tr(
      `${Dr(e)} - ${Dr(i)}`,
      `Operator '${t}' cannot be applied to ${gi(e.type)} type.`
    ), {
      type: Z,
      value: e.value + i.value
    };
  let n = t === "+" ? e.value + i.value : e.value - i.value;
  if (e.type === q)
    try {
      n = en(r, n), li(r, n);
    } catch (o) {
      Tr(
        `${Dr(e)} ${t} ${Dr(i)}`,
        o.message
      );
    }
  return {
    type: e.type,
    value: n
  };
}
function f_(r, t, e, i) {
  e.type !== q && e.type !== we && Tr(
    `${Dr(e)} ${t} ${Dr(i)}`,
    `Operator '${t}' cannot be applied to ${gi(e.type)} type.`
  );
  let n;
  if (t === "*")
    n = e.value * i.value;
  else if (t === "/" || t === "%")
    Number(i.value) === 0 && Tr(
      `${Dr(e)} ${t} ${Dr(i)}`,
      "Division by zero is not supported."
    ), t === "/" ? n = e.value / i.value : n = e.value % i.value;
  else
    throw new Error(`Unsupported operation ${t}`);
  if (e.type === q)
    try {
      n = en(r, n), li(r, n);
    } catch (o) {
      Tr(
        `${Dr(e)} ${t} ${Dr(i)}`,
        o.message
      );
    }
  return {
    type: e.type,
    value: n
  };
}
function g_(r, t) {
  const e = t.operator;
  let i = ii(r, t.left), n = ii(r, t.right);
  if ((i.type === "number" && n.type === "integer" || i.type === "integer" && n.type === "number") && (i.type === "integer" ? i = Go(i) : n.type === "integer" && (n = Go(n))), i.type !== n.type && Tr(
    `${Dr(i)} ${t.operator} ${Dr(n)}`,
    `Operator '${e}' cannot be applied to different types: ${gi(i.type)} and ${gi(n.type)}.`
  ), e === "==" || e === "!=")
    return c_(e, i, n);
  if (e === ">" || e === ">=" || e === "<" || e === "<=")
    return u_(e, i, n);
  if (e === "+" || e === "-")
    return d_(r, e, i, n);
  if (e === "/" || e === "*" || e === "%")
    return f_(r, e, i, n);
  throw new Error(`Unsupported operation ${e}`);
}
function vo(r) {
  return r.map(Dr).join(", ");
}
function p_(r, t) {
  const e = t.callee.name;
  let i, n = t.arguments.map((c) => ii(r, c));
  const o = e + ":" + n.map((c) => c.type).join("#");
  let l;
  if (r.customFunctions && (l = Ko(r.customFunctions, e, n)), !l || !("func" in l))
    if (Jo.has(o))
      l = {
        func: Jo.get(o),
        conversions: 0
      };
    else {
      const c = Ko(Qn, e, n);
      ("func" in c || !l) && (l = c);
    }
  if (l && (("expected" in l || "type" in l && l.type === "missing") && h_(e, n, l), i = l.func, l.conversions && (n = fl(i, n))), !i)
    throw new Error("Function not found");
  try {
    return i.cb(r, ...n);
  } catch (c) {
    const d = `${e}(${vo(n)})`;
    Tr(d, c.message);
  }
}
function h_(r, t, e) {
  const i = t.map((o) => gi(o.type)).join(", "), n = `${r}(${vo(t)})`;
  if (e.type === "few" && t.length === 0 && e.hasOverloads)
    Tr(n, "Function requires non empty argument list.");
  else if (e.type === "many" || e.type === "few" || e.type === "mismatch")
    if (e.hasOverloads)
      Tr(n, `Function has no matching overload for given argument types: ${i}.`);
    else if (e.type === "many" || e.type === "few")
      e.def.args.some((o) => typeof o == "object" && o.isVararg) ? Tr(n, `At least ${e.def.args.length} argument(s) expected.`) : Tr(n, `Exactly ${e.def.args.length} argument(s) expected.`);
    else {
      const o = e.def.args.map((l) => gi(typeof l == "string" ? l : l.type)).join(", ");
      Tr(n, `Invalid argument type: expected ${o}, got ${i}.`);
    }
  else
    Tr(n, `Unknown function name: ${r}.`);
}
function __(r, t) {
  const e = t.method.name;
  let i, n = [t.object, ...t.arguments].map((l) => ii(r, l));
  const o = e + ":" + n.map((l) => l.type).join("#");
  if (Yo.has(o))
    i = Yo.get(o);
  else {
    const l = Ko(eo, e, n);
    if ("expected" in l || "type" in l && l.type === "missing") {
      const c = n.slice(1).map((f) => gi(f.type)).join(", "), d = `${e}(${vo(n.slice(1))})`;
      l.type === "few" && n.length === 1 ? Tr(d, "Method requires non empty argument list.") : l.type === "many" ? Tr(d, `Method has no matching overload for given argument types: ${c}.`) : l.type === "few" || l.type === "mismatch" ? Tr(d, `Method has no matching overload for given argument types: ${c}.`) : Tr(d, `Unknown method name: ${e}.`);
    }
    i = l.func, l.conversions && (n = fl(i, n));
  }
  if (!i)
    throw new Error("Method not found");
  try {
    return i.cb(r, ...n);
  } catch (l) {
    const c = `${e}(${vo(n.slice(1))})`;
    Tr(c, l.message);
  }
}
function m_(r, t) {
  const e = t.id.name, i = r.variables.get(e);
  if (i)
    return Gf(i);
  throw new Error(`Variable '${e}' is missing.`);
}
const Fa = {
  StringLiteral: e_,
  NumberLiteral: t_,
  IntegerLiteral: r_,
  BooleanLiteral: i_,
  UnaryExpression: n_,
  ConditionalExpression: o_,
  TryExpression: s_,
  TemplateLiteral: a_,
  LogicalExpression: l_,
  BinaryExpression: g_,
  CallExpression: p_,
  MethodExpression: __,
  Variable: m_
};
function ii(r, t) {
  if (t.type in Fa)
    return Fa[t.type](r, t);
  throw new Error("Unsupported expression");
}
function bs(r, t, e, i, n) {
  try {
    const o = {
      variables: r,
      customFunctions: t,
      warnings: [],
      store: e,
      weekStartDay: (n == null ? void 0 : n.weekStartDay) || 0
    };
    return {
      result: ii(o, i),
      warnings: o.warnings,
      usedVars: o.storeUsedVars
    };
  } catch (o) {
    return {
      result: {
        type: "error",
        value: o.message
      },
      warnings: []
    };
  }
}
function v_(r, t) {
  return t && t[3] && t[7] ? { type: "ConditionalExpression", test: r, consequent: t[3], alternate: t[7] } : r;
}
function b_(r, t) {
  return t && t[3] ? { type: "TryExpression", test: r, alternate: t[3] } : r;
}
function Jn(r, t) {
  return t.length ? t.reduce((e, i) => ({
    type: "BinaryExpression",
    operator: i[1],
    left: e,
    right: i[3]
  }), r) : r;
}
function Ia(r, t) {
  return t.length ? t.reduce((e, i) => ({
    type: "LogicalExpression",
    operator: i[1],
    left: e,
    right: i[3]
  }), r) : r;
}
function y_(r, t) {
  return t.length ? t.reduce((e, i) => {
    if (!i[5])
      throw new Error("Method expected after .");
    return {
      type: "MethodExpression",
      object: e,
      method: i[3],
      arguments: i[5][2]
    };
  }, r) : r;
}
function w_(r) {
  return r === "true" || r === "false" ? { type: "BooleanLiteral", value: r === "true" } : { type: "Variable", id: { type: "Identifier", name: r } };
}
function Da(r) {
  if (r.every((e) => typeof e == "string"))
    return { type: "StringLiteral", value: r.join("") };
  let t = r.reduce((e, i) => (typeof i == "string" && typeof e[e.length - 1] == "string" ? e[e.length - 1] += i : e.push(i), e), []).reduce((e, i) => (typeof i == "string" ? e.quasis.push({ type: "StringLiteral", value: i }) : (e.quasis.length === e.expressions.length && e.quasis.push({ type: "StringLiteral", value: "" }), e.expressions.push(i)), e), {
    type: "TemplateLiteral",
    quasis: [],
    expressions: []
  });
  return t.quasis.length === t.expressions.length && t.quasis.push({ type: "StringLiteral", value: "" }), t;
}
function k_(r) {
  try {
    return zr(r);
  } catch {
    throw new Error(`Value ${r} can't be converted to Integer type.`);
  }
}
function Ta(r) {
  if (r === "'" || r === "\\")
    return r;
  throw new Error("Incorrect string escape");
}
function $_(r, t) {
  function e() {
    this.constructor = r;
  }
  e.prototype = t.prototype, r.prototype = new e();
}
function mn(r, t, e, i) {
  var n = Error.call(this, r);
  return Object.setPrototypeOf && Object.setPrototypeOf(n, mn.prototype), n.expected = t, n.found = e, n.location = i, n.name = "SyntaxError", n;
}
$_(mn, Error);
function Oo(r, t, e) {
  return e = e || " ", r.length > t ? r : (t -= r.length, e += e.repeat(t), r + e.slice(0, t));
}
mn.prototype.format = function(r) {
  var t = "Error: " + this.message;
  if (this.location) {
    var e = null, i;
    for (i = 0; i < r.length; i++)
      if (r[i].source === this.location.source) {
        e = r[i].text.split(/\r\n|\n|\r/g);
        break;
      }
    var n = this.location.start, o = this.location.source && typeof this.location.source.offset == "function" ? this.location.source.offset(n) : n, l = this.location.source + ":" + o.line + ":" + o.column;
    if (e) {
      var c = this.location.end, d = Oo("", o.line.toString().length, " "), f = e[n.line - 1], h = n.line === c.line ? c.column : f.length + 1, C = h - n.column || 1;
      t += `
 --> ` + l + `
` + d + ` |
` + o.line + " | " + f + `
` + d + " | " + Oo("", n.column - 1, " ") + Oo("", C, "^");
    } else
      t += `
 at ` + l;
  }
  return t;
};
mn.buildMessage = function(r, t) {
  var e = {
    literal: function(f) {
      return '"' + n(f.text) + '"';
    },
    class: function(f) {
      var h = f.parts.map(function(C) {
        return Array.isArray(C) ? o(C[0]) + "-" + o(C[1]) : o(C);
      });
      return "[" + (f.inverted ? "^" : "") + h.join("") + "]";
    },
    any: function() {
      return "any character";
    },
    end: function() {
      return "end of input";
    },
    other: function(f) {
      return f.description;
    }
  };
  function i(f) {
    return f.charCodeAt(0).toString(16).toUpperCase();
  }
  function n(f) {
    return f.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(h) {
      return "\\x0" + i(h);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(h) {
      return "\\x" + i(h);
    });
  }
  function o(f) {
    return f.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(h) {
      return "\\x0" + i(h);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(h) {
      return "\\x" + i(h);
    });
  }
  function l(f) {
    return e[f.type](f);
  }
  function c(f) {
    var h = f.map(l), C, T;
    if (h.sort(), h.length > 0) {
      for (C = 1, T = 1; C < h.length; C++)
        h[C - 1] !== h[C] && (h[T] = h[C], T++);
      h.length = T;
    }
    switch (h.length) {
      case 1:
        return h[0];
      case 2:
        return h[0] + " or " + h[1];
      default:
        return h.slice(0, -1).join(", ") + ", or " + h[h.length - 1];
    }
  }
  function d(f) {
    return f ? '"' + n(f) + '"' : "end of input";
  }
  return "Expected " + c(r) + " but " + d(t) + " found.";
};
function bl(r, t) {
  t = t !== void 0 ? t : {};
  var e = {}, i = t.grammarSource, n = { start: Nr, JsonStringContents: Vr }, o = Nr, l = "@{", c = "}", d = "@{}", f = "\\", h = "?", C = ":", T = "!:", P = "||", z = "&&", G = "==", I = "!=", F = ">=", ke = ">", K = "<=", ge = "<", Q = "+", ue = "-", oe = "/", ye = "*", ee = "%", be = "!", $e = ".", ne = "(", Ne = ")", Ie = ",", Me = "'", Re = "e", Be = "E", Fe = /^[^}]/, Ue = /^[^'}]/, xe = /^[0-9]/, J = /^[a-zA-Z_]/, te = /^[a-zA-Z_0-9]/, de = /^[ \t\r\n]/, fe = ut("@{", !1), Qe = ut("}", !1), Ge = ut("@{}", !1), gt = ut("\\", !1), lt = Zr(), pt = Rr(["}"], !0, !1), R = ut("?", !1), We = ut(":", !1), pe = ut("!:", !1), Le = ut("||", !1), ht = ut("&&", !1), xt = ut("==", !1), Je = ut("!=", !1), Ke = ut(">=", !1), He = ut(">", !1), Ae = ut("<=", !1), qe = ut("<", !1), it = ut("+", !1), nt = ut("-", !1), Pe = ut("/", !1), Ce = ut("*", !1), zt = ut("%", !1), Y = ut("!", !1), wt = ut(".", !1), et = ut("(", !1), ot = ut(")", !1), tt = ut(",", !1), It = vr("string"), De = ut("'", !1), Wt = Rr(["'", "}"], !0, !1), At = vr("integer"), kt = Rr([["0", "9"]], !1, !1), Xe = vr("number"), re = ut("e", !1), ct = ut("E", !1), Gt = Rr([["a", "z"], ["A", "Z"], "_"], !1, !1), b = Rr([["a", "z"], ["A", "Z"], "_", ["0", "9"]], !1, !1), Nt = vr("whitespace"), se = Rr([" ", "	", "\r", `
`], !1, !1), Ve = function(a) {
    return a;
  }, bt = function(a) {
    return Da(a);
  }, ve = function(a) {
    return a;
  }, _e = function() {
    return "";
  }, ae = function() {
    return mr();
  }, Ot = function() {
    throw new Error("Error tokenizing '" + r + "'.");
  }, St = function() {
    throw new Error("Error tokenizing '" + r + "'.");
  }, Vt = function(a) {
    return a;
  }, Lt = function(a) {
    return Ta(a);
  }, _t = function() {
    throw new Error("Error tokenizing '" + r + "'.");
  }, $t = function(a, p) {
    return v_(a, p);
  }, yt = function(a, p) {
    return b_(a, p);
  }, Dt = function(a, p) {
    return Ia(a, p);
  }, Ct = function(a, p) {
    return Ia(a, p);
  }, Xt = function(a, p) {
    return Jn(a, p);
  }, Ut = function(a, p) {
    return Jn(a, p);
  }, jt = function(a, p) {
    return Jn(a, p);
  }, Ht = function(a, p) {
    return Jn(a, p);
  }, Rt = function(a) {
    return a;
  }, mt = function(a) {
    return a;
  }, Ze = function(a, p) {
    return { type: "UnaryExpression", operator: a, argument: p };
  }, er = function() {
    throw new Error("Incorrect unary operator");
  }, ir = function(a, p) {
    return y_(a, p);
  }, nr = function(a, p) {
    return { type: "CallExpression", callee: a, arguments: p };
  }, tr = function(a, p) {
    return [a, ...p];
  }, qt = function(a) {
    return a;
  }, U = function(a) {
    return a;
  }, S = function(a) {
    return Da(a);
  }, H = function(a) {
    return a;
  }, B = function() {
    return "";
  }, V = function() {
    return mr();
  }, Ee = function() {
    throw new Error("Error tokenizing '" + r + "'.");
  }, m = function() {
    throw new Error("Error tokenizing '" + r + "'.");
  }, ie = function(a) {
    return a;
  }, L = function(a) {
    return Ta(a);
  }, Te = function() {
    throw new Error("Error tokenizing '" + r + "'.");
  }, ze = function() {
    return { type: "IntegerLiteral", value: k_(mr()) };
  }, pr = function() {
    return { type: "NumberLiteral", value: parseFloat(mr()) };
  }, je = function() {
    return { type: "NumberLiteral", value: parseFloat(mr()) };
  }, Ar = function() {
    const a = mr();
    if (/\.\./.test(a) || /\.$/.test(a))
      throw new Error("Unexpected token: .");
    return w_(a);
  }, Xr = function() {
    return { type: "Identifier", name: mr() };
  }, s = 0, he = 0, Jt = [{ line: 1, column: 1 }], Kt = 0, Tt = [], D = 0, _r;
  if ("startRule" in t) {
    if (!(t.startRule in n))
      throw new Error(`Can't start parsing from rule "` + t.startRule + '".');
    o = n[t.startRule];
  }
  function mr() {
    return r.substring(he, s);
  }
  function ut(a, p) {
    return { type: "literal", text: a, ignoreCase: p };
  }
  function Rr(a, p, w) {
    return { type: "class", parts: a, inverted: p, ignoreCase: w };
  }
  function Zr() {
    return { type: "any" };
  }
  function Br() {
    return { type: "end" };
  }
  function vr(a) {
    return { type: "other", description: a };
  }
  function Mr(a) {
    var p = Jt[a], w;
    if (p)
      return p;
    for (w = a - 1; !Jt[w]; )
      w--;
    for (p = Jt[w], p = {
      line: p.line,
      column: p.column
    }; w < a; )
      r.charCodeAt(w) === 10 ? (p.line++, p.column = 1) : p.column++, w++;
    return Jt[a] = p, p;
  }
  function Sr(a, p, w) {
    var v = Mr(a), N = Mr(p), M = {
      source: i,
      start: {
        offset: a,
        line: v.line,
        column: v.column
      },
      end: {
        offset: p,
        line: N.line,
        column: N.column
      }
    };
    return M;
  }
  function O(a) {
    s < Kt || (s > Kt && (Kt = s, Tt = []), Tt.push(a));
  }
  function $r(a, p, w) {
    return new mn(
      mn.buildMessage(a, p),
      a,
      p,
      w
    );
  }
  function Nr() {
    var a, p;
    return a = s, Ye(), p = Fr(), p !== e ? (Ye(), he = a, a = Ve(p)) : (s = a, a = e), a;
  }
  function Vr() {
    var a, p, w;
    for (a = s, p = [], w = Qr(); w !== e; )
      p.push(w), w = Qr();
    return he = a, p = bt(p), a = p, a;
  }
  function Qr() {
    var a, p, w, v, N;
    if (a = s, r.substr(s, 2) === l ? (p = l, s += 2) : (p = e, D === 0 && O(fe)), p !== e ? (w = Ye(), v = Fr(), v !== e ? (Ye(), r.charCodeAt(s) === 125 ? (N = c, s++) : (N = e, D === 0 && O(Qe)), N !== e ? (he = a, a = ve(v)) : (s = a, a = e)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, r.substr(s, 3) === d ? (p = d, s += 3) : (p = e, D === 0 && O(Ge)), p !== e && (he = a, p = _e()), a = p, a === e && (a = s, p = s, D++, r.charCodeAt(s) === 92 ? (w = f, s++) : (w = e, D === 0 && O(gt)), w === e && (r.substr(s, 2) === l ? (w = l, s += 2) : (w = e, D === 0 && O(fe))), D--, w === e ? p = void 0 : (s = p, p = e), p !== e ? (r.length > s ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(lt)), w !== e ? (he = a, a = ae()) : (s = a, a = e)) : (s = a, a = e), a === e))) {
      if (a = s, r.substr(s, 2) === l ? (p = l, s += 2) : (p = e, D === 0 && O(fe)), p !== e) {
        if (w = [], Fe.test(r.charAt(s)) ? (v = r.charAt(s), s++) : (v = e, D === 0 && O(pt)), v !== e)
          for (; v !== e; )
            w.push(v), Fe.test(r.charAt(s)) ? (v = r.charAt(s), s++) : (v = e, D === 0 && O(pt));
        else
          w = e;
        w !== e ? (r.charCodeAt(s) === 125 ? (v = c, s++) : (v = e, D === 0 && O(Qe)), v !== e ? (he = a, a = Ot()) : (s = a, a = e)) : (s = a, a = e);
      } else
        s = a, a = e;
      a === e && (a = s, r.substr(s, 2) === l ? (p = l, s += 2) : (p = e, D === 0 && O(fe)), p !== e && (he = a, p = St()), a = p, a === e && (a = s, r.charCodeAt(s) === 92 ? (p = f, s++) : (p = e, D === 0 && O(gt)), p !== e ? (r.substr(s, 2) === l ? (w = l, s += 2) : (w = e, D === 0 && O(fe)), w !== e ? (he = a, a = Vt(w)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, r.charCodeAt(s) === 92 ? (p = f, s++) : (p = e, D === 0 && O(gt)), p !== e ? (r.length > s ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(lt)), w !== e ? (he = a, a = Lt(w)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, r.charCodeAt(s) === 92 ? (p = f, s++) : (p = e, D === 0 && O(gt)), p !== e && (he = a, p = _t()), a = p))));
    }
    return a;
  }
  function Fr() {
    var a, p, w, v, N, M, st, at, Cr, ur, yr;
    return a = s, p = br(), p !== e ? (w = s, v = Ye(), r.charCodeAt(s) === 63 ? (N = h, s++) : (N = e, D === 0 && O(R)), N !== e ? (M = Ye(), st = Fr(), st !== e ? (at = Ye(), r.charCodeAt(s) === 58 ? (Cr = C, s++) : (Cr = e, D === 0 && O(We)), Cr !== e ? (ur = Ye(), yr = Fr(), yr !== e ? (v = [v, N, M, st, at, Cr, ur, yr], w = v) : (s = w, w = e)) : (s = w, w = e)) : (s = w, w = e)) : (s = w, w = e), w === e && (w = null), he = a, a = $t(p, w)) : (s = a, a = e), a;
  }
  function br() {
    var a, p, w, v, N, M, st;
    return a = s, p = ci(), p !== e ? (w = s, v = Ye(), r.substr(s, 2) === T ? (N = T, s += 2) : (N = e, D === 0 && O(pe)), N !== e ? (M = Ye(), st = Fr(), st !== e ? (v = [v, N, M, st], w = v) : (s = w, w = e)) : (s = w, w = e), w === e && (w = null), he = a, a = yt(p, w)) : (s = a, a = e), a;
  }
  function ci() {
    var a, p, w, v, N, M, st, at;
    if (a = s, p = u(), p !== e) {
      for (w = [], v = s, N = Ye(), r.substr(s, 2) === P ? (M = P, s += 2) : (M = e, D === 0 && O(Le)), M !== e ? (st = Ye(), at = u(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, N = Ye(), r.substr(s, 2) === P ? (M = P, s += 2) : (M = e, D === 0 && O(Le)), M !== e ? (st = Ye(), at = u(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e);
      he = a, a = Dt(p, w);
    } else
      s = a, a = e;
    return a;
  }
  function u() {
    var a, p, w, v, N, M, st, at;
    if (a = s, p = g(), p !== e) {
      for (w = [], v = s, N = Ye(), r.substr(s, 2) === z ? (M = z, s += 2) : (M = e, D === 0 && O(ht)), M !== e ? (st = Ye(), at = g(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, N = Ye(), r.substr(s, 2) === z ? (M = z, s += 2) : (M = e, D === 0 && O(ht)), M !== e ? (st = Ye(), at = g(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e);
      he = a, a = Ct(p, w);
    } else
      s = a, a = e;
    return a;
  }
  function g() {
    var a, p, w, v, N, M, st, at;
    if (a = s, p = _(), p !== e) {
      for (w = [], v = s, N = Ye(), r.substr(s, 2) === G ? (M = G, s += 2) : (M = e, D === 0 && O(xt)), M === e && (r.substr(s, 2) === I ? (M = I, s += 2) : (M = e, D === 0 && O(Je))), M !== e ? (st = Ye(), at = _(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, N = Ye(), r.substr(s, 2) === G ? (M = G, s += 2) : (M = e, D === 0 && O(xt)), M === e && (r.substr(s, 2) === I ? (M = I, s += 2) : (M = e, D === 0 && O(Je))), M !== e ? (st = Ye(), at = _(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e);
      he = a, a = Xt(p, w);
    } else
      s = a, a = e;
    return a;
  }
  function _() {
    var a, p, w, v, N, M, st, at;
    if (a = s, p = A(), p !== e) {
      for (w = [], v = s, N = Ye(), r.substr(s, 2) === F ? (M = F, s += 2) : (M = e, D === 0 && O(Ke)), M === e && (r.charCodeAt(s) === 62 ? (M = ke, s++) : (M = e, D === 0 && O(He)), M === e && (r.substr(s, 2) === K ? (M = K, s += 2) : (M = e, D === 0 && O(Ae)), M === e && (r.charCodeAt(s) === 60 ? (M = ge, s++) : (M = e, D === 0 && O(qe))))), M !== e ? (st = Ye(), at = A(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, N = Ye(), r.substr(s, 2) === F ? (M = F, s += 2) : (M = e, D === 0 && O(Ke)), M === e && (r.charCodeAt(s) === 62 ? (M = ke, s++) : (M = e, D === 0 && O(He)), M === e && (r.substr(s, 2) === K ? (M = K, s += 2) : (M = e, D === 0 && O(Ae)), M === e && (r.charCodeAt(s) === 60 ? (M = ge, s++) : (M = e, D === 0 && O(qe))))), M !== e ? (st = Ye(), at = A(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e);
      he = a, a = Ut(p, w);
    } else
      s = a, a = e;
    return a;
  }
  function A() {
    var a, p, w, v, N, M, st, at;
    if (a = s, p = y(), p !== e) {
      for (w = [], v = s, N = Ye(), r.charCodeAt(s) === 43 ? (M = Q, s++) : (M = e, D === 0 && O(it)), M === e && (r.charCodeAt(s) === 45 ? (M = ue, s++) : (M = e, D === 0 && O(nt))), M !== e ? (st = Ye(), at = y(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, N = Ye(), r.charCodeAt(s) === 43 ? (M = Q, s++) : (M = e, D === 0 && O(it)), M === e && (r.charCodeAt(s) === 45 ? (M = ue, s++) : (M = e, D === 0 && O(nt))), M !== e ? (st = Ye(), at = y(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e);
      he = a, a = jt(p, w);
    } else
      s = a, a = e;
    return a;
  }
  function y() {
    var a, p, w, v, N, M, st, at;
    if (a = s, p = me(), p !== e) {
      for (w = [], v = s, N = Ye(), r.charCodeAt(s) === 47 ? (M = oe, s++) : (M = e, D === 0 && O(Pe)), M === e && (r.charCodeAt(s) === 42 ? (M = ye, s++) : (M = e, D === 0 && O(Ce)), M === e && (r.charCodeAt(s) === 37 ? (M = ee, s++) : (M = e, D === 0 && O(zt)))), M !== e ? (st = Ye(), at = me(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, N = Ye(), r.charCodeAt(s) === 47 ? (M = oe, s++) : (M = e, D === 0 && O(Pe)), M === e && (r.charCodeAt(s) === 42 ? (M = ye, s++) : (M = e, D === 0 && O(Ce)), M === e && (r.charCodeAt(s) === 37 ? (M = ee, s++) : (M = e, D === 0 && O(zt)))), M !== e ? (st = Ye(), at = me(), at !== e ? (N = [N, M, st, at], v = N) : (s = v, v = e)) : (s = v, v = e);
      he = a, a = Ht(p, w);
    } else
      s = a, a = e;
    return a;
  }
  function me() {
    var a, p, w, v;
    return a = s, p = s, D++, r.charCodeAt(s) === 45 ? (w = ue, s++) : (w = e, D === 0 && O(nt)), D--, w !== e ? (s = p, p = void 0) : p = e, p !== e ? (w = Ir(), w !== e ? (he = a, a = Rt(w)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, p = s, D++, r.charCodeAt(s) === 45 ? (w = ue, s++) : (w = e, D === 0 && O(nt)), D--, w !== e ? (s = p, p = void 0) : p = e, p !== e ? (w = ce(), w !== e ? (he = a, a = mt(w)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, r.charCodeAt(s) === 33 ? (p = be, s++) : (p = e, D === 0 && O(Y)), p === e && (r.charCodeAt(s) === 43 ? (p = Q, s++) : (p = e, D === 0 && O(it)), p === e && (r.charCodeAt(s) === 45 ? (p = ue, s++) : (p = e, D === 0 && O(nt)))), p !== e ? (w = Ye(), v = W(), v === e && (v = rt()), v !== e ? (he = a, a = Ze(p, v)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = rt()))), a;
  }
  function W() {
    var a, p;
    return a = s, r.charCodeAt(s) === 43 ? (p = Q, s++) : (p = e, D === 0 && O(it)), p === e && (r.charCodeAt(s) === 45 ? (p = ue, s++) : (p = e, D === 0 && O(nt))), p !== e && (he = a, p = er()), a = p, a;
  }
  function rt() {
    var a, p, w, v, N, M, st, at, Cr, ur, yr, Gi, Pi, rn, wi;
    if (a = s, p = dt(), p !== e) {
      for (w = [], v = s, N = Ye(), r.charCodeAt(s) === 46 ? (M = $e, s++) : (M = e, D === 0 && O(wt)), M !== e ? (st = Ye(), at = cr(), at !== e ? (Cr = Ye(), ur = s, r.charCodeAt(s) === 40 ? (yr = ne, s++) : (yr = e, D === 0 && O(et)), yr !== e ? (Gi = Ye(), Pi = le(), Pi !== e ? (rn = Ye(), r.charCodeAt(s) === 41 ? (wi = Ne, s++) : (wi = e, D === 0 && O(ot)), wi !== e ? (yr = [yr, Gi, Pi, rn, wi], ur = yr) : (s = ur, ur = e)) : (s = ur, ur = e)) : (s = ur, ur = e), ur === e && (ur = null), N = [N, M, st, at, Cr, ur], v = N) : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, N = Ye(), r.charCodeAt(s) === 46 ? (M = $e, s++) : (M = e, D === 0 && O(wt)), M !== e ? (st = Ye(), at = cr(), at !== e ? (Cr = Ye(), ur = s, r.charCodeAt(s) === 40 ? (yr = ne, s++) : (yr = e, D === 0 && O(et)), yr !== e ? (Gi = Ye(), Pi = le(), Pi !== e ? (rn = Ye(), r.charCodeAt(s) === 41 ? (wi = Ne, s++) : (wi = e, D === 0 && O(ot)), wi !== e ? (yr = [yr, Gi, Pi, rn, wi], ur = yr) : (s = ur, ur = e)) : (s = ur, ur = e)) : (s = ur, ur = e), ur === e && (ur = null), N = [N, M, st, at, Cr, ur], v = N) : (s = v, v = e)) : (s = v, v = e);
      he = a, a = ir(p, w);
    } else
      s = a, a = e;
    return a;
  }
  function dt() {
    var a, p, w, v, N;
    return a = s, p = cr(), p !== e ? (Ye(), r.charCodeAt(s) === 40 ? (w = ne, s++) : (w = e, D === 0 && O(et)), w !== e ? (Ye(), v = le(), v !== e ? (Ye(), r.charCodeAt(s) === 41 ? (N = Ne, s++) : (N = e, D === 0 && O(ot)), N !== e ? (he = a, a = nr(p, v)) : (s = a, a = e)) : (s = a, a = e)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = vt()), a;
  }
  function le() {
    var a, p, w, v, N, M;
    if (a = s, p = Fr(), p !== e) {
      for (w = [], v = s, Ye(), r.charCodeAt(s) === 44 ? (N = Ie, s++) : (N = e, D === 0 && O(tt)), N !== e ? (Ye(), M = Fr(), M !== e ? v = M : (s = v, v = e)) : (s = v, v = e); v !== e; )
        w.push(v), v = s, Ye(), r.charCodeAt(s) === 44 ? (N = Ie, s++) : (N = e, D === 0 && O(tt)), N !== e ? (Ye(), M = Fr(), M !== e ? v = M : (s = v, v = e)) : (s = v, v = e);
      he = a, a = tr(p, w);
    } else
      s = a, a = e;
    return a === e && (a = Ye()), a;
  }
  function vt() {
    var a, p, w, v;
    return a = Ur(), a === e && (a = Oe(), a === e && (a = Ir(), a === e && (a = ce(), a === e && (a = s, r.charCodeAt(s) === 40 ? (p = ne, s++) : (p = e, D === 0 && O(et)), p !== e ? (Ye(), w = Fr(), w !== e ? (Ye(), r.charCodeAt(s) === 41 ? (v = Ne, s++) : (v = e, D === 0 && O(ot)), v !== e ? (he = a, a = qt(w)) : (s = a, a = e)) : (s = a, a = e)) : (s = a, a = e))))), a;
  }
  function Oe() {
    var a, p, w, v;
    return D++, a = s, r.charCodeAt(s) === 39 ? (p = Me, s++) : (p = e, D === 0 && O(De)), p !== e ? (w = Bt(), r.charCodeAt(s) === 39 ? (v = Me, s++) : (v = e, D === 0 && O(De)), v !== e ? (he = a, a = U(w)) : (s = a, a = e)) : (s = a, a = e), D--, a === e && (p = e, D === 0 && O(It)), a;
  }
  function Bt() {
    var a, p, w;
    for (a = s, p = [], w = sr(); w !== e; )
      p.push(w), w = sr();
    return he = a, p = S(p), a = p, a;
  }
  function sr() {
    var a, p, w, v, N;
    if (a = s, r.substr(s, 2) === l ? (p = l, s += 2) : (p = e, D === 0 && O(fe)), p !== e ? (w = Ye(), v = Fr(), v !== e ? (Ye(), r.charCodeAt(s) === 125 ? (N = c, s++) : (N = e, D === 0 && O(Qe)), N !== e ? (he = a, a = H(v)) : (s = a, a = e)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, r.substr(s, 3) === d ? (p = d, s += 3) : (p = e, D === 0 && O(Ge)), p !== e && (he = a, p = B()), a = p, a === e && (a = s, p = s, D++, r.charCodeAt(s) === 92 ? (w = f, s++) : (w = e, D === 0 && O(gt)), w === e && (r.charCodeAt(s) === 39 ? (w = Me, s++) : (w = e, D === 0 && O(De)), w === e && (r.substr(s, 2) === l ? (w = l, s += 2) : (w = e, D === 0 && O(fe)))), D--, w === e ? p = void 0 : (s = p, p = e), p !== e ? (r.length > s ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(lt)), w !== e ? (he = a, a = V()) : (s = a, a = e)) : (s = a, a = e), a === e))) {
      if (a = s, r.substr(s, 2) === l ? (p = l, s += 2) : (p = e, D === 0 && O(fe)), p !== e) {
        if (w = [], Ue.test(r.charAt(s)) ? (v = r.charAt(s), s++) : (v = e, D === 0 && O(Wt)), v !== e)
          for (; v !== e; )
            w.push(v), Ue.test(r.charAt(s)) ? (v = r.charAt(s), s++) : (v = e, D === 0 && O(Wt));
        else
          w = e;
        w !== e ? (r.charCodeAt(s) === 125 ? (v = c, s++) : (v = e, D === 0 && O(Qe)), v !== e ? (he = a, a = Ee()) : (s = a, a = e)) : (s = a, a = e);
      } else
        s = a, a = e;
      a === e && (a = s, r.substr(s, 2) === l ? (p = l, s += 2) : (p = e, D === 0 && O(fe)), p !== e && (he = a, p = m()), a = p, a === e && (a = s, r.charCodeAt(s) === 92 ? (p = f, s++) : (p = e, D === 0 && O(gt)), p !== e ? (r.substr(s, 2) === l ? (w = l, s += 2) : (w = e, D === 0 && O(fe)), w !== e ? (he = a, a = ie(w)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, r.charCodeAt(s) === 92 ? (p = f, s++) : (p = e, D === 0 && O(gt)), p !== e ? (r.length > s ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(lt)), w !== e ? (he = a, a = L(w)) : (s = a, a = e)) : (s = a, a = e), a === e && (a = s, r.charCodeAt(s) === 92 ? (p = f, s++) : (p = e, D === 0 && O(gt)), p !== e && (he = a, p = Te()), a = p))));
    }
    return a;
  }
  function ce() {
    var a, p, w;
    if (D++, a = s, r.charCodeAt(s) === 45 ? s++ : D === 0 && O(nt), p = [], xe.test(r.charAt(s)) ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(kt)), w !== e)
      for (; w !== e; )
        p.push(w), xe.test(r.charAt(s)) ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(kt));
    else
      p = e;
    return p !== e ? (he = a, a = ze()) : (s = a, a = e), D--, a === e && D === 0 && O(At), a;
  }
  function Ir() {
    var a, p, w, v, N, M, st, at, Cr;
    for (D++, a = s, r.charCodeAt(s) === 45 ? s++ : D === 0 && O(nt), p = [], xe.test(r.charAt(s)) ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(kt)); w !== e; )
      p.push(w), xe.test(r.charAt(s)) ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(kt));
    if (r.charCodeAt(s) === 46 ? (w = $e, s++) : (w = e, D === 0 && O(wt)), w !== e) {
      if (v = [], xe.test(r.charAt(s)) ? (N = r.charAt(s), s++) : (N = e, D === 0 && O(kt)), N !== e)
        for (; N !== e; )
          v.push(N), xe.test(r.charAt(s)) ? (N = r.charAt(s), s++) : (N = e, D === 0 && O(kt));
      else
        v = e;
      if (v !== e) {
        if (N = s, r.charCodeAt(s) === 101 ? (M = Re, s++) : (M = e, D === 0 && O(re)), M === e && (r.charCodeAt(s) === 69 ? (M = Be, s++) : (M = e, D === 0 && O(ct))), M !== e) {
          if (r.charCodeAt(s) === 43 ? (st = Q, s++) : (st = e, D === 0 && O(it)), st === e && (r.charCodeAt(s) === 45 ? (st = ue, s++) : (st = e, D === 0 && O(nt))), st === e && (st = null), at = [], xe.test(r.charAt(s)) ? (Cr = r.charAt(s), s++) : (Cr = e, D === 0 && O(kt)), Cr !== e)
            for (; Cr !== e; )
              at.push(Cr), xe.test(r.charAt(s)) ? (Cr = r.charAt(s), s++) : (Cr = e, D === 0 && O(kt));
          else
            at = e;
          at !== e ? (M = [M, st, at], N = M) : (s = N, N = e);
        } else
          s = N, N = e;
        N === e && (N = null), he = a, a = pr();
      } else
        s = a, a = e;
    } else
      s = a, a = e;
    if (a === e) {
      if (a = s, r.charCodeAt(s) === 45 ? s++ : D === 0 && O(nt), p = [], xe.test(r.charAt(s)) ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(kt)), w !== e)
        for (; w !== e; )
          p.push(w), xe.test(r.charAt(s)) ? (w = r.charAt(s), s++) : (w = e, D === 0 && O(kt));
      else
        p = e;
      if (p !== e)
        if (r.charCodeAt(s) === 101 ? (w = Re, s++) : (w = e, D === 0 && O(re)), w === e && (r.charCodeAt(s) === 69 ? (w = Be, s++) : (w = e, D === 0 && O(ct))), w !== e) {
          if (r.charCodeAt(s) === 43 ? (v = Q, s++) : (v = e, D === 0 && O(it)), v === e && (r.charCodeAt(s) === 45 ? (v = ue, s++) : (v = e, D === 0 && O(nt))), v === e && (v = null), N = [], xe.test(r.charAt(s)) ? (M = r.charAt(s), s++) : (M = e, D === 0 && O(kt)), M !== e)
            for (; M !== e; )
              N.push(M), xe.test(r.charAt(s)) ? (M = r.charAt(s), s++) : (M = e, D === 0 && O(kt));
          else
            N = e;
          N !== e ? (he = a, a = je()) : (s = a, a = e);
        } else
          s = a, a = e;
      else
        s = a, a = e;
    }
    return D--, a === e && D === 0 && O(Xe), a;
  }
  function Ur() {
    var a, p, w, v, N, M, st, at, Cr, ur, yr;
    if (a = s, J.test(r.charAt(s)) ? (p = r.charAt(s), s++) : (p = e, D === 0 && O(Gt)), p !== e) {
      if (w = [], v = [], te.test(r.charAt(s)) ? (N = r.charAt(s), s++) : (N = e, D === 0 && O(b)), N !== e)
        for (; N !== e; )
          v.push(N), te.test(r.charAt(s)) ? (N = r.charAt(s), s++) : (N = e, D === 0 && O(b));
      else
        v = e;
      for (v === e && (v = s, r.charCodeAt(s) === 46 ? (N = $e, s++) : (N = e, D === 0 && O(wt)), N !== e ? (M = s, D++, st = s, at = Ye(), Cr = cr(), Cr !== e ? (ur = Ye(), r.charCodeAt(s) === 40 ? (yr = ne, s++) : (yr = e, D === 0 && O(et)), yr !== e ? (at = [at, Cr, ur, yr], st = at) : (s = st, st = e)) : (s = st, st = e), D--, st === e ? M = void 0 : (s = M, M = e), M !== e ? (N = [N, M], v = N) : (s = v, v = e)) : (s = v, v = e)); v !== e; ) {
        if (w.push(v), v = [], te.test(r.charAt(s)) ? (N = r.charAt(s), s++) : (N = e, D === 0 && O(b)), N !== e)
          for (; N !== e; )
            v.push(N), te.test(r.charAt(s)) ? (N = r.charAt(s), s++) : (N = e, D === 0 && O(b));
        else
          v = e;
        v === e && (v = s, r.charCodeAt(s) === 46 ? (N = $e, s++) : (N = e, D === 0 && O(wt)), N !== e ? (M = s, D++, st = s, at = Ye(), Cr = cr(), Cr !== e ? (ur = Ye(), r.charCodeAt(s) === 40 ? (yr = ne, s++) : (yr = e, D === 0 && O(et)), yr !== e ? (at = [at, Cr, ur, yr], st = at) : (s = st, st = e)) : (s = st, st = e), D--, st === e ? M = void 0 : (s = M, M = e), M !== e ? (N = [N, M], v = N) : (s = v, v = e)) : (s = v, v = e));
      }
      he = a, a = Ar();
    } else
      s = a, a = e;
    return a;
  }
  function cr() {
    var a, p, w, v;
    if (a = s, J.test(r.charAt(s)) ? (p = r.charAt(s), s++) : (p = e, D === 0 && O(Gt)), p !== e) {
      for (w = [], te.test(r.charAt(s)) ? (v = r.charAt(s), s++) : (v = e, D === 0 && O(b)); v !== e; )
        w.push(v), te.test(r.charAt(s)) ? (v = r.charAt(s), s++) : (v = e, D === 0 && O(b));
      he = a, a = Xr();
    } else
      s = a, a = e;
    return a;
  }
  function Ye() {
    var a, p;
    for (D++, a = [], de.test(r.charAt(s)) ? (p = r.charAt(s), s++) : (p = e, D === 0 && O(se)); p !== e; )
      a.push(p), de.test(r.charAt(s)) ? (p = r.charAt(s), s++) : (p = e, D === 0 && O(se));
    return D--, p = e, D === 0 && O(Nt), a;
  }
  if (_r = o(), _r !== e && s === r.length)
    return _r;
  throw _r !== e && s < r.length && O(Br()), $r(
    Tt,
    Kt < r.length ? r.charAt(Kt) : null,
    Kt < r.length ? Sr(Kt, Kt + 1) : Sr(Kt, Kt)
  );
}
const j_ = 128, un = /* @__PURE__ */ new Map();
let Ma;
function yl(r) {
  return un.get(r);
}
function wl(r, t) {
  r !== Ma && (un.delete(r), un.size >= j_ && un.delete(un.keys().next().value), un.set(r, t), Ma = r);
}
const Pa = /* @__PURE__ */ new Set([
  "string",
  "integer",
  "number",
  "boolean",
  "datetime",
  "color",
  "url",
  "dict",
  "array"
]);
function E_(r) {
  if (!(typeof r.name == "string" && r.name))
    throw new Error("Incorrect function name");
  if (!(typeof r.body == "string" && r.body))
    throw new Error("Incorrect function body");
  if (!(r.return_type && Pa.has(r.return_type)))
    throw new Error("Incorrect function return_type");
  if (!Array.isArray(r.arguments))
    throw new Error("Incorrect function arguments");
  const t = /* @__PURE__ */ new Set();
  r.arguments.forEach((e) => {
    if (!(typeof e.name == "string" && e.name))
      throw new Error("Incorrect argument name");
    if (!(e.type && Pa.has(e.type)))
      throw new Error("Incorrect argument type");
    if (t.has(e.name))
      throw new Error("Duplicate argument name");
    t.add(e.name);
  });
}
function x_(r) {
  let t;
  return {
    args: r.arguments.map((e) => ({
      type: e.type
    })),
    cb(e, ...i) {
      t || (t = yl(r.body) || bl(r.body, {
        startRule: "JsonStringContents"
      }), wl(r.body, t));
      const n = /* @__PURE__ */ new Map();
      i.forEach((c, d) => {
        const f = Zn(r.arguments[d].name, c.type, c.value);
        n.set(f.getName(), f);
      });
      const o = bs(n, e.customFunctions, e.store, t, {
        weekStartDay: e.weekStartDay
      });
      o.warnings.forEach((c) => {
        e.warnings.push(c);
      });
      const l = o.result;
      if (l.type === "error")
        throw new Error(l.value);
      if (l.type !== r.return_type)
        throw new Error("Incorrect function return_type");
      return l;
    }
  };
}
function A_(r, t) {
  if (!r)
    return t || void 0;
  if (!t)
    return r || void 0;
  const e = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set();
  for (const [n, o] of t) {
    for (const l of o) {
      const c = ia(n, l);
      i.add(c);
    }
    e.set(n, o);
  }
  for (const [n, o] of r)
    for (const l of o) {
      const c = ia(n, l);
      if (!i.has(c)) {
        i.add(c);
        const d = e.get(n) || [];
        d.push(l), e.set(n, d);
      }
    }
  return e;
}
function C_(r) {
  if (!r)
    return x(new Error("Missing object"));
  const t = r.card, e = r.templates || {};
  if (!t)
    return x(new Error("Missing card"));
  if (!t.states || !t.states.length)
    return x(new Error("Missing states"));
  for (const i in e)
    if (e.hasOwnProperty(i) && i in dl)
      return x(new Error("Template name collision"), {
        additional: {
          templateName: i
        }
      });
  for (let i = 0; i < t.states.length; ++i) {
    if (!t.states[i].div)
      return x(new Error("Missing state div"), {
        additional: {
          stateId: t.states[i].state_id
        }
      });
    if (typeof t.states[i].state_id != "number")
      return x(new Error("Missing state_id"), {
        additional: {
          index: i
        }
      });
  }
  return null;
}
function S_(r) {
  return [...new Set(r)];
}
class kl {
  constructor(t, e) {
    Er(this, "ast");
    Er(this, "expr");
    this.ast = t, this.expr = e;
  }
  /**
   * Applies variables into ast
   * @param variables
   * @param logError
   */
  apply({
    variables: t,
    customFunctions: e,
    logError: i,
    store: n,
    weekStartDay: o,
    keepComplex: l
  }) {
    let c;
    try {
      c = bs(t, e, n, this.ast, {
        weekStartDay: o
      }), c.warnings.forEach(i);
      const d = c.result;
      if (d.type === "error")
        return i(x(new Error("Expression execution error"), {
          additional: {
            message: d.value,
            expression: this.expr
          }
        })), {
          result: void 0,
          usedVars: c.usedVars
        };
      const f = d.value;
      if (f instanceof Date)
        return {
          result: tl(f),
          usedVars: c.usedVars
        };
      if (d.type === "boolean")
        return {
          result: !!f,
          usedVars: c.usedVars
        };
      if (d.type === "color") {
        const h = ji(String(f));
        if (h)
          return {
            result: tn(h),
            usedVars: c.usedVars
          };
        i(x(new Error("Expression execution error")));
      }
      if (d.type === "integer")
        return f > Cf || f < Sf ? (i(x(new Error("Expression result is out of 32-bit int range"))), {
          result: void 0,
          usedVars: c.usedVars
        }) : {
          result: Number(f),
          usedVars: c.usedVars
        };
      if (!l && (d.type === "array" || d.type === "dict"))
        try {
          return {
            result: JSON.stringify(f),
            usedVars: c.usedVars
          };
        } catch {
          return i(x(new Error(`Failed to stringify ${d.type}`))), {
            result: `<${d.type}>`,
            usedVars: c.usedVars
          };
        }
      return {
        result: f,
        usedVars: c.usedVars
      };
    } catch {
      return i(x(new Error("Expression execution error"), {
        additional: {
          expression: this.expr
        }
      })), {
        result: void 0,
        usedVars: c == null ? void 0 : c.usedVars
      };
    }
  }
}
function V_(r) {
  return r.indexOf("@{") > -1 || r.indexOf("\\") > -1;
}
function is(r, t, e) {
  if (r)
    if (typeof r == "string") {
      if (V_(r)) {
        t.hasExpression = !0;
        try {
          const i = yl(r) || bl(r, {
            startRule: "JsonStringContents"
          });
          wl(r, i);
          const n = If(i);
          return t.vars.push(...n), new kl(i, r);
        } catch {
          e(x(new Error("Unable to parse expression"), {
            additional: {
              expression: r
            }
          }));
          return;
        }
      }
    } else {
      if (Array.isArray(r))
        return r.map((i) => is(i, t, e));
      if (typeof r == "object") {
        const i = {};
        for (const n in r)
          i[n] = is(r[n], t, e);
        return i;
      }
    }
  return r;
}
function ns(r, t) {
  if (r) {
    if (r instanceof kl)
      return r.apply(t);
    if (Array.isArray(r)) {
      let e;
      return {
        result: r.map((n) => {
          const o = ns(n, t);
          if (o.usedVars) {
            e || (e = /* @__PURE__ */ new Set());
            for (const l of o.usedVars)
              e.add(l);
          }
          return o.result;
        }),
        usedVars: e
      };
    } else if (typeof r == "object") {
      const e = {};
      let i;
      for (const n in r) {
        const o = ns(r[n], t);
        if (e[n] = o.result, o.usedVars) {
          i || (i = /* @__PURE__ */ new Set());
          for (const l of o.usedVars)
            i.add(l);
        }
      }
      return {
        result: e,
        usedVars: i
      };
    }
  }
  return {
    result: r
  };
}
function za(r, t, e, i) {
  const n = {
    vars: [],
    hasExpression: !1
  }, o = is(r, n, t);
  return {
    vars: S_(n.vars),
    hasExpression: n.hasExpression,
    applyVars(c, d, f) {
      return ns(o, {
        variables: c,
        customFunctions: d,
        logError: t,
        store: e,
        weekStartDay: i,
        keepComplex: f
      });
    }
  };
}
class $l {
  constructor() {
    Er(this, "_vars", /* @__PURE__ */ new Map());
    Er(this, "_lastAddedVariable", Ci(""));
  }
  setVariable(t) {
    const e = t.getName();
    if (this._vars.has(e))
      throw new Error("Variable with the same name already exist");
    this._vars.set(e, t), this._lastAddedVariable.set(e);
  }
  getVariable(t) {
    return this._vars.get(t);
  }
  list() {
    return this._vars.values();
  }
  getVariables() {
    return this._vars;
  }
  getLastAddedVariableStore() {
    return this._lastAddedVariable;
  }
}
function _m() {
  return new $l();
}
const F_ = ["start", "stop", "pause", "resume", "cancel", "reset"], I_ = new Set(F_);
class D_ {
  constructor(t) {
    Er(this, "timers", /* @__PURE__ */ new Map());
    Er(this, "logError");
    Er(this, "applyVars");
    Er(this, "hasVariableWithType");
    Er(this, "setVariableValue");
    Er(this, "execAnyActions");
    Er(this, "visibilityHandler");
    Er(this, "awaitActions", []);
    this.logError = t.logError, this.applyVars = t.applyVars, this.hasVariableWithType = t.hasVariableWithType, this.setVariableValue = t.setVariableValue, this.execAnyActions = t.execAnyActions, this.visibilityHandler = () => {
      document.visibilityState === "visible" ? (this.awaitActions.forEach(({ id: e, action: i }) => {
        this.execTimerAction(e, i);
      }), this.awaitActions = [], this.unholdAll()) : this.holdAll();
    }, document.addEventListener("visibilitychange", this.visibilityHandler);
  }
  destroy() {
    document.removeEventListener("visibilitychange", this.visibilityHandler);
    for (const [t, e] of this.timers)
      this.stopTimerTimeouts(e);
  }
  createTimer(t) {
    if (!(t != null && t.id)) {
      this.logError(x(new Error("Missing timer id")));
      return;
    }
    if (!(t.duration || t.tick_interval && (t.value_variable || t.tick_actions))) {
      this.logError(x(new Error("Misconfigured timer"), {
        additional: {
          id: t.id
        }
      }));
      return;
    }
    this.timers.set(t.id, {
      state: "stopped",
      definition: t
    });
  }
  execTimerAction(t, e) {
    if (!t || !e || !this.timers.has(t) || !I_.has(e)) {
      this.logError(x(new Error("Incorrect timer action"), {
        additional: {
          id: t,
          action: e
        }
      }));
      return;
    }
    const i = e;
    if (document.visibilityState !== "visible") {
      this.awaitActions.push({
        id: t,
        action: i
      });
      return;
    }
    const n = this.timers.get(t);
    this[i](n);
  }
  stopTimerTimeouts(t) {
    t.durationTimeout && (clearTimeout(t.durationTimeout), t.durationTimeout = void 0), t.tickTimeout && (clearTimeout(t.tickTimeout), t.tickTimeout = void 0);
  }
  async tickOrUnholdAction(t) {
    const e = performance.now(), i = (t.durationPassed || 0) + e - (t.durationStarted || 0);
    t.duration && i > t.duration || (this.updateVariable(t, i), await this.callActions(t, "tick"), t.tickCount !== void 0 && ++t.tickCount);
  }
  startOrResume(t) {
    t.state = "running", t.hold = !1, t.durationStarted = performance.now();
    const e = t.duration;
    e && (t.durationTimeout = window.setTimeout(async () => {
      this.updateVariable(t, e), t.tickCountPredict && t.tickCount !== void 0 && t.tickCount < t.tickCountPredict && await this.callActions(t, "tick"), this.stop(t);
    }, Math.max(0, e - (t.durationPassed || 0))));
    const i = t.tick;
    if (i) {
      const n = () => {
        const o = t.tickStarted = performance.now(), l = Math.max(0, i - (t.tickPassed || 0));
        t.tickTimeout = window.setTimeout(async () => {
          await this.tickOrUnholdAction(t), t.tickPassed = (performance.now() - o - l) % i, t.state === "running" && n();
        }, l);
      };
      n();
    }
  }
  applyVarsInt(t) {
    let e = this.applyVars(t);
    if (typeof e == "string") {
      if (e === t)
        return;
      e = Number(e);
    }
    if (!(e === void 0 || Number.isNaN(e) || Math.round(e) !== e))
      return e;
  }
  start(t) {
    if (t.state === "running") {
      this.logError(x(new Error("The timer is already running")));
      return;
    } else if (t.state === "paused") {
      this.logError(x(new Error("The timer is paused")));
      return;
    }
    const e = t.definition.value_variable;
    if (e && !this.hasVariableWithType(e, "integer")) {
      this.logError(x(new Error("Cannot find variable"), {
        additional: {
          name: e
        }
      }));
      return;
    }
    if (e && this.setVariableValue(e, 0), t.definition.duration !== void 0 && (t.duration = this.applyVarsInt(t.definition.duration), t.duration === void 0 || t.duration < 0)) {
      this.logError(x(new Error("Incorrect timer properties"), {
        additional: {
          id: t.definition.id
        }
      }));
      return;
    }
    if (t.definition.tick_interval !== void 0 && (t.tick = this.applyVarsInt(t.definition.tick_interval), t.tick === void 0 || t.tick <= 0)) {
      this.logError(x(new Error("Incorrect timer properties"), {
        additional: {
          id: t.definition.id
        }
      }));
      return;
    }
    t.duration !== void 0 && t.tick !== void 0 && (t.tickCount = 0, t.tickCountPredict = Math.floor(t.duration / t.tick)), this.startOrResume(t);
  }
  stop(t) {
    if (t.state === "stopped") {
      this.logError(x(new Error("The timer has already been stopped")));
      return;
    }
    t.state = "stopped", t.durationPassed = 0, t.tickPassed = 0, this.stopTimerTimeouts(t), this.callActions(t, "end");
  }
  pause(t) {
    if (t.state === "stopped") {
      this.logError(x(new Error("The timer has already been stopped")));
      return;
    } else if (t.state === "paused") {
      this.logError(x(new Error("The timer has already been paused")));
      return;
    }
    t.state = "paused", this.stopTimerTimeouts(t);
    const e = performance.now();
    t.durationStarted && (t.durationPassed = (t.durationPassed || 0) + e - t.durationStarted), t.tickStarted && (t.tickPassed = (t.tickPassed || 0) + e - t.tickStarted);
    const i = t.definition.value_variable;
    i && t.durationPassed && this.setVariableValue(i, Math.round(t.durationPassed));
  }
  resume(t) {
    if (t.state === "stopped") {
      this.logError(x(new Error("The timer has already been stopped")));
      return;
    } else if (t.state === "running") {
      this.logError(x(new Error("The timer is already running")));
      return;
    }
    this.startOrResume(t);
  }
  cancel(t) {
    t.state !== "stopped" && (t.state = "stopped", t.durationPassed = 0, t.tickPassed = 0, this.stopTimerTimeouts(t));
  }
  reset(t) {
    this.cancel(t), this.start(t);
  }
  updateVariable(t, e) {
    const i = t.definition.value_variable;
    i && this.setVariableValue(i, Math.round(e));
  }
  async callActions(t, e) {
    const i = t.definition[e === "end" ? "end_actions" : "tick_actions"];
    if (i)
      return this.execAnyActions(i, {
        processUrls: !1
      });
  }
  holdAll() {
    for (const [t, e] of this.timers)
      e.state === "running" && (e.hold = !0, this.stopTimerTimeouts(e));
  }
  async unholdAll() {
    for (const [t, e] of this.timers)
      if (e.state === "running" && e.hold) {
        const i = performance.now();
        e.durationStarted && (e.durationPassed = (e.durationPassed || 0) + i - e.durationStarted), e.tickStarted && (e.tickPassed = (e.tickPassed || 0) + i - e.tickStarted), e.tick && await this.tickOrUnholdAction(e), this.startOrResume(e);
      }
  }
}
function T_(r, t, e, i) {
  const { variable_name: n, index: o, value: l } = i;
  if (!l || typeof o != "number" && o !== void 0) {
    e(x(new Error("Incorrect array_insert_value action"), {
      additional: {
        name: n
      }
    }));
    return;
  }
  ys(r, t, e, i, (c) => {
    const d = c.getValue();
    if (typeof o == "number" && (o < 0 || o > d.length))
      e(x(new Error(`Index out of bound for mutation ${i.type}`), {
        additional: {
          name: n,
          index: o,
          length: d.length
        }
      }));
    else if (!l.type)
      e(x(new Error("Incorrect value type"), {
        additional: {
          name: n
        }
      }));
    else {
      const f = d.slice(), h = Eo(l);
      typeof o == "number" ? f.splice(o, 0, h) : f.push(h), c.setValue(f);
    }
  });
}
function M_(r, t, e, i) {
  const { variable_name: n, index: o } = i;
  if (typeof o != "number") {
    e(x(new Error("Incorrect array_remove_value action"), {
      additional: {
        name: n
      }
    }));
    return;
  }
  ys(r, t, e, i, (l) => {
    const c = l.getValue();
    if (typeof o == "number" && (o < 0 || o >= c.length))
      e(x(new Error(`Index out of bound for mutation ${i.type}`), {
        additional: {
          name: n,
          index: o,
          length: c.length
        }
      }));
    else {
      const d = c.slice();
      d.splice(o, 1), l.setValue(d);
    }
  });
}
function P_(r, t, e, i) {
  const { variable_name: n, index: o, value: l } = i;
  if (!l || typeof o != "number") {
    e(x(new Error("Incorrect array_set_value action"), {
      additional: {
        name: n
      }
    }));
    return;
  }
  ys(r, t, e, i, (c) => {
    const d = c.getValue();
    if (typeof o == "number" && (o < 0 || o >= d.length))
      e(x(new Error(`Index out of bound for mutation ${i.type}`), {
        additional: {
          name: n,
          index: o,
          length: d.length
        }
      }));
    else if (!l.type)
      e(x(new Error("Incorrect value type"), {
        additional: {
          name: n
        }
      }));
    else {
      const f = d.slice();
      f[o] = Eo(l), c.setValue(f);
    }
  });
}
function ys(r, t, e, i, n) {
  const { variable_name: o } = i;
  if (!o) {
    e(x(new Error(`Incorrect ${i.type} action`), {
      additional: {
        name: o
      }
    }));
    return;
  }
  const l = (r == null ? void 0 : r.getVariable(o)) || t.get(o);
  if (!l) {
    e(x(new Error("Cannot find variable"), {
      additional: {
        name: o
      }
    }));
    return;
  }
  const c = l.getType();
  c === "array" ? n(l) : e(x(new Error("Trying to insert value into the non-array"), {
    additional: {
      name: o,
      type: c
    }
  }));
}
function z_(r, t, e, i) {
  const { variable_name: n, key: o, value: l } = i;
  if (typeof o != "string") {
    e(x(new Error("Incorrect dict_set_value action"), {
      additional: {
        name: n
      }
    }));
    return;
  }
  if (!n) {
    e(x(new Error(`Incorrect ${i.type} action`), {
      additional: {
        name: n
      }
    }));
    return;
  }
  l && !l.type && e(x(new Error("Incorrect value type"), {
    additional: {
      name: n
    }
  }));
  const c = (r == null ? void 0 : r.getVariable(n)) || t.get(n);
  if (!c) {
    e(x(new Error("Cannot find variable"), {
      additional: {
        name: n
      }
    }));
    return;
  }
  const d = c.getType();
  if (d === "dict") {
    const h = { ...c.getValue() };
    l ? h[o] = Eo(l) : delete h[o], c.setValue(h);
  } else
    e(x(new Error("Trying to set value into the non-dict"), {
      additional: {
        name: n,
        type: d
      }
    }));
}
function O_(r, t) {
  if (!(t.content && (t.content.type === "text" || t.content.type === "url") && typeof t.content.value == "string")) {
    r(x(new Error("Incorrect action"), {
      additional: {
        action: t
      }
    }));
    return;
  }
  if (!(typeof navigator < "u" && "clipboard" in navigator && navigator.clipboard && "writeText" in navigator.clipboard && typeof navigator.clipboard.writeText == "function")) {
    r(x(new Error("Clipboard is unavailable"), {
      additional: {
        action: t
      }
    }));
    return;
  }
  navigator.clipboard.writeText(t.content.value).catch((e) => {
    r(x(new Error("Failed to copy to the clipboard"), {
      additional: {
        originalError: String(e)
      }
    }));
  });
}
function N_(r) {
  if (r === "normal" || r === "reverse" || r === "alternate" || r === "alternate_reverse")
    return r;
}
function R_(r, t, e, i) {
  var K, ge, Q, ue;
  const n = fi(r.duration, 0);
  if (!n || r.type !== "color_animator" && r.type !== "number_animator")
    return;
  const o = (K = r.start_value_typed ? r.start_value_typed.value : r.start_value) != null ? K : t.getValue(), l = r.end_value_typed ? r.end_value_typed.value : r.end_value;
  if (o === void 0 || l === void 0 || r.type === "color_animator" && (typeof o != "string" && o !== void 0 || typeof l != "string") || r.type === "number_animator" && (typeof o != "number" && o !== void 0 || typeof l != "number"))
    return;
  const c = r.type === "color_animator" && ji(o), d = r.type === "color_animator" && ji(l);
  if (r.type === "color_animator" && (!c || !d))
    return;
  const f = wr(r.start_delay, 0), h = Wd(r.interpolator || "linear"), C = N_(r.direction) || "normal", T = ((ge = r.repeat_count) == null ? void 0 : ge.type) === "infinity" ? 1 / 0 : ((Q = r.repeat_count) == null ? void 0 : Q.type) === "fixed" ? wr((ue = r.repeat_count) == null ? void 0 : ue.value, 1) : 1;
  let P = 0, z = performance.now();
  const G = T === 1 / 0 ? 1 / 0 : T * n + f;
  function I(oe) {
    if (r.type === "color_animator") {
      if (!c || !d)
        throw new Error("Missing start/end value");
      return tn({
        a: Ri(Cn(c.a, d.a, oe), 0, 255),
        r: Ri(Cn(c.r, d.r, oe), 0, 255),
        g: Ri(Cn(c.g, d.g, oe), 0, 255),
        b: Ri(Cn(c.b, d.b, oe), 0, 255)
      });
    }
    return Cn(o, l, oe);
  }
  function F(oe) {
    const ye = oe - z;
    if (z = oe, P += ye, P >= f) {
      let ee = Math.floor((P - f) / n), be = (P - f - ee * n) / n;
      ee >= T && (ee = T - 1, be = 1);
      let $e;
      C === "normal" || C === "alternate" && ee % 2 === 0 || C === "alternate_reverse" && ee % 2 === 1 ? $e = "normal" : $e = "reverse", $e === "reverse" && (be = 1 - be);
      const ne = I(h(be));
      t.setValue(ne);
    }
    P < G ? ke = requestAnimationFrame(F) : (e(), i(r.end_actions));
  }
  let ke = requestAnimationFrame(F);
  return {
    stop() {
      cancelAnimationFrame(ke), i(r.cancel_actions), i(r.end_actions);
    }
  };
}
function B_(r) {
  let t = r;
  for (; t && !t.isTooltipRoot; )
    t = t.parent;
  return t;
}
function L_(r) {
  let t = r;
  for (; t != null && t.parent && t.json.type !== "state" && !t.isRootState && !t.isTooltipRoot; )
    t = t.parent;
  return t;
}
function bo(r) {
  return !!(r && typeof r == "string");
}
const H_ = /* @__PURE__ */ new Set([
  "get",
  "post",
  "put",
  "patch",
  "delete",
  "head",
  "options"
]);
function W_(r) {
  return r === void 0 || H_.has(r);
}
function U_(r) {
  return r === void 0 || Array.isArray(r) && r.every((t) => bo(t.name) && bo(t.value));
}
function G_(r) {
  var t, e, i;
  return bo(r.container_id) && bo((t = r.request) == null ? void 0 : t.url) && W_((e = r.request) == null ? void 0 : e.method) && U_((i = r.request) == null ? void 0 : i.headers);
}
function q_(r, t, e, i) {
  const { variable_name: n, path: o, value: l } = i;
  if (!(l != null && l.value)) {
    e(x(new Error("Missing value for an action"), {
      additional: {
        name: n
      }
    }));
    return;
  }
  if (typeof o != "string" || !o || o.charAt(0) === "/" || o.charAt(o.length - 1) === "/") {
    e(x(new Error(`Value '${o}' for key 'path' is not valid`), {
      additional: {
        name: n
      }
    }));
    return;
  }
  if (!n) {
    e(x(new Error(`Incorrect ${i.type} action`), {
      additional: {
        name: n
      }
    }));
    return;
  }
  const c = (r == null ? void 0 : r.getVariable(n)) || t.get(n);
  if (!c) {
    e(x(new Error("Cannot find variable"), {
      additional: {
        name: n
      }
    }));
    return;
  }
  const d = c.getType();
  if (d === "dict" || d === "array") {
    const f = c.getValue(), h = o.replace(/\/+/g, "/");
    if (h === "/") {
      e(x(new Error(`Value '${o}' for key 'path' is not valid`), {
        additional: {
          name: n,
          type: d,
          path: o
        }
      }));
      return;
    }
    const C = h.split("/"), T = d === "array" ? f.slice() : { ...f };
    let P = T;
    for (let z = 0; z < C.length; ++z) {
      const G = C[z];
      if (!G) {
        e(x(new Error("Path is empty"), {
          additional: {
            name: n,
            type: d,
            path: o
          }
        }));
        return;
      }
      if (!P || typeof P != "object") {
        e(x(new Error(`Element with path '${C.slice(0, z).join("/")}' is not ${P === void 0 ? "found" : "a structure"}`), {
          additional: {
            name: n,
            type: d,
            path: o
          }
        }));
        return;
      }
      if (Array.isArray(P)) {
        const I = Number(G);
        if (Number.isNaN(I)) {
          e(x(new Error(`Unable to use '${G}' as array index`), {
            additional: {
              name: n,
              type: d,
              path: o
            }
          }));
          return;
        }
        if (z + 1 === C.length && (I < 0 || I > P.length)) {
          e(x(new Error(`Position '${I}' is out of array bounds`), {
            additional: {
              name: n,
              type: d,
              path: o
            }
          }));
          return;
        }
      }
      z + 1 < C.length && (P = P[G]);
    }
    P[C[C.length - 1]] = Eo(l), c.setValue(T);
  } else
    e(x(new Error("Action requires array or dictionary variable"), {
      additional: {
        name: n,
        type: d
      }
    }));
}
const J_ = "appkit-outer", Y_ = "appkit-root__clickable", K_ = "undefined", X_ = "appkit-tooltip", Z_ = "appkit-tooltip_visible", Q_ = "appkit-tooltip_modal", em = "appkit-tooltip__inner", tm = "appkit-tooltip__overlay", Yn = {
  outer: J_,
  root__clickable: Y_,
  "root__clickable-no-transition": "appkit-root__clickable-no-transition",
  root__selectable: K_,
  tooltip: X_,
  tooltip_visible: Z_,
  tooltip_modal: Q_,
  tooltip__inner: em,
  tooltip__overlay: tm
}, rm = typeof window < "u" && "HTMLDialogElement" in window;
let Oa = [];
const im = xr((r, t, e, i) => {
  var J, te, de, fe, Qe;
  let n, o, l, c, d, f, h = E, C = () => (h(), h = $(l, (Ge) => Ge), l), T = E, P = () => (T(), T = $(o, (Ge) => Ge), o), z = E, G = () => (z(), z = $(n, (Ge) => Ge), n), I, F, ke = E, K = () => (ke(), ke = $(c, (Ge) => Ge), c), ge = E, Q = () => (ge(), ge = $(d, (Ge) => Ge), d), { ownerNode: ue } = t, { data: oe } = t, { internalId: ye } = t, { parentComponentContext: ee } = t;
  const $e = kr(Wr).isDesktop;
  F = $($e, (Ge) => I = Ge);
  let ne, Ne = !1, Ie = "", Me = "", Re = "", Be = "", Fe, Ue = !0, xe = null;
  return Kr(() => {
    if (Fe && Fe.destroy(), Oa = Oa.filter((Ge) => Ge !== ne), Ue && xe && xe instanceof HTMLElement)
      try {
        xe.focus({ preventScroll: !0 });
      } catch {
      }
  }), t.ownerNode === void 0 && e.ownerNode && ue !== void 0 && e.ownerNode(ue), t.data === void 0 && e.data && oe !== void 0 && e.data(oe), t.internalId === void 0 && e.internalId && ye !== void 0 && e.internalId(ye), t.parentComponentContext === void 0 && e.parentComponentContext && ee !== void 0 && e.parentComponentContext(ee), Fe && Fe.destroy(), Fe = ee.produceChildContext(oe.div || {}, { isTooltipRoot: !0 }), G(n = ee.getDerivedFromVars(oe.position)), P(o = ee.getDerivedFromVars((te = (J = oe.offset) == null ? void 0 : J.x) == null ? void 0 : te.value)), C(l = ee.getDerivedFromVars((fe = (de = oe.offset) == null ? void 0 : de.y) == null ? void 0 : fe.value)), K(c = ee.getDerivedFromVars(oe.animation_in)), Q(d = ee.getDerivedFromVars(oe.animation_out)), ((Qe = oe.mode) == null ? void 0 : Qe.type) === "non_modal" ? Ue = !1 : Ue = !0, f = { visible: Ne, modal: Ue }, h(), T(), z(), F(), ke(), ge(), `  ${rm ? ` <dialog class="${ft(rr("tooltip", Yn, f), !0) + " " + ft(I ? Lr.root_platform_desktop : "", !0)}"${Hr({
    top: Me,
    left: Ie,
    width: Re,
    height: Be
  })}${j("this", ne, 0)}> <div${j("class", Yn.tooltip__inner, 0)}>${Yt(yi, "Unknown").$$render(r, { componentContext: Fe }, {}, {})}</div></dialog>` : `  <div class="${ft(rr("tooltip", Yn, f), !0) + " " + ft(I ? Lr.root_platform_desktop : "", !0)}" role="dialog"${j("aria-modal", Ue, 0)}${Hr({
    top: Me,
    left: Ie,
    width: Re,
    height: Be
  })}${j("this", ne, 0)}><div${j("class", Yn.tooltip__inner, 0)}>${Yt(yi, "Unknown").$$render(r, { componentContext: Fe }, {}, {})}</div></div>`}`;
}), nm = "appkit-root_platform_desktop", om = "appkit-menu", sm = "appkit-menu_visible", am = "appkit-menu__list", lm = "appkit-menu__item", No = {
  root_platform_desktop: nm,
  menu: om,
  menu_visible: sm,
  menu__list: am,
  menu__item: lm
}, cm = xr((r, t, e, i) => {
  let n, o, l, { ownerNode: c } = t, { items: d } = t, { parentComponentContext: f } = t;
  const h = kr(Wr), C = h.getCustomization("menuPopupClass") || "", T = h.getCustomization("menuItemClass") || "", P = h.isDesktop;
  l = $(P, (ue) => o = ue);
  const z = Il();
  let G, I = !1, F = "", ke = "", K = "", ge = "";
  function Q() {
    return z("close"), !0;
  }
  return Kr(() => {
  }), t.ownerNode === void 0 && e.ownerNode && c !== void 0 && e.ownerNode(c), t.items === void 0 && e.items && d !== void 0 && e.items(d), t.parentComponentContext === void 0 && e.parentComponentContext && f !== void 0 && e.parentComponentContext(f), n = { visible: I }, l(), ` <div class="${ft(rr("menu", No, n), !0) + " " + ft(o ? Lr.root_platform_desktop : "", !0) + " " + ft(C, !0)}"${Hr({
    top: ke,
    left: F,
    width: K,
    height: ge
  })}${j("this", G, 0)}><ul${j("class", No.menu__list, 0)}>${Or(d, (ue) => `<li>${Yt($o, "Actionable").$$render(
    r,
    {
      componentContext: f,
      actions: ue.actions || ue.action && [ue.action],
      cls: No.menu__item + " " + T,
      customAction: Q
    },
    {},
    {
      default: () => `${ft(ue.text)} `
    }
  )} </li>`)}</ul></div>`;
});
let ws = Ci(!0), Na = 0;
function um() {
  ws.set(!1);
}
function dm() {
  ws.set(!0);
}
const fm = /* @__PURE__ */ new Set(["string", "integer", "number", "url", "color", "boolean"]), gm = /* @__PURE__ */ new Set(["string", "integer", "number", "url", "color", "boolean", "array", "dict"]);
function Ti(r, t) {
  if (r && t)
    return new Map([...r, ...t]);
  if (r)
    return r;
  if (t)
    return t;
}
const pm = xr((r, t, e, i) => {
  var Vr, Qr, Fr, br, ci;
  let n, o, l, c, d, f, { id: h } = t, { json: C = {} } = t, { platform: T = "auto" } = t, { theme: P = "system" } = t, { globalVariablesController: z = void 0 } = t, { mix: G = "" } = t, { customization: I = {} } = t, { builtinProtocols: F = ["http", "https", "tel", "mailto", "intent"] } = t, { extensions: ke = /* @__PURE__ */ new Map() } = t, { onError: K = void 0 } = t, { onStat: ge = void 0 } = t, { onSubmit: Q = void 0 } = t, { onCustomAction: ue = void 0 } = t, { onComponent: oe = void 0 } = t, { typefaceProvider: ye = (u) => "" } = t, { fetchInit: ee = {} } = t, { tooltipRoot: be = void 0 } = t, { customComponents: $e = void 0 } = t, { direction: ne = "ltr" } = t, { store: Ne = void 0 } = t, { pagerChildrenClipEnabled: Ie = !0 } = t, { pagerMouseDragEnabled: Me = !0 } = t, { weekStartDay: Re = 0 } = t, { videoPlayerProvider: Be = void 0 } = t, { devtoolCreateHierarchy: Fe = "lazy" } = t, Ue = !0, xe = Ci(T === "desktop");
  if (c = $(xe, (u) => l = u), T === "auto" && typeof matchMedia < "u") {
    const u = matchMedia("(any-pointer: coarse)");
    xe.set(!u.matches), u.addListener(() => {
      xe.set(!u.matches);
    });
  }
  let J = "light", te = null;
  const de = Ci(ne === "rtl" ? "rtl" : "ltr");
  f = $(de, (u) => d = u);
  function fe() {
    P !== "system" || !te || (J = te.matches ? "dark" : "light");
  }
  function Qe(u) {
    P = u;
  }
  function Ge() {
    return /* @__PURE__ */ new Map();
  }
  function gt() {
    return /* @__PURE__ */ new Map();
  }
  function lt(u) {
    C = u;
  }
  function pt(u) {
    return Ct(u, De);
  }
  const R = new Set(F);
  let We = !1, pe = !1;
  h || (pe = !0, De(x(new Error('"id" prop is required'))));
  const Le = { stateChange: !1 }, ht = z || new $l(), xt = ht.getLastAddedVariableStore(), Je = ht.getVariables(), Ke = /* @__PURE__ */ new Map(), He = /* @__PURE__ */ new Map(), Ae = /* @__PURE__ */ new Map(), qe = /* @__PURE__ */ new Map();
  let it = null;
  const nt = /* @__PURE__ */ new Map();
  let Pe = 0, Ce = [];
  const zt = /* @__PURE__ */ new Set();
  let Y;
  const wt = [];
  function et(u) {
    return I == null ? void 0 : I[u];
  }
  function ot(u, g, { additionalVars: _, keepComplex: A = !1, customFunctions: y, emptyVarsError: me } = {}) {
    var le;
    if (!g)
      return Ki(g);
    const W = Ti(He, _), rt = za(g, u, Ne, Re);
    if (!rt.vars.length)
      if (rt.hasExpression) {
        const vt = rt.applyVars(W, y);
        if (!((le = vt.usedVars) != null && le.size))
          return me && me(), Ki(vt.result);
      } else
        return me && me(), Ki(g);
    const dt = rt.vars.map((vt) => W.get(vt) || Ar(vt)).filter(Fi);
    return Ci(void 0, (vt) => {
      const Oe = /* @__PURE__ */ new Map();
      let Bt;
      const sr = () => {
        var Ir;
        const ce = rt.applyVars(W, y, A);
        for (const [Ur, cr] of Oe)
          (Ir = ce.usedVars) != null && Ir.has(Ur) || (cr(), Oe.delete(Ur));
        if (ce.usedVars) {
          for (const Ur of ce.usedVars)
            if (!Oe.has(Ur)) {
              let cr = !0;
              Oe.set(Ur, Ur.subscribe(() => {
                cr || vt(sr()), cr = !1;
              }));
            }
        }
        return ce.result;
      };
      return Bt = vn(dt, sr).subscribe((ce) => {
        vt(ce);
      }), () => {
        Bt == null || Bt();
        for (const [ce, Ir] of Oe)
          Ir();
      };
    });
  }
  function tt(u, g, _, A = !1, y = void 0) {
    const me = za(g, u, Ne, Re);
    if (!me.hasExpression)
      return g;
    const W = Ti(He, _);
    return me.applyVars(W, y, A).result;
  }
  function It(u, g, _) {
    const A = /* @__PURE__ */ new Map(), y = Zn(u, "dict", g);
    A.set(u, y);
    const me = Zn("index", "integer", _);
    return A.set("index", me), A;
  }
  function De(u) {
    K ? K({ error: u }) : (u == null ? void 0 : u.level) === "warn" ? console.warn(u) : console.error(u);
  }
  function Wt(u, g) {
    ge && ge({ type: u, action: g });
  }
  function At(u) {
    return u in n;
  }
  function kt(u, g) {
    if (!u)
      return { json: u, templateContext: g };
    const _ = /* @__PURE__ */ new Set([u.type]);
    for (; u.type && u.type in n; ) {
      if ({ json: u, templateContext: g } = Tg(u, g, n, De), _.has(u.type))
        return { json: u, templateContext: g };
      _.add(u.type);
    }
    return { json: u, templateContext: g };
  }
  function Xe({ type: u, node: g, json: _, origJson: A, templateContext: y, componentContext: me, devapi: W }) {
    oe && oe({
      type: u,
      node: g,
      json: _,
      origJson: A,
      templateContext: y,
      componentContext: me,
      devapi: W
    });
  }
  let re = 0;
  function ct(u) {
    return `${h}-${re++}`;
  }
  function Gt(u) {
    return `divkit-${ct()}`;
  }
  let b = {}, Nt = {};
  function se(u, g) {
    const _ = `${u}:${g}`;
    if (Nt[_] = Nt[_] || 0, ++Nt[_], b[_])
      return b[_];
    const A = `${ct()}-svg-filter`;
    return b = { ...b, [_]: A }, A;
  }
  function Ve(u, g) {
    if (!u)
      return;
    const _ = `${u}:${g}`;
    Nt[_] && --Nt[_] === 0 && (b = Object.keys(b).reduce(
      (A, y) => (Nt[y] && (A[y] = b[y]), A),
      {}
    ));
  }
  const bt = ct() + "-id-", ve = /* @__PURE__ */ new Map(), _e = /* @__PURE__ */ new Map();
  function ae(u) {
    return bt + u;
  }
  function Ot(u, g) {
    let _ = ve.get(u) || [];
    return ve.has(u) || ve.set(u, _), _.push(g), () => {
      _ = _.filter((y) => y !== g), _.length || ve.delete(u);
      const A = ae(u);
      _e.has(A) && _e.delete(A);
    };
  }
  function St(u) {
    var _, A;
    const g = (A = (_ = ve.get(u)) == null ? void 0 : _[0]) == null ? void 0 : A.node();
    if (g) {
      const y = ae(u), me = _e.get(y);
      return me && me !== g && me.removeAttribute("id"), g.setAttribute("id", y), _e.set(y, g), y;
    }
    return "";
  }
  async function Vt(u, g) {
    var W, rt;
    if (!u)
      throw new Error("Missing state id");
    let _ = u.split("/");
    const A = _.length % 2 === 0 && B_(g);
    let y = A || O;
    const me = (g == null ? void 0 : g.logError) || De;
    if (!A)
      if ((W = y.states) != null && W.root) {
        const dt = y.states.root;
        if (dt.length > 1) {
          me(x(new Error("Error resolving state. Found multiple elements that respond to path"), { additional: { stateId: u } }));
          return;
        }
        if (y = await dt[0](_[0]), !y)
          return;
        _ = _.slice(1);
      } else
        return;
    for (let dt = 0; dt < _.length; dt += 2) {
      const le = _[dt], vt = _[dt + 1];
      if ((rt = y.states) != null && rt[le]) {
        const Oe = y.states[le];
        if (Oe.length > 1) {
          me(x(new Error("Error resolving state. Found multiple elements that respond to path"), { additional: { stateId: u } }));
          return;
        }
        if (y = await Oe[0](vt), !y)
          return;
      } else
        return;
    }
  }
  async function Lt(u, g, _) {
    var Bt;
    const A = (u == null ? void 0 : u.logError) || De;
    if (!G_(g)) {
      A(x(new Error("Incorrect submit action"), {
        additional: { containerId: g.container_id }
      }));
      return;
    }
    const y = ve.get(g.container_id);
    if ((y == null ? void 0 : y.length) !== 1) {
      A(x(new Error("Error resolving container. Found multiple elements that respond to id"), {
        additional: { containerId: g.container_id }
      }));
      return;
    }
    const me = y[0].context(), W = {};
    if (me.variables)
      for (const [sr, ce] of me.variables) {
        const Ir = ce.getValue();
        typeof Ir == "bigint" ? W[sr] = Number(Ir) : W[sr] = Ir;
      }
    if (Q) {
      Promise.resolve().then(() => Q(g, W)).then(() => {
        Ze(_.on_success_actions, { componentContext: u });
      }).catch(() => {
        Ze(_.on_fail_actions, { componentContext: u });
      });
      return;
    }
    const rt = Object.keys(W).length > 0, dt = (g.request.method || "post").toLowerCase();
    if ((dt === "get" || dt === "head") && rt) {
      A(x(new Error("Can't send variables using the get/head method."), { additional: { url: g.request.url } }));
      return;
    }
    let le = !1;
    const vt = [];
    (Bt = g.request.headers) == null || Bt.forEach((sr) => {
      vt.push([sr.name, sr.value]), sr.name.toLowerCase() === "content-type" && (le = !0);
    }), le || vt.push(["Content-Type", "application/json"]);
    let Oe;
    typeof ee == "function" ? Oe = ee(g.request.url) : Oe = ee, fetch(g.request.url, {
      ...Oe,
      method: dt,
      headers: vt,
      body: rt ? JSON.stringify(W) : void 0
    }).then((sr) => {
      if (!sr.ok)
        throw new Error("Response is not ok");
      Ze(_.on_success_actions, { componentContext: u });
    }).catch((sr) => {
      A(x(new Error("Failed to submit"), {
        additional: {
          url: g.request.url,
          originalError: sr
        }
      })), Ze(_.on_fail_actions, { componentContext: u });
    });
  }
  function _t(u, g) {
    var y, me, W, rt, dt, le, vt, Oe, Bt;
    const _ = (u == null ? void 0 : u.logError) || De, A = g.id && m(g.id);
    if (!A) {
      _(x(new Error('Missing component for "scroll_to" action'), { additional: { id: g.id } }));
      return;
    }
    if (g.animated !== void 0 && typeof g.animated != "boolean") {
      _(x(new Error('Missing properties for "scroll_to" action'), { additional: { id: g.id } }));
      return;
    }
    switch ((y = g.destination) == null ? void 0 : y.type) {
      case "index": {
        typeof g.destination.value == "number" && A.setCurrentItem(g.destination.value, (me = g.animated) != null ? me : !0);
        break;
      }
      case "offset": {
        typeof g.destination.value == "number" && ((rt = A.scrollToPosition) == null || rt.call(A, g.destination.value, (W = g.animated) != null ? W : !0));
        break;
      }
      case "start": {
        (le = A.scrollToStart) == null || le.call(A, (dt = g.animated) != null ? dt : !0);
        break;
      }
      case "end": {
        (Oe = A.scrollToEnd) == null || Oe.call(A, (vt = g.animated) != null ? vt : !0);
        break;
      }
      default:
        _(x(new Error('Unknown destination for "scroll_to" action'), {
          additional: {
            id: g.id,
            destination: (Bt = g.destination) == null ? void 0 : Bt.type
          }
        }));
    }
  }
  function $t(u, g) {
    var y;
    const _ = (u == null ? void 0 : u.logError) || De, A = g.id && m(g.id);
    if (!A) {
      _(x(new Error('Missing component for "scroll_by" action'), { additional: { id: g.id } }));
      return;
    }
    if (typeof g.item_count != "number" && g.item_count !== void 0 || typeof g.offset != "number" && g.offset !== void 0 || g.overflow !== void 0 && g.overflow !== "clamp" && g.overflow !== "ring" || g.animated !== void 0 && typeof g.animated != "boolean") {
      _(x(new Error('Missing properties for "scroll_by" action'), { additional: { id: g.id } }));
      return;
    }
    (y = A.scrollCombined) == null || y.call(A, {
      step: g.item_count,
      offset: g.offset,
      overflow: g.overflow,
      animated: g.animated
    });
  }
  function yt(u, g, { item: _, step: A, overflow: y, animated: me }) {
    var vt, Oe, Bt, sr, ce;
    if (!g)
      throw new Error(`Missing id for "${u}" action`);
    const W = Number(_);
    if (u === "set_current_item" && Number.isNaN(W))
      throw new Error(`Incorrect item for "${u}" action`);
    let rt = Number(A);
    if (!A && (u === "set_previous_item" || u === "set_next_item") && (rt = 1), !A && (u === "scroll_backward" || u === "scroll_forward" || u === "scroll_to_position") || Number.isNaN(rt))
      throw new Error(`Incorrect step value for "${u}" action`);
    if (y && y !== "clamp" && y !== "ring")
      throw new Error(`Incorrect overflow value for "${u}" action`);
    y = y || "clamp";
    const dt = me === null || me !== "0" && me !== "false", le = m(g);
    if (le)
      switch (u) {
        case "set_current_item":
          le.setCurrentItem(W, dt);
          return;
        case "set_previous_item":
          le.setPreviousItem(rt, y, dt);
          return;
        case "set_next_item":
          le.setNextItem(rt, y, dt);
          return;
        case "scroll_to_start":
          (vt = le.scrollToStart) == null || vt.call(le, dt);
          return;
        case "scroll_to_end":
          (Oe = le.scrollToEnd) == null || Oe.call(le, dt);
          return;
        case "scroll_backward":
          (Bt = le.scrollCombined) == null || Bt.call(le, {
            offset: -rt,
            overflow: y,
            animated: dt
          });
          return;
        case "scroll_forward":
          (sr = le.scrollCombined) == null || sr.call(le, {
            offset: rt,
            overflow: y,
            animated: dt
          });
          return;
        case "scroll_to_position":
          (ce = le.scrollToPosition) == null || ce.call(le, rt, dt);
          return;
      }
  }
  function Dt(u, g, _) {
    const A = (_ == null ? void 0 : _.logError) || De;
    if (u) {
      const y = m(u);
      y ? g === "start" ? y.start() : g === "pause" ? y.pause() : A(x(new Error("Unknown video action"), { additional: { id: u, action: g } })) : A(x(new Error("Video component is not found"), { additional: { id: u, action: g } }));
    } else
      A(x(new Error("Missing id in video action"), { additional: { action: g } }));
  }
  function Ct(u, g, _) {
    var A, y, me;
    if (u.templates)
      for (const W in u.templates)
        n.hasOwnProperty(W) || (n[W] = u.templates[W]);
    if (Array.isArray((A = u.patch) == null ? void 0 : A.changes)) {
      if (u.patch.mode === "transactional") {
        const W = u.patch.changes.find((rt) => {
          const dt = U.get(rt.id);
          if (!dt)
            return !0;
          const le = Array.isArray(rt.items) ? rt.items.length : 0;
          return !!(dt.isSingleMode && le !== 1);
        });
        if (W)
          return g(x(new Error("Skipping transactional, child is not found or broken"), { additional: { url: _, id: W.id } })), Ze((y = u.patch) == null ? void 0 : y.on_failed_actions), !1;
      }
      return u.patch.changes.forEach((W) => {
        const rt = U.get(W.id);
        rt && rt.replaceWith(W.id, W.items);
      }), Ze((me = u.patch) == null ? void 0 : me.on_applied_actions), !0;
    }
    return !1;
  }
  function Xt(u, g, _) {
    const A = (_ == null ? void 0 : _.logError) || De;
    if (u) {
      let y;
      typeof ee == "function" ? y = ee(u) : y = ee, fetch(u, y).then((me) => {
        if (!me.ok)
          throw new Error("Response is not ok");
        return me.json();
      }).then((me) => {
        if (!me) {
          A(x(new Error("Incorrect patch"), { additional: { url: u } })), Ze(g == null ? void 0 : g.on_fail_actions, { componentContext: _ });
          return;
        }
        Ct(me, A, u) ? Ze(g == null ? void 0 : g.on_success_actions, { componentContext: _ }) : Ze(g == null ? void 0 : g.on_fail_actions, { componentContext: _ });
      }).catch((me) => {
        A(x(new Error("Failed to download the patch"), { additional: { url: u, originalError: me } })), Ze(g == null ? void 0 : g.on_fail_actions, { componentContext: _ });
      });
    } else
      A(x(new Error("Missing url in download action"), { additional: { url: u } }));
  }
  function Ut(u, g, _) {
    var rt;
    const A = (_ == null ? void 0 : _.logError) || De;
    if (!u) {
      A(x(new Error("Missing id in show_tooltip action")));
      return;
    }
    const y = H.get(u);
    if (!y) {
      A(x(new Error("Tooltip with the provided id is not found"), { additional: { id: u } }));
      return;
    }
    if (g !== "true" && g !== !0 && zt.has(u))
      return;
    zt.add(u);
    const me = {
      internalId: ++Pe,
      ownerNode: y.onwerNode,
      desc: y.tooltip,
      timeoutId: 0,
      componentContext: _
    };
    Ce = [...Ce, me];
    const W = (rt = y.tooltip.duration) != null ? rt : 5e3;
    W && (me.timeoutId = window.setTimeout(
      () => {
        me.timeoutId = 0, Ce = Ce.filter((dt) => dt.internalId !== me.internalId);
      },
      W
    ));
  }
  function jt(u, g) {
    const _ = (g == null ? void 0 : g.logError) || De;
    if (!u) {
      _(x(new Error("Missing id in hide_tooltip action")));
      return;
    }
    Ce = Ce.filter((A) => {
      const y = A.desc.id !== u;
      return !y && A.timeoutId && (clearTimeout(A.timeoutId), A.timeoutId = null), y;
    });
  }
  function Ht(u, g, _, A, y) {
    const me = (u == null ? void 0 : u.logError) || De;
    if (!Ne) {
      me(x(new Error("Store is not configured")));
      return;
    }
    let W = _;
    if (!g || !W || !A || !y) {
      me(x(new Error("Missing required params for set_stored_value")));
      return;
    }
    if (!gm.has(A)) {
      me(x(new Error("Incorrect stored type")));
      return;
    }
    if (A === "boolean" && (W = W === "true" || W === "1"), Ne.set)
      Ne.set(g, A, W, Number(y));
    else if (Ne.setValue) {
      if (!fm.has(A)) {
        me(x(new Error("Incorrect stored type")));
        return;
      }
      if (typeof W != "string" && typeof W != "number" && typeof W != "boolean") {
        me(x(new Error("Incorrect stored value")));
        return;
      }
      (A === "integer" || A === "number") && (W = Number(W)), Ne.setValue(g, A, W, Number(y));
    }
  }
  function Rt(u) {
    mt(tt(De, u, void 0, !0), u);
  }
  async function mt(u, g, _) {
    var rt, dt;
    const A = u.scope_id, y = (_ == null ? void 0 : _.logError) || De;
    if (A) {
      const le = B.get(A);
      if (le && (le == null ? void 0 : le.size) > 1)
        y(x(new Error(`Ambiguous scope id. There are ${le.size} divs with id '${A}'`), { additional: { count: le.size, scopeId: A } }));
      else if ((le == null ? void 0 : le.size) === 1) {
        const vt = le.values().next().value;
        vt && (_ = vt);
      } else {
        y(x(new Error("The scope with the specified scope_id is missing"), { additional: { scopeId: A } }));
        return;
      }
    }
    const me = u.url ? String(u.url) : "", W = u.typed;
    if (ls(u)) {
      if (W)
        switch (W.type) {
          case "set_variable": {
            const { variable_name: le, value: vt } = W;
            if (le && vt) {
              const Oe = (_ == null ? void 0 : _.getVariable(le)) || He.get(le);
              Oe ? Oe.getType() === vt.type ? Oe.setValue(vt.value) : y(x(new Error("Trying to set value with invalid type"), { additional: { name: le, type: vt.type } })) : y(x(new Error("Cannot find variable"), { additional: { name: le } }));
            } else
              y(x(new Error("Incorrect set_variable action"), { additional: { name: le } }));
            break;
          }
          case "array_insert_value":
            T_(_, He, y, W);
            break;
          case "array_remove_value":
            M_(_, He, y, W);
            break;
          case "array_set_value":
            P_(_, He, y, W);
            break;
          case "copy_to_clipboard":
            O_(y, W);
            break;
          case "focus_element": {
            const le = W.element_id && S.get(W.element_id);
            le ? le.focus() : y(x(new Error("Incorrect focus_element action"), {
              additional: { elementId: W.element_id }
            }));
            break;
          }
          case "clear_focus": {
            try {
              document.activeElement instanceof HTMLElement && document.activeElement.blur();
            } catch {
            }
            break;
          }
          case "dict_set_value": {
            z_(_, He, y, W);
            break;
          }
          case "animator_start": {
            const le = W.animator_id && (_ == null ? void 0 : _.getAnimator(W.animator_id));
            if (!le) {
              y(x(new Error("Missing animator"), {
                additional: { animator_id: W.animator_id }
              }));
              return;
            }
            const { duration: vt, start_delay: Oe, interpolator: Bt, direction: sr, repeat_count: ce, start_value: Ir, end_value: Ur } = W, cr = _ ? _.getJsonWithVars(le) : tt(De, le), Ye = {
              ...cr,
              end_actions: le.end_actions,
              cancel_actions: le.cancel_actions,
              duration: vt !== void 0 ? vt : cr.duration,
              start_delay: Oe !== void 0 ? Oe : cr.start_delay,
              interpolator: Bt !== void 0 ? Bt : cr.interpolator,
              direction: sr !== void 0 ? sr : cr.direction,
              repeat_count: ce !== void 0 ? ce : cr.repeat_count,
              start_value_typed: Ir,
              end_value_typed: Ur
            }, a = le.variable_name && ((_ == null ? void 0 : _.getVariable(le.variable_name)) || He.get(le.variable_name));
            if (!a)
              return;
            const p = nt.get(le.id);
            p && p.stop();
            const w = R_(
              Ye,
              a,
              () => {
                nt.delete(le.id);
              },
              (v, N) => ((_ == null ? void 0 : _.execAnyActions) || Ze)(v, N)
            );
            w && nt.set(le.id, w);
            break;
          }
          case "animator_stop": {
            const le = nt.get(W.animator_id);
            le && (le.stop(), nt.delete(W.animator_id));
            break;
          }
          case "show_tooltip": {
            Ut(W.id, W.multiple, _);
            break;
          }
          case "hide_tooltip": {
            jt(W.id, _);
            break;
          }
          case "timer": {
            it ? it.execTimerAction(W.id, W.action) : y(x(new Error("Incorrect timer action"), {
              additional: {
                id: W.id,
                action: W.action
              }
            }));
            break;
          }
          case "download": {
            Xt(W.url, g.typed, _);
            break;
          }
          case "video": {
            Dt(W.id, W.action, _);
            break;
          }
          case "set_stored_value": {
            Ht(_, W.name, (rt = W.value) == null ? void 0 : rt.value, (dt = W.value) == null ? void 0 : dt.type, W.lifetime);
            break;
          }
          case "set_state": {
            await Vt(W.state_id, _);
            break;
          }
          case "submit": {
            await Lt(_, W, g.typed);
            break;
          }
          case "scroll_to": {
            _t(_, W);
            break;
          }
          case "scroll_by": {
            $t(_, W);
            break;
          }
          case "update_structure": {
            q_(_, He, y, W);
            break;
          }
          default:
            y(x(new Error("Unknown type of action"), { additional: { type: W.type } }));
        }
      else if (me)
        try {
          const le = me.replace(/div-action:\/\//, ""), vt = /([^?]+)\?(.+)/.exec(le);
          if (!vt)
            return;
          const Oe = new URLSearchParams(vt[2]);
          switch (vt[1]) {
            case "set_state":
              await Vt(Oe.get("state_id"), _);
              break;
            case "set_current_item":
            case "set_previous_item":
            case "set_next_item":
            case "scroll_to_start":
            case "scroll_to_end":
            case "scroll_backward":
            case "scroll_forward":
            case "scroll_to_position":
              yt(vt[1], Oe.get("id"), {
                item: Oe.get("item"),
                step: Oe.get("step"),
                overflow: Oe.get("overflow"),
                animated: Oe.get("animated")
              });
              break;
            case "set_variable":
              const Bt = Oe.get("name"), sr = Oe.get("value");
              if (Bt && sr !== null) {
                const Ur = (_ == null ? void 0 : _.getVariable(Bt)) || He.get(Bt);
                Ur ? Ur.set(sr) : y(x(new Error("Cannot find variable"), { additional: { name: Bt } }));
              } else
                y(x(new Error("Incorrect set_variable_action"), { additional: { url: le } }));
              break;
            case "timer":
              const ce = Oe.get("action"), Ir = Oe.get("id");
              it ? it.execTimerAction(Ir, ce) : y(x(new Error("Incorrect timer action"), {
                additional: { id: Ir, action: ce }
              }));
              break;
            case "video":
              Dt(Oe.get("id"), Oe.get("action"), _);
              break;
            case "download":
              Xt(Oe.get("url"), g.download_callbacks, _);
              break;
            case "show_tooltip":
              Ut(Oe.get("id"), Oe.get("multiple"), _);
              break;
            case "hide_tooltip":
              jt(Oe.get("id"), _);
              break;
            case "set_stored_value": {
              Ht(_, Oe.get("name"), Oe.get("value"), Oe.get("type"), Oe.get("lifetime"));
              break;
            }
            default:
              y(x(new Error("Unknown type of action"), { additional: { url: me } }));
          }
        } catch (le) {
          y(x(le, { additional: { url: me } }));
        }
    }
  }
  async function Ze(u, g = {}) {
    var me;
    if (!u || !Array.isArray(u))
      return;
    const _ = ((me = g.componentContext) == null ? void 0 : me.logError) || De, A = (W) => g.componentContext ? g.componentContext.getJsonWithVars(W, g.additionalVars, !0) : tt(_, W, g.additionalVars, !0), y = u.filter((W) => {
      const rt = A(W.is_enabled);
      return rt !== 0 && rt !== !1;
    });
    for (let W = 0; W < y.length; ++W) {
      let rt = A(y[W]);
      const dt = rt.url;
      if (rt.typed)
        await mt(rt, y[W], g.componentContext);
      else if (dt) {
        const vt = qa(dt);
        if (vt)
          if (Ja(vt, R)) {
            if (g.processUrls)
              if (rt.target === "_blank") {
                const Oe = window.open("", "_blank");
                Oe && (Oe.opener = null, Oe.location = dt);
              } else
                location.href = dt;
          } else
            vt === "div-action" ? (await mt(rt, y[W], g.componentContext), await $i()) : rt.log_id && (er(rt), await $i());
      } else
        g.node && Array.isArray(rt.menu_items) && rt.menu_items.length && (Y = {
          items: rt.menu_items,
          node: g.node,
          componentContext: g.componentContext
        });
    }
    y.forEach((W) => {
      W.log_id && Wt(g.logType || "click", W);
    });
  }
  function er(u) {
    ue == null || ue(u);
  }
  function ir(u, g) {
    const _ = (u == null ? void 0 : u.logError) || De;
    if (!Array.isArray(g) || !g.length)
      return;
    const A = [];
    return g.forEach((y) => {
      let me = !1;
      if (typeof y.condition != "string") {
        _(x(new Error("variable_trigger has a condition that is not a string"), {
          additional: { condition: y.condition }
        }));
        return;
      }
      if (!Array.isArray(y.actions)) {
        _(x(new Error("variable_trigger has no actions"), {
          additional: { condition: y.condition }
        }));
        return;
      }
      const W = y.mode || "on_condition";
      if (W !== "on_variable" && W !== "on_condition") {
        _(x(new Error("variable_trigger has an unsupported mode"), { additional: { mode: W } }));
        return;
      }
      const dt = ot(_, { condition: y.condition }, {
        additionalVars: u == null ? void 0 : u.variables,
        customFunctions: u == null ? void 0 : u.customFunctions,
        emptyVarsError: () => {
          _(x(new Error("variable_trigger must have variables in the condition"), {
            additional: { condition: y.condition }
          }));
        }
      }).subscribe(async (le) => {
        le.condition !== void 0 && (// if condition is truthy
        le.condition && // and trigger mode matches
        (W === "on_variable" || W === "on_condition" && me === !1) ? (me = !!le.condition, u ? await u.execAnyActions(y.actions, { logType: "trigger" }) : await Ze(y.actions, { logType: "trigger" })) : me = !!le.condition);
      });
      A.push(dt);
    }), () => {
      A.forEach((y) => {
        y();
      });
    };
  }
  function nr(u) {
    return Le[u];
  }
  function tr(u, g) {
    Le[u] = g;
  }
  const qt = /* @__PURE__ */ new Map(), U = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map(), H = /* @__PURE__ */ new Map(), B = /* @__PURE__ */ new Map();
  function V(u, g, _ = "error") {
    if (qt.has(u)) {
      De(x(new Error("Duplicate instance id"), {
        level: _,
        additional: { id: u }
      }));
      return;
    }
    qt.set(u, g);
  }
  function Ee(u) {
    qt.delete(u);
  }
  function m(u) {
    if (!qt.has(u)) {
      De(x(new Error("Missing instance with id"), { additional: { id: u } }));
      return;
    }
    return qt.get(u);
  }
  function ie(u, g) {
    U.set(u, g);
  }
  function L(u) {
    U.delete(u);
  }
  function Te(u, g) {
    S.set(u, g);
  }
  function ze(u) {
    S.delete(u);
  }
  function pr(u, g) {
    const _ = g.id;
    _ && (H.has(_) && De(x(new Error("Duplicate tooltip id"), { additional: { id: _ } })), H.set(_, { onwerNode: u, tooltip: g }));
  }
  function je(u) {
    const g = u.id;
    g && (H.delete(g), Ce.some((_) => _.desc.id === g) && (Ce = Ce.filter((_) => _.desc.id !== g)));
  }
  function Ar(u) {
    const g = Ae.get(u) || Ci(void 0);
    return Ae.has(u) || Ae.set(u, g), g;
  }
  function Xr(u, g, _) {
    const A = qe.get(u);
    if (A)
      return A;
    const y = Si(u, g, _);
    return qe.set(u, y), y;
  }
  function s() {
    if (!Mr)
      return;
    Mr[J].forEach((g) => {
      const _ = He.get(g.name);
      _ && _.setValue(g.color);
    });
  }
  function he() {
    return R;
  }
  function Jt(u, g) {
    const _ = ke.get(u);
    if (_)
      return new _(g || {});
  }
  function Kt(u) {
    return {
      variables: Ti(He, u.variables),
      derviedExpression(g) {
        return u.getDerivedFromVars(g);
      },
      processExpressions(g) {
        return u.getJsonWithVars(g);
      },
      execAction: Rt,
      logError: De,
      getComponentProperty(g) {
        return u.getJsonWithVars(u.json[g]);
      },
      direction: ne
    };
  }
  function Tt(u, g) {
    const _ = /* @__PURE__ */ new Map(), A = (g == null ? void 0 : g.logError) || De;
    return u.forEach((y) => {
      if (_) {
        try {
          E_(y);
        } catch (rt) {
          A(x(rt));
          return;
        }
        const me = y, W = _.get(me.name) || [];
        W.push(x_(me)), _.set(me.name, W);
      }
    }), _;
  }
  function D(u) {
    const g = {
      id: "",
      json: {},
      path: [],
      templateContext: {},
      logError(_) {
        _.additional = _.additional || {}, _.additional.path = g.path.join("/"), De(_);
      },
      execAnyActions(_, A = {}) {
        return Ze(_, {
          componentContext: g,
          processUrls: A.processUrls,
          node: A.node,
          logType: A.logType,
          additionalVars: A.additionalVars
        });
      },
      getDerivedFromVars(_, A, y = !1) {
        return ot(g.logError, _, {
          additionalVars: Ti(g.variables, A),
          keepComplex: y,
          customFunctions: g.customFunctions
        });
      },
      getJsonWithVars(_, A, y = !1) {
        return tt(g.logError, _, Ti(g.variables, A), y, g.customFunctions);
      },
      evalExpression(_, A, y) {
        return bs(Ti(He, g.variables), g.customFunctions, _, A, y);
      },
      produceChildContext(_, A = {}) {
        const y = D(this);
        let me = _, W = this.templateContext;
        const { templateContext: rt, json: dt } = kt(me, W);
        if (y.json = dt, y.templateContext = rt, y.origJson = _, y.id = A.id || dt.id || "", y.id) {
          let Oe = B.get(y.id);
          Oe || (Oe = /* @__PURE__ */ new Set(), B.set(y.id, Oe)), Oe.add(y);
        }
        A.key && (y.key = A.key), A.path !== void 0 && y.path.push(String(A.path)), _.type && !A.isRootState && y.path.push(_.type), A.isTooltipRoot && (y.isTooltipRoot = !0);
        let le;
        Array.isArray(dt.variables) ? (le = Ti(this.variables, Ti(A.variables, /* @__PURE__ */ new Map())), dt.variables.forEach((Oe) => {
          const Bt = Zr(Oe, y, le);
          Bt && le && le.set(Bt.getName(), Bt);
        })) : A.variables ? le = Ti(this.variables, A.variables) : this.variables && (le = this.variables), y.variables = le;
        let vt;
        return Array.isArray(dt.functions) && (vt = Tt(dt.functions, this)), y.customFunctions = A_(this.customFunctions, vt), Array.isArray(dt.animators) && (y.animators = dt.animators.reduce(
          (Oe, Bt) => (Bt.id && (Oe[Bt.id] = Bt), Oe),
          {}
        )), A.fake && (y.fakeElement = A.fake), A.isRootState && (y.isRootState = !0), y;
      },
      dup(_) {
        return { ...g, fakeElement: _ };
      },
      getVariable(_, A) {
        var me;
        const y = ((me = g.variables) == null ? void 0 : me.get(_)) || He.get(_);
        if (y) {
          const W = y.getType();
          if (A && W !== A) {
            g.logError(x(new Error(`Variable should have type "${A}"`), { additional: { name: _, foundType: W } }));
            return;
          }
        }
        return y;
      },
      getAnimator(_) {
        var A, y;
        return ((A = g.animators) == null ? void 0 : A[_]) || ((y = g.parent) == null ? void 0 : y.getAnimator(_)) || void 0;
      },
      registerState(_, A) {
        const y = L_(g.parent);
        return y && (y.states = y.states || {}, y.states[_] = y.states[_] || [], y.states[_].push(A)), () => {
          var me;
          (me = y == null ? void 0 : y.states) != null && me[_] && (y.states[_] = y.states[_].filter((W) => W !== A), y.states[_].length || delete y.states[_]);
        };
      },
      registerPager(_) {
        const A = g.parent;
        return A ? (A.pagers = A.pagers || /* @__PURE__ */ new Map(), A.pagers.has(_) ? {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          update() {
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          destroy() {
          }
        } : (A.pagers.set(_, null), {
          update(y) {
            var dt, le;
            A.pagers && A.pagers.set(_, y);
            const me = _ ? (dt = A.pagerListeners) == null ? void 0 : dt.get(_) : void 0, W = (le = A.pagerListeners) == null ? void 0 : le.get(void 0), rt = [...me || [], ...W || []];
            rt && rt.forEach((vt) => {
              vt(y);
            });
          },
          destroy() {
            A.pagers && A.pagers.delete(_);
          }
        })) : {
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          update() {
          },
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          destroy() {
          }
        };
      },
      listenPager(_, A) {
        var dt, le, vt;
        let y = g.parent;
        for (; y && !(y.pagers && (_ ? y.pagers.get(_) : (dt = y.pagers) != null && dt.size)); )
          y = y.parent;
        if (!y)
          return () => {
          };
        y.pagerListeners = g.pagerListeners || /* @__PURE__ */ new Map();
        const me = y.pagerListeners.get(_) || [];
        y.pagerListeners.has(_) || y.pagerListeners.set(_, me), me.push(A);
        const W = _ || ((le = y.pagers) == null ? void 0 : le.keys().next().value) || void 0, rt = (vt = y.pagers) == null ? void 0 : vt.get(W);
        return rt && A(rt), () => {
          if (!y.pagerListeners)
            return;
          let Oe = y.pagerListeners.get(W);
          Oe && (Oe = Oe.filter((Bt) => Bt !== A) || [], Oe.length ? y.pagerListeners.set(_, Oe) : y.pagerListeners.delete(_));
        };
      },
      destroy() {
        const _ = B.get(g.id);
        _ && (_.delete(g), _.size || B.delete(g.id));
      }
    };
    return u ? (g.parent = u, g.path = u.path.slice(), u.fakeElement && (g.fakeElement = u.fakeElement)) : (g.json = { type: "root" }, g.isRootState = !0), g;
  }
  function _r(u) {
    Ue ? wt.push(u) : clearTimeout(u);
  }
  Yi(Wr, {
    logStat: Wt,
    hasTemplate: At,
    genId: ct,
    genClass: Gt,
    execCustomAction: er,
    processVariableTriggers: ir,
    isRunning: nr,
    setRunning: tr,
    pagerChildrenClipEnabled: Ie,
    pagerMouseDragEnabled: Me,
    registerInstance: V,
    unregisterInstance: Ee,
    registerParentOf: ie,
    unregisterParentOf: L,
    registerTooltip: pr,
    unregisterTooltip: je,
    onTooltipClose: Nr,
    tooltipRoot: be,
    registerFocusable: Te,
    unregisterFocusable: ze,
    addSvgFilter: se,
    removeSvgFilter: Ve,
    registerId: Ot,
    getComponentId: St,
    preparePrototypeVariables: It,
    getCustomization: et,
    getBuiltinProtocols: he,
    getExtension: Jt,
    getExtensionContext: Kt,
    registerTimeout: _r,
    typefaceProvider: ye,
    isDesktop: xe,
    isPointerFocus: ws,
    customComponents: $e,
    direction: de,
    videoPlayerProvider: Be,
    awaitGlobalVariable: Xr,
    componentDevtool: oe ? Xe : void 0,
    devtoolCreateHierarchy: oe ? Fe || "eager" : "lazy"
  }), Yi(Xi, {
    hasAction() {
      return !1;
    }
  }), Yi(as, {
    runVisibilityTransition(u, g, _, A, y) {
      return Promise.resolve();
    },
    registerChildWithTransitionIn(u, g, _, A) {
      return Promise.resolve();
    },
    registerChildWithTransitionOut(u, g, _, A) {
      return Promise.resolve();
    },
    registerChildWithTransitionChange(u, g, _, A) {
      return Promise.resolve();
    },
    hasTransitionChange(u) {
      return !1;
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    registerChild(u) {
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    unregisterChild(u) {
    }
  }), Yi(cs, { isEnabled: Ki(!0) });
  function mr(u, g) {
    const _ = He.get(u);
    return (_ == null ? void 0 : _.getType()) === g;
  }
  function ut(u, g) {
    const _ = He.get(u);
    _ ? _.setValue(g) : De(x(new Error("Cannot find variable"), { additional: { name: u } }));
  }
  function Rr(u, g, _) {
    const A = (g == null ? void 0 : g.logError) || De, y = u.name, me = u.value_type;
    if (typeof u.get != "string" || !u.get) {
      A(x(new Error("Incorrect property getter"), { additional: { name: y } }));
      return;
    }
    if (!y) {
      A(x(new Error("Missing property name")));
      return;
    }
    if (!me) {
      A(x(new Error("Missing property value_type")));
      return;
    }
    const W = g ? g.getDerivedFromVars(u.get, void 0, !0) : ot(De, u.get, { keepComplex: !0 });
    if (Ro(W) === void 0)
      return;
    const dt = (le) => {
      const vt = Zn(u.new_value_variable_name || "new_value", u.value_type, le), Oe = new Map(_);
      Oe.set(vt.getName(), vt), Array.isArray(u.set) && u.set.length ? g ? g.execAnyActions(u.set, { additionalVars: Oe }) : Ze(u.set, { additionalVars: Oe }) : A(x(new Error("Cannot set property. No setters provided."), { additional: { name: y } }));
    };
    return {
      getName() {
        return y;
      },
      subscribe(le) {
        return W.subscribe(le);
      },
      set(le) {
        const vt = qf(le, me);
        dt(vt);
      },
      setValue: dt,
      getValue() {
        return Ro(W);
      },
      getType() {
        return me;
      }
    };
  }
  function Zr(u, g, _) {
    if (u.type === "property")
      return Rr(u, g, _);
    if (!u.type || !u.name || !(u.type in qo) || !("value" in u))
      return;
    const A = u.value;
    let y = g ? g.getJsonWithVars(A, _, !0) : tt(De, A, _, !0);
    if (!(A && typeof A == "string" && y === void 0)) {
      u.type === "integer" && typeof y == "number" && (y > Number.MAX_SAFE_INTEGER || y < Number.MIN_SAFE_INTEGER) && De(x(new Error("The value of the integer variable could lose accuracy"), {
        level: "warn",
        additional: { name: u.name, value: y }
      }));
      try {
        return Si(u.name, u.type, y);
      } catch (me) {
        De(x(me, { additional: { name: u.name } }));
      }
    }
  }
  function Br(u) {
    const g = Zr(u);
    g && (Ke.set(u.name, g), He.set(u.name, g));
  }
  for (const [u, g] of Je)
    He.has(u) || He.set(u, g);
  const vr = (Vr = C == null ? void 0 : C.card) == null ? void 0 : Vr.variables;
  Array.isArray(vr) && vr.forEach((u) => {
    if (u && u.name) {
      if (Ke.has(u.name)) {
        De(x(new Error("Duplicate variable"), { additional: { name: u.name } }));
        return;
      }
      Br(u);
    }
  });
  const Mr = C.palette;
  Mr && Mr[J].forEach((g) => {
    if (Ke.has(g.name)) {
      De(x(new Error("Duplicate variable"), { additional: { name: g.name } }));
      return;
    }
    try {
      const _ = Si(g.name, "color", g.color);
      Ke.set(g.name, _), He.set(g.name, _);
    } catch (_) {
      De(x(_, { additional: { name: g.name } }));
    }
  }), xt.subscribe((u) => {
    if (u && !He.has(u)) {
      const g = Je.get(u);
      He.set(u, g);
      const _ = Ae.get(u);
      if (_) {
        let y = 0;
        g.subscribe(() => {
          _.set(++y);
        });
      }
      const A = qe.get(u);
      A && A.getType() === g.getType() && g.subscribe((y) => {
        A.set(y);
      });
    }
  });
  const Sr = (Qr = C == null ? void 0 : C.card) == null ? void 0 : Qr.timers;
  if (Sr && typeof document < "u") {
    const u = it = new D_({
      logError: De,
      applyVars: (g) => tt(De, g),
      hasVariableWithType: mr,
      setVariableValue: ut,
      execAnyActions: Ze
    });
    Sr.forEach((g) => u.createTimer(g));
  }
  const O = D();
  Array.isArray((Fr = C.card) == null ? void 0 : Fr.functions) && (O.customFunctions = Tt(C.card.functions));
  let $r;
  function Nr(u) {
    Ce = Ce.filter((g) => g.internalId !== u);
  }
  Kr(() => {
    Ue = !1, Na--, Na || (window.removeEventListener("keydown", um), window.removeEventListener("pointerdown", dm));
    for (const [u, g] of nt)
      g.stop();
    it && it.destroy(), Ce.forEach((u) => {
      u.timeoutId && (clearTimeout(u.timeoutId), u.timeoutId = null);
    }), wt.forEach((u) => {
      clearTimeout(u);
    });
  }), t.id === void 0 && e.id && h !== void 0 && e.id(h), t.json === void 0 && e.json && C !== void 0 && e.json(C), t.platform === void 0 && e.platform && T !== void 0 && e.platform(T), t.theme === void 0 && e.theme && P !== void 0 && e.theme(P), t.globalVariablesController === void 0 && e.globalVariablesController && z !== void 0 && e.globalVariablesController(z), t.mix === void 0 && e.mix && G !== void 0 && e.mix(G), t.customization === void 0 && e.customization && I !== void 0 && e.customization(I), t.builtinProtocols === void 0 && e.builtinProtocols && F !== void 0 && e.builtinProtocols(F), t.extensions === void 0 && e.extensions && ke !== void 0 && e.extensions(ke), t.onError === void 0 && e.onError && K !== void 0 && e.onError(K), t.onStat === void 0 && e.onStat && ge !== void 0 && e.onStat(ge), t.onSubmit === void 0 && e.onSubmit && Q !== void 0 && e.onSubmit(Q), t.onCustomAction === void 0 && e.onCustomAction && ue !== void 0 && e.onCustomAction(ue), t.onComponent === void 0 && e.onComponent && oe !== void 0 && e.onComponent(oe), t.typefaceProvider === void 0 && e.typefaceProvider && ye !== void 0 && e.typefaceProvider(ye), t.fetchInit === void 0 && e.fetchInit && ee !== void 0 && e.fetchInit(ee), t.tooltipRoot === void 0 && e.tooltipRoot && be !== void 0 && e.tooltipRoot(be), t.customComponents === void 0 && e.customComponents && $e !== void 0 && e.customComponents($e), t.direction === void 0 && e.direction && ne !== void 0 && e.direction(ne), t.store === void 0 && e.store && Ne !== void 0 && e.store(Ne), t.pagerChildrenClipEnabled === void 0 && e.pagerChildrenClipEnabled && Ie !== void 0 && e.pagerChildrenClipEnabled(Ie), t.pagerMouseDragEnabled === void 0 && e.pagerMouseDragEnabled && Me !== void 0 && e.pagerMouseDragEnabled(Me), t.weekStartDay === void 0 && e.weekStartDay && Re !== void 0 && e.weekStartDay(Re), t.videoPlayerProvider === void 0 && e.videoPlayerProvider && Be !== void 0 && e.videoPlayerProvider(Be), t.devtoolCreateHierarchy === void 0 && e.devtoolCreateHierarchy && Fe !== void 0 && e.devtoolCreateHierarchy(Fe), t.setTheme === void 0 && e.setTheme && Qe !== void 0 && e.setTheme(Qe), t.getDebugVariables === void 0 && e.getDebugVariables && Ge !== void 0 && e.getDebugVariables(Ge), t.getDebugAllVariables === void 0 && e.getDebugAllVariables && gt !== void 0 && e.getDebugAllVariables(gt), t.setData === void 0 && e.setData && lt !== void 0 && e.setData(lt), t.applyPatch === void 0 && e.applyPatch && pt !== void 0 && e.applyPatch(pt), t.execAction === void 0 && e.execAction && Rt !== void 0 && e.execAction(Rt), P === "light" || P === "dark" ? J = P : P === "system" ? typeof matchMedia < "u" ? (te || (te = matchMedia("(prefers-color-scheme: dark)"), te.addListener(fe)), J = te.matches ? "dark" : "light") : J = "light" : De(x(new Error("Unsupported theme"))), J && s();
  {
    We = !1;
    const u = C_(C);
    u && (We = !0, De(u));
  }
  if (n = C.templates || {}, (br = C == null ? void 0 : C.card) != null && br.variables && Array.isArray(C.card.variables) && C.card.variables !== vr && C.card.variables.forEach((u) => {
    u && u.name && !Ke.has(u.name) && !He.has(u.name) && Br(u);
  }), o = (ci = C == null ? void 0 : C.card) == null ? void 0 : ci.states, o && !We && !pe) {
    const u = {
      type: "state",
      id: "root",
      width: { type: "match_parent" },
      height: { type: "match_parent" },
      states: o.map((g) => ({
        state_id: g.state_id.toString(),
        div: g.div
      }))
    };
    $r = O.produceChildContext(u, { isRootState: !0 });
  }
  return c(), f(), `${!We && !pe && $r ? `<div class="${ft(Lr.root, !0) + ft(l ? ` ${Lr.root_platform_desktop}` : "", !0) + ft(G ? ` ${G}` : "", !0)}"${j("dir", d, 0)}>${Yt(Dg, "RootSvgFilters").$$render(r, { svgFiltersMap: b }, {}, {})} ${Yt(yi, "Unknown").$$render(
    r,
    {
      componentContext: $r
    },
    {},
    {}
  )} ${Ce ? `${Or(Ce, (u) => `${Yt(im, "TooltipView").$$render(
    r,
    {
      ownerNode: u.ownerNode,
      data: u.desc,
      internalId: u.internalId,
      parentComponentContext: u.componentContext || $r
    },
    {},
    {}
  )}`)}` : ""} ${Y ? `${Yt(cm, "Menu").$$render(
    r,
    {
      ownerNode: Y.node,
      items: Y.items,
      parentComponentContext: Y.componentContext || $r
    },
    {},
    {}
  )}` : ""}</div>` : ""}`;
});
function mm(r) {
  return pm.render(r).html;
}
export {
  _m as createGlobalVariablesController,
  Si as createVariable,
  mm as render
};
//# sourceMappingURL=server.mjs.map
